// @ts-nocheck
import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Long: any;
  Map: any;
  Time: any;
  Upload: any;
};

export type AcceptFirmClientInvitationInput = {
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  invitationID: Scalars['ID'];
  password: Scalars['String'];
};

export type AcceptFirmClientInvitationPayload = {
  __typename?: 'AcceptFirmClientInvitationPayload';
  firm: Firm;
  primaryHousehold: Household;
  tokenSet: TokenSet;
  user: User;
};

export type AcceptFirmInviteLinkInput = {
  email: Scalars['String'];
  familyName: Scalars['String'];
  firmInviteLinkID: Scalars['ID'];
  givenName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type AcceptFirmInviteLinkPayload = {
  __typename?: 'AcceptFirmInviteLinkPayload';
  firmClientID: Scalars['String'];
  householdID: Scalars['String'];
  /**
   * True when the user was newly signed up and must confirm their account with
   * the emailed Cognito verification code; false when an archived user was
   * reactivated (already confirmed, no code is sent).
   */
  requiresConfirmation?: Maybe<Scalars['Boolean']>;
};

export type AddFeatureDiscoveryTriggerToFirmClientInput = {
  clientID: Scalars['ID'];
  featureDiscoveryTrigger: FeatureDiscoveryTrigger;
};

export type AddFeatureDiscoveryTriggerToFirmClientPayload = {
  __typename?: 'AddFeatureDiscoveryTriggerToFirmClientPayload';
  added: Scalars['Boolean'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
};

export type AiClientSummary = {
  __typename?: 'AiClientSummary';
  /** @deprecated This flag will be removed in a future release. */
  advisorApproved: Scalars['Boolean'];
  aiResponses: AiResponses;
  dataConfidenceLevel?: Maybe<DataConfidenceLevel>;
  dataConfidenceSummary?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated */
  householdCategorySummary?: Maybe<Scalars['String']>;
  modelID?: Maybe<ModelId>;
  /** @deprecated This field is deprecated */
  shortHouseholdCategorySummary?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated */
  summary: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type AiClientSummaryChanges = {
  advisorApproved?: InputMaybe<Scalars['Boolean']>;
  aiResponses?: InputMaybe<AiResponsesInput>;
  dataConfidenceLevel?: InputMaybe<DataConfidenceLevel>;
  dataConfidenceSummary?: InputMaybe<Scalars['String']>;
};

export type AiClientSummaryVersion = {
  __typename?: 'AiClientSummaryVersion';
  aiResponses: AiResponses;
  dataConfidenceLevel?: Maybe<DataConfidenceLevel>;
  dataConfidenceSummary?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated */
  householdCategorySummary?: Maybe<Scalars['String']>;
  modelID?: Maybe<ModelId>;
  publishedAt?: Maybe<Scalars['Time']>;
  publishedBy: Scalars['String'];
  /** @deprecated This field is deprecated */
  shortHouseholdCategorySummary?: Maybe<Scalars['String']>;
  /** @deprecated This field is deprecated */
  summary: Scalars['String'];
  updatedAt: Scalars['Time'];
  versionID: Scalars['ID'];
};

export type AiResponses = {
  __typename?: 'AiResponses';
  areasForImprovement: Array<AreaForImprovement>;
  elementDetails: ElementDetails;
  /** @deprecated Use areasForImprovement instead. */
  financialAreasForImprovement: Array<Scalars['String']>;
  /** @deprecated Use strengths instead. */
  financialStrengths: Array<Scalars['String']>;
  /** @deprecated Use strengths and areasForImprovement instead. */
  observations: Array<Scalars['String']>;
  shortCategoryExplanation: Scalars['String'];
  strengths: Array<Scalars['String']>;
};

export type AiResponsesInput = {
  areasForImprovement?: InputMaybe<Array<AreaForImprovementInput>>;
  elementDetails?: InputMaybe<ElementDetailsInput>;
  shortCategoryExplanation?: InputMaybe<Scalars['String']>;
  strengths?: InputMaybe<Array<Scalars['String']>>;
};

export enum AppType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Other = 'OTHER',
  Web = 'WEB'
}

export type ApplyPlaidItemAccountMappingInput = {
  accountsMapping: Array<PlaidItemAccountMappingInput>;
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
};

export type ApplyTargetScoreRangeTemplateToClientInput = {
  clientID: Scalars['ID'];
  templateID: Scalars['ID'];
};

export type ArchiveFirmClientInput = {
  clientID: Scalars['ID'];
};

export type ArchiveFirmClientPayload = {
  __typename?: 'ArchiveFirmClientPayload';
  archived: Scalars['Boolean'];
};

export type ArchiveIncomeSourceInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type ArchiveIncomeSourcePayload = {
  __typename?: 'ArchiveIncomeSourcePayload';
  archived: Scalars['Boolean'];
};

export type AreaForImprovement = {
  __typename?: 'AreaForImprovement';
  body: Scalars['String'];
  goalBody: Scalars['String'];
};

export type AreaForImprovementInput = {
  body?: InputMaybe<Scalars['String']>;
  goalBody?: InputMaybe<Scalars['String']>;
};

export type AssetLoan = SynchronizedItem & {
  __typename?: 'AssetLoan';
  assetID: Scalars['ID'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  loanID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type AssetLoanList = {
  __typename?: 'AssetLoanList';
  items: Array<AssetLoan>;
  pageInfo: PageInfo;
};

export type AssignClientToGroupInput = {
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
  groupID: Scalars['ID'];
};

export type AssignClientToGroupPayload = {
  __typename?: 'AssignClientToGroupPayload';
  assigned: Scalars['Boolean'];
};

export type AssignedBaaAccountList = {
  __typename?: 'AssignedBaaAccountList';
  items: Array<BaaAccount>;
  pageInfo: PageInfo;
};

export type AssociateSoftwareTokenInput = {
  code: Scalars['String'];
  friendlyDeviceName: SoftwareTokenFriendlyDeviceNameType;
};

export type AuthenticationChallenge = {
  __typename?: 'AuthenticationChallenge';
  challenge: AuthenticationChallengeType;
  parameters: Array<AuthenticationChallengeParameter>;
  session: Scalars['String'];
};

export type AuthenticationChallengeParameter = {
  __typename?: 'AuthenticationChallengeParameter';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AuthenticationChallengeResponse = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum AuthenticationChallengeType {
  /** New password required. */
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
  /** Selects the MFA type. Valid MFA options are SMS_MFA for text SMS MFA, and SOFTWARE_TOKEN_MFA for time-based one-time password (TOTP) software token MFA. */
  SelectMfaType = 'SELECT_MFA_TYPE',
  /** Next challenge is to supply an SMS_MFA_CODE, delivered via SMS, and USERNAME. */
  SmsMfa = 'SMS_MFA',
  /** Next challenge is to supply a SOFTWARE_TOKEN_MFA_CODE, delivered via a TOTP software application such as Google Authenticator, and USERNAME. */
  SoftwareTokenMfa = 'SOFTWARE_TOKEN_MFA'
}

export type BaaAccount = {
  __typename?: 'BaaAccount';
  BAAAccountID: Scalars['ID'];
  BAAFinancialProfileID: Scalars['ID'];
  accountNumber?: Maybe<Scalars['String']>;
  accountType: BaaAccountType;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  financialInstitutionID: Scalars['String'];
  financialInstitutionName: Scalars['String'];
  firmClientID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  mappedEntityID: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Time'];
  value: MonetaryAmount;
};

export enum BaaAccountType {
  BankingCd = 'BANKING_CD',
  BankingChecking = 'BANKING_CHECKING',
  BankingCreditline = 'BANKING_CREDITLINE',
  BankingDeposit = 'BANKING_DEPOSIT',
  BankingMoneymarket = 'BANKING_MONEYMARKET',
  BankingOther = 'BANKING_OTHER',
  BankingSavings = 'BANKING_SAVINGS',
  Creditcard = 'CREDITCARD',
  HealthaccountFsa = 'HEALTHACCOUNT_FSA',
  HealthaccountHra = 'HEALTHACCOUNT_HRA',
  HealthaccountHsa = 'HEALTHACCOUNT_HSA',
  HealthaccountOther = 'HEALTHACCOUNT_OTHER',
  InsuranceAnnuity = 'INSURANCE_ANNUITY',
  InsuranceLifeinsurance = 'INSURANCE_LIFEINSURANCE',
  InsuranceOther = 'INSURANCE_OTHER',
  Investment_401A = 'INVESTMENT_401A',
  Investment_401K = 'INVESTMENT_401K',
  Investment_403B = 'INVESTMENT_403B',
  Investment_457B = 'INVESTMENT_457B',
  Investment_529 = 'INVESTMENT_529',
  InvestmentBrokerage = 'INVESTMENT_BROKERAGE',
  InvestmentCashmanagement = 'INVESTMENT_CASHMANAGEMENT',
  InvestmentCoverdell = 'INVESTMENT_COVERDELL',
  InvestmentIra = 'INVESTMENT_IRA',
  InvestmentKeogh = 'INVESTMENT_KEOGH',
  InvestmentMutualfund = 'INVESTMENT_MUTUALFUND',
  InvestmentOther = 'INVESTMENT_OTHER',
  InvestmentPension = 'INVESTMENT_PENSION',
  InvestmentPrepaidtuition = 'INVESTMENT_PREPAIDTUITION',
  InvestmentProfitshare = 'INVESTMENT_PROFITSHARE',
  InvestmentRetirement = 'INVESTMENT_RETIREMENT',
  InvestmentRothira = 'INVESTMENT_ROTHIRA',
  InvestmentSarsep = 'INVESTMENT_SARSEP',
  InvestmentSavingsbond = 'INVESTMENT_SAVINGSBOND',
  InvestmentSepira = 'INVESTMENT_SEPIRA',
  InvestmentTreasurybond = 'INVESTMENT_TREASURYBOND',
  InvestmentTrust = 'INVESTMENT_TRUST',
  InvestmentUgma = 'INVESTMENT_UGMA',
  InvestmentUtma = 'INVESTMENT_UTMA',
  LoanAuto = 'LOAN_AUTO',
  LoanBank = 'LOAN_BANK',
  LoanBoat = 'LOAN_BOAT',
  LoanHomeequity = 'LOAN_HOMEEQUITY',
  LoanMortgage = 'LOAN_MORTGAGE',
  LoanOther = 'LOAN_OTHER',
  LoanPersonal = 'LOAN_PERSONAL',
  LoanStudent = 'LOAN_STUDENT',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

export type BaaPerson = {
  __typename?: 'BaaPerson';
  BAAPersonID: Scalars['ID'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  emailAddress: Scalars['String'];
  firmID: Scalars['ID'];
  firmMemberID: Scalars['String'];
  id: Scalars['ID'];
  role: BaaPersonRole;
  updatedAt: Scalars['Time'];
  username: Scalars['String'];
};

export enum BaaPersonRole {
  Advisor = 'ADVISOR',
  Assistant = 'ASSISTANT',
  Consultant = 'CONSULTANT',
  Investor = 'INVESTOR'
}

export type BeginPasswordlessSignInInput = {
  domain: Scalars['String'];
  email: Scalars['String'];
};

export type BeginPasswordlessSignInPayload = {
  __typename?: 'BeginPasswordlessSignInPayload';
  sent: Scalars['Boolean'];
};

export type BrDetails = {
  __typename?: 'BrDetails';
  annualExpenses: MonetaryAmount;
  annualIncome: MonetaryAmount;
  br?: Maybe<Scalars['Float']>;
  estimatedSpendingMinusDebtPayments: RecurringTotals;
  incomeUpdates: Array<IncomeChangeLineItem>;
  spendingUpdates: Array<SpendingChangeLineItem>;
  totalDebtPayments: RecurringTotals;
};

export type BtDetails = {
  __typename?: 'BtDetails';
  annualExpenses: MonetaryAmount;
  bt?: Maybe<Scalars['Float']>;
  businesses: Array<BusinessEquityLineItem>;
  privateStock: Array<Investment>;
  totalBusinessDebt: MonetaryAmount;
  totalBusinessEquity: MonetaryAmount;
  totalBusinessValue: MonetaryAmount;
  totalPrivateStock: MonetaryAmount;
};

export type BurnRateHistoryItem = {
  __typename?: 'BurnRateHistoryItem';
  burnRate: Scalars['Float'];
  dateTime: Scalars['Time'];
};

export type BurnRateReportData = {
  __typename?: 'BurnRateReportData';
  burnRate: Scalars['Float'];
  burnRateHistory: Array<BurnRateHistoryItem>;
  /**
   * The Burn Rate numerator: annual living expenses, i.e. household spending minus
   * personal annual debt payments (debt is measured separately by Debt Rate).
   */
  estimatedSpendingMinusDebtPayments: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  reportDisclosureText: Scalars['String'];
  totalAnnualIncome: MonetaryAmount;
  type: ReportType;
};

export type Business = NetWorthItem & Owner & SynchronizedItem & {
  __typename?: 'Business';
  address?: Maybe<Address>;
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  entityTaxStructure: EntityTaxStructure;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  ownerType: OwnerType;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type BusinessEquityLineItem = {
  __typename?: 'BusinessEquityLineItem';
  business: Business;
  loans: Array<Loan>;
  ownedCashAccounts: Array<CashAccount>;
  ownedDebt: MonetaryAmount;
  ownedNonQualifiedInvestments: Array<Investment>;
  ownedQualifiedInvestments: Array<Investment>;
  ownedRealEstate: Array<RealEstate>;
  ownedValue: MonetaryAmount;
  totalOwnedCashAccounts: MonetaryAmount;
  totalOwnedEquity: MonetaryAmount;
  totalOwnedNonQualifiedInvestments: MonetaryAmount;
  totalOwnedQualifiedInvestments: MonetaryAmount;
  totalOwnedRealEstate: MonetaryAmount;
};

export type BusinessList = {
  __typename?: 'BusinessList';
  items: Array<Business>;
  pageInfo: PageInfo;
};

export type BusinessTermBusiness = {
  __typename?: 'BusinessTermBusiness';
  createdAt: Scalars['Time'];
  equity: MonetaryAmount;
  name: Scalars['String'];
  ownedValue: ValueForDate;
  ownershipAllocation: Scalars['Float'];
  primaryOwner: Scalars['String'];
  relatedLoans: Array<ReportLoan>;
};

export type BusinessTermReportData = {
  __typename?: 'BusinessTermReportData';
  businessEquityHistory: Array<ValueForDate>;
  businessTerm: Scalars['Float'];
  businesses: Array<BusinessTermBusiness>;
  estimatedAnnualSpending: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  privateStock: Array<ReportInvestment>;
  reportDisclosureText: Scalars['String'];
  totalBusinessEquity: MonetaryAmount;
  totalOwnedBusinessDebt: MonetaryAmount;
  totalOwnedBusinessValue: MonetaryAmount;
  totalPrivateStock: MonetaryAmount;
  type: ReportType;
};

export type CashAccount = LinkedAccount & NetWorthItem & SynchronizedItem & {
  __typename?: 'CashAccount';
  accountLinkProvider?: Maybe<MappedAccountProvider>;
  cashAccountType: CashAccountType;
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  linkID?: Maybe<Scalars['String']>;
  linkStatus?: Maybe<MappedAccountStatus>;
  linkedInstitutionName?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  recurringContribution: RecurringMonetaryAmountDataPointGroup;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type CashAccountList = {
  __typename?: 'CashAccountList';
  items: Array<CashAccount>;
  pageInfo: PageInfo;
};

export enum CashAccountType {
  Cash = 'CASH',
  CashManagementAccount = 'CASH_MANAGEMENT_ACCOUNT',
  CertificateOfDeposit = 'CERTIFICATE_OF_DEPOSIT',
  CheckingAccount = 'CHECKING_ACCOUNT',
  MoneyMarketAccount = 'MONEY_MARKET_ACCOUNT',
  SavingsAccount = 'SAVINGS_ACCOUNT',
  TreasuryBill = 'TREASURY_BILL'
}

export type CategoryEstimate = {
  __typename?: 'CategoryEstimate';
  category: SpendingCategoryEstimateCategory;
  estimate: MonetaryAmount;
};

export type CategoryEstimateInput = {
  category: SpendingCategoryEstimateCategory;
  estimate: MonetaryAmountInput;
};

export type ChangeAccountToCashAccountInput = {
  cashAccountName: Scalars['String'];
  fromAccountID: Scalars['ID'];
  householdID: Scalars['String'];
  toCashAccountType: CashAccountType;
};

export type ChangeAccountToCashAccountPayload = {
  __typename?: 'ChangeAccountToCashAccountPayload';
  cashAccountID: Scalars['ID'];
};

export type ChangeAccountToInsurancePolicyInput = {
  fromAccountID: Scalars['ID'];
  householdID: Scalars['String'];
  insurancePolicyName: Scalars['String'];
  toInsurancePolicySubType: InsurancePolicySubtype;
  toInsurancePolicyType: InsurancePolicyType;
};

export type ChangeAccountToInsurancePolicyPayload = {
  __typename?: 'ChangeAccountToInsurancePolicyPayload';
  insurancePolicyID: Scalars['ID'];
};

export type ChangeAccountToInvestmentInput = {
  fromAccountID: Scalars['ID'];
  householdID: Scalars['String'];
  investmentName: Scalars['String'];
  toInvestmentType: InvestmentType;
};

export type ChangeAccountToInvestmentPayload = {
  __typename?: 'ChangeAccountToInvestmentPayload';
  investmentID: Scalars['ID'];
};

export type ChangeAccountToLoanInput = {
  fromAccountID: Scalars['ID'];
  householdID: Scalars['String'];
  loanName: Scalars['String'];
  toLoanType: LoanType;
};

export type ChangeAccountToLoanPayload = {
  __typename?: 'ChangeAccountToLoanPayload';
  loanID: Scalars['ID'];
};

export type ChangeEmailInput = {
  email: Scalars['String'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type ChangeUsernameInput = {
  accessToken: Scalars['String'];
  username: Scalars['String'];
};

export type ClientInvitation = Invitation & {
  __typename?: 'ClientInvitation';
  acceptedAt?: Maybe<Scalars['Time']>;
  clientID: Scalars['ID'];
  createdAt: Scalars['Time'];
  /** dateTime is here only temporarily for backwards compatability. Please use `createdAt` instead. */
  dateTime: Scalars['Time'];
  firmID: Scalars['ID'];
  firmName: Scalars['String'];
  /**
   * The ID of the the household of the firm client the user is being invited to. Optional for now, once the migration over to
   * Create Client is complete, will make non-optional
   */
  householdID?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  inviteeEmail: Scalars['String'];
  inviteeFamilyName?: Maybe<Scalars['String']>;
  inviteeGivenName?: Maybe<Scalars['String']>;
  inviter: UserProfile;
  /**
   * The ID of the person in the household the user is being invited to. Optional for now, once the migration over to
   * Create Client is complete, will make non-optional
   */
  personID?: Maybe<Scalars['ID']>;
  status: InvitationStatus;
  /** type is here only temporarily for backwards compatability. Please use the actual typed invitation's typename. */
  type: InvitationType;
  updatedAt: Scalars['Time'];
};

export type ClientSmartGroup = {
  __typename?: 'ClientSmartGroup';
  createdAt: Scalars['Time'];
  firmClientID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  smartGroupID: Scalars['ID'];
  status: ClientSmartGroupStatus;
};

export enum ClientSmartGroupStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  ManualActive = 'MANUAL_ACTIVE',
  ManualInactive = 'MANUAL_INACTIVE'
}

export type ClientSmartGroupsForFirmClientList = {
  __typename?: 'ClientSmartGroupsForFirmClientList';
  items: Array<ClientSmartGroup>;
};

export type ClientSmartGroupsForFirmClientListInput = {
  firmClientID: Scalars['ID'];
};

export type ClientVersionInfo = {
  __typename?: 'ClientVersionInfo';
  app: Scalars['String'];
  os: Scalars['String'];
};

export type CloseBusinessInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseBusinessPayload = {
  __typename?: 'CloseBusinessPayload';
  changeToken: Scalars['String'];
};

export type CloseCashAccountInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseCashAccountPayload = {
  __typename?: 'CloseCashAccountPayload';
  changeToken: Scalars['String'];
};

export type CloseInvestmentInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseInvestmentPayload = {
  __typename?: 'CloseInvestmentPayload';
  changeToken: Scalars['String'];
};

export type CloseLoanInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseLoanPayload = {
  __typename?: 'CloseLoanPayload';
  changeToken: Scalars['String'];
};

export type CloseNoteReceivableInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseNoteReceivablePayload = {
  __typename?: 'CloseNoteReceivablePayload';
  changeToken: Scalars['String'];
};

export type ClosePersonalPropertyItemInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type ClosePersonalPropertyItemPayload = {
  __typename?: 'ClosePersonalPropertyItemPayload';
  changeToken: Scalars['String'];
};

export type CloseRealEstatePropertyInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type CloseRealEstatePropertyPayload = {
  __typename?: 'CloseRealEstatePropertyPayload';
  changeToken: Scalars['String'];
};

export enum CollateralType {
  AdditionalResidence = 'ADDITIONAL_RESIDENCE',
  BusinessProperty = 'BUSINESS_PROPERTY',
  InvestmentProperty = 'INVESTMENT_PROPERTY',
  None = 'NONE',
  PrimaryResidence = 'PRIMARY_RESIDENCE'
}

export type CommunityProperty = {
  __typename?: 'CommunityProperty';
  owners: Array<Owner>;
};

export type CommunityPropertyInput = {
  owners: Array<OwnerInput>;
};

export type CompletePasswordlessSignInInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type CompletePasswordlessSignInPayload = {
  __typename?: 'CompletePasswordlessSignInPayload';
  tokenSet: TokenSet;
};

export type CompleteProspectDiscoveryInput = {
  clientID: Scalars['ID'];
};

export type CompleteProspectDiscoveryPayload = {
  __typename?: 'CompleteProspectDiscoveryPayload';
  complete: Scalars['Boolean'];
};

export type CompleteQuarterlyProgressReportReviewInput = {
  firmClientID: Scalars['ID'];
};

export type CompleteQuarterlyProgressReportReviewPayload = {
  __typename?: 'CompleteQuarterlyProgressReportReviewPayload';
  review: QuarterlyProgressReportReview;
};

export type CompleteQuarterlyProgressReportReviewSectionInput = {
  firmClientID: Scalars['ID'];
  section: QuarterlyProgressReportReviewSection;
};

export type CompleteQuarterlyProgressReportReviewSectionPayload = {
  __typename?: 'CompleteQuarterlyProgressReportReviewSectionPayload';
  review: QuarterlyProgressReportReview;
};

export type ConfirmAccountInput = {
  code: Scalars['String'];
  email: Scalars['String'];
  sendDownloadLinksEmail?: InputMaybe<Scalars['Boolean']>;
};

export type ConfirmAccountPayload = {
  __typename?: 'ConfirmAccountPayload';
  tokenSet: TokenSet;
};

export type ConfirmPasswordResetInput = {
  code: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
};

export type Conversation = SynchronizedItem & {
  __typename?: 'Conversation';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  firmClientID: Scalars['ID'];
  firmID: Scalars['ID'];
  hasUnreadMessages: Scalars['Boolean'];
  id: Scalars['ID'];
  lastMessageRead?: Maybe<Scalars['ID']>;
  latestMessageDateTime?: Maybe<Scalars['Time']>;
  latestMessageID?: Maybe<Scalars['ID']>;
  latestMessagePreview?: Maybe<Scalars['String']>;
  muted: Scalars['Boolean'];
  participants: Array<ConversationParticipant>;
  updatedAt: Scalars['Time'];
};

export type ConversationList = {
  __typename?: 'ConversationList';
  items: Array<Conversation>;
  pageInfo: PageInfo;
};

export type ConversationParticipant = {
  __typename?: 'ConversationParticipant';
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  profileColor: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  type: ConversationParticipantType;
  userID: Scalars['String'];
};

export enum ConversationParticipantType {
  FirmMember = 'FIRM_MEMBER',
  Person = 'PERSON'
}

export type CreateAiFeedbackInput = {
  clientID: Scalars['ID'];
  feedbackType: FeedbackType;
  firmID: Scalars['ID'];
  score: Scalars['Int'];
  writtenFeedback: Scalars['String'];
};

export type CreateAiFeedbackPayload = {
  __typename?: 'CreateAiFeedbackPayload';
  success: Scalars['Boolean'];
};

export type CreateAssetLoanInput = {
  assetLoan: CreateAssetLoanPartial;
  householdID: Scalars['ID'];
};

export type CreateAssetLoanPartial = {
  assetID: Scalars['ID'];
  loanID: Scalars['ID'];
};

export type CreateAssetLoanPayload = {
  __typename?: 'CreateAssetLoanPayload';
  assetLoan: AssetLoan;
};

export type CreateBaaAccountInput = {
  BAAAccountID: Scalars['ID'];
  BAAFinancialProfileID: Scalars['ID'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType?: InputMaybe<BaaAccountType>;
  accountValue: Scalars['Float'];
  financialInstitutionID: Scalars['String'];
  financialInstitutionName: Scalars['String'];
  firmClientID: Scalars['ID'];
  firmID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
  householdID: Scalars['ID'];
  mappedEntityID?: InputMaybe<Scalars['ID']>;
  status: MappedAccountStatus;
  statusErrorCode: Scalars['String'];
};

export type CreateBaaAccountPayload = {
  __typename?: 'CreateBaaAccountPayload';
  account: BaaAccount;
};

export type CreateBaaAccountsForClientAccountInput = {
  BAAAccountID: Scalars['ID'];
  BAAFinancialProfileID: Scalars['ID'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType?: InputMaybe<BaaAccountType>;
  accountValue: Scalars['Float'];
  financialInstitutionID: Scalars['String'];
  financialInstitutionName: Scalars['String'];
  mappedEntityID?: InputMaybe<Scalars['ID']>;
  status: MappedAccountStatus;
  statusErrorCode: Scalars['String'];
};

export type CreateBaaAccountsForClientPayload = {
  __typename?: 'CreateBaaAccountsForClientPayload';
  accounts: Array<BaaAccount>;
};

export type CreateBaaAccountsForClientSharedInput = {
  firmClientID: Scalars['ID'];
  firmID: Scalars['ID'];
  householdID: Scalars['ID'];
};

export type CreateBaaPersonInput = {
  baaPerson: CreateBaaPersonPartial;
  firmID: Scalars['String'];
};

export type CreateBaaPersonPartial = {
  role: BaaPersonRole;
  username?: InputMaybe<Scalars['String']>;
};

export type CreateBaaPersonPayload = {
  __typename?: 'CreateBaaPersonPayload';
  baaPerson: BaaPerson;
  temporaryPassword: Scalars['String'];
};

export type CreateBusinessInput = {
  business: CreateBusinessPartial;
  householdID: Scalars['ID'];
};

export type CreateBusinessPartial = {
  address?: InputMaybe<AddressInput>;
  entityTaxStructure: EntityTaxStructure;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateBusinessPayload = {
  __typename?: 'CreateBusinessPayload';
  business: Business;
};

export type CreateCashAccountInput = {
  cashAccount: CreateCashAccountPartial;
  householdID: Scalars['ID'];
  linkSwitch?: InputMaybe<LinkSwitchInput>;
};

export type CreateCashAccountPartial = {
  cashAccountType: CashAccountType;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  recurringContributionDataPointGroup?: InputMaybe<Scalars['ID']>;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateCashAccountPayload = {
  __typename?: 'CreateCashAccountPayload';
  cashAccount: CashAccount;
};

export type CreateDataPointGroupInput = {
  dataPointGroup: CreateDataPointGroupPartial;
  tenantID: Scalars['ID'];
};

export type CreateDataPointGroupPartial = {
  groupType: DataPointGroupType;
  valueExpirationExtension?: InputMaybe<Scalars['Float']>;
};

export type CreateDataPointGroupPayload = {
  __typename?: 'CreateDataPointGroupPayload';
  dataPointGroup: DataPointGroup;
};

export type CreateDataPointInput = {
  dataPoint: CreateDataPointPartial;
  tenantID: Scalars['ID'];
};

export type CreateDataPointPartial = {
  data: DataPointValueInput;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
};

export type CreateDataPointPayload = {
  __typename?: 'CreateDataPointPayload';
  dataPoint: DataPoint;
};

export type CreateFileAttachmentInput = {
  fileAttachment: CreateFileAttachmentPartial;
  tenantID: Scalars['ID'];
};

export type CreateFileAttachmentPartial = {
  /** The id of the file. */
  fileID: Scalars['ID'];
  /** The id of the synchronized item. */
  itemID: Scalars['ID'];
};

export type CreateFileAttachmentPayload = {
  __typename?: 'CreateFileAttachmentPayload';
  fileAttachment: FileAttachment;
};

export type CreateFileInput = {
  file: CreateFilePartial;
  tenantID: Scalars['ID'];
};

export type CreateFilePartial = {
  /** The name of the file, including the extension. */
  name: Scalars['String'];
  /**
   * If standalone is true, it is expected that this file will possibly not have
   * any attachments, and should _not_ be deleted if it is not attached to any
   * item. This is useful for profile photos and firm logos, for example. If not
   * provided, this defaults to true.
   */
  standalone?: InputMaybe<Scalars['Boolean']>;
};

export type CreateFilePayload = {
  __typename?: 'CreateFilePayload';
  file: File;
};

export type CreateFinancialGoalInput = {
  financialGoal: CreateFinancialGoalPartial;
  householdID: Scalars['ID'];
};

export type CreateFinancialGoalPartial = {
  achieved: Scalars['Boolean'];
  aiSuggested?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
};

export type CreateFinancialGoalPayload = {
  __typename?: 'CreateFinancialGoalPayload';
  financialGoal: FinancialGoal;
};

export type CreateFinancialNextStepInput = {
  financialNextStep: CreateFinancialNextStepPartial;
  householdID: Scalars['ID'];
};

export type CreateFinancialNextStepPartial = {
  aiSuggested?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  done: Scalars['Boolean'];
  dueDate?: InputMaybe<Scalars['Date']>;
};

export type CreateFinancialNextStepPayload = {
  __typename?: 'CreateFinancialNextStepPayload';
  financialNextStep: FinancialNextStep;
};

export type CreateFirmClientGroupInput = {
  firmID: Scalars['ID'];
  group: CreateFirmClientGroupPartial;
};

export type CreateFirmClientGroupPartial = {
  name: Scalars['String'];
};

export type CreateFirmClientGroupPayload = {
  __typename?: 'CreateFirmClientGroupPayload';
  firmClientGroup: FirmClientGroup;
};

export type CreateFirmClientIndividualPartial = {
  emailAddress?: InputMaybe<Scalars['String']>;
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  /**
   * The role of the individual in the household. Gets saved on the new Person created for this individual. Must be a
   * "head of household" subset - ie HEAD_OF_HOUSEHOLD, HUSBAND, WIFE, or PARTNER
   */
  role: RelationshipType;
  sendUserInvite: Scalars['Boolean'];
};

export type CreateFirmClientInput = {
  firmClientEntitlements?: InputMaybe<FirmClientEntitlementsPartial>;
  firmClientMode: FirmClientMode;
  firmID: Scalars['ID'];
  individuals: Array<CreateFirmClientIndividualPartial>;
  notes?: InputMaybe<Scalars['String']>;
  onboardingProcess: FirmClientOnboardingProcess;
};

export type CreateFirmClientPayload = {
  __typename?: 'CreateFirmClientPayload';
  firmClient: FirmClient;
};

export type CreateFirmInviteLinkInput = {
  campaignName: Scalars['String'];
  description: Scalars['String'];
  disclosure?: InputMaybe<Scalars['String']>;
  firmClientEntitlements?: InputMaybe<FirmClientEntitlementsPartial>;
  firmID: Scalars['ID'];
  maxInvitationsToAccept?: InputMaybe<Scalars['Int']>;
  primaryAdvisorFirmMemberID?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type CreateFirmMemberInput = {
  firmID: Scalars['ID'];
  firmMember: CreateFirmMemberPartial;
};

export type CreateFirmMemberPartial = {
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  role: FirmMemberRole;
};

export type CreateFirmMemberPayload = {
  __typename?: 'CreateFirmMemberPayload';
  firmMember: FirmMember;
};

export type CreateIncomeAllocationInput = {
  householdID: Scalars['ID'];
  incomeAllocation: CreateIncomeAllocationPartial;
};

export type CreateIncomeAllocationPartial = {
  dateTime: Scalars['Time'];
  debtValue: MonetaryAmountInput;
  income: MonetaryAmountInput;
  savingsValue: MonetaryAmountInput;
  spendingValue: MonetaryAmountInput;
  taxValue: MonetaryAmountInput;
  term: IncomeAllocationTerm;
};

export type CreateIncomeAllocationPayload = {
  __typename?: 'CreateIncomeAllocationPayload';
  incomeAllocation: IncomeAllocation;
};

export type CreateIncomeSourceInput = {
  householdID: Scalars['ID'];
  incomeSource: CreateIncomeSourcePartial;
};

export type CreateIncomeSourcePartial = {
  amountDataPointGroupID?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  omitFromScorecard?: InputMaybe<Scalars['Boolean']>;
  personID: Scalars['ID'];
  sourceType: IncomeSourceType;
};

export type CreateIncomeSourcePayload = {
  __typename?: 'CreateIncomeSourcePayload';
  incomeSource: IncomeSource;
};

export type CreateInsurancePolicyInput = {
  householdID: Scalars['ID'];
  insurancePolicy: CreateInsurancePolicyPartial;
};

export type CreateInsurancePolicyPartial = {
  coverageAmount: MonetaryAmountInput;
  expirationDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  policySubtype: InsurancePolicySubtype;
  policyType: InsurancePolicyType;
  purchasedDate?: InputMaybe<Scalars['Date']>;
};

export type CreateInsurancePolicyPayload = {
  __typename?: 'CreateInsurancePolicyPayload';
  insurancePolicy: InsurancePolicy;
};

export type CreateInvestmentInput = {
  householdID: Scalars['ID'];
  investment: CreateInvestmentPartial;
  linkSwitch?: InputMaybe<LinkSwitchInput>;
};

export type CreateInvestmentPartial = {
  incomeSourceID?: InputMaybe<Scalars['ID']>;
  investmentMixDataPointGroup?: InputMaybe<Scalars['ID']>;
  investmentType: InvestmentType;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  recurringContributionDataPointGroup?: InputMaybe<Scalars['ID']>;
  recurringContributionPercentageDataPointGroup?: InputMaybe<Scalars['ID']>;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateInvestmentPayload = {
  __typename?: 'CreateInvestmentPayload';
  investment: Investment;
};

export type CreateLoanInput = {
  householdID: Scalars['ID'];
  linkSwitch?: InputMaybe<LinkSwitchInput>;
  loan: CreateLoanPartial;
};

export type CreateLoanPartial = {
  balanceDataPointGroup?: InputMaybe<Scalars['ID']>;
  balloonPaymentDate?: InputMaybe<Scalars['Date']>;
  collateralType?: InputMaybe<CollateralType>;
  extraPaymentAmountDataPointGroup?: InputMaybe<Scalars['ID']>;
  interestRateDataPointGroup?: InputMaybe<Scalars['ID']>;
  interestRateDescription?: InputMaybe<Scalars['String']>;
  interestRateType?: InputMaybe<InterestRateType>;
  loanType: LoanType;
  maturityDate?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<MonetaryAmountInput>;
  originalLoanLength?: InputMaybe<Scalars['Int']>;
  originationDate?: InputMaybe<Scalars['Date']>;
  ownership: OwnershipInput;
  paymentAmountDataPointGroup?: InputMaybe<Scalars['ID']>;
  repaymentType?: InputMaybe<RepaymentType>;
};

export type CreateLoanPayload = {
  __typename?: 'CreateLoanPayload';
  loan: Loan;
};

export type CreateMagicNumberInput = {
  householdID: Scalars['ID'];
  magicNumber: CreateMagicNumberPartial;
};

export type CreateMagicNumberPartial = {
  annualWithdrawalRate: Scalars['Float'];
  averageNetWorthGrowthNeeded: MonetaryAmountInput;
  dateTime: Scalars['Time'];
  magicNumber: MonetaryAmountInput;
  monthlyLivingExpenses: MonetaryAmountInput;
  retirementAge: Scalars['Int'];
  targetTotalTermScore: Scalars['Float'];
};

export type CreateMagicNumberPayload = {
  __typename?: 'CreateMagicNumberPayload';
  magicNumber: MagicNumber;
};

/**
 * Either conversationID or firmClientID must be provided.
 * If provided a conversationID, this message will be added to an existing conversation by that id.
 * If provided a client ID, a conversation will be found for that firm client and if none are found, a new
 * conversation will be created for all all needed recipients for that firm client.
 */
export type CreateMessageInput = {
  conversationID?: InputMaybe<Scalars['ID']>;
  firmClientID?: InputMaybe<Scalars['ID']>;
  message: CreateMessagePartial;
};

export type CreateMessagePartial = {
  freeform?: InputMaybe<FreeformContentInput>;
  hasOnboardingReminder?: InputMaybe<Scalars['Boolean']>;
};

export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  message: Message;
};

export type CreateNoteReceivableInput = {
  householdID: Scalars['ID'];
  noteReceivable: CreateNoteReceivablePartial;
};

export type CreateNoteReceivablePartial = {
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateNoteReceivablePayload = {
  __typename?: 'CreateNoteReceivablePayload';
  noteReceivable: NoteReceivable;
};

export type CreatePersonInput = {
  householdID: Scalars['ID'];
  person: CreatePersonPartial;
};

export type CreatePersonPartial = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName: Scalars['String'];
  occupation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  relationship: RelationshipType;
  userID?: InputMaybe<Scalars['String']>;
};

export type CreatePersonPayload = {
  __typename?: 'CreatePersonPayload';
  person: Person;
};

export type CreatePersonalPropertyItemInput = {
  householdID: Scalars['ID'];
  personalPropertyItem: CreatePersonalPropertyItemPartial;
};

export type CreatePersonalPropertyItemPartial = {
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreatePersonalPropertyItemPayload = {
  __typename?: 'CreatePersonalPropertyItemPayload';
  personalPropertyItem: PersonalPropertyItem;
};

export type CreateProfessionalInput = {
  householdID: Scalars['String'];
  professional: CreateProfessionalPartial;
};

export type CreateProfessionalPartial = {
  emailAddress: Scalars['String'];
  familyName?: InputMaybe<Scalars['String']>;
  givenName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<Scalars['String']>;
  role: ProfessionalRole;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateProfessionalPayload = {
  __typename?: 'CreateProfessionalPayload';
  professional: Professional;
};

export type CreateRealEstateInput = {
  householdID: Scalars['ID'];
  realEstate: CreateRealEstatePartial;
};

export type CreateRealEstatePartial = {
  address?: InputMaybe<AddressInput>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  realEstateType: RealEstateType;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateRealEstatePayload = {
  __typename?: 'CreateRealEstatePayload';
  realEstate: RealEstate;
};

export type CreateSelfServeCheckoutSessionInput = {
  offer: SelfServeCheckoutOffer;
};

export type CreateSmartGroupInput = {
  firmID: Scalars['ID'];
  name: Scalars['String'];
  smartGroupCriteria: Array<SmartGroupCriteriaTokenInput>;
};

export type CreateSoftwareTokenSecretInput = {
  /** The size (width and height) of the QR code in pixels. */
  qrCodeSize?: InputMaybe<Scalars['Int']>;
};

export type CreateSoftwareTokenSecretPayload = {
  __typename?: 'CreateSoftwareTokenSecretPayload';
  /** A base64 encoded PNG image of the QR code. */
  qrCode: Scalars['String'];
  secretCode: Scalars['String'];
};

export type CreateSpendingCategoryEstimateInput = {
  householdID: Scalars['ID'];
  spendingCategoryEstimate: CreateSpendingCategoryEstimatePartial;
};

export type CreateSpendingCategoryEstimatePartial = {
  categoryEstimates: Array<CategoryEstimateInput>;
  dateTime: Scalars['Time'];
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateSpendingCategoryEstimatePayload = {
  __typename?: 'CreateSpendingCategoryEstimatePayload';
  spendingCategoryEstimate: SpendingCategoryEstimate;
};

export type CreateTargetScoreRangeTemplateInput = {
  firmID: Scalars['ID'];
  template: CreateTargetScoreRangeTemplatePartial;
};

export type CreateTargetScoreRangeTemplatePartial = {
  name: Scalars['String'];
  ranges: TargetScoreRangesInput;
};

export type CreateTargetScoreRangeTemplatePayload = {
  __typename?: 'CreateTargetScoreRangeTemplatePayload';
  template: TargetScoreRangeTemplate;
};

export type CreateTaxReturnSummaryInput = {
  householdID: Scalars['ID'];
  taxReturnSummary: CreateTaxReturnSummaryPartial;
};

export type CreateTaxReturnSummaryPartial = {
  federalTaxesPaid?: InputMaybe<MonetaryAmountInput>;
  filingStatus: TaxFilingStatus;
  income: MonetaryAmountInput;
  notes?: InputMaybe<Scalars['String']>;
  stateTaxesPaid?: InputMaybe<MonetaryAmountInput>;
  year: Scalars['Int'];
};

export type CreateTaxReturnSummaryPayload = {
  __typename?: 'CreateTaxReturnSummaryPayload';
  taxReturnSummary: TaxReturnSummary;
};

export type CreateTrustInput = {
  householdID: Scalars['ID'];
  trust: CreateTrustPartial;
};

export type CreateTrustPartial = {
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  ownership: OwnershipInput;
  trustType: TrustType;
  valueDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type CreateTrustPayload = {
  __typename?: 'CreateTrustPayload';
  trust: Trust;
};

export enum DataConfidenceLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DataPoint = {
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: DataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type DataPointGroup = {
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: DataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export enum DataPointGroupType {
  Float = 'FLOAT',
  InvestmentMix = 'INVESTMENT_MIX',
  MonetaryAmount = 'MONETARY_AMOUNT',
  RecurringMonetaryAmount = 'RECURRING_MONETARY_AMOUNT',
  String = 'STRING'
}

export type DataPointList = FloatDataPointList | InvestmentMixDataPointList | MonetaryAmountDataPointList | RecurringMonetaryAmountDataPointList | StringDataPointList;

export type DataPointValue = FloatDataPointValue | InvestmentMixDataPointValue | MonetaryAmountDataPointValue | RecurringMonetaryAmountDataPointValue | StringDataPointValue;

export type DataPointValueInput = {
  floatValue?: InputMaybe<FloatDataPointValueInput>;
  investmentMixValue?: InputMaybe<InvestmentMixDataPointValueInput>;
  monetaryAmountValue?: InputMaybe<MonetaryAmountDataPointValueInput>;
  recurringMonetaryAmountValue?: InputMaybe<RecurringMonetaryAmountDataPointValueInput>;
  stringValue?: InputMaybe<StringDataPointValueInput>;
};

export type DebtRateReportData = {
  __typename?: 'DebtRateReportData';
  businessLoansSummary: ReportLoanSummaryByGroup;
  debtRate: Scalars['Float'];
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  loans: Array<ReportLoan>;
  otherLoansSummary: ReportLoanSummaryByGroup;
  personalRealEstateLoansSummary: ReportLoanSummaryByGroup;
  reportDisclosureText: Scalars['String'];
  studentLoansSummary: ReportLoanSummaryByGroup;
  totalAnnualDebtPayments?: Maybe<MonetaryAmount>;
  totalAnnualIncome?: Maybe<MonetaryAmount>;
  totalDebtBalances: Array<ValueForDate>;
  type: ReportType;
};

export type DeleteAssetLoanInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteAssetLoanPayload = {
  __typename?: 'DeleteAssetLoanPayload';
  changeToken: Scalars['String'];
};

export type DeleteBusinessInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteBusinessPayload = {
  __typename?: 'DeleteBusinessPayload';
  changeToken: Scalars['String'];
};

export type DeleteCashAccountInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteCashAccountPayload = {
  __typename?: 'DeleteCashAccountPayload';
  changeToken: Scalars['String'];
};

export type DeleteDataPointInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteDataPointPayload = {
  __typename?: 'DeleteDataPointPayload';
  changeToken: Scalars['String'];
};

export type DeleteFileAttachmentInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteFileAttachmentPayload = {
  __typename?: 'DeleteFileAttachmentPayload';
  changeToken: Scalars['String'];
};

export type DeleteFileInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteFilePayload = {
  __typename?: 'DeleteFilePayload';
  changeToken: Scalars['String'];
};

export type DeleteFinancialGoalInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteFinancialGoalPayload = {
  __typename?: 'DeleteFinancialGoalPayload';
  changeToken: Scalars['String'];
  goals: Array<FinancialGoal>;
};

export type DeleteFinancialNextStepInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteFinancialNextStepPayload = {
  __typename?: 'DeleteFinancialNextStepPayload';
  changeToken: Scalars['String'];
  nextSteps: Array<FinancialNextStep>;
};

export type DeleteFirmClientGroupInput = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteFirmClientGroupPayload = {
  __typename?: 'DeleteFirmClientGroupPayload';
  deleted: Scalars['Boolean'];
};

export type DeleteFirmMemberInput = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
  /** ID of the firm member to reassign all the firm clients to */
  reassignClientsTo: Scalars['ID'];
};

export type DeleteFirmMemberPayload = {
  __typename?: 'DeleteFirmMemberPayload';
  deleted: Scalars['Boolean'];
};

export type DeleteIncomeAllocationInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteIncomeAllocationPayload = {
  __typename?: 'DeleteIncomeAllocationPayload';
  changeToken: Scalars['String'];
};

export type DeleteInsurancePolicyInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteInsurancePolicyPayload = {
  __typename?: 'DeleteInsurancePolicyPayload';
  changeToken: Scalars['String'];
};

export type DeleteInvestmentInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteInvestmentPayload = {
  __typename?: 'DeleteInvestmentPayload';
  changeToken: Scalars['String'];
};

export type DeleteInvitationInput = {
  invitationID: Scalars['String'];
};

export type DeleteLoanInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteLoanPayload = {
  __typename?: 'DeleteLoanPayload';
  changeToken: Scalars['String'];
};

export type DeleteMagicNumberInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteMagicNumberPayload = {
  __typename?: 'DeleteMagicNumberPayload';
  changeToken: Scalars['String'];
};

export type DeleteNoteReceivableInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteNoteReceivablePayload = {
  __typename?: 'DeleteNoteReceivablePayload';
  changeToken: Scalars['String'];
};

export type DeletePersonInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeletePersonPayload = {
  __typename?: 'DeletePersonPayload';
  changeToken: Scalars['String'];
};

export type DeletePersonalPropertyItemInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeletePersonalPropertyItemPayload = {
  __typename?: 'DeletePersonalPropertyItemPayload';
  changeToken: Scalars['String'];
};

export type DeleteProfessionalInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteProfessionalPayload = {
  __typename?: 'DeleteProfessionalPayload';
  changeToken: Scalars['String'];
};

export type DeleteRealEstateInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteRealEstatePayload = {
  __typename?: 'DeleteRealEstatePayload';
  changeToken: Scalars['String'];
};

export type DeleteSmartGroupInput = {
  firmID: Scalars['ID'];
  smartGroupID: Scalars['ID'];
};

export type DeleteSpendingCategoryEstimateInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteSpendingCategoryEstimatePayload = {
  __typename?: 'DeleteSpendingCategoryEstimatePayload';
  changeToken: Scalars['String'];
};

export type DeleteTargetScoreRangeTemplateInput = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteTargetScoreRangeTemplatePayload = {
  __typename?: 'DeleteTargetScoreRangeTemplatePayload';
  deleted: Scalars['Boolean'];
};

export type DeleteTaxReturnSummaryInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteTaxReturnSummaryPayload = {
  __typename?: 'DeleteTaxReturnSummaryPayload';
  changeToken: Scalars['String'];
};

export type DeleteTrustInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteTrustPayload = {
  __typename?: 'DeleteTrustPayload';
  changeToken: Scalars['String'];
};

export type DeletedItem = SynchronizedItem & {
  __typename?: 'DeletedItem';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  type: DeletedItemType;
  updatedAt: Scalars['Time'];
};

export enum DeletedItemType {
  AssetLoan = 'ASSET_LOAN',
  Business = 'BUSINESS',
  CashAccount = 'CASH_ACCOUNT',
  Conversation = 'CONVERSATION',
  DataPoint = 'DATA_POINT',
  DataPointGroup = 'DATA_POINT_GROUP',
  File = 'FILE',
  FileAttachment = 'FILE_ATTACHMENT',
  FirmInviteLink = 'FIRM_INVITE_LINK',
  IncomeAllocation = 'INCOME_ALLOCATION',
  InsurancePolicy = 'INSURANCE_POLICY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  MagicNumber = 'MAGIC_NUMBER',
  Message = 'MESSAGE',
  NoteReceivable = 'NOTE_RECEIVABLE',
  Person = 'PERSON',
  PersonalPropertyItem = 'PERSONAL_PROPERTY_ITEM',
  PlaidItem = 'PLAID_ITEM',
  Professional = 'PROFESSIONAL',
  RealEstate = 'REAL_ESTATE',
  SpendingCategoryEstimate = 'SPENDING_CATEGORY_ESTIMATE',
  TaxReturnSummary = 'TAX_RETURN_SUMMARY',
  Trust = 'TRUST'
}

export type DisassociateSoftwareTokenInput = {
  code: Scalars['String'];
};

export type DisconnectAccountLinking = {
  accountLinkProvider: MappedAccountProvider;
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
  linkID: Scalars['String'];
};

export type DrDetails = {
  __typename?: 'DrDetails';
  annualDebtPayments: MonetaryAmount;
  annualIncome: MonetaryAmount;
  dr?: Maybe<Scalars['Float']>;
  monthlyAutoLoanPayments: RecurringMonetaryAmount;
  monthlyCreditCardPayments: RecurringMonetaryAmount;
  monthlyInvestmentRealEstatePayments: RecurringMonetaryAmount;
  monthlyOtherDebtPayments: RecurringMonetaryAmount;
  monthlyPersonalRealEstatePayments: RecurringMonetaryAmount;
  monthlyStudentLoanPayments: RecurringMonetaryAmount;
  totalAutoLoans: MonetaryAmount;
  totalCreditCardDebt: MonetaryAmount;
  totalDebt: MonetaryAmount;
  totalInvestmentRealEstateLoans: MonetaryAmount;
  totalOtherDebt: MonetaryAmount;
  totalPersonalRealEstateLoans: MonetaryAmount;
  totalStudentLoans: MonetaryAmount;
};

export enum Element {
  Br = 'BR',
  Bt = 'BT',
  Dr = 'DR',
  Er = 'ER',
  Es = 'ES',
  Ir = 'IR',
  Lt = 'LT',
  Qt = 'QT',
  Rt = 'RT',
  Sr = 'SR',
  Tr = 'TR',
  Tt = 'TT'
}

export type ElementDetails = {
  __typename?: 'ElementDetails';
  Br: Scalars['String'];
  Bt: Scalars['String'];
  Dr: Scalars['String'];
  Er: Scalars['String'];
  Ir: Scalars['String'];
  Lt: Scalars['String'];
  Qt: Scalars['String'];
  Rt: Scalars['String'];
  Sr: Scalars['String'];
  Tr: Scalars['String'];
  Tt: Scalars['String'];
};

export type ElementDetailsInput = {
  Br?: InputMaybe<Scalars['String']>;
  Bt?: InputMaybe<Scalars['String']>;
  Dr?: InputMaybe<Scalars['String']>;
  Er?: InputMaybe<Scalars['String']>;
  Ir?: InputMaybe<Scalars['String']>;
  Lt?: InputMaybe<Scalars['String']>;
  Qt?: InputMaybe<Scalars['String']>;
  Rt?: InputMaybe<Scalars['String']>;
  Sr?: InputMaybe<Scalars['String']>;
  Tr?: InputMaybe<Scalars['String']>;
  Tt?: InputMaybe<Scalars['String']>;
};

export enum Entitlement {
  AllowSharedBaaAccountsAcrossFirm = 'ALLOW_SHARED_BAA_ACCOUNTS_ACROSS_FIRM',
  Baa = 'BAA',
  DisableAi = 'DISABLE_AI',
  DisableConsolidatedAccounting = 'DISABLE_CONSOLIDATED_ACCOUNTING',
  DisableCurrencySigns = 'DISABLE_CURRENCY_SIGNS',
  DisableDisclosureEdits = 'DISABLE_DISCLOSURE_EDITS',
  DisableEmailInvites = 'DISABLE_EMAIL_INVITES',
  Documents = 'DOCUMENTS',
  Insights = 'INSIGHTS',
  Messaging = 'MESSAGING',
  MfaRequired = 'MFA_REQUIRED',
  Plaid = 'PLAID',
  RemoveScorecard = 'REMOVE_SCORECARD'
}

export type EntityIdMap = {
  __typename?: 'EntityIDMap';
  clientID: Scalars['ID'];
  serverID: Scalars['ID'];
};

export type EntityIdMapInput = {
  clientID: Scalars['ID'];
  serverID: Scalars['ID'];
};

export enum EntityTaxStructure {
  CCorporation = 'C_CORPORATION',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP',
  SCorporation = 'S_CORPORATION'
}

export type EquityRateHistoryItem = {
  __typename?: 'EquityRateHistoryItem';
  dateTime: Scalars['Time'];
  equityRate: Scalars['Float'];
};

export type EquityRateReportData = {
  __typename?: 'EquityRateReportData';
  /**
   * The Equity Rate numerator: personally owned equity (stock) investments,
   * including private stock.
   */
  equityInvestmentAmount: MonetaryAmount;
  /**
   * Equity Rate as a percentage (0–100): equity (stock) investments divided by
   * total investments and personal cash. Reconciles with the scorecard Equity Rate.
   */
  equityRate: Scalars['Float'];
  /**
   * Equity Rate over the trailing 12 months, one point per month (oldest to
   * newest). Months before the client completed onboarding are zeroed, mirroring
   * Burn Rate history.
   */
  equityRateHistory: Array<EquityRateHistoryItem>;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  reportDisclosureText: Scalars['String'];
  /**
   * The Equity Rate denominator: all personal investments (qualified +
   * non-qualified + private stock) plus personal cash.
   */
  totalInvestmentAmount: MonetaryAmount;
  type: ReportType;
};

export type ErDetails = {
  __typename?: 'ErDetails';
  er?: Maybe<Scalars['Float']>;
  investments: Array<Investment>;
  totalBondHoldings: MonetaryAmount;
  totalCash: MonetaryAmount;
  totalEquityInvestments: MonetaryAmount;
  totalInvestmentsAndCash: MonetaryAmount;
};

export type EstateStatus = {
  __typename?: 'EstateStatus';
  changeToken: Scalars['String'];
  checklist: Array<EstateStatusChecklistItem>;
  score?: Maybe<Scalars['Float']>;
  summary: EstateStatusSummary;
};

export type EstateStatusAttachmentLink = {
  __typename?: 'EstateStatusAttachmentLink';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  uploadedAt?: Maybe<Scalars['Time']>;
  uploadedByUserID: Scalars['ID'];
  url: Scalars['String'];
};

export type EstateStatusChecklistItem = {
  __typename?: 'EstateStatusChecklistItem';
  attachmentLinks: Array<EstateStatusAttachmentLink>;
  id: Scalars['ID'];
  label: Scalars['String'];
  lastReviewedAt?: Maybe<Scalars['Time']>;
  note: Scalars['String'];
  state: EstateStatusItemState;
  weight: Scalars['Float'];
};

export type EstateStatusFirmTemplate = {
  __typename?: 'EstateStatusFirmTemplate';
  changeToken: Scalars['String'];
  checklist: Array<EstateStatusFirmTemplateChecklistItem>;
  firmID: Scalars['ID'];
};

export type EstateStatusFirmTemplateChecklistItem = {
  __typename?: 'EstateStatusFirmTemplateChecklistItem';
  id: Scalars['ID'];
  label: Scalars['String'];
  weight: Scalars['Float'];
};

export enum EstateStatusItemState {
  Na = 'NA',
  No = 'NO',
  Yes = 'YES'
}

export type EstateStatusSummary = {
  __typename?: 'EstateStatusSummary';
  applicable: Scalars['Int'];
  applicableWeight: Scalars['Float'];
  completed: Scalars['Int'];
  earnedWeight: Scalars['Float'];
  score?: Maybe<Scalars['Float']>;
  total: Scalars['Int'];
  totalWeight: Scalars['Float'];
};

export type ExchangePlaidPublicTokenInput = {
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
  publicToken: Scalars['String'];
};

export type ExtendedSignInInput = {
  password: Scalars['String'];
  userIDToImpersonate?: InputMaybe<Scalars['String']>;
  usernameOrEmail: Scalars['String'];
};

export enum FeatureDiscoveryTrigger {
  GenerateOnePagePlan = 'GENERATE_ONE_PAGE_PLAN'
}

export type FeatureSuggestionInput = {
  suggestion: Scalars['String'];
};

export type FeatureSuggestionPayload = {
  __typename?: 'FeatureSuggestionPayload';
  sent: Scalars['Boolean'];
};

export enum FeedbackType {
  AdvisorAssessmentFeedback = 'ADVISOR_ASSESSMENT_FEEDBACK',
  ClientAssessmentFeedback = 'CLIENT_ASSESSMENT_FEEDBACK'
}

export type File = SynchronizedItem & {
  __typename?: 'File';
  changeToken: Scalars['String'];
  contentType: Scalars['String'];
  createdAt: Scalars['Time'];
  createdBy: UserProfile;
  /** The download url with which to download the file from. */
  downloadURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * If standalone is true, it is expected that this file will possibly not have
   * any attachments, and should _not_ be deleted if it is not attached to any
   * item. This is useful for profile photos and firm logos, for example.
   */
  standalone: Scalars['Boolean'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  uploadStatus: FileUploadStatus;
  /**
   * The url to upload the file content to. If the uploadStatus is complete,
   * this will always be null. This URL is valid for 3 days, and after 3 days
   * if no upload has been completed it will automatically get removed.
   */
  uploadURL?: Maybe<Scalars['String']>;
};

export type FileAttachment = SynchronizedItem & {
  __typename?: 'FileAttachment';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  /**
   * Nested - resolved by the associated file ID. If requested, will return the
   * full file associated with this attachment.
   */
  file: File;
  /** The id of the file that is attached to the item. */
  fileID: Scalars['ID'];
  id: Scalars['ID'];
  /** The id of the item the file is attached to. */
  itemID: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type FileAttachmentList = {
  __typename?: 'FileAttachmentList';
  items: Array<FileAttachment>;
  pageInfo: PageInfo;
};

export type FileList = {
  __typename?: 'FileList';
  items: Array<File>;
  pageInfo: PageInfo;
};

export enum FileUploadStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING'
}

export enum FinancialCategory {
  Distressed = 'DISTRESSED',
  Secure = 'SECURE',
  Stable = 'STABLE',
  Unknown = 'UNKNOWN',
  VerySecure = 'VERY_SECURE',
  Vulnerable = 'VULNERABLE'
}

export type FinancialGoal = {
  __typename?: 'FinancialGoal';
  achieved: Scalars['Boolean'];
  achievedAt?: Maybe<Scalars['Time']>;
  aiSuggested: Scalars['Boolean'];
  body: Scalars['String'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  order: Scalars['Int'];
  updatedAt: Scalars['Time'];
};

export type FinancialGoalList = {
  __typename?: 'FinancialGoalList';
  items: Array<FinancialGoal>;
  pageInfo: PageInfo;
};

export type FinancialNextStep = {
  __typename?: 'FinancialNextStep';
  aiSuggested: Scalars['Boolean'];
  body: Scalars['String'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  done: Scalars['Boolean'];
  doneAt?: Maybe<Scalars['Time']>;
  dueDate?: Maybe<Scalars['Date']>;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  order: Scalars['Int'];
  updatedAt: Scalars['Time'];
};

export type FinancialNextStepList = {
  __typename?: 'FinancialNextStepList';
  items: Array<FinancialNextStep>;
  pageInfo: PageInfo;
};

export type Firm = FirmBrandingInterface & SynchronizedItem & {
  __typename?: 'Firm';
  aiDisclosureText?: Maybe<Scalars['String']>;
  aiPromptAugmentation?: Maybe<Scalars['String']>;
  billingPortalLink?: Maybe<Scalars['String']>;
  changeToken: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['Time'];
  delinquent: Scalars['Boolean'];
  disableEmailNotifications?: Maybe<Scalars['Boolean']>;
  elementCustomizationBetaEnabled?: Maybe<Scalars['Boolean']>;
  elementCustomizations: Array<FirmElementCustomization>;
  emailDisclosureText?: Maybe<Scalars['String']>;
  entitlements: Array<Entitlement>;
  estateStatusBetaEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logo?: Maybe<File>;
  mcpBetaEnabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  reportDisclosureText?: Maybe<Scalars['String']>;
  type: FirmType;
  updatedAt: Scalars['Time'];
};

export enum FirmBillingEligiblePlan {
  Core = 'CORE',
  CoreXypn = 'CORE_XYPN'
}

export type FirmBillingGateStatus = {
  __typename?: 'FirmBillingGateStatus';
  canManageBilling: Scalars['Boolean'];
  clientCount: Scalars['Int'];
  clientLimit: Scalars['Int'];
  eligiblePlan?: Maybe<FirmBillingEligiblePlan>;
  firmID: Scalars['ID'];
  firstNoticeEmailRequired: Scalars['Boolean'];
  isNewFirm: Scalars['Boolean'];
  isOverClientLimit: Scalars['Boolean'];
  lockClientDetails: Scalars['Boolean'];
  noticeDeadline?: Maybe<Scalars['Time']>;
  noticeStartedAt?: Maybe<Scalars['Time']>;
  paidStatus: FirmBillingPaidStatus;
  reasonCode: FirmBillingReasonCode;
  requiredAction: FirmBillingRequiredAction;
  upgradeURL?: Maybe<Scalars['String']>;
};

export enum FirmBillingPaidStatus {
  CorporateManaged = 'CORPORATE_MANAGED',
  Exempt = 'EXEMPT',
  Grandfathered = 'GRANDFATHERED',
  Paid = 'PAID',
  Unknown = 'UNKNOWN',
  Unpaid = 'UNPAID'
}

export enum FirmBillingReasonCode {
  CorporateManaged = 'CORPORATE_MANAGED',
  Exempt = 'EXEMPT',
  GracePeriodActive = 'GRACE_PERIOD_ACTIVE',
  GracePeriodExpired = 'GRACE_PERIOD_EXPIRED',
  Grandfathered = 'GRANDFATHERED',
  None = 'NONE',
  NoticeRequired = 'NOTICE_REQUIRED',
  Paid = 'PAID',
  ReviewRequired = 'REVIEW_REQUIRED',
  UnderLimit = 'UNDER_LIMIT'
}

export enum FirmBillingRequiredAction {
  ContactSupport = 'CONTACT_SUPPORT',
  None = 'NONE',
  UpgradeRequired = 'UPGRADE_REQUIRED'
}

export type FirmBranding = FirmBrandingInterface & {
  __typename?: 'FirmBranding';
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<File>;
  name: Scalars['String'];
  type: FirmType;
};

export type FirmBrandingInterface = {
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<File>;
  name: Scalars['String'];
  type: FirmType;
};

/** Represents the relation between a Firm and a Household. */
export type FirmClient = SynchronizedItem & {
  __typename?: 'FirmClient';
  activeFeatureDiscoveryTriggers: Array<FeatureDiscoveryTrigger>;
  aiResponses: AiResponses;
  aiSummary?: Maybe<Scalars['String']>;
  aiSummaryUpdatedAt?: Maybe<Scalars['Time']>;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  elementVisibilityOverrides: Array<FirmClientElementVisibilityOverride>;
  /**
   * When populated, only these firm members receive email notifications when the client performs actions.
   * When empty, all firm members are notified (default behavior).
   */
  emailNotificationFirmMemberIds: Array<Scalars['ID']>;
  endDate?: Maybe<Scalars['Time']>;
  entitlements: FirmClientEntitlements;
  familyNamesDisplay: Scalars['String'];
  featureAccess?: Maybe<FirmClientFeatureAccess>;
  firmID: Scalars['ID'];
  givenNamesDisplay: Scalars['String'];
  group?: Maybe<FirmClientGroup>;
  /**
   * household will be null if the client has not yet accepted the invite by the firm (for now), for old invites.
   * This is done to ensure backwards compatability. Once Create Client/Invite Only is complete, this will always have
   * a value and become non-nullable.
   */
  household?: Maybe<Household>;
  householdCategorySummary?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Individuals returns `Person`s that are the heads of household. Changing a `Person` does not rev the change token
   * for this entity.
   */
  individuals: Array<FirmClientIndividual>;
  mode: FirmClientMode;
  notes: StringDataPointGroup;
  onboardingCompletionTime?: Maybe<Scalars['Time']>;
  onboardingProcess: FirmClientOnboardingProcess;
  originFirmInviteLink?: Maybe<FirmInviteLink>;
  pendingInvitations: Array<ClientInvitation>;
  /**
   * Null if onboardingProcess is advisor directed.
   * Otherwise, will be representative of the status of if the client is going through onboarding or not. (Not the same
   * as the onboarding mode on the client)
   */
  selfDirectedOnboardingStatus?: Maybe<SelfDirectedOnboardingStatus>;
  shortHouseholdCategorySummary?: Maybe<Scalars['String']>;
  startDate: Scalars['Time'];
  status: FirmClientStatus;
  team: Array<FirmClientTeamMember>;
  updatedAt: Scalars['Time'];
};

export type FirmClientElementVisibilityOverride = {
  __typename?: 'FirmClientElementVisibilityOverride';
  element: Element;
  visible: Scalars['Boolean'];
};

export type FirmClientElementVisibilityOverrideInput = {
  element: Element;
  visible: Scalars['Boolean'];
};

export type FirmClientEntitlements = {
  __typename?: 'FirmClientEntitlements';
  aiAssessment: Scalars['Boolean'];
};

export type FirmClientEntitlementsPartial = {
  aiAssessment?: InputMaybe<Scalars['Boolean']>;
};

export type FirmClientFeatureAccess = {
  __typename?: 'FirmClientFeatureAccess';
  estateStatus: Scalars['Boolean'];
};

export type FirmClientGroup = {
  __typename?: 'FirmClientGroup';
  count: Scalars['Int'];
  createdAt: Scalars['Time'];
  firmID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type FirmClientGroupList = {
  __typename?: 'FirmClientGroupList';
  items: Array<FirmClientGroup>;
  pageInfo: PageInfo;
};

export type FirmClientIndividual = {
  age?: Maybe<Scalars['Int']>;
  emailAddress?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  relationship: RelationshipType;
  userID?: Maybe<Scalars['String']>;
};

export type FirmClientList = {
  __typename?: 'FirmClientList';
  items: Array<FirmClient>;
  pageInfo: PageInfo;
};

export enum FirmClientMode {
  /** "Active" */
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  /** "Onboarding" */
  OnboardingInProgress = 'ONBOARDING_IN_PROGRESS',
  Prospect = 'PROSPECT',
  Sample = 'SAMPLE',
  Subscriber = 'SUBSCRIBER'
}

export enum FirmClientOnboardingProcess {
  AdvisorDirected = 'ADVISOR_DIRECTED',
  SelfDirected = 'SELF_DIRECTED'
}

export type FirmClientPayload = {
  __typename?: 'FirmClientPayload';
  firmClient: FirmClient;
};

export enum FirmClientStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type FirmClientTeamMember = {
  __typename?: 'FirmClientTeamMember';
  member: FirmMember;
  role: FirmClientTeamMemberRole;
};

export type FirmClientTeamMemberInput = {
  memberID: Scalars['ID'];
  role: FirmClientTeamMemberRole;
};

export enum FirmClientTeamMemberRole {
  AdministrativeAssistant = 'ADMINISTRATIVE_ASSISTANT',
  AssociateAdvisor = 'ASSOCIATE_ADVISOR',
  ClientSuccessManager = 'CLIENT_SUCCESS_MANAGER',
  Planner = 'PLANNER',
  PrimaryAdvisor = 'PRIMARY_ADVISOR'
}

export type FirmElementCustomization = {
  __typename?: 'FirmElementCustomization';
  customName?: Maybe<Scalars['String']>;
  element: Element;
  shortName?: Maybe<Scalars['String']>;
  visibleByDefault: Scalars['Boolean'];
};

export type FirmElementCustomizationInput = {
  customName?: InputMaybe<Scalars['String']>;
  element: Element;
  shortName?: InputMaybe<Scalars['String']>;
  visibleByDefault: Scalars['Boolean'];
};

export type FirmInviteLink = SynchronizedItem & {
  __typename?: 'FirmInviteLink';
  acceptFormURL: Scalars['String'];
  campaignName: Scalars['String'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  description: Scalars['String'];
  disclosure?: Maybe<Scalars['String']>;
  firm: FirmBranding;
  firmClientEntitlements: FirmClientEntitlements;
  id: Scalars['ID'];
  invitationsAccepted: Scalars['Int'];
  inviterUserID: Scalars['ID'];
  maxInvitationsToAccept: Scalars['Int'];
  primaryAdvisorFirmMemberID: Scalars['ID'];
  status: FirmInviteLinkStatus;
  title: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type FirmInviteLinkList = {
  __typename?: 'FirmInviteLinkList';
  items: Array<FirmInviteLink>;
  pageInfo: PageInfo;
};

export enum FirmInviteLinkStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Invalidated = 'INVALIDATED'
}

export type FirmList = {
  __typename?: 'FirmList';
  items: Array<Firm>;
  pageInfo: PageInfo;
};

export type FirmMember = SynchronizedItem & {
  __typename?: 'FirmMember';
  calendarSchedulingLink?: Maybe<Scalars['String']>;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  emailSignature?: Maybe<Scalars['String']>;
  familyName: Scalars['String'];
  firmID: Scalars['ID'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  profileColor: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  role: FirmMemberRole;
  updatedAt: Scalars['Time'];
  userID?: Maybe<Scalars['String']>;
};

/**
 * Per-firm-member opt-outs for the non-essential email categories. Each field is
 * true when the member receives that category. A member who has never changed
 * these receives everything (all fields default to true). Security and billing
 * emails are mandatory and are intentionally not represented here.
 *
 * This is a standalone object rather than a field on FirmMember: FirmMember is a
 * federated @shareable type and these preferences are a monolith-only concern that
 * should not be replicated into the sync subgraph.
 */
export type FirmMemberEmailNotificationSettings = {
  __typename?: 'FirmMemberEmailNotificationSettings';
  changeToken: Scalars['String'];
  clientAccountDeletions: Scalars['Boolean'];
  clientActivity: Scalars['Boolean'];
  firmMemberID: Scalars['ID'];
  newClientMessages: Scalars['Boolean'];
  newClientsAndProspects: Scalars['Boolean'];
  quarterlyReviewReminders: Scalars['Boolean'];
};

export type FirmMemberList = {
  __typename?: 'FirmMemberList';
  items: Array<FirmMember>;
  pageInfo: PageInfo;
};

export enum FirmMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Support = 'SUPPORT'
}

export type FirmSmartGroupList = {
  __typename?: 'FirmSmartGroupList';
  items: Array<SmartGroup>;
};

export enum FirmType {
  Coaching = 'COACHING',
  Ria = 'RIA'
}

export type FloatDataPoint = DataPoint & SynchronizedItem & {
  __typename?: 'FloatDataPoint';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: FloatDataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type FloatDataPointGroup = DataPointGroup & SynchronizedItem & {
  __typename?: 'FloatDataPointGroup';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: FloatDataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export type FloatDataPointList = {
  __typename?: 'FloatDataPointList';
  items: Array<FloatDataPoint>;
  pageInfo: PageInfo;
};

export type FloatDataPointValue = {
  __typename?: 'FloatDataPointValue';
  value: Scalars['Float'];
};

export type FloatDataPointValueInput = {
  value: Scalars['Float'];
};

export type FloatGraphPointValue = {
  __typename?: 'FloatGraphPointValue';
  value: Scalars['Float'];
};

/**
 * The min and max contain the range of valid values. Optional to allow for specifying a range with just an upper bound or
 * just a lower bound.
 */
export type FloatRange = {
  __typename?: 'FloatRange';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type FloatRangeInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type FreeformContentInput = {
  attachmentFileIDs?: InputMaybe<Array<Scalars['ID']>>;
  content: Scalars['String'];
  suggestedResponses?: InputMaybe<Array<Scalars['String']>>;
};

export type FreeformMessage = Message & SynchronizedItem & {
  __typename?: 'FreeformMessage';
  attachments?: Maybe<Array<File>>;
  changeToken: Scalars['String'];
  conversationID: Scalars['ID'];
  createdAt: Scalars['Time'];
  hasOnboardingReminder?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  sender: Scalars['ID'];
  suggestedResponses?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['Time'];
};

export type GeneratePlaidLinkTokenInput = {
  androidPackageName?: InputMaybe<Scalars['String']>;
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
  oauthRedirectLink?: InputMaybe<Scalars['String']>;
  plaidItemID?: InputMaybe<Scalars['String']>;
};

export type GetInvitationInput = {
  invitationID: Scalars['String'];
};

export type GetProfileImageUploadUrlInput = {
  /** The name of the file, including the extension. */
  name: Scalars['String'];
};

export type GetProfileImageUploadUrlPayload = {
  __typename?: 'GetProfileImageUploadURLPayload';
  uploadURL: Scalars['String'];
};

export type GraphPoint = {
  __typename?: 'GraphPoint';
  dateTime: Scalars['Time'];
  /**
   * Whether or not this point was interpolated. If true, the value didn't change from the last point to this point, (ie
   * no new data point).
   */
  interpolated: Scalars['Boolean'];
  value: GraphPointValue;
};

export type GraphPointValue = FloatGraphPointValue | MonetaryAmountGraphPointValue;

export type GraphSettings = {
  end?: InputMaybe<Scalars['Time']>;
  numberOfPoints: Scalars['Int'];
  start: Scalars['Time'];
};

export type Household = SynchronizedItem & {
  __typename?: 'Household';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  financialCategorization?: Maybe<FinancialCategory>;
  financialCategoryScore?: Maybe<Scalars['Float']>;
  financialPurpose: StringDataPointGroup;
  firmClients?: Maybe<Array<FirmClient>>;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  income: RecurringMonetaryAmountDataPointGroup;
  ownerID: Scalars['ID'];
  spending: RecurringMonetaryAmountDataPointGroup;
  updatedAt: Scalars['Time'];
};

export type HouseholdList = {
  __typename?: 'HouseholdList';
  items: Array<Household>;
  pageInfo: PageInfo;
};

export type IncomeAllocation = SynchronizedItem & {
  __typename?: 'IncomeAllocation';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dateTime: Scalars['Time'];
  debtValue: MonetaryAmount;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  income: MonetaryAmount;
  savingsValue: MonetaryAmount;
  spendingValue: MonetaryAmount;
  taxValue: MonetaryAmount;
  term: IncomeAllocationTerm;
  updatedAt: Scalars['Time'];
};

export type IncomeAllocationList = {
  __typename?: 'IncomeAllocationList';
  items: Array<IncomeAllocation>;
  pageInfo: PageInfo;
};

export enum IncomeAllocationTerm {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type IncomeChangeLineItem = {
  __typename?: 'IncomeChangeLineItem';
  annualAmount: MonetaryAmount;
  dataPointGroupID: Scalars['ID'];
  dataPointID: Scalars['ID'];
  dateTime: Scalars['Time'];
  delta: MonetaryAmount;
};

export type IncomeSource = SynchronizedItem & {
  __typename?: 'IncomeSource';
  amountDataPointGroup: RecurringMonetaryAmountDataPointGroup;
  archived: Scalars['Boolean'];
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  /** Returns true if the source type is SOCIAL_SECURITY, ANNUITY, or PENSION */
  isFutureGuaranteedIncome: Scalars['Boolean'];
  name: Scalars['String'];
  notes: Scalars['String'];
  /** Defaults to false, determines if the income source should be omitted from the scorecard calculation or not. */
  omitFromScorecard: Scalars['Boolean'];
  /** If archived, the person will be null */
  person?: Maybe<Person>;
  /** If archived, the person id will be null */
  personID?: Maybe<Scalars['ID']>;
  sourceType: IncomeSourceType;
  updatedAt: Scalars['Time'];
};

export type IncomeSourceList = {
  __typename?: 'IncomeSourceList';
  items: Array<IncomeSource>;
  pageInfo: PageInfo;
};

export enum IncomeSourceType {
  Annuity = 'ANNUITY',
  Other = 'OTHER',
  Pension = 'PENSION',
  RentalIncome = 'RENTAL_INCOME',
  Salary = 'SALARY',
  SelfEmployment = 'SELF_EMPLOYMENT',
  SocialSecurity = 'SOCIAL_SECURITY'
}

export type InsurancePolicy = NetWorthItem & SynchronizedItem & {
  __typename?: 'InsurancePolicy';
  changeToken: Scalars['String'];
  coverageAmount: MonetaryAmount;
  createdAt: Scalars['Time'];
  expirationDate?: Maybe<Scalars['Date']>;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  policySubtype: InsurancePolicySubtype;
  policyType: InsurancePolicyType;
  purchasedDate?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Time'];
};

export type InsurancePolicyList = {
  __typename?: 'InsurancePolicyList';
  items: Array<InsurancePolicy>;
  pageInfo: PageInfo;
};

export enum InsurancePolicySubtype {
  BusinessLiability = 'BUSINESS_LIABILITY',
  BusinessOverhead = 'BUSINESS_OVERHEAD',
  BuySell = 'BUY_SELL',
  CashValue = 'CASH_VALUE',
  KeyPerson = 'KEY_PERSON',
  Malpractice = 'MALPRACTICE',
  PersonalDisability = 'PERSONAL_DISABILITY',
  PersonalUmbrella = 'PERSONAL_UMBRELLA',
  Term = 'TERM'
}

export enum InsurancePolicyType {
  Disability = 'DISABILITY',
  Liability = 'LIABILITY',
  Life = 'LIFE'
}

export type InsuranceRateCoverage = {
  __typename?: 'InsuranceRateCoverage';
  heldCoverage: MonetaryAmount;
  neededCoverage: MonetaryAmount;
  overallCoverage: Scalars['Float'];
  /** Optional as it will only exist for life and disability, not liability. */
  person?: Maybe<Person>;
};

export type InsuranceRateReportCoverage = {
  __typename?: 'InsuranceRateReportCoverage';
  heldCoverage: MonetaryAmount;
  neededCoverage: MonetaryAmount;
  /**
   * The coverage sub-score as a percentage (0–100): held coverage divided by
   * needed coverage, capped at 100.
   */
  overallCoverage: Scalars['Float'];
  personGivenName?: Maybe<Scalars['String']>;
  /**
   * The covered head of household. Null for the household-level liability section,
   * which is not tied to a single person.
   */
  personID?: Maybe<Scalars['ID']>;
};

export type InsuranceRateReportData = {
  __typename?: 'InsuranceRateReportData';
  /** Disability insurance coverage, one entry per head of household. */
  disabilityCoverages: Array<InsuranceRateReportCoverage>;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  /**
   * Insurance Rate as a percentage (0–100): the average of the life, disability,
   * and liability coverage sub-scores. Reconciles with the scorecard Insurance Rate.
   */
  insuranceRate: Scalars['Float'];
  /** Liability (umbrella) insurance coverage, measured at the household level. */
  liabilityCoverage: InsuranceRateReportCoverage;
  /** Life insurance coverage, one entry per head of household. */
  lifeCoverages: Array<InsuranceRateReportCoverage>;
  reportDisclosureText: Scalars['String'];
  type: ReportType;
};

export enum InterestRateType {
  Fixed = 'FIXED',
  Variable = 'VARIABLE'
}

export type Investment = LinkedAccount & NetWorthItem & SynchronizedItem & {
  __typename?: 'Investment';
  accountLinkProvider?: Maybe<MappedAccountProvider>;
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  /** Optional income source linked to this investment (ELE-667). */
  incomeSourceID?: Maybe<Scalars['ID']>;
  investmentMix: InvestmentMixDataPointGroup;
  investmentType: InvestmentType;
  linkID?: Maybe<Scalars['String']>;
  linkStatus?: Maybe<MappedAccountStatus>;
  linkedInstitutionName?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  recurringContribution: RecurringMonetaryAmountDataPointGroup;
  recurringContributionPercentage?: Maybe<FloatDataPointGroup>;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type InvestmentList = {
  __typename?: 'InvestmentList';
  items: Array<Investment>;
  pageInfo: PageInfo;
};

export enum InvestmentMix {
  AggressiveGrowth = 'AGGRESSIVE_GROWTH',
  Balanced = 'BALANCED',
  BalancedGrowth = 'BALANCED_GROWTH',
  Conservative = 'CONSERVATIVE',
  DontKnow = 'DONT_KNOW',
  EquityGrowth = 'EQUITY_GROWTH',
  Growth = 'GROWTH',
  Moderate = 'MODERATE',
  ModerateGrowth = 'MODERATE_GROWTH',
  VeryConservative = 'VERY_CONSERVATIVE'
}

export type InvestmentMixDataPoint = DataPoint & SynchronizedItem & {
  __typename?: 'InvestmentMixDataPoint';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: InvestmentMixDataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type InvestmentMixDataPointGroup = DataPointGroup & SynchronizedItem & {
  __typename?: 'InvestmentMixDataPointGroup';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: InvestmentMixDataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export type InvestmentMixDataPointList = {
  __typename?: 'InvestmentMixDataPointList';
  items: Array<InvestmentMixDataPoint>;
  pageInfo: PageInfo;
};

export type InvestmentMixDataPointValue = {
  __typename?: 'InvestmentMixDataPointValue';
  value: InvestmentMix;
};

export type InvestmentMixDataPointValueInput = {
  value: InvestmentMix;
};

export enum InvestmentType {
  Annuity = 'ANNUITY',
  BrokerageAccount = 'BROKERAGE_ACCOUNT',
  Cryptocurrency = 'CRYPTOCURRENCY',
  DeferredCompensationPlan_457BAccount = 'DEFERRED_COMPENSATION_PLAN_457B_ACCOUNT',
  DefinedBenefitPlanAccount = 'DEFINED_BENEFIT_PLAN_ACCOUNT',
  HealthSavingsAccount = 'HEALTH_SAVINGS_ACCOUNT',
  IndividualRetirementAccount = 'INDIVIDUAL_RETIREMENT_ACCOUNT',
  MinorIndividualRetirementAccount = 'MINOR_INDIVIDUAL_RETIREMENT_ACCOUNT',
  MinorRothIndividualRetirementAccount = 'MINOR_ROTH_INDIVIDUAL_RETIREMENT_ACCOUNT',
  PrivateStock = 'PRIVATE_STOCK',
  ProfitSharingAccount = 'PROFIT_SHARING_ACCOUNT',
  QualifiedTuitionPlan_529 = 'QUALIFIED_TUITION_PLAN_529',
  Roth_403BAccount = 'ROTH_403B_ACCOUNT',
  Roth_457BAccount = 'ROTH_457B_ACCOUNT',
  RothIndividualRetirementAccount = 'ROTH_INDIVIDUAL_RETIREMENT_ACCOUNT',
  RothSepIraAccount = 'ROTH_SEP_IRA_ACCOUNT',
  RothSimpleIraAccount = 'ROTH_SIMPLE_IRA_ACCOUNT',
  RothSubsection_401KAccount = 'ROTH_SUBSECTION_401K_ACCOUNT',
  SimpleIndividualRetirementAccount = 'SIMPLE_INDIVIDUAL_RETIREMENT_ACCOUNT',
  SimplifiedEmployeePensionAccount = 'SIMPLIFIED_EMPLOYEE_PENSION_ACCOUNT',
  StockOption = 'STOCK_OPTION',
  Subsection_401KAccount = 'SUBSECTION_401K_ACCOUNT',
  TaxShelteredAnnuity_403BAccount = 'TAX_SHELTERED_ANNUITY_403B_ACCOUNT',
  Traditional_403BAccount = 'TRADITIONAL_403B_ACCOUNT',
  Traditional_457BAccount = 'TRADITIONAL_457B_ACCOUNT',
  TraditionalSepIraAccount = 'TRADITIONAL_SEP_IRA_ACCOUNT',
  TraditionalSimpleIraAccount = 'TRADITIONAL_SIMPLE_IRA_ACCOUNT',
  UniversalTrustForMinorAccount = 'UNIVERSAL_TRUST_FOR_MINOR_ACCOUNT'
}

export type Invitation = {
  acceptedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  /** dateTime is here only temporarily for backwards compatability. Please use `createdAt` instead. */
  dateTime: Scalars['Time'];
  id: Scalars['ID'];
  inviteeEmail: Scalars['String'];
  inviteeFamilyName?: Maybe<Scalars['String']>;
  inviteeGivenName?: Maybe<Scalars['String']>;
  inviter: UserProfile;
  status: InvitationStatus;
  /** type is here only temporarily for backwards compatability. Please use the actual typed invitation's typename. */
  type: InvitationType;
  updatedAt: Scalars['Time'];
};

export type InvitationList = {
  __typename?: 'InvitationList';
  items: Array<Invitation>;
  pageInfo: PageInfo;
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export enum InvitationType {
  Client = 'CLIENT',
  FirmMember = 'FIRM_MEMBER'
}

export type InviteFirmClientInput = {
  clientID: Scalars['ID'];
  /** Optional. If passed, will change the email address with the person as well as send the invite to the updated email. */
  emailAddress?: InputMaybe<Scalars['String']>;
  personID: Scalars['ID'];
};

export type InviteFirmClientPayload = {
  __typename?: 'InviteFirmClientPayload';
  invitation: ClientInvitation;
};

export type JointWithRightsOfSurvivorship = {
  __typename?: 'JointWithRightsOfSurvivorship';
  owners: Array<Owner>;
};

export type JointWithRightsOfSurvivorshipInput = {
  owners: Array<OwnerInput>;
};

export type LinkSwitchInput = {
  linkID?: InputMaybe<Scalars['String']>;
  previousNWIID?: InputMaybe<Scalars['ID']>;
};

export type LinkedAccount = {
  accountLinkProvider?: Maybe<MappedAccountProvider>;
  linkID?: Maybe<Scalars['String']>;
  linkStatus?: Maybe<MappedAccountStatus>;
  linkedInstitutionName?: Maybe<Scalars['String']>;
  mask?: Maybe<Scalars['String']>;
};

export type LiquidTermReportData = {
  __typename?: 'LiquidTermReportData';
  businessCashAccounts: Array<ReportCashAccount>;
  currentTotalLiquidAssets: MonetaryAmount;
  estimatedAnnualSpending: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  liquidTerm: Scalars['Float'];
  nonQualifiedInvestments: Array<ReportInvestment>;
  personalCashAccounts: Array<ReportCashAccount>;
  reportDisclosureText: Scalars['String'];
  totalLiquidAssetsHistory: Array<ValueForDate>;
  totalOwnedBusinessCashAccountsValue: MonetaryAmount;
  totalOwnedNonQualifiedInvestmentsValue: MonetaryAmount;
  totalOwnedPersonalCashAccountsValue: MonetaryAmount;
  type: ReportType;
};

export type Loan = LinkedAccount & NetWorthItem & SynchronizedItem & {
  __typename?: 'Loan';
  accountLinkProvider?: Maybe<MappedAccountProvider>;
  balance: MonetaryAmountDataPointGroup;
  balloonPaymentDate?: Maybe<Scalars['Date']>;
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  collateralType?: Maybe<CollateralType>;
  createdAt: Scalars['Time'];
  extraPaymentAmount: RecurringMonetaryAmountDataPointGroup;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  interestRate: FloatDataPointGroup;
  interestRateDescription?: Maybe<Scalars['String']>;
  interestRateType?: Maybe<InterestRateType>;
  linkID?: Maybe<Scalars['String']>;
  linkStatus?: Maybe<MappedAccountStatus>;
  linkedInstitutionName?: Maybe<Scalars['String']>;
  loanType: LoanType;
  mask?: Maybe<Scalars['String']>;
  maturityDate?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  notes: Scalars['String'];
  originalAmount?: Maybe<MonetaryAmount>;
  originalLoanLength?: Maybe<Scalars['Int']>;
  originationDate?: Maybe<Scalars['Date']>;
  ownedBalance: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  paymentAmount: RecurringMonetaryAmountDataPointGroup;
  repaymentType?: Maybe<RepaymentType>;
  updatedAt: Scalars['Time'];
};

export enum LoanGroup {
  BusinessLoans = 'BUSINESS_LOANS',
  OtherLoans = 'OTHER_LOANS',
  PersonalRealEstateLoans = 'PERSONAL_REAL_ESTATE_LOANS',
  StudentLoans = 'STUDENT_LOANS'
}

export type LoanList = {
  __typename?: 'LoanList';
  items: Array<Loan>;
  pageInfo: PageInfo;
};

export enum LoanType {
  AutoLoan = 'AUTO_LOAN',
  BusinessLoan = 'BUSINESS_LOAN',
  CreditCard = 'CREDIT_CARD',
  HomeEquityLineOfCredit = 'HOME_EQUITY_LINE_OF_CREDIT',
  HomeEquityLoan = 'HOME_EQUITY_LOAN',
  InvestmentRealEstateLoan = 'INVESTMENT_REAL_ESTATE_LOAN',
  Mortgage = 'MORTGAGE',
  OtherBusinessLoan = 'OTHER_BUSINESS_LOAN',
  OtherBusinessRealEstateLoan = 'OTHER_BUSINESS_REAL_ESTATE_LOAN',
  OtherLoan = 'OTHER_LOAN',
  PersonalLoan = 'PERSONAL_LOAN',
  ReverseMortgage = 'REVERSE_MORTGAGE',
  SecuredLineOfCredit = 'SECURED_LINE_OF_CREDIT',
  StudentLoan = 'STUDENT_LOAN',
  UnsecuredLineOfCredit = 'UNSECURED_LINE_OF_CREDIT'
}

export type LogClientSideEventInput = {
  appType?: InputMaybe<AppType>;
  message: Scalars['String'];
  system: LogSystem;
};

export enum LogSystem {
  Other = 'OTHER',
  Plaid = 'PLAID'
}

export type LtDetails = {
  __typename?: 'LtDetails';
  afterTaxInvestmentItems: Array<Investment>;
  annualExpenses: MonetaryAmount;
  businessCashItems: Array<CashAccount>;
  lt?: Maybe<Scalars['Float']>;
  personalCashItems: Array<CashAccount>;
  totalAfterTaxInvestments: MonetaryAmount;
  totalBusinessCash: MonetaryAmount;
  totalLiquidAssets: MonetaryAmount;
  totalPersonalCash: MonetaryAmount;
};

export enum MfaType {
  SmsMfa = 'SMS_MFA',
  SoftwareTokenMfa = 'SOFTWARE_TOKEN_MFA'
}

export type MagicNumber = SynchronizedItem & {
  __typename?: 'MagicNumber';
  annualWithdrawalRate: Scalars['Float'];
  averageNetWorthGrowthNeeded: MonetaryAmount;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dateTime: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  magicNumber: MonetaryAmount;
  monthlyLivingExpenses: MonetaryAmount;
  retirementAge: Scalars['Int'];
  targetTotalTermScore: Scalars['Float'];
  updatedAt: Scalars['Time'];
};

export type MagicNumberList = {
  __typename?: 'MagicNumberList';
  items: Array<MagicNumber>;
  pageInfo: PageInfo;
};

export enum MappedAccountProvider {
  MorningstarBaa = 'MORNINGSTAR_BAA',
  Plaid = 'PLAID'
}

export enum MappedAccountStatus {
  Active = 'ACTIVE',
  Error = 'ERROR',
  PendingExpiration = 'PENDING_EXPIRATION',
  Revoked = 'REVOKED'
}

export enum MappedEntityType {
  CashAccount = 'CASH_ACCOUNT',
  DoNotMap = 'DO_NOT_MAP',
  Investment = 'INVESTMENT',
  Loan = 'LOAN'
}

export type MarkConversationReadInput = {
  conversationID: Scalars['ID'];
};

export type MarkMessageReadPayload = {
  __typename?: 'MarkMessageReadPayload';
  read: Scalars['Boolean'];
};

export type MarkQuarterlyProgressReportReviewOpenedInput = {
  firmClientID: Scalars['ID'];
};

export type MarkQuarterlyProgressReportReviewOpenedPayload = {
  __typename?: 'MarkQuarterlyProgressReportReviewOpenedPayload';
  review: QuarterlyProgressReportReview;
};

export type MergeBusinessesInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeBusinessesPayload = {
  __typename?: 'MergeBusinessesPayload';
  merged: Scalars['Boolean'];
};

export type MergeCashAccountsInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeCashAccountsPayload = {
  __typename?: 'MergeCashAccountsPayload';
  merged: Scalars['Boolean'];
};

export type MergeInvestmentsInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeInvestmentsPayload = {
  __typename?: 'MergeInvestmentsPayload';
  merged: Scalars['Boolean'];
};

export type MergeLoansInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeLoansPayload = {
  __typename?: 'MergeLoansPayload';
  merged: Scalars['Boolean'];
};

export type MergeNoteReceivablesInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeNoteReceivablesPayload = {
  __typename?: 'MergeNoteReceivablesPayload';
  merged: Scalars['Boolean'];
};

export type MergePersonalPropertyItemsInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergePersonalPropertyItemsPayload = {
  __typename?: 'MergePersonalPropertyItemsPayload';
  merged: Scalars['Boolean'];
};

export type MergeRealEstatesInput = {
  householdID: Scalars['ID'];
  sourceAccountID: Scalars['ID'];
  targetAccountID: Scalars['ID'];
};

export type MergeRealEstatesPayload = {
  __typename?: 'MergeRealEstatesPayload';
  merged: Scalars['Boolean'];
};

export type Message = {
  attachments?: Maybe<Array<File>>;
  changeToken: Scalars['String'];
  conversationID: Scalars['ID'];
  createdAt: Scalars['Time'];
  hasOnboardingReminder?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** ID of the conversation participant who sent the message */
  sender: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type MessagesList = {
  __typename?: 'MessagesList';
  items: Array<Message>;
  pageInfo: PageInfo;
};

export type MinimumClientVersions = {
  __typename?: 'MinimumClientVersions';
  iOS: ClientVersionInfo;
};

export enum ModelId {
  Claude_3_5Sonnet = 'CLAUDE_3_5_SONNET',
  Claude_3_7Sonnet = 'CLAUDE_3_7_SONNET',
  Gpt_4O = 'GPT_4O',
  Gpt_5 = 'GPT_5',
  GptO3 = 'GPT_O3'
}

/** Represents a monetary amount comprising of the minor unit in the `amount` and the ISO-4217 currency code in `currencyCode` */
export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  currencyCode: Scalars['String'];
  value: Scalars['Long'];
};

export type MonetaryAmountDataPoint = DataPoint & SynchronizedItem & {
  __typename?: 'MonetaryAmountDataPoint';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: MonetaryAmountDataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type MonetaryAmountDataPointGroup = DataPointGroup & SynchronizedItem & {
  __typename?: 'MonetaryAmountDataPointGroup';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: MonetaryAmountDataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export type MonetaryAmountDataPointList = {
  __typename?: 'MonetaryAmountDataPointList';
  items: Array<MonetaryAmountDataPoint>;
  pageInfo: PageInfo;
};

export type MonetaryAmountDataPointValue = {
  __typename?: 'MonetaryAmountDataPointValue';
  value: MonetaryAmount;
};

export type MonetaryAmountDataPointValueInput = {
  value: MonetaryAmountInput;
};

export type MonetaryAmountGraphPointValue = {
  __typename?: 'MonetaryAmountGraphPointValue';
  value: MonetaryAmount;
};

export type MonetaryAmountInput = {
  currencyCode: Scalars['String'];
  value: Scalars['Long'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptFirmClientInvitation: AcceptFirmClientInvitationPayload;
  acceptFirmInviteLink: AcceptFirmInviteLinkPayload;
  addFeatureDiscoveryTriggerToFirmClient: AddFeatureDiscoveryTriggerToFirmClientPayload;
  applyPlaidItemAccountMapping: Scalars['Boolean'];
  /** Applies a template to a client. */
  applyTargetScoreRangeTemplateToClient: TargetScoreRangesForClientPayload;
  archiveFirmClient: ArchiveFirmClientPayload;
  archiveIncomeSource: ArchiveIncomeSourcePayload;
  assignClientToGroup: AssignClientToGroupPayload;
  /** Associates a software token with the user's account, enabling software token MFA. */
  associateSoftwareToken: Scalars['Boolean'];
  beginPasswordlessSignIn: BeginPasswordlessSignInPayload;
  changeAccountToCashAccount: ChangeAccountToCashAccountPayload;
  changeAccountToInsurancePolicy: ChangeAccountToInsurancePolicyPayload;
  changeAccountToInvestment: ChangeAccountToInvestmentPayload;
  changeAccountToLoan: ChangeAccountToLoanPayload;
  changeEmail: Scalars['Boolean'];
  changePassword: Scalars['Boolean'];
  changeUsername: Scalars['Boolean'];
  closeBusiness: CloseBusinessPayload;
  closeCashAccount: CloseCashAccountPayload;
  closeInvestment: CloseInvestmentPayload;
  closeLoan: CloseLoanPayload;
  closeNoteReceivable: CloseNoteReceivablePayload;
  closePersonalPropertyItem: ClosePersonalPropertyItemPayload;
  closeRealEstateProperty: CloseRealEstatePropertyPayload;
  completePasswordlessSignIn: CompletePasswordlessSignInPayload;
  completeProspectDiscovery: CompleteProspectDiscoveryPayload;
  completeQuarterlyProgressReportReview: CompleteQuarterlyProgressReportReviewPayload;
  completeQuarterlyProgressReportReviewSection: CompleteQuarterlyProgressReportReviewSectionPayload;
  /** Confirms an email address. Primarily used when changing email addresses, as users are now created and auto-confirmed. */
  confirmAccount: ConfirmAccountPayload;
  /** Reset a forgotten password with a code received through an email. */
  confirmPasswordReset: Scalars['Boolean'];
  createAiFeedback: CreateAiFeedbackPayload;
  createAssetLoan: CreateAssetLoanPayload;
  createBaaAccount: CreateBaaAccountPayload;
  createBaaAccountsForClient: CreateBaaAccountsForClientPayload;
  createBaaPerson: CreateBaaPersonPayload;
  createBusiness: CreateBusinessPayload;
  createCashAccount: CreateCashAccountPayload;
  createDataPoint: CreateDataPointPayload;
  createDataPointGroup: CreateDataPointGroupPayload;
  /**
   * Creates a file. Resulting file will have the 'pending' upload status, with
   * an upload url containing the link to upload the file. If this file does not
   * get uploaded within 3 days, this file will get automatically deleted, and a
   * resulting 'DeletedItem' record get written for it and any associated
   * FileAttachments.
   */
  createFile: CreateFilePayload;
  /** Creates a file attachment. */
  createFileAttachment: CreateFileAttachmentPayload;
  createFinancialGoal?: Maybe<CreateFinancialGoalPayload>;
  createFinancialNextStep?: Maybe<CreateFinancialNextStepPayload>;
  createFirmClient: CreateFirmClientPayload;
  createFirmClientGroup: CreateFirmClientGroupPayload;
  createFirmInviteLink: FirmInviteLink;
  createFirmMember: CreateFirmMemberPayload;
  createIncomeAllocation?: Maybe<CreateIncomeAllocationPayload>;
  createIncomeSource: CreateIncomeSourcePayload;
  createInsurancePolicy: CreateInsurancePolicyPayload;
  createInvestment: CreateInvestmentPayload;
  createLoan: CreateLoanPayload;
  createMagicNumber: CreateMagicNumberPayload;
  createMessage: CreateMessagePayload;
  createNoteReceivable: CreateNoteReceivablePayload;
  createPerson: CreatePersonPayload;
  createPersonalPropertyItem: CreatePersonalPropertyItemPayload;
  createProfessional: CreateProfessionalPayload;
  createRealEstateProperty: CreateRealEstatePayload;
  createSelfServeCheckoutSession: SelfServeCheckoutSessionPayload;
  createSmartGroup: SmartGroup;
  /** Creates a secret code for a software token MFA. */
  createSoftwareTokenSecret: CreateSoftwareTokenSecretPayload;
  createSpendingCategoryEstimate: CreateSpendingCategoryEstimatePayload;
  /** Create a new target score range template. */
  createTargetScoreRangeTemplate: CreateTargetScoreRangeTemplatePayload;
  createTaxReturnSummary: CreateTaxReturnSummaryPayload;
  createTrust: CreateTrustPayload;
  createXYPNStartingCheckoutSession: SelfServeCheckoutSessionPayload;
  deleteAccount: Scalars['Boolean'];
  deleteAssetLoan: DeleteAssetLoanPayload;
  deleteBusiness: DeleteBusinessPayload;
  deleteCashAccount: DeleteCashAccountPayload;
  deleteDataPoint: DeleteDataPointPayload;
  /** Deletes a file and any associated file attachments. */
  deleteFile: DeleteFilePayload;
  /**
   * Deletes a file attachment. Side effects: if a file attachment is deleted and
   * it's accompanying file has no more attachments, the underlying file will be
   * cleaned up and removed.
   */
  deleteFileAttachment: DeleteFileAttachmentPayload;
  deleteFinancialGoal?: Maybe<DeleteFinancialGoalPayload>;
  deleteFinancialNextStep?: Maybe<DeleteFinancialNextStepPayload>;
  deleteFirmClientGroup: DeleteFirmClientGroupPayload;
  deleteFirmInviteLink: Scalars['Boolean'];
  deleteFirmMember: DeleteFirmMemberPayload;
  deleteIncomeAllocation?: Maybe<DeleteIncomeAllocationPayload>;
  deleteInsurancePolicy: DeleteInsurancePolicyPayload;
  deleteInvestment: DeleteInvestmentPayload;
  /** Delete/revoke an invitation. */
  deleteInvitation: Scalars['Boolean'];
  deleteLoan: DeleteLoanPayload;
  deleteMagicNumber: DeleteMagicNumberPayload;
  deleteNoteReceivable: DeleteNoteReceivablePayload;
  deletePerson: DeletePersonPayload;
  deletePersonalPropertyItem: DeletePersonalPropertyItemPayload;
  deleteProfessional: DeleteProfessionalPayload;
  deleteRealEstateProperty: DeleteRealEstatePayload;
  deleteSmartGroup: Scalars['Boolean'];
  deleteSpendingCategoryEstimate: DeleteSpendingCategoryEstimatePayload;
  /** Delete a target score range template. Throws an error if attempting to delete the defaults template. */
  deleteTargetScoreRangeTemplate: DeleteTargetScoreRangeTemplatePayload;
  deleteTaxReturnSummary: DeleteTaxReturnSummaryPayload;
  deleteTrust: DeleteTrustPayload;
  /** Disassociate a software token with the user's account, disabling software token MFA. */
  disassociateSoftwareToken: Scalars['Boolean'];
  disconnectAccountLinking: Scalars['Boolean'];
  exchangePlaidPublicToken: PlaidItemsPayload;
  /** Sign in to an account with ability to impersonate another user. */
  extendedSignIn: SignInPayload;
  /** Send a forgot password email with a link to reset the password. */
  forgotPassword: Scalars['Boolean'];
  generatePlaidLinkToken: PlaidLinkTokenPayload;
  /** Get a presigned URL for uploading a profile image. */
  getProfileImageUploadURL: GetProfileImageUploadUrlPayload;
  healthcheck: Scalars['String'];
  inviteFirmClient: InviteFirmClientPayload;
  logClientSideEvent: Scalars['Boolean'];
  markConversationRead: MarkMessageReadPayload;
  markQuarterlyProgressReportReviewOpened: MarkQuarterlyProgressReportReviewOpenedPayload;
  mergeBusinesses: MergeBusinessesPayload;
  mergeCashAccounts: MergeCashAccountsPayload;
  mergeInvestments: MergeInvestmentsPayload;
  mergeLoans: MergeLoansPayload;
  mergeNoteReceivables: MergeNoteReceivablesPayload;
  mergePersonalPropertyItems: MergePersonalPropertyItemsPayload;
  mergeRealEstates: MergeRealEstatesPayload;
  muteConversation: MuteOrUnmuteConversationPayload;
  publishAiClientSummary: PublishAiClientSummaryPayload;
  refreshAIRecommendations?: Maybe<RefreshAiRecommendationsPayload>;
  refreshAiClientSummary: RefreshAiClientSummaryPayload;
  /** Refresh the auth token given a refresh token. */
  refreshTokens: RefreshTokensPayload;
  registerDevice: Scalars['Boolean'];
  removeAssignedAccount: RemoveAssignedAccountPayload;
  removeBAAAccountsForNetWorthItem: Scalars['Boolean'];
  removeClientAccess: RemoveClientAccessPayload;
  removeFeatureDiscoveryTriggerFromFirmClient: RemoveFeatureDiscoveryTriggerFromFirmClientPayload;
  reorderFinancialGoal?: Maybe<ReorderFinancialGoalPayload>;
  reorderFinancialNextStep?: Maybe<ReorderFinancialNextStepPayload>;
  requestQuarterlyProgressReportReview: RequestQuarterlyProgressReportReviewPayload;
  /**
   * Resend the email verification code for an unconfirmed account. Always returns true when the request is accepted,
   * regardless of whether the email matches an account, to avoid leaking account existence.
   */
  resendConfirmationCode: Scalars['Boolean'];
  resendEmailVerification: Scalars['Boolean'];
  /**
   * Reset a given Element's values of a template. If this is a custom template, this will reset the value to the firm defaults.
   * If this is the firm defaults, this will reset to the Elements defaults.
   */
  resetTargetScoreRangeTemplateValue: ResetTargetScoreRangeTemplateValuePayload;
  /**
   * Resets a given Element's ranges for a client. If a custom template has been applied, it will reapply the value from
   * the custom template, otherwise it will reset to the firm's defaults.
   */
  resetTargetScoreRangeValueForClient: TargetScoreRangesForClientPayload;
  /**
   * Respond to an authentication challenge. This could be in the form of an MFA challenge, or a force change password
   * challenge.
   */
  respondToAuthChallenge: RespondToAuthChallengePayload;
  reviewQuarterlyProgressReportReviewSection: ReviewQuarterlyProgressReportReviewSectionPayload;
  revokeUserAccess?: Maybe<RevokeUserAccessPayload>;
  saveEstateStatus: SaveEstateStatusPayload;
  saveEstateStatusFirmTemplate: SaveEstateStatusFirmTemplatePayload;
  sendFeatureSuggestion: FeatureSuggestionPayload;
  /** Sign in to an account. */
  signIn: SignInPayload;
  /**
   * DEPRECATED. Please use `acceptInvitationToFirm` which creates a user account with an invitation ID. This will stop
   * working at some point.
   */
  signUp: SignUpPayload;
  startProspectDiscovery: StartProspectDiscoveryPayload;
  switchFirmClientMode: FirmClientPayload;
  switchFirmClientOnboarding: FirmClientPayload;
  syncExistingPlaidConnections: Scalars['Boolean'];
  unassignClientFromAnyGroup: UnassignClientFromAnyGroupPayload;
  updateAiClientSummary: UpdateAiClientSummaryPayload;
  updateBusiness: UpdateBusinessPayload;
  updateCashAccount: UpdateCashAccountPayload;
  updateClientSmartGroupStatus: UpdateClientSmartGroupStatusPayload;
  updateDataPoint: UpdateDataPointPayload;
  updateDataPointGroup: UpdateDataPointGroupPayload;
  updateEntityIDMapping: UpdateEntityIdMappingPayload;
  updateFinancialGoal?: Maybe<UpdateFinancialGoalPayload>;
  updateFinancialNextStep?: Maybe<UpdateFinancialNextStepPayload>;
  updateFirm: UpdateFirmPayload;
  /** Updates a firm client. Can be invoked by either a client or a member of a firm. */
  updateFirmClient: UpdateFirmClientPayload;
  updateFirmClientGroup: UpdateFirmClientGroupPayload;
  updateFirmInviteLink: FirmInviteLink;
  updateFirmMember: UpdateFirmMemberPayload;
  updateFirmMemberEmailNotificationSettings: UpdateFirmMemberEmailNotificationSettingsPayload;
  updateIncomeAllocation?: Maybe<UpdateIncomeAllocationPayload>;
  updateIncomeSource: UpdateIncomeSourcePayload;
  updateInsurancePolicy: UpdateInsurancePolicyPayload;
  updateInvestment: UpdateInvestmentPayload;
  /**
   * Updates the invitation email. Can be used to resend the invitation - just pass the same email as before and it will
   * resend the invitation as a side effect.
   */
  updateInvitation: Scalars['Boolean'];
  updateLoan: UpdateLoanPayload;
  updateMagicNumber: UpdateMagicNumberPayload;
  updateNoteReceivable: UpdateNoteReceivablePayload;
  updatePerson: UpdatePersonPayload;
  updatePersonalPropertyItem: UpdatePersonalPropertyItemPayload;
  updatePlaidLinkAfterRefresh: Scalars['Boolean'];
  updatePrimaryHousehold: UpdatePrimaryHouseholdPayload;
  updateProfessional: UpdateProfessionalPayload;
  updateProfilePhoto: Scalars['Boolean'];
  updateRealEstateProperty: UpdateRealEstatePayload;
  updateSmartGroup: SmartGroup;
  updateSpendingCategoryEstimate: UpdateSpendingCategoryEstimatePayload;
  /** Update a target score range template. Throws an error if attempting to update the name of the defaults template. */
  updateTargetScoreRangeTemplate: UpdateTargetScoreRangeTemplatePayload;
  /** Update the target score ranges for a client. */
  updateTargetScoreRangesForClient: TargetScoreRangesForClientPayload;
  updateTaxReturnSummary: UpdateTaxReturnSummaryPayload;
  updateTrust: UpdateTrustPayload;
  updateUser: Scalars['Boolean'];
  verifyEmail: Scalars['Boolean'];
};


export type MutationAcceptFirmClientInvitationArgs = {
  input: AcceptFirmClientInvitationInput;
};


export type MutationAcceptFirmInviteLinkArgs = {
  input: AcceptFirmInviteLinkInput;
};


export type MutationAddFeatureDiscoveryTriggerToFirmClientArgs = {
  input: AddFeatureDiscoveryTriggerToFirmClientInput;
};


export type MutationApplyPlaidItemAccountMappingArgs = {
  input: ApplyPlaidItemAccountMappingInput;
};


export type MutationApplyTargetScoreRangeTemplateToClientArgs = {
  input: ApplyTargetScoreRangeTemplateToClientInput;
};


export type MutationArchiveFirmClientArgs = {
  input: ArchiveFirmClientInput;
};


export type MutationArchiveIncomeSourceArgs = {
  input: ArchiveIncomeSourceInput;
};


export type MutationAssignClientToGroupArgs = {
  input: AssignClientToGroupInput;
};


export type MutationAssociateSoftwareTokenArgs = {
  input: AssociateSoftwareTokenInput;
};


export type MutationBeginPasswordlessSignInArgs = {
  input: BeginPasswordlessSignInInput;
};


export type MutationChangeAccountToCashAccountArgs = {
  input: ChangeAccountToCashAccountInput;
};


export type MutationChangeAccountToInsurancePolicyArgs = {
  input: ChangeAccountToInsurancePolicyInput;
};


export type MutationChangeAccountToInvestmentArgs = {
  input: ChangeAccountToInvestmentInput;
};


export type MutationChangeAccountToLoanArgs = {
  input: ChangeAccountToLoanInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeUsernameArgs = {
  input: ChangeUsernameInput;
};


export type MutationCloseBusinessArgs = {
  input: CloseBusinessInput;
};


export type MutationCloseCashAccountArgs = {
  input: CloseCashAccountInput;
};


export type MutationCloseInvestmentArgs = {
  input: CloseInvestmentInput;
};


export type MutationCloseLoanArgs = {
  input: CloseLoanInput;
};


export type MutationCloseNoteReceivableArgs = {
  input: CloseNoteReceivableInput;
};


export type MutationClosePersonalPropertyItemArgs = {
  input: ClosePersonalPropertyItemInput;
};


export type MutationCloseRealEstatePropertyArgs = {
  input: CloseRealEstatePropertyInput;
};


export type MutationCompletePasswordlessSignInArgs = {
  input: CompletePasswordlessSignInInput;
};


export type MutationCompleteProspectDiscoveryArgs = {
  input: CompleteProspectDiscoveryInput;
};


export type MutationCompleteQuarterlyProgressReportReviewArgs = {
  input: CompleteQuarterlyProgressReportReviewInput;
};


export type MutationCompleteQuarterlyProgressReportReviewSectionArgs = {
  input: CompleteQuarterlyProgressReportReviewSectionInput;
};


export type MutationConfirmAccountArgs = {
  input: ConfirmAccountInput;
};


export type MutationConfirmPasswordResetArgs = {
  input: ConfirmPasswordResetInput;
};


export type MutationCreateAiFeedbackArgs = {
  input: CreateAiFeedbackInput;
};


export type MutationCreateAssetLoanArgs = {
  input: CreateAssetLoanInput;
};


export type MutationCreateBaaAccountArgs = {
  input: CreateBaaAccountInput;
};


export type MutationCreateBaaAccountsForClientArgs = {
  accounts: Array<CreateBaaAccountsForClientAccountInput>;
  sharedInput: CreateBaaAccountsForClientSharedInput;
};


export type MutationCreateBaaPersonArgs = {
  input: CreateBaaPersonInput;
};


export type MutationCreateBusinessArgs = {
  input: CreateBusinessInput;
};


export type MutationCreateCashAccountArgs = {
  input: CreateCashAccountInput;
};


export type MutationCreateDataPointArgs = {
  input: CreateDataPointInput;
};


export type MutationCreateDataPointGroupArgs = {
  input: CreateDataPointGroupInput;
};


export type MutationCreateFileArgs = {
  input: CreateFileInput;
};


export type MutationCreateFileAttachmentArgs = {
  input: CreateFileAttachmentInput;
};


export type MutationCreateFinancialGoalArgs = {
  input: CreateFinancialGoalInput;
};


export type MutationCreateFinancialNextStepArgs = {
  input: CreateFinancialNextStepInput;
};


export type MutationCreateFirmClientArgs = {
  input: CreateFirmClientInput;
};


export type MutationCreateFirmClientGroupArgs = {
  input: CreateFirmClientGroupInput;
};


export type MutationCreateFirmInviteLinkArgs = {
  input: CreateFirmInviteLinkInput;
};


export type MutationCreateFirmMemberArgs = {
  input: CreateFirmMemberInput;
};


export type MutationCreateIncomeAllocationArgs = {
  input: CreateIncomeAllocationInput;
};


export type MutationCreateIncomeSourceArgs = {
  input: CreateIncomeSourceInput;
};


export type MutationCreateInsurancePolicyArgs = {
  input: CreateInsurancePolicyInput;
};


export type MutationCreateInvestmentArgs = {
  input: CreateInvestmentInput;
};


export type MutationCreateLoanArgs = {
  input: CreateLoanInput;
};


export type MutationCreateMagicNumberArgs = {
  input: CreateMagicNumberInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateNoteReceivableArgs = {
  input: CreateNoteReceivableInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePersonalPropertyItemArgs = {
  input: CreatePersonalPropertyItemInput;
};


export type MutationCreateProfessionalArgs = {
  input: CreateProfessionalInput;
};


export type MutationCreateRealEstatePropertyArgs = {
  input: CreateRealEstateInput;
};


export type MutationCreateSelfServeCheckoutSessionArgs = {
  input: CreateSelfServeCheckoutSessionInput;
};


export type MutationCreateSmartGroupArgs = {
  input: CreateSmartGroupInput;
};


export type MutationCreateSoftwareTokenSecretArgs = {
  input: CreateSoftwareTokenSecretInput;
};


export type MutationCreateSpendingCategoryEstimateArgs = {
  input: CreateSpendingCategoryEstimateInput;
};


export type MutationCreateTargetScoreRangeTemplateArgs = {
  input: CreateTargetScoreRangeTemplateInput;
};


export type MutationCreateTaxReturnSummaryArgs = {
  input: CreateTaxReturnSummaryInput;
};


export type MutationCreateTrustArgs = {
  input: CreateTrustInput;
};


export type MutationDeleteAssetLoanArgs = {
  input: DeleteAssetLoanInput;
};


export type MutationDeleteBusinessArgs = {
  input: DeleteBusinessInput;
};


export type MutationDeleteCashAccountArgs = {
  input: DeleteCashAccountInput;
};


export type MutationDeleteDataPointArgs = {
  input: DeleteDataPointInput;
};


export type MutationDeleteFileArgs = {
  input: DeleteFileInput;
};


export type MutationDeleteFileAttachmentArgs = {
  input: DeleteFileAttachmentInput;
};


export type MutationDeleteFinancialGoalArgs = {
  input: DeleteFinancialGoalInput;
};


export type MutationDeleteFinancialNextStepArgs = {
  input: DeleteFinancialNextStepInput;
};


export type MutationDeleteFirmClientGroupArgs = {
  input: DeleteFirmClientGroupInput;
};


export type MutationDeleteFirmInviteLinkArgs = {
  firmInviteLinkID: Scalars['ID'];
};


export type MutationDeleteFirmMemberArgs = {
  input: DeleteFirmMemberInput;
};


export type MutationDeleteIncomeAllocationArgs = {
  input: DeleteIncomeAllocationInput;
};


export type MutationDeleteInsurancePolicyArgs = {
  input: DeleteInsurancePolicyInput;
};


export type MutationDeleteInvestmentArgs = {
  input: DeleteInvestmentInput;
};


export type MutationDeleteInvitationArgs = {
  input?: InputMaybe<DeleteInvitationInput>;
};


export type MutationDeleteLoanArgs = {
  input: DeleteLoanInput;
};


export type MutationDeleteMagicNumberArgs = {
  input: DeleteMagicNumberInput;
};


export type MutationDeleteNoteReceivableArgs = {
  input: DeleteNoteReceivableInput;
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput;
};


export type MutationDeletePersonalPropertyItemArgs = {
  input: DeletePersonalPropertyItemInput;
};


export type MutationDeleteProfessionalArgs = {
  input: DeleteProfessionalInput;
};


export type MutationDeleteRealEstatePropertyArgs = {
  input: DeleteRealEstateInput;
};


export type MutationDeleteSmartGroupArgs = {
  input: DeleteSmartGroupInput;
};


export type MutationDeleteSpendingCategoryEstimateArgs = {
  input: DeleteSpendingCategoryEstimateInput;
};


export type MutationDeleteTargetScoreRangeTemplateArgs = {
  input: DeleteTargetScoreRangeTemplateInput;
};


export type MutationDeleteTaxReturnSummaryArgs = {
  input: DeleteTaxReturnSummaryInput;
};


export type MutationDeleteTrustArgs = {
  input: DeleteTrustInput;
};


export type MutationDisassociateSoftwareTokenArgs = {
  input: DisassociateSoftwareTokenInput;
};


export type MutationDisconnectAccountLinkingArgs = {
  input: DisconnectAccountLinking;
};


export type MutationExchangePlaidPublicTokenArgs = {
  input: ExchangePlaidPublicTokenInput;
};


export type MutationExtendedSignInArgs = {
  input: ExtendedSignInInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGeneratePlaidLinkTokenArgs = {
  input: GeneratePlaidLinkTokenInput;
};


export type MutationGetProfileImageUploadUrlArgs = {
  input: GetProfileImageUploadUrlInput;
};


export type MutationHealthcheckArgs = {
  input: Scalars['String'];
};


export type MutationInviteFirmClientArgs = {
  input: InviteFirmClientInput;
};


export type MutationLogClientSideEventArgs = {
  input: LogClientSideEventInput;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationMarkQuarterlyProgressReportReviewOpenedArgs = {
  input: MarkQuarterlyProgressReportReviewOpenedInput;
};


export type MutationMergeBusinessesArgs = {
  input: MergeBusinessesInput;
};


export type MutationMergeCashAccountsArgs = {
  input: MergeCashAccountsInput;
};


export type MutationMergeInvestmentsArgs = {
  input: MergeInvestmentsInput;
};


export type MutationMergeLoansArgs = {
  input: MergeLoansInput;
};


export type MutationMergeNoteReceivablesArgs = {
  input: MergeNoteReceivablesInput;
};


export type MutationMergePersonalPropertyItemsArgs = {
  input: MergePersonalPropertyItemsInput;
};


export type MutationMergeRealEstatesArgs = {
  input: MergeRealEstatesInput;
};


export type MutationMuteConversationArgs = {
  input: MuteOrUnmuteConversationInput;
};


export type MutationPublishAiClientSummaryArgs = {
  input: PublishAiClientSummaryInput;
};


export type MutationRefreshAiRecommendationsArgs = {
  input: RefreshAiRecommendationsInput;
};


export type MutationRefreshAiClientSummaryArgs = {
  input: RefreshAiClientSummaryInput;
};


export type MutationRefreshTokensArgs = {
  input: RefreshTokensInput;
};


export type MutationRegisterDeviceArgs = {
  input: RegisterDeviceInput;
};


export type MutationRemoveAssignedAccountArgs = {
  input: RemoveAssignedAccountInput;
};


export type MutationRemoveBaaAccountsForNetWorthItemArgs = {
  householdID: Scalars['ID'];
  mappedEntityID: Scalars['ID'];
};


export type MutationRemoveClientAccessArgs = {
  input: RemoveClientAccessInput;
};


export type MutationRemoveFeatureDiscoveryTriggerFromFirmClientArgs = {
  input: RemoveFeatureDiscoveryTriggerFromFirmClientInput;
};


export type MutationReorderFinancialGoalArgs = {
  input: ReorderFinancialGoalInput;
};


export type MutationReorderFinancialNextStepArgs = {
  input: ReorderFinancialNextStepInput;
};


export type MutationRequestQuarterlyProgressReportReviewArgs = {
  input: RequestQuarterlyProgressReportReviewInput;
};


export type MutationResendConfirmationCodeArgs = {
  input: ResendConfirmationCodeInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResetTargetScoreRangeTemplateValueArgs = {
  input: ResetTargetScoreRangeTemplateValueInput;
};


export type MutationResetTargetScoreRangeValueForClientArgs = {
  input: ResetTargetScoreRangeValueForClientInput;
};


export type MutationRespondToAuthChallengeArgs = {
  input: RespondToAuthChallengeInput;
};


export type MutationReviewQuarterlyProgressReportReviewSectionArgs = {
  input: ReviewQuarterlyProgressReportReviewSectionInput;
};


export type MutationRevokeUserAccessArgs = {
  firmID: Scalars['ID'];
  firmMemberID?: InputMaybe<Scalars['String']>;
};


export type MutationSaveEstateStatusArgs = {
  input: SaveEstateStatusInput;
};


export type MutationSaveEstateStatusFirmTemplateArgs = {
  input: SaveEstateStatusFirmTemplateInput;
};


export type MutationSendFeatureSuggestionArgs = {
  input: FeatureSuggestionInput;
};


export type MutationSignInArgs = {
  input: SignInInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationStartProspectDiscoveryArgs = {
  input: StartProspectDiscoveryInput;
};


export type MutationSwitchFirmClientModeArgs = {
  input: SwitchFirmClientModeInput;
};


export type MutationSwitchFirmClientOnboardingArgs = {
  input: SwitchFirmClientOnboardingInput;
};


export type MutationSyncExistingPlaidConnectionsArgs = {
  input: SyncExistingPlaidConnectionsInput;
};


export type MutationUnassignClientFromAnyGroupArgs = {
  input: UnassignClientFromAnyGroupInput;
};


export type MutationUpdateAiClientSummaryArgs = {
  input: UpdateAiClientSummaryInput;
};


export type MutationUpdateBusinessArgs = {
  input: UpdateBusinessInput;
};


export type MutationUpdateCashAccountArgs = {
  input: UpdateCashAccountInput;
};


export type MutationUpdateClientSmartGroupStatusArgs = {
  input: UpdateClientSmartGroupStatusInput;
};


export type MutationUpdateDataPointArgs = {
  input: UpdateDataPointInput;
};


export type MutationUpdateDataPointGroupArgs = {
  input: UpdateDataPointGroupInput;
};


export type MutationUpdateEntityIdMappingArgs = {
  input: UpdateEntityIdMappingInput;
};


export type MutationUpdateFinancialGoalArgs = {
  input: UpdateFinancialGoalInput;
};


export type MutationUpdateFinancialNextStepArgs = {
  input: UpdateFinancialNextStepInput;
};


export type MutationUpdateFirmArgs = {
  input: UpdateFirmInput;
};


export type MutationUpdateFirmClientArgs = {
  input: UpdateFirmClientInput;
};


export type MutationUpdateFirmClientGroupArgs = {
  input: UpdateFirmClientGroupInput;
};


export type MutationUpdateFirmInviteLinkArgs = {
  input: UpdateFirmInviteLinkInput;
};


export type MutationUpdateFirmMemberArgs = {
  input: UpdateFirmMemberInput;
};


export type MutationUpdateFirmMemberEmailNotificationSettingsArgs = {
  input: UpdateFirmMemberEmailNotificationSettingsInput;
};


export type MutationUpdateIncomeAllocationArgs = {
  input: UpdateIncomeAllocationInput;
};


export type MutationUpdateIncomeSourceArgs = {
  input: UpdateIncomeSourceInput;
};


export type MutationUpdateInsurancePolicyArgs = {
  input: UpdateInsurancePolicyInput;
};


export type MutationUpdateInvestmentArgs = {
  input: UpdateInvestmentInput;
};


export type MutationUpdateInvitationArgs = {
  input?: InputMaybe<UpdateInvitationInput>;
};


export type MutationUpdateLoanArgs = {
  input: UpdateLoanInput;
};


export type MutationUpdateMagicNumberArgs = {
  input: UpdateMagicNumberInput;
};


export type MutationUpdateNoteReceivableArgs = {
  input: UpdateNoteReceivableInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePersonalPropertyItemArgs = {
  input: UpdatePersonalPropertyItemInput;
};


export type MutationUpdatePlaidLinkAfterRefreshArgs = {
  input: UpdatePlaidLinkAfterRefreshInput;
};


export type MutationUpdatePrimaryHouseholdArgs = {
  input: UpdatePrimaryHouseholdInput;
};


export type MutationUpdateProfessionalArgs = {
  input: UpdateProfessionalInput;
};


export type MutationUpdateProfilePhotoArgs = {
  input: UpdateProfilePhotoInput;
};


export type MutationUpdateRealEstatePropertyArgs = {
  input: UpdateRealEstateInput;
};


export type MutationUpdateSmartGroupArgs = {
  input: UpdateSmartGroupInput;
};


export type MutationUpdateSpendingCategoryEstimateArgs = {
  input: UpdateSpendingCategoryEstimateInput;
};


export type MutationUpdateTargetScoreRangeTemplateArgs = {
  input: UpdateTargetScoreRangeTemplateInput;
};


export type MutationUpdateTargetScoreRangesForClientArgs = {
  input: UpdateTargetScoreRangesForClientInput;
};


export type MutationUpdateTaxReturnSummaryArgs = {
  input: UpdateTaxReturnSummaryInput;
};


export type MutationUpdateTrustArgs = {
  input: UpdateTrustInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

export type MuteOrUnmuteConversationInput = {
  conversationID: Scalars['ID'];
  muted: Scalars['Boolean'];
};

export type MuteOrUnmuteConversationPayload = {
  __typename?: 'MuteOrUnmuteConversationPayload';
  muted: Scalars['Boolean'];
};

export type NetWorthItem = {
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ownership: Ownership;
  updatedAt: Scalars['Time'];
};

export type NetWorthItemList = {
  __typename?: 'NetWorthItemList';
  items: Array<NetWorthItem>;
  pageInfo: PageInfo;
};

export type NoteReceivable = NetWorthItem & SynchronizedItem & {
  __typename?: 'NoteReceivable';
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type NoteReceivableList = {
  __typename?: 'NoteReceivableList';
  items: Array<NoteReceivable>;
  pageInfo: PageInfo;
};

export type Owner = {
  id: Scalars['ID'];
  ownerType: OwnerType;
};

export type OwnerInput = {
  id: Scalars['ID'];
  type: OwnerType;
};

export enum OwnerType {
  Business = 'BUSINESS',
  Person = 'PERSON'
}

export type Ownership = CommunityProperty | JointWithRightsOfSurvivorship | SoleOwnership | TenantsInCommon;

export type OwnershipInput = {
  communityProperty?: InputMaybe<CommunityPropertyInput>;
  jointWithRightsOfSurvivorship?: InputMaybe<JointWithRightsOfSurvivorshipInput>;
  soleOwnership?: InputMaybe<SoleOwnershipInput>;
  tenantsInCommon?: InputMaybe<TenantsInCommonInput>;
};

export type OwnershipInterest = {
  __typename?: 'OwnershipInterest';
  owner: Owner;
  percentage: Scalars['Float'];
};

export type OwnershipInterestInput = {
  owner: OwnerInput;
  percentage: Scalars['Float'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
};

export type Person = FirmClientIndividual & Owner & SynchronizedItem & {
  __typename?: 'Person';
  /** age is derived from the dateOfBirth and is relative to the current date. */
  age?: Maybe<Scalars['Int']>;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dateOfBirth?: Maybe<Scalars['Date']>;
  emailAddress?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  occupation?: Maybe<Scalars['String']>;
  ownerType: OwnerType;
  phoneNumber?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  relationship: RelationshipType;
  updatedAt: Scalars['Time'];
  userID?: Maybe<Scalars['String']>;
};

export type PersonList = {
  __typename?: 'PersonList';
  items: Array<Person>;
  pageInfo: PageInfo;
};

export type PersonalFinancialStatementReportData = {
  __typename?: 'PersonalFinancialStatementReportData';
  businesses: Array<ReportBusiness>;
  cashAccounts: Array<ReportCashAccount>;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  loans: Array<ReportLoan>;
  nonQualifiedInvestments: Array<ReportInvestment>;
  noteReceivables: Array<ReportNoteReceivable>;
  personalPropertyItems: Array<ReportPersonalPropertyItem>;
  privateStock: Array<ReportInvestment>;
  qualifiedInvestments: Array<ReportInvestment>;
  realEstateProperties: Array<ReportRealEstate>;
  reportDisclosureText: Scalars['String'];
  type: ReportType;
};

export type PersonalPropertyItem = NetWorthItem & SynchronizedItem & {
  __typename?: 'PersonalPropertyItem';
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type PersonalPropertyItemList = {
  __typename?: 'PersonalPropertyItemList';
  items: Array<PersonalPropertyItem>;
  pageInfo: PageInfo;
};

export type PlaidItem = SynchronizedItem & {
  __typename?: 'PlaidItem';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  institutionID: Scalars['String'];
  institutionName: Scalars['String'];
  newAccountsAvailable: Scalars['Boolean'];
  plaidItemID: Scalars['String'];
  status: MappedAccountStatus;
  updatedAt: Scalars['Time'];
};

export type PlaidItemAccountMapping = {
  __typename?: 'PlaidItemAccountMapping';
  balance?: Maybe<MonetaryAmount>;
  mappedCashAccountType?: Maybe<CashAccountType>;
  mappedEntityID?: Maybe<Scalars['String']>;
  mappedInvestmentType?: Maybe<InvestmentType>;
  mappedLoanType?: Maybe<LoanType>;
  mappedType?: Maybe<MappedEntityType>;
  mask: Scalars['String'];
  name: Scalars['String'];
  officialName: Scalars['String'];
  plaidItemAccountID: Scalars['String'];
  plaidItemID: Scalars['String'];
};

export type PlaidItemAccountMappingInput = {
  balance?: InputMaybe<MonetaryAmountInput>;
  mappedCashAccountType?: InputMaybe<CashAccountType>;
  mappedEntityID?: InputMaybe<Scalars['String']>;
  mappedInvestmentType?: InputMaybe<InvestmentType>;
  mappedLoanType?: InputMaybe<LoanType>;
  mappedType?: InputMaybe<MappedEntityType>;
  name: Scalars['String'];
  officialName: Scalars['String'];
  plaidItemAccountID: Scalars['String'];
  plaidItemID: Scalars['String'];
};

export type PlaidItemsPayload = {
  __typename?: 'PlaidItemsPayload';
  accountsMapping: Array<PlaidItemAccountMapping>;
  plaidItemID: Scalars['String'];
};

export type PlaidLinkTokenPayload = {
  __typename?: 'PlaidLinkTokenPayload';
  linkToken: Scalars['String'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Professional = SynchronizedItem & {
  __typename?: 'Professional';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  emailAddress: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  role: ProfessionalRole;
  updatedAt: Scalars['Time'];
  website?: Maybe<Scalars['String']>;
};

export type ProfessionalList = {
  __typename?: 'ProfessionalList';
  items: Array<Professional>;
  pageInfo: PageInfo;
};

export enum ProfessionalRole {
  Accountant = 'ACCOUNTANT',
  Attorney = 'ATTORNEY',
  Banker = 'BANKER',
  Bookkeeper = 'BOOKKEEPER',
  Consultant = 'CONSULTANT',
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  InsuranceAgent = 'INSURANCE_AGENT',
  LoanOfficer = 'LOAN_OFFICER',
  OfficeManager = 'OFFICE_MANAGER',
  Other = 'OTHER',
  PayrollAdministrator = 'PAYROLL_ADMINISTRATOR',
  PersonalAssistant = 'PERSONAL_ASSISTANT',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  ThirdPartyAdministrator = 'THIRD_PARTY_ADMINISTRATOR'
}

export type ProgressReportData = {
  __typename?: 'ProgressReportData';
  businesses: Array<ReportBusiness>;
  cashAccounts: Array<ReportCashAccount>;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  loans: Array<ReportLoan>;
  netWorthHistory: Array<ValueForDate>;
  nonQualifiedInvestments: Array<ReportInvestment>;
  notesReceivable: Array<ReportNoteReceivable>;
  personalPropertyItems: Array<ReportPersonalPropertyItem>;
  privateStock: Array<ReportInvestment>;
  qualifiedInvestments: Array<ReportInvestment>;
  realEstateProperties: Array<ReportRealEstate>;
  reportDisclosureText: Scalars['String'];
  type: ReportType;
};

export type PublishAiClientSummaryInput = {
  clientID: Scalars['ID'];
};

export type PublishAiClientSummaryPayload = {
  __typename?: 'PublishAiClientSummaryPayload';
  success: Scalars['Boolean'];
  versionID: Scalars['ID'];
};

export type QtDetails = {
  __typename?: 'QtDetails';
  annualExpenses: MonetaryAmount;
  otherAccounts: Array<Investment>;
  qt?: Maybe<Scalars['Float']>;
  taxDeferredAccounts: Array<Investment>;
  taxFreeAccounts: Array<Investment>;
  totalOther: MonetaryAmount;
  totalOtherSavings: RecurringTotals;
  totalRetirementAssets: MonetaryAmount;
  totalTaxDeferred: MonetaryAmount;
  totalTaxDeferredSavings: RecurringTotals;
  totalTaxFree: MonetaryAmount;
  totalTaxFreeSavings: RecurringTotals;
};

export type QualifiedTermReportData = {
  __typename?: 'QualifiedTermReportData';
  estimatedAnnualSpending: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  otherQualifiedInvestments: Array<ReportInvestment>;
  qualifiedAssetsValueHistory: Array<ValueForDate>;
  qualifiedTerm: Scalars['Float'];
  reportDisclosureText: Scalars['String'];
  taxDeferredQualifiedInvestments: Array<ReportInvestment>;
  taxFreeQualifiedInvestments: Array<ReportInvestment>;
  totalCurrentQualifiedAssets: MonetaryAmount;
  totalOwnedOtherQualifiedInvestmentsValue: MonetaryAmount;
  totalOwnedTaxDeferredQualifiedInvestmentsValue: MonetaryAmount;
  totalOwnedTaxFreeQualifiedInvestmentsValue: MonetaryAmount;
  type: ReportType;
};

export type QuarterlyProgressReportReview = {
  __typename?: 'QuarterlyProgressReportReview';
  assetsReviewedAt?: Maybe<Scalars['Time']>;
  assetsSnapshot?: Maybe<QuarterlyProgressReportReviewSectionSnapshot>;
  clientReviewCompletedAt?: Maybe<Scalars['Time']>;
  clientReviewStartedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  debtsReviewedAt?: Maybe<Scalars['Time']>;
  debtsSnapshot?: Maybe<QuarterlyProgressReportReviewSectionSnapshot>;
  firmClientID: Scalars['ID'];
  firmID: Scalars['ID'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  lastRequestedAt?: Maybe<Scalars['Time']>;
  periodEnd: Scalars['Date'];
  periodStart: Scalars['Date'];
  spendingReviewedAt?: Maybe<Scalars['Time']>;
  spendingSnapshot?: Maybe<QuarterlyProgressReportReviewSectionSnapshot>;
  status: QuarterlyProgressReportReviewStatus;
  updatedAt: Scalars['Time'];
};

export enum QuarterlyProgressReportReviewSection {
  Assets = 'ASSETS',
  Debts = 'DEBTS',
  Spending = 'SPENDING'
}

export type QuarterlyProgressReportReviewSectionSnapshot = {
  __typename?: 'QuarterlyProgressReportReviewSectionSnapshot';
  changedAccountCount: Scalars['Int'];
  currentTotal: MonetaryAmount;
  priorQuarterTotal: MonetaryAmount;
  reviewedAt: Scalars['Time'];
};

export type QuarterlyProgressReportReviewSectionSnapshotInput = {
  changedAccountCount: Scalars['Int'];
  currentTotal: MonetaryAmountInput;
  priorQuarterTotal: MonetaryAmountInput;
};

export enum QuarterlyProgressReportReviewStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type Query = {
  __typename?: 'Query';
  activeMFATypes: Array<MfaType>;
  aiClientSummary?: Maybe<AiClientSummary>;
  aiClientSummaryVersions: Array<AiClientSummaryVersion>;
  aiSuggestedGoals?: Maybe<FinancialGoalList>;
  allFinancialGoals?: Maybe<FinancialGoalList>;
  allFinancialNextSteps?: Maybe<FinancialNextStepList>;
  assetLoansForAsset: AssetLoanList;
  assetLoansForLoan: AssetLoanList;
  assignedBaaAccountsForFirm: AssignedBaaAccountList;
  assignedBaaAccountsForFirmMember: AssignedBaaAccountList;
  baaPersonForSelf?: Maybe<BaaPerson>;
  billingPortalLink?: Maybe<Scalars['String']>;
  brDetails: BrDetails;
  btDetails: BtDetails;
  burnRateReportData: BurnRateReportData;
  business?: Maybe<Business>;
  businessTermReportData: BusinessTermReportData;
  businesses: BusinessList;
  businessesForOwner: BusinessList;
  cashAccount?: Maybe<CashAccount>;
  cashAccounts: CashAccountList;
  cashAccountsForOwner: CashAccountList;
  /** Fetches the changes for a tenant. If token is nil, this filters out the deleted items. */
  changes: SynchronizedItemList;
  /** Fetches the changes for a firm. If token is nil, this filters out the deleted items. */
  changesForFirm: SynchronizedItemList;
  /** Fetches the changes for a household. If token is nil, this filters out the deleted items. */
  changesForHousehold: SynchronizedItemList;
  /** Fetches the changes for a user. If the token is nil, this filters out the deleted items. */
  changesForUser: SynchronizedItemList;
  /** Fetch all the sent invitations for any within the whole firm. */
  clientInvitationsForFirm?: Maybe<InvitationList>;
  clientSmartGroupsForFirmClient: ClientSmartGroupsForFirmClientList;
  /** Returns a conversation by either its ID or a firm client ID. One of these must be provided. */
  conversation: Conversation;
  conversations: ConversationList;
  /** Returns the current calendar-quarter review for a firm client, creating the not-started review record when one does not already exist. */
  currentQuarterlyProgressReportReview: QuarterlyProgressReportReview;
  dataPoint?: Maybe<DataPoint>;
  dataPointGroup?: Maybe<DataPointGroup>;
  /**
   * List data points for a group.
   *
   * The `from` and `to` arguments are used to filter the data points by their `dateTime` field.
   * If `from` is provided, only data points with a `dateTime` greater than or equal to `from` will be returned.
   * If `to` is provided, only data points with a `dateTime` less than or equal to `to` will be returned.
   */
  dataPointsInGroup: DataPointList;
  debtRateReportData: DebtRateReportData;
  drDetails: DrDetails;
  entityIDMapping: Array<Maybe<EntityIdMap>>;
  equityRateReportData: EquityRateReportData;
  erDetails: ErDetails;
  estateStatus?: Maybe<EstateStatus>;
  estateStatusFirmTemplate: EstateStatusFirmTemplate;
  file: File;
  fileAttachment: FileAttachment;
  fileAttachmentsForItem: FileAttachmentList;
  filesForHousehold: FileList;
  financialGoals?: Maybe<FinancialGoalList>;
  financialNextSteps?: Maybe<FinancialNextStepList>;
  firm?: Maybe<Firm>;
  firmBillingGateStatus: FirmBillingGateStatus;
  firmBranding: FirmBranding;
  firmClient?: Maybe<FirmClient>;
  firmClientForSelf: FirmClient;
  firmClientGroup?: Maybe<FirmClientGroup>;
  firmClientGroups: FirmClientGroupList;
  /**
   * List the clients the current user has access to - be it that they are the primary advisor for or are on the support
   * team for. If the user is an admin for the firm, this will return all clients for the firm.
   */
  firmClientsForFirm: FirmClientList;
  firmClientsForGroup: FirmClientList;
  /** Shorthand for just calling targetScoreRangeTemplate given a firmID and the string "defaults". */
  firmDefaultsTargetScoreRangeTemplate: TargetScoreRangeTemplate;
  firmInviteLink: FirmInviteLink;
  firmInviteLinks: FirmInviteLinkList;
  firmMemberEmailNotificationSettings: FirmMemberEmailNotificationSettings;
  firmMembersForFirm: FirmMemberList;
  firms: FirmList;
  graphDataPointsInGroup: Array<GraphPoint>;
  graphNetWorth: Array<GraphPoint>;
  healthcheck: Scalars['String'];
  households: HouseholdList;
  incomeAllocation?: Maybe<IncomeAllocation>;
  incomeAllocations?: Maybe<IncomeAllocationList>;
  incomeSource?: Maybe<IncomeSource>;
  incomeSources: IncomeSourceList;
  insurancePolicies: InsurancePolicyList;
  insurancePoliciesForOwner: InsurancePolicyList;
  insurancePolicy?: Maybe<InsurancePolicy>;
  insuranceRateReportData: InsuranceRateReportData;
  investment?: Maybe<Investment>;
  investments: InvestmentList;
  investmentsForOwner: InvestmentList;
  /** Not authenticated. Used for fetching the details of an invite prior to accepting. */
  invitation?: Maybe<Invitation>;
  latestAiClientSummaryVersion?: Maybe<AiClientSummaryVersion>;
  liquidTermReportData: LiquidTermReportData;
  loan?: Maybe<Loan>;
  loans: LoanList;
  loansForOwner: LoanList;
  ltDetails: LtDetails;
  magicNumber?: Maybe<MagicNumber>;
  magicNumbers: MagicNumberList;
  messages: MessagesList;
  minimumSupportedClientVersions: MinimumClientVersions;
  netWorthItems: NetWorthItemList;
  netWorthItemsForOwner: NetWorthItemList;
  noteReceivable?: Maybe<NoteReceivable>;
  noteReceivables: NoteReceivableList;
  noteReceivablesForOwner: NoteReceivableList;
  numberOfUnreadConversations: Scalars['Int'];
  person?: Maybe<Person>;
  personalFinancialStatementReportData: PersonalFinancialStatementReportData;
  personalPropertyItem?: Maybe<PersonalPropertyItem>;
  personalPropertyItems: PersonalPropertyItemList;
  personalPropertyItemsForOwner: PersonalPropertyItemList;
  persons: PersonList;
  primaryHousehold: Household;
  professional?: Maybe<Professional>;
  professionals: ProfessionalList;
  progressReportData: ProgressReportData;
  qtDetails: QtDetails;
  qualifiedTermReportData: QualifiedTermReportData;
  /** Returns the current calendar-quarter review for a firm client without creating one. */
  quarterlyProgressReportReview?: Maybe<QuarterlyProgressReportReview>;
  realEstateProperties: RealEstateList;
  realEstatePropertiesForOwner: RealEstateList;
  realEstateProperty?: Maybe<RealEstate>;
  realEstateTermReportData: RealEstateTermReportData;
  rtDetails: RtDetails;
  savingsRateReportData: SavingsRateReportData;
  scoreAssessmentsForFirm: ScoreAssessmentList;
  scorecard: Scorecard;
  self?: Maybe<User>;
  /** Returns the smartGroups for the clients of the current authenticated advisor. */
  smartGroup: SmartGroup;
  smartGroupsForFirm: FirmSmartGroupList;
  spendingCategoryEstimate?: Maybe<SpendingCategoryEstimate>;
  spendingCategoryEstimates: SpendingCategoryEstimateList;
  srDetails: SrDetails;
  stepFunctionExecutionStatus: Scalars['String'];
  suggestedFinancialNextSteps?: Maybe<FinancialNextStepList>;
  /** Fetches any item that resides under the tenant by ID. */
  synchronizedItem?: Maybe<SynchronizedItem>;
  /** Fetches any item that resides under the tenancy of a firm by ID. */
  synchronizedItemForFirm?: Maybe<SynchronizedItem>;
  /** Fetches any item that resides under the tenancy of a household by ID. */
  synchronizedItemForHousehold?: Maybe<SynchronizedItem>;
  /** Fetches any item that resides under the tenancy of a user by ID. */
  synchronizedItemForUser?: Maybe<SynchronizedItem>;
  /** Fetch a target score range template by ID. */
  targetScoreRangeTemplate: TargetScoreRangeTemplate;
  /** Fetch all target score range templates for a firm. If includeDefaults is true, this will include the firm defaults. */
  targetScoreRangeTemplates: TargetScoreRangeTemplateList;
  /** Fetch the target score ranges for a client. */
  targetScoreRanges: TargetScoreRangesForClientPayload;
  taxRateReportData: TaxRateReportData;
  taxReturnSummaries: TaxReturnSummaryList;
  taxReturnSummary?: Maybe<TaxReturnSummary>;
  totalTermReportData: TotalTermReportData;
  trust?: Maybe<Trust>;
  trusts: TrustList;
  trustsForOwner: TrustList;
  ttDetails: TtDetails;
  unassignedBaaAccountsForFirm: UnassignedBaaAccountList;
  unassignedBaaAccountsForFirmMember: UnassignedBaaAccountList;
};


export type QueryAiClientSummaryArgs = {
  clientID: Scalars['ID'];
};


export type QueryAiClientSummaryVersionsArgs = {
  clientID: Scalars['ID'];
};


export type QueryAiSuggestedGoalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryAllFinancialGoalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryAllFinancialNextStepsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryAssetLoansForAssetArgs = {
  assetID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryAssetLoansForLoanArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  loanID: Scalars['ID'];
};


export type QueryAssignedBaaAccountsForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryAssignedBaaAccountsForFirmMemberArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
};


export type QueryBaaPersonForSelfArgs = {
  firmID: Scalars['ID'];
};


export type QueryBillingPortalLinkArgs = {
  firmID: Scalars['ID'];
};


export type QueryBrDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryBtDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryBurnRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryBusinessArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryBusinessTermReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryBusinessesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBusinessesForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryCashAccountArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryCashAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCashAccountsForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryChangesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
};


export type QueryChangesForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  since?: InputMaybe<Scalars['ID']>;
};


export type QueryChangesForHouseholdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  since?: InputMaybe<Scalars['ID']>;
};


export type QueryChangesForUserArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  since?: InputMaybe<Scalars['ID']>;
  userID: Scalars['ID'];
};


export type QueryClientInvitationsForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryClientSmartGroupsForFirmClientArgs = {
  input: ClientSmartGroupsForFirmClientListInput;
};


export type QueryConversationArgs = {
  firmClientID?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryConversationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID?: InputMaybe<Scalars['ID']>;
};


export type QueryCurrentQuarterlyProgressReportReviewArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryDataPointArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryDataPointGroupArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryDataPointsInGroupArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  groupID: Scalars['ID'];
  tenantID: Scalars['ID'];
  to?: InputMaybe<Scalars['Date']>;
};


export type QueryDebtRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryDrDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryEntityIdMappingArgs = {
  householdID: Scalars['ID'];
};


export type QueryEquityRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryErDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryEstateStatusArgs = {
  householdID: Scalars['ID'];
};


export type QueryEstateStatusFirmTemplateArgs = {
  firmID: Scalars['ID'];
};


export type QueryFileArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryFileAttachmentArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryFileAttachmentsForItemArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryFilesForHouseholdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryFinancialGoalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryFinancialNextStepsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryFirmArgs = {
  id: Scalars['ID'];
};


export type QueryFirmBillingGateStatusArgs = {
  firmID: Scalars['ID'];
};


export type QueryFirmBrandingArgs = {
  id: Scalars['ID'];
};


export type QueryFirmClientArgs = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryFirmClientForSelfArgs = {
  firmID: Scalars['ID'];
};


export type QueryFirmClientGroupArgs = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryFirmClientGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryFirmClientsForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  mode?: InputMaybe<FirmClientMode>;
};


export type QueryFirmClientsForGroupArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  groupID: Scalars['ID'];
};


export type QueryFirmDefaultsTargetScoreRangeTemplateArgs = {
  firmID: Scalars['ID'];
};


export type QueryFirmInviteLinkArgs = {
  firmInviteLinkID: Scalars['ID'];
};


export type QueryFirmInviteLinksArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryFirmMemberEmailNotificationSettingsArgs = {
  firmMemberID: Scalars['ID'];
};


export type QueryFirmMembersForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryFirmsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
};


export type QueryGraphDataPointsInGroupArgs = {
  groupID: Scalars['ID'];
  settings?: InputMaybe<GraphSettings>;
  tenantID: Scalars['ID'];
};


export type QueryGraphNetWorthArgs = {
  householdID: Scalars['ID'];
  settings?: InputMaybe<GraphSettings>;
};


export type QueryHouseholdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
};


export type QueryIncomeAllocationArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryIncomeAllocationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryIncomeSourceArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryIncomeSourcesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryInsurancePoliciesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryInsurancePoliciesForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryInsurancePolicyArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryInsuranceRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryInvestmentArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryInvestmentsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInvestmentsForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryInvitationArgs = {
  input: GetInvitationInput;
};


export type QueryLatestAiClientSummaryVersionArgs = {
  clientID: Scalars['ID'];
};


export type QueryLiquidTermReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryLoanArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryLoansArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLoansForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryLtDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryMagicNumberArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryMagicNumbersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryMessagesArgs = {
  conversationID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
};


export type QueryNetWorthItemsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryNetWorthItemsForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryNoteReceivableArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryNoteReceivablesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNoteReceivablesForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryNumberOfUnreadConversationsArgs = {
  firmID?: InputMaybe<Scalars['ID']>;
};


export type QueryPersonArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryPersonalFinancialStatementReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryPersonalPropertyItemArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryPersonalPropertyItemsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPersonalPropertyItemsForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryPersonsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryProfessionalArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryProfessionalsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryProgressReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryQtDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryQualifiedTermReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryQuarterlyProgressReportReviewArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryRealEstatePropertiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  includeClosedAccounts?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRealEstatePropertiesForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryRealEstatePropertyArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryRealEstateTermReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryRtDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QuerySavingsRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryScoreAssessmentsForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryScorecardArgs = {
  dateTime?: InputMaybe<Scalars['Time']>;
  householdID: Scalars['ID'];
};


export type QuerySmartGroupArgs = {
  input?: InputMaybe<SmartGroupInput>;
};


export type QuerySmartGroupsForFirmArgs = {
  input?: InputMaybe<SmartGroupsForFirmInput>;
};


export type QuerySpendingCategoryEstimateArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QuerySpendingCategoryEstimatesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QuerySrDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryStepFunctionExecutionStatusArgs = {
  clientID: Scalars['ID'];
  executionArn: Scalars['String'];
};


export type QuerySuggestedFinancialNextStepsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QuerySynchronizedItemArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QuerySynchronizedItemForFirmArgs = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QuerySynchronizedItemForHouseholdArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QuerySynchronizedItemForUserArgs = {
  id: Scalars['ID'];
  userID: Scalars['ID'];
};


export type QueryTargetScoreRangeTemplateArgs = {
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryTargetScoreRangeTemplatesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  includeDefaults: Scalars['Boolean'];
};


export type QueryTargetScoreRangesArgs = {
  clientID: Scalars['ID'];
};


export type QueryTaxRateReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryTaxReturnSummariesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryTaxReturnSummaryArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryTotalTermReportDataArgs = {
  firmClientID: Scalars['ID'];
};


export type QueryTrustArgs = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryTrustsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
};


export type QueryTrustsForOwnerArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  householdID: Scalars['ID'];
  ownerID: Scalars['ID'];
};


export type QueryTtDetailsArgs = {
  householdID: Scalars['ID'];
};


export type QueryUnassignedBaaAccountsForFirmArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
};


export type QueryUnassignedBaaAccountsForFirmMemberArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  firmID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
};

export type RealEstate = NetWorthItem & SynchronizedItem & {
  __typename?: 'RealEstate';
  address?: Maybe<Address>;
  changeToken: Scalars['String'];
  closedAt?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  ownedValue: MonetaryAmount;
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  realEstateType: RealEstateType;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type RealEstateEquityLineItem = {
  __typename?: 'RealEstateEquityLineItem';
  isBusinessOwned: Scalars['Boolean'];
  loans: Array<Loan>;
  ownedDebt: MonetaryAmount;
  ownedValue: MonetaryAmount;
  realEstate: RealEstate;
  totalOwnedEquity: MonetaryAmount;
};

export type RealEstateList = {
  __typename?: 'RealEstateList';
  items: Array<RealEstate>;
  pageInfo: PageInfo;
};

export type RealEstateTermRealEstateProperty = {
  __typename?: 'RealEstateTermRealEstateProperty';
  address: Address;
  createdAt: Scalars['Time'];
  equity: MonetaryAmount;
  name: Scalars['String'];
  ownedValue: ValueForDate;
  relatedLoans: Array<ReportLoan>;
};

export type RealEstateTermReportData = {
  __typename?: 'RealEstateTermReportData';
  estimatedAnnualSpending: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  realEstateEquityHistory: Array<ValueForDate>;
  realEstateProperties: Array<RealEstateTermRealEstateProperty>;
  realEstateTerm: Scalars['Float'];
  reportDisclosureText: Scalars['String'];
  totalOwnedRealEstateDebt: MonetaryAmount;
  totalOwnedRealEstateValue: MonetaryAmount;
  totalRealEstateEquity: MonetaryAmount;
  type: ReportType;
  unattachedRealEstateLoans: Array<ReportLoan>;
};

export enum RealEstateType {
  BusinessRealEstate = 'BUSINESS_REAL_ESTATE',
  InvestmentRealEstate = 'INVESTMENT_REAL_ESTATE',
  Land = 'LAND',
  PrimaryResidence = 'PRIMARY_RESIDENCE',
  SecondHome = 'SECOND_HOME',
  Timeshare = 'TIMESHARE'
}

export enum RecurringFrequency {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Unknown = 'UNKNOWN'
}

export type RecurringMonetaryAmount = {
  __typename?: 'RecurringMonetaryAmount';
  amount: MonetaryAmount;
  frequency: RecurringFrequency;
};

export type RecurringMonetaryAmountDataPoint = DataPoint & SynchronizedItem & {
  __typename?: 'RecurringMonetaryAmountDataPoint';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: RecurringMonetaryAmountDataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type RecurringMonetaryAmountDataPointGroup = DataPointGroup & SynchronizedItem & {
  __typename?: 'RecurringMonetaryAmountDataPointGroup';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: RecurringMonetaryAmountDataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export type RecurringMonetaryAmountDataPointList = {
  __typename?: 'RecurringMonetaryAmountDataPointList';
  items: Array<RecurringMonetaryAmountDataPoint>;
  pageInfo: PageInfo;
};

export type RecurringMonetaryAmountDataPointValue = {
  __typename?: 'RecurringMonetaryAmountDataPointValue';
  value: RecurringMonetaryAmount;
};

export type RecurringMonetaryAmountDataPointValueInput = {
  value: RecurringMonetaryAmountInput;
};

export type RecurringMonetaryAmountInput = {
  amount: MonetaryAmountInput;
  frequency: RecurringFrequency;
};

export type RecurringTotals = {
  __typename?: 'RecurringTotals';
  annual: MonetaryAmount;
  monthly: MonetaryAmount;
};

export type RefreshAiRecommendationsInput = {
  firmClientID: Scalars['ID'];
};

export type RefreshAiRecommendationsPayload = {
  __typename?: 'RefreshAIRecommendationsPayload';
  executionID?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type RefreshAiClientSummaryInput = {
  clientID: Scalars['ID'];
};

export type RefreshAiClientSummaryPayload = {
  __typename?: 'RefreshAiClientSummaryPayload';
  executionID: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RefreshTokensInput = {
  refreshToken: Scalars['String'];
};

export type RefreshTokensPayload = {
  __typename?: 'RefreshTokensPayload';
  authenticationChallenge?: Maybe<AuthenticationChallenge>;
  tokenSet?: Maybe<TokenSet>;
};

export type RegisterDeviceInput = {
  deviceToken: Scalars['String'];
  platform: Platform;
};

export enum RelationshipType {
  Aunt = 'AUNT',
  Boyfriend = 'BOYFRIEND',
  Brother = 'BROTHER',
  BusinessPartner = 'BUSINESS_PARTNER',
  Child = 'CHILD',
  Cousin = 'COUSIN',
  Daughter = 'DAUGHTER',
  DivorcedHusband = 'DIVORCED_HUSBAND',
  DivorcedWife = 'DIVORCED_WIFE',
  Father = 'FATHER',
  FatherInLaw = 'FATHER_IN_LAW',
  Friend = 'FRIEND',
  Girlfriend = 'GIRLFRIEND',
  Grandchild = 'GRANDCHILD',
  Granddaughter = 'GRANDDAUGHTER',
  Grandfather = 'GRANDFATHER',
  Grandmother = 'GRANDMOTHER',
  Grandson = 'GRANDSON',
  HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
  Husband = 'HUSBAND',
  Investor = 'INVESTOR',
  Mother = 'MOTHER',
  MotherInLaw = 'MOTHER_IN_LAW',
  Nephew = 'NEPHEW',
  Niece = 'NIECE',
  Partner = 'PARTNER',
  Sister = 'SISTER',
  Son = 'SON',
  Uncle = 'UNCLE',
  Wife = 'WIFE'
}

export type RemoveAssignedAccountInput = {
  firmID: Scalars['ID'];
  firmMemberID?: InputMaybe<Scalars['ID']>;
  householdID: Scalars['ID'];
  mappedEntityID: Scalars['ID'];
};

export type RemoveAssignedAccountPayload = {
  __typename?: 'RemoveAssignedAccountPayload';
  deleted: Scalars['Boolean'];
};

export type RemoveClientAccessInput = {
  clientID: Scalars['ID'];
  personID: Scalars['ID'];
};

export type RemoveClientAccessPayload = {
  __typename?: 'RemoveClientAccessPayload';
  removed: Scalars['Boolean'];
};

export type RemoveFeatureDiscoveryTriggerFromFirmClientInput = {
  clientID: Scalars['ID'];
  featureDiscoveryTrigger: FeatureDiscoveryTrigger;
};

export type RemoveFeatureDiscoveryTriggerFromFirmClientPayload = {
  __typename?: 'RemoveFeatureDiscoveryTriggerFromFirmClientPayload';
  removed: Scalars['Boolean'];
};

export type ReorderFinancialGoalInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export type ReorderFinancialGoalPayload = {
  __typename?: 'ReorderFinancialGoalPayload';
  goals: Array<FinancialGoal>;
};

export type ReorderFinancialNextStepInput = {
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  order: Scalars['Int'];
};

export type ReorderFinancialNextStepPayload = {
  __typename?: 'ReorderFinancialNextStepPayload';
  nextSteps: Array<FinancialNextStep>;
};

export enum RepaymentType {
  IncomeBased = 'INCOME_BASED',
  Standard = 'STANDARD'
}

export type ReportBusiness = {
  __typename?: 'ReportBusiness';
  createdAt: Scalars['Time'];
  entityTaxStructure: EntityTaxStructure;
  name: Scalars['String'];
  ownedValue: ValueForDate;
};

export type ReportCashAccount = {
  __typename?: 'ReportCashAccount';
  accountType: CashAccountType;
  createdAt: Scalars['Time'];
  name: Scalars['String'];
  ownedValue: ValueForDate;
};

export type ReportCashSavingsGroup = {
  __typename?: 'ReportCashSavingsGroup';
  annualContributions: MonetaryAmount;
  items: Array<ReportCashSavingsItem>;
};

export type ReportCashSavingsItem = {
  __typename?: 'ReportCashSavingsItem';
  cashAccountType: CashAccountType;
  contributions: RecurringMonetaryAmount;
  name: Scalars['String'];
  ownedBalance: ValueForDate;
};

export type ReportFirmBranding = {
  __typename?: 'ReportFirmBranding';
  color: Scalars['String'];
  logoURL?: Maybe<Scalars['String']>;
};

export type ReportFirmClientIndividual = {
  __typename?: 'ReportFirmClientIndividual';
  emailAddress?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
};

export type ReportInvestment = {
  __typename?: 'ReportInvestment';
  createdAt: Scalars['Time'];
  investmentType: InvestmentType;
  name: Scalars['String'];
  ownedValue: ValueForDate;
};

export type ReportInvestmentSavingsGroup = {
  __typename?: 'ReportInvestmentSavingsGroup';
  annualContributions: MonetaryAmount;
  items: Array<ReportInvestmentSavingsItem>;
};

export type ReportInvestmentSavingsItem = {
  __typename?: 'ReportInvestmentSavingsItem';
  contributions: RecurringMonetaryAmount;
  investmentAccountType: InvestmentType;
  name: Scalars['String'];
  ownedBalance: ValueForDate;
};

export type ReportLoan = {
  __typename?: 'ReportLoan';
  balloonPaymentDate?: Maybe<Scalars['Time']>;
  createdAt: Scalars['Time'];
  extraPayments?: Maybe<RecurringMonetaryAmount>;
  interestRateType?: Maybe<InterestRateType>;
  latestInterestRate?: Maybe<Scalars['Float']>;
  loanType: LoanType;
  maturityDate?: Maybe<Scalars['Time']>;
  name: Scalars['String'];
  ownedBalance?: Maybe<ValueForDate>;
  paymentDetails?: Maybe<ReportLoanPaymentDetails>;
};

export type ReportLoanPaymentDetails = {
  __typename?: 'ReportLoanPaymentDetails';
  frequency: RecurringFrequency;
  paymentValue: MonetaryAmount;
};

export type ReportLoanSummaryByGroup = {
  __typename?: 'ReportLoanSummaryByGroup';
  annualDebtPayments?: Maybe<MonetaryAmount>;
  balance?: Maybe<MonetaryAmount>;
  count: Scalars['Long'];
  loanGroup: LoanGroup;
};

export type ReportNoteReceivable = {
  __typename?: 'ReportNoteReceivable';
  createdAt: Scalars['Time'];
  name: Scalars['String'];
  ownedValue: ValueForDate;
};

export type ReportPersonalPropertyItem = {
  __typename?: 'ReportPersonalPropertyItem';
  createdAt: Scalars['Time'];
  name: Scalars['String'];
  ownedValue: ValueForDate;
};

export type ReportRealEstate = {
  __typename?: 'ReportRealEstate';
  createdAt: Scalars['Time'];
  name: Scalars['String'];
  ownedValue: ValueForDate;
  realEstateType: RealEstateType;
};

/** Currently only used when sending client insights. As we add support for additional reports, we should add the cases here. */
export enum ReportType {
  BurnRate = 'BURN_RATE',
  BusinessTerm = 'BUSINESS_TERM',
  DebtRate = 'DEBT_RATE',
  EquityRate = 'EQUITY_RATE',
  InsuranceRate = 'INSURANCE_RATE',
  LiquidTerm = 'LIQUID_TERM',
  PersonalFinancialStatement = 'PERSONAL_FINANCIAL_STATEMENT',
  ProgressReport = 'PROGRESS_REPORT',
  QualifiedTerm = 'QUALIFIED_TERM',
  RealEstateTerm = 'REAL_ESTATE_TERM',
  SavingsRate = 'SAVINGS_RATE',
  TaxRate = 'TAX_RATE',
  TotalTerm = 'TOTAL_TERM'
}

export type RequestQuarterlyProgressReportReviewInput = {
  firmClientID: Scalars['ID'];
};

export type RequestQuarterlyProgressReportReviewPayload = {
  __typename?: 'RequestQuarterlyProgressReportReviewPayload';
  created: Scalars['Boolean'];
  eligibleRecipientCount: Scalars['Int'];
  emailNotificationRequestCount: Scalars['Int'];
  pushNotificationRequestCount: Scalars['Int'];
  review: QuarterlyProgressReportReview;
};

export type ResendConfirmationCodeInput = {
  email: Scalars['String'];
};

export type ResendEmailVerificationInput = {
  email: Scalars['String'];
};

export type ResetTargetScoreRangeTemplateValueInput = {
  firmID: Scalars['ID'];
  templateID: Scalars['ID'];
  value: TargetScoreRangeValueType;
};

export type ResetTargetScoreRangeTemplateValuePayload = {
  __typename?: 'ResetTargetScoreRangeTemplateValuePayload';
  template: TargetScoreRangeTemplate;
};

export type ResetTargetScoreRangeValueForClientInput = {
  clientID: Scalars['ID'];
  value: TargetScoreRangeValueType;
};

export type RespondToAuthChallengeInput = {
  challenge: AuthenticationChallengeType;
  responses: Array<AuthenticationChallengeResponse>;
  session: Scalars['String'];
};

export type RespondToAuthChallengePayload = SignedInUserData & {
  __typename?: 'RespondToAuthChallengePayload';
  authenticationChallenge?: Maybe<AuthenticationChallenge>;
  firms?: Maybe<FirmList>;
  primaryHousehold?: Maybe<Household>;
  tokenSet?: Maybe<TokenSet>;
  user?: Maybe<User>;
};

export type ReviewQuarterlyProgressReportReviewSectionInput = {
  firmClientID: Scalars['ID'];
  section: QuarterlyProgressReportReviewSection;
  snapshot: QuarterlyProgressReportReviewSectionSnapshotInput;
};

export type ReviewQuarterlyProgressReportReviewSectionPayload = {
  __typename?: 'ReviewQuarterlyProgressReportReviewSectionPayload';
  review: QuarterlyProgressReportReview;
};

export type RevokeUserAccessPayload = {
  __typename?: 'RevokeUserAccessPayload';
  revoked: Scalars['Boolean'];
};

export type RtDetails = {
  __typename?: 'RtDetails';
  annualExpenses: MonetaryAmount;
  realEstate: Array<RealEstateEquityLineItem>;
  rt?: Maybe<Scalars['Float']>;
  totalRealEstateDebt: MonetaryAmount;
  totalRealEstateEquity: MonetaryAmount;
  totalRealEstateValue: MonetaryAmount;
  totalUnattachedLoans: MonetaryAmount;
  unattachedLoans: Array<Loan>;
};

export type SaveEstateStatusAttachmentLinkInput = {
  fileName: Scalars['String'];
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type SaveEstateStatusChecklistItemInput = {
  attachmentLinks: Array<SaveEstateStatusAttachmentLinkInput>;
  id: Scalars['ID'];
  lastReviewedAt?: InputMaybe<Scalars['Time']>;
  note: Scalars['String'];
  state: EstateStatusItemState;
};

export type SaveEstateStatusFirmTemplateChecklistItemInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
  weight: Scalars['Float'];
};

export type SaveEstateStatusFirmTemplateInput = {
  changeToken: Scalars['String'];
  checklist: Array<SaveEstateStatusFirmTemplateChecklistItemInput>;
  firmID: Scalars['ID'];
};

export type SaveEstateStatusFirmTemplatePayload = {
  __typename?: 'SaveEstateStatusFirmTemplatePayload';
  template: EstateStatusFirmTemplate;
};

export type SaveEstateStatusInput = {
  changeToken: Scalars['String'];
  checklist: Array<SaveEstateStatusChecklistItemInput>;
  householdID: Scalars['ID'];
};

export type SaveEstateStatusPayload = {
  __typename?: 'SaveEstateStatusPayload';
  estateStatus: EstateStatus;
};

export type SavingsRateReportData = {
  __typename?: 'SavingsRateReportData';
  afterTaxSavings: ReportInvestmentSavingsGroup;
  cashSavings: ReportCashSavingsGroup;
  educationSavings: ReportInvestmentSavingsGroup;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  householdIncome: MonetaryAmount;
  preTaxSavings: ReportInvestmentSavingsGroup;
  reportDisclosureText: Scalars['String'];
  savingsRate: Scalars['Float'];
  totalAnnualSavings: MonetaryAmount;
  type: ReportType;
};

export type ScoreAssessment = {
  __typename?: 'ScoreAssessment';
  annualDebtPayments: MonetaryAmount;
  annualExpenses: MonetaryAmount;
  annualIncome: MonetaryAmount;
  annualSavings: MonetaryAmount;
  businessEquity: MonetaryAmount;
  disabilityCoverages: Array<ScoreAssessmentInsuranceRateCoverage>;
  firmClient: FirmClient;
  liabilityCoverages: ScoreAssessmentInsuranceRateCoverage;
  lifeCoverages: Array<ScoreAssessmentInsuranceRateCoverage>;
  liquidity: MonetaryAmount;
  netWorth: MonetaryAmount;
  qualifiedAssets: MonetaryAmount;
  realEstateEquity: MonetaryAmount;
  scorecard: ScorecardScores;
  taxInfo?: Maybe<ScoreAssessmentTaxInfo>;
};

export type ScoreAssessmentInsuranceRateCoverage = {
  __typename?: 'ScoreAssessmentInsuranceRateCoverage';
  overallCoverage: Scalars['Float'];
  person?: Maybe<ScoreAssessmentPerson>;
};

export type ScoreAssessmentList = {
  __typename?: 'ScoreAssessmentList';
  items: Array<ScoreAssessment>;
  pageInfo: PageInfo;
};

export type ScoreAssessmentPerson = {
  __typename?: 'ScoreAssessmentPerson';
  givenName: Scalars['String'];
};

export type ScoreAssessmentTaxInfo = {
  __typename?: 'ScoreAssessmentTaxInfo';
  mostRecentTaxYear: Scalars['Int'];
  taxedIncome: MonetaryAmount;
  taxesPaid: MonetaryAmount;
};

export type Scorecard = {
  __typename?: 'Scorecard';
  annualDebtPayments: MonetaryAmount;
  annualExpenses: MonetaryAmount;
  annualIncome: MonetaryAmount;
  annualSavings: MonetaryAmount;
  br?: Maybe<Scalars['Float']>;
  bt?: Maybe<Scalars['Float']>;
  businessEquity: MonetaryAmount;
  /** DEPRECATED. Use disabilityCoverages instead. */
  disabilityCoverage?: Maybe<Scalars['Float']>;
  disabilityCoverages: Array<InsuranceRateCoverage>;
  dr?: Maybe<Scalars['Float']>;
  equityMix: MonetaryAmount;
  er?: Maybe<Scalars['Float']>;
  es?: Maybe<Scalars['Float']>;
  investmentsAndCash: MonetaryAmount;
  ir?: Maybe<Scalars['Float']>;
  /** DEPRECATED. Use liabilityCoverages instead. */
  liabilityCoverage?: Maybe<Scalars['Float']>;
  liabilityCoverages: InsuranceRateCoverage;
  lifeAdjustedNetWorth: MonetaryAmount;
  /** DEPRECATED. Use lifeCoverages instead. */
  lifeCoverage?: Maybe<Scalars['Float']>;
  lifeCoverages: Array<InsuranceRateCoverage>;
  liquidity: MonetaryAmount;
  lt?: Maybe<Scalars['Float']>;
  mostRecentTaxYear: Scalars['Int'];
  mostRecentTaxedIncome: MonetaryAmount;
  mostRecentTaxesPaid: MonetaryAmount;
  netWorth: MonetaryAmount;
  newIr?: Maybe<Scalars['Float']>;
  primaryResidenceRealEstateEquity: MonetaryAmount;
  qt?: Maybe<Scalars['Float']>;
  qualifiedAssets: MonetaryAmount;
  realEstateEquity: MonetaryAmount;
  rt?: Maybe<Scalars['Float']>;
  sr?: Maybe<Scalars['Float']>;
  tr?: Maybe<Scalars['Float']>;
  tt?: Maybe<Scalars['Float']>;
};

export type ScorecardScores = {
  __typename?: 'ScorecardScores';
  br?: Maybe<Scalars['Float']>;
  bt?: Maybe<Scalars['Float']>;
  dr?: Maybe<Scalars['Float']>;
  er?: Maybe<Scalars['Float']>;
  ir?: Maybe<Scalars['Float']>;
  lt?: Maybe<Scalars['Float']>;
  qt?: Maybe<Scalars['Float']>;
  rt?: Maybe<Scalars['Float']>;
  sr?: Maybe<Scalars['Float']>;
  tr?: Maybe<Scalars['Float']>;
  tt?: Maybe<Scalars['Float']>;
};

export enum SelfDirectedOnboardingStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum SelfServeCheckoutOffer {
  RetailStarting = 'RETAIL_STARTING',
  XypnStarting = 'XYPN_STARTING'
}

export type SelfServeCheckoutSessionPayload = {
  __typename?: 'SelfServeCheckoutSessionPayload';
  checkoutSessionID: Scalars['String'];
  url: Scalars['String'];
};

export type SignInInput = {
  password: Scalars['String'];
  usernameOrEmail: Scalars['String'];
};

export type SignInPayload = SignedInUserData & {
  __typename?: 'SignInPayload';
  authenticationChallenge?: Maybe<AuthenticationChallenge>;
  firms?: Maybe<FirmList>;
  primaryHousehold?: Maybe<Household>;
  tokenSet?: Maybe<TokenSet>;
  user?: Maybe<User>;
};

export type SignUpInput = {
  email: Scalars['String'];
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SignUpPayload = SignedInUserData & {
  __typename?: 'SignUpPayload';
  firms: FirmList;
  primaryHousehold: Household;
  tokenSet: TokenSet;
  user: User;
};

export type SignedInUserData = {
  firms?: Maybe<FirmList>;
  primaryHousehold?: Maybe<Household>;
  user?: Maybe<User>;
};

export type SinglePlaidItemAccountInput = {
  mappedCashAccountType?: InputMaybe<CashAccountType>;
  mappedEntityID: Scalars['ID'];
  mappedInvestmentType?: InputMaybe<InvestmentType>;
  mappedLoanType?: InputMaybe<LoanType>;
  mappedType?: InputMaybe<MappedEntityType>;
  plaidAccountName: Scalars['String'];
  plaidAccountOfficialName: Scalars['String'];
  plaidItemAccountID: Scalars['String'];
};

export type SmartGroup = {
  __typename?: 'SmartGroup';
  firmClients: Array<FirmClient>;
  firmID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  smartGroupCriteria: Array<SmartGroupCriteriaToken>;
};

export enum SmartGroupAssessmentCriteriaOperator {
  Equals = 'EQUALS',
  GreaterEquals = 'GREATER_EQUALS',
  GreaterThan = 'GREATER_THAN',
  LessEquals = 'LESS_EQUALS',
  LessThan = 'LESS_THAN',
  NotEquals = 'NOT_EQUALS'
}

export enum SmartGroupComparisonData {
  Age = 'AGE',
  Br = 'BR',
  Bt = 'BT',
  Dr = 'DR',
  Er = 'ER',
  FirmClientMode = 'FIRM_CLIENT_MODE',
  HouseholdHealth = 'HOUSEHOLD_HEALTH',
  Income = 'INCOME',
  Ir = 'IR',
  Lt = 'LT',
  NetWorth = 'NET_WORTH',
  Qt = 'QT',
  Rt = 'RT',
  Sr = 'SR',
  Tr = 'TR',
  Tt = 'TT'
}

export type SmartGroupCriteriaComparator = {
  __typename?: 'SmartGroupCriteriaComparator';
  comparisonData?: Maybe<SmartGroupComparisonData>;
  firmClientModeValue?: Maybe<FirmClientMode>;
  floatValue?: Maybe<Scalars['Float']>;
  householdHealthValue?: Maybe<FinancialCategory>;
  monetaryAmountInCents?: Maybe<Scalars['Int']>;
};

export type SmartGroupCriteriaComparatorInput = {
  comparisonData?: InputMaybe<SmartGroupComparisonData>;
  firmClientModeValue?: InputMaybe<FirmClientMode>;
  floatValue?: InputMaybe<Scalars['Float']>;
  householdHealthValue?: InputMaybe<FinancialCategory>;
  monetaryAmountInCents?: InputMaybe<Scalars['Int']>;
};

export type SmartGroupCriteriaToken = {
  __typename?: 'SmartGroupCriteriaToken';
  type: SmartGroupCriteriaTokenType;
  value: SmartGroupCriteriaTokenValue;
};

export type SmartGroupCriteriaTokenInput = {
  type: SmartGroupCriteriaTokenType;
  value: SmartGroupCriteriaTokenValueInput;
};

export enum SmartGroupCriteriaTokenType {
  DataComparison = 'DATA_COMPARISON',
  LogicOperator = 'LOGIC_OPERATOR'
}

export type SmartGroupCriteriaTokenValue = {
  __typename?: 'SmartGroupCriteriaTokenValue';
  dataComparison?: Maybe<SmartGroupDataComparisonTokenValue>;
  logicOperator?: Maybe<SmartGroupLogicOperators>;
};

export type SmartGroupCriteriaTokenValueInput = {
  dataComparison?: InputMaybe<SmartGroupDataComparisonTokenValueInput>;
  logicOperator?: InputMaybe<SmartGroupLogicOperators>;
};

export type SmartGroupDataComparisonTokenValue = {
  __typename?: 'SmartGroupDataComparisonTokenValue';
  comparator: SmartGroupCriteriaComparator;
  comparisonData: SmartGroupComparisonData;
  operator: SmartGroupAssessmentCriteriaOperator;
};

export type SmartGroupDataComparisonTokenValueInput = {
  comparator: SmartGroupCriteriaComparatorInput;
  comparisonData: SmartGroupComparisonData;
  operator: SmartGroupAssessmentCriteriaOperator;
};

export type SmartGroupInput = {
  firmID: Scalars['ID'];
  smartGroupID: Scalars['ID'];
};

export enum SmartGroupLogicOperators {
  And = 'AND',
  CloseParentheses = 'CLOSE_PARENTHESES',
  Not = 'NOT',
  OpenParentheses = 'OPEN_PARENTHESES',
  Or = 'OR',
  Xor = 'XOR'
}

export type SmartGroupsForFirmInput = {
  firmID: Scalars['ID'];
};

export enum SoftwareTokenFriendlyDeviceNameType {
  GoogleAuthenticator = 'GOOGLE_AUTHENTICATOR',
  Icloud = 'ICLOUD',
  LastPass = 'LAST_PASS',
  MicrosoftAuthenticator = 'MICROSOFT_AUTHENTICATOR',
  OktaVerify = 'OKTA_VERIFY',
  OnePassword = 'ONE_PASSWORD',
  Other = 'OTHER',
  TwilioAuthy = 'TWILIO_AUTHY'
}

export type SoleOwnership = {
  __typename?: 'SoleOwnership';
  owner: Owner;
};

export type SoleOwnershipInput = {
  owner: OwnerInput;
};

export type SpendingCategoryEstimate = SynchronizedItem & {
  __typename?: 'SpendingCategoryEstimate';
  categoryEstimates: Array<CategoryEstimate>;
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dateTime: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  notes: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export enum SpendingCategoryEstimateCategory {
  BasicHousing = 'BASIC_HOUSING',
  Charity = 'CHARITY',
  Education = 'EDUCATION',
  Food = 'FOOD',
  Fun = 'FUN',
  HousingUpkeep = 'HOUSING_UPKEEP',
  InsurancePolicy = 'INSURANCE_POLICY',
  NonHousingDebt = 'NON_HOUSING_DEBT',
  Utilities = 'UTILITIES',
  Vehicle = 'VEHICLE',
  WellnessCare = 'WELLNESS_CARE'
}

export type SpendingCategoryEstimateList = {
  __typename?: 'SpendingCategoryEstimateList';
  items: Array<SpendingCategoryEstimate>;
  pageInfo: PageInfo;
};

export type SpendingChangeLineItem = {
  __typename?: 'SpendingChangeLineItem';
  dataPointGroupID: Scalars['ID'];
  dataPointID: Scalars['ID'];
  dateTime: Scalars['Time'];
  monthlyAmount: MonetaryAmount;
};

export type SrDetails = {
  __typename?: 'SrDetails';
  afterTaxSavings: Array<Investment>;
  annualIncome: MonetaryAmount;
  annualSavings: MonetaryAmount;
  cashSavings: Array<CashAccount>;
  educationSavings: Array<Investment>;
  preTaxSavings: Array<Investment>;
  sr?: Maybe<Scalars['Float']>;
  totalAfterTaxSavings: RecurringTotals;
  totalCashSavings: RecurringTotals;
  totalEducationSavings: RecurringTotals;
  totalPreTaxSavings: RecurringTotals;
};

export type StartProspectDiscoveryInput = {
  invitationID: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
};

export type StartProspectDiscoveryPayload = {
  __typename?: 'StartProspectDiscoveryPayload';
  tokenSet: TokenSet;
};

export type StringDataPoint = DataPoint & SynchronizedItem & {
  __typename?: 'StringDataPoint';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  data: StringDataPointValue;
  dateTime: Scalars['Time'];
  groupID: Scalars['ID'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type StringDataPointGroup = DataPointGroup & SynchronizedItem & {
  __typename?: 'StringDataPointGroup';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  dataPoints: StringDataPointList;
  id: Scalars['ID'];
  latestDataPoint?: Maybe<DataPoint>;
  parentEntityID?: Maybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Time'];
  valueExpirationExtension: Scalars['Float'];
};

export type StringDataPointList = {
  __typename?: 'StringDataPointList';
  items: Array<StringDataPoint>;
  pageInfo: PageInfo;
};

export type StringDataPointValue = {
  __typename?: 'StringDataPointValue';
  value: Scalars['String'];
};

export type StringDataPointValueInput = {
  value: Scalars['String'];
};

export type SwitchFirmClientModeInput = {
  clientID: Scalars['ID'];
  mode: FirmClientMode;
};

export type SwitchFirmClientOnboardingInput = {
  clientID: Scalars['ID'];
  onboardingProcess: FirmClientOnboardingProcess;
};

export type SyncExistingPlaidConnectionsInput = {
  accessToken: Scalars['String'];
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
  institutionID: Scalars['String'];
  institutionName: Scalars['String'];
  plaidItemAccounts: Array<SinglePlaidItemAccountInput>;
};

export type SynchronizedItem = {
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  id: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

export type SynchronizedItemList = {
  __typename?: 'SynchronizedItemList';
  items: Array<SynchronizedItem>;
  pageInfo: PageInfo;
};

export type TargetScoreRange = {
  __typename?: 'TargetScoreRange';
  customized: Scalars['Boolean'];
  /** Only populated if customized is true and this is for clients. Does not apply to templates. */
  customizedAt?: Maybe<Scalars['Time']>;
  range?: Maybe<FloatRange>;
  resetsTo?: Maybe<FloatRange>;
};

export type TargetScoreRangeOverrides = {
  __typename?: 'TargetScoreRangeOverrides';
  br?: Maybe<FloatRange>;
  bt35To44?: Maybe<FloatRange>;
  bt45To54?: Maybe<FloatRange>;
  bt55To64?: Maybe<FloatRange>;
  bt65AndOver?: Maybe<FloatRange>;
  btUnder35?: Maybe<FloatRange>;
  dr?: Maybe<FloatRange>;
  er35To44?: Maybe<FloatRange>;
  er45To54?: Maybe<FloatRange>;
  er55To64?: Maybe<FloatRange>;
  er65AndOver?: Maybe<FloatRange>;
  erUnder35?: Maybe<FloatRange>;
  es?: Maybe<FloatRange>;
  ir?: Maybe<FloatRange>;
  lt?: Maybe<FloatRange>;
  qt35To44?: Maybe<FloatRange>;
  qt45To54?: Maybe<FloatRange>;
  qt55To64?: Maybe<FloatRange>;
  qt65AndOver?: Maybe<FloatRange>;
  qtUnder35?: Maybe<FloatRange>;
  rt35To44?: Maybe<FloatRange>;
  rt45To54?: Maybe<FloatRange>;
  rt55To64?: Maybe<FloatRange>;
  rt65AndOver?: Maybe<FloatRange>;
  rtUnder35?: Maybe<FloatRange>;
  sr?: Maybe<FloatRange>;
  tr?: Maybe<FloatRange>;
  tt35To44?: Maybe<FloatRange>;
  tt45To54?: Maybe<FloatRange>;
  tt55To64?: Maybe<FloatRange>;
  tt65AndOver?: Maybe<FloatRange>;
  ttUnder35?: Maybe<FloatRange>;
};

export type TargetScoreRangeTemplate = {
  __typename?: 'TargetScoreRangeTemplate';
  createdAt: Scalars['Time'];
  derivedRanges: TargetScoreRanges;
  /** Shorthand for checking the id to see if it matches "defaults". */
  firmDefaults: Scalars['Boolean'];
  firmID: Scalars['ID'];
  /**
   * The ID of the template. If this template was created by a member of a firm, this
   * should be a unique ID (a ULID). If this template is the firm defaults, this will
   * just be the string "defaults".
   */
  id: Scalars['ID'];
  name: Scalars['String'];
  overrides: TargetScoreRangeOverrides;
  updatedAt: Scalars['Time'];
};

export type TargetScoreRangeTemplateList = {
  __typename?: 'TargetScoreRangeTemplateList';
  items: Array<TargetScoreRangeTemplate>;
  pageInfo: PageInfo;
};

export enum TargetScoreRangeValueType {
  Br = 'BR',
  Bt_35To_44 = 'BT_35_TO_44',
  Bt_45To_54 = 'BT_45_TO_54',
  Bt_55To_64 = 'BT_55_TO_64',
  Bt_65AndOver = 'BT_65_AND_OVER',
  BtUnder_35 = 'BT_UNDER_35',
  Dr = 'DR',
  Er_35To_44 = 'ER_35_TO_44',
  Er_45To_54 = 'ER_45_TO_54',
  Er_55To_64 = 'ER_55_TO_64',
  Er_65AndOver = 'ER_65_AND_OVER',
  ErUnder_35 = 'ER_UNDER_35',
  Es = 'ES',
  Ir = 'IR',
  Lt = 'LT',
  Qt_35To_44 = 'QT_35_TO_44',
  Qt_45To_54 = 'QT_45_TO_54',
  Qt_55To_64 = 'QT_55_TO_64',
  Qt_65AndOver = 'QT_65_AND_OVER',
  QtUnder_35 = 'QT_UNDER_35',
  Rt_35To_44 = 'RT_35_TO_44',
  Rt_45To_54 = 'RT_45_TO_54',
  Rt_55To_64 = 'RT_55_TO_64',
  Rt_65AndOver = 'RT_65_AND_OVER',
  RtUnder_35 = 'RT_UNDER_35',
  Sr = 'SR',
  Tr = 'TR',
  Tt_35To_44 = 'TT_35_TO_44',
  Tt_45To_54 = 'TT_45_TO_54',
  Tt_55To_64 = 'TT_55_TO_64',
  Tt_65AndOver = 'TT_65_AND_OVER',
  TtUnder_35 = 'TT_UNDER_35'
}

export type TargetScoreRanges = {
  __typename?: 'TargetScoreRanges';
  br: TargetScoreRange;
  bt35To44: TargetScoreRange;
  bt45To54: TargetScoreRange;
  bt55To64: TargetScoreRange;
  bt65AndOver: TargetScoreRange;
  btUnder35: TargetScoreRange;
  dr: TargetScoreRange;
  er35To44: TargetScoreRange;
  er45To54: TargetScoreRange;
  er55To64: TargetScoreRange;
  er65AndOver: TargetScoreRange;
  erUnder35: TargetScoreRange;
  es: TargetScoreRange;
  ir: TargetScoreRange;
  lt: TargetScoreRange;
  qt35To44: TargetScoreRange;
  qt45To54: TargetScoreRange;
  qt55To64: TargetScoreRange;
  qt65AndOver: TargetScoreRange;
  qtUnder35: TargetScoreRange;
  rt35To44: TargetScoreRange;
  rt45To54: TargetScoreRange;
  rt55To64: TargetScoreRange;
  rt65AndOver: TargetScoreRange;
  rtUnder35: TargetScoreRange;
  sr: TargetScoreRange;
  tr: TargetScoreRange;
  tt35To44: TargetScoreRange;
  tt45To54: TargetScoreRange;
  tt55To64: TargetScoreRange;
  tt65AndOver: TargetScoreRange;
  ttUnder35: TargetScoreRange;
};

export type TargetScoreRangesForClientPayload = {
  __typename?: 'TargetScoreRangesForClientPayload';
  /** The template that was applied to this client. Can be either a custom template or the firm defaults. */
  appliedTemplate: TargetScoreRangeTemplate;
  /** The ranges applied for this client */
  ranges: TargetScoreRanges;
};

export type TargetScoreRangesInput = {
  br?: InputMaybe<FloatRangeInput>;
  bt35To44?: InputMaybe<FloatRangeInput>;
  bt45To54?: InputMaybe<FloatRangeInput>;
  bt55To64?: InputMaybe<FloatRangeInput>;
  bt65AndOver?: InputMaybe<FloatRangeInput>;
  btUnder35?: InputMaybe<FloatRangeInput>;
  dr?: InputMaybe<FloatRangeInput>;
  er35To44?: InputMaybe<FloatRangeInput>;
  er45To54?: InputMaybe<FloatRangeInput>;
  er55To64?: InputMaybe<FloatRangeInput>;
  er65AndOver?: InputMaybe<FloatRangeInput>;
  erUnder35?: InputMaybe<FloatRangeInput>;
  es?: InputMaybe<FloatRangeInput>;
  ir?: InputMaybe<FloatRangeInput>;
  lt?: InputMaybe<FloatRangeInput>;
  qt35To44?: InputMaybe<FloatRangeInput>;
  qt45To54?: InputMaybe<FloatRangeInput>;
  qt55To64?: InputMaybe<FloatRangeInput>;
  qt65AndOver?: InputMaybe<FloatRangeInput>;
  qtUnder35?: InputMaybe<FloatRangeInput>;
  rt35To44?: InputMaybe<FloatRangeInput>;
  rt45To54?: InputMaybe<FloatRangeInput>;
  rt55To64?: InputMaybe<FloatRangeInput>;
  rt65AndOver?: InputMaybe<FloatRangeInput>;
  rtUnder35?: InputMaybe<FloatRangeInput>;
  sr?: InputMaybe<FloatRangeInput>;
  tr?: InputMaybe<FloatRangeInput>;
  tt35To44?: InputMaybe<FloatRangeInput>;
  tt45To54?: InputMaybe<FloatRangeInput>;
  tt55To64?: InputMaybe<FloatRangeInput>;
  tt65AndOver?: InputMaybe<FloatRangeInput>;
  ttUnder35?: InputMaybe<FloatRangeInput>;
};

export enum TaxFilingStatus {
  HeadOfHousehold = 'HEAD_OF_HOUSEHOLD',
  MarriedFilingJointly = 'MARRIED_FILING_JOINTLY',
  MarriedFilingSeparately = 'MARRIED_FILING_SEPARATELY',
  QualifyingWidowWidower = 'QUALIFYING_WIDOW_WIDOWER',
  Single = 'SINGLE'
}

export type TaxRateHistoryItem = {
  __typename?: 'TaxRateHistoryItem';
  dateTime: Scalars['Time'];
  taxRate: Scalars['Float'];
};

export type TaxRateReportData = {
  __typename?: 'TaxRateReportData';
  federalTaxesPaid: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  reportDisclosureText: Scalars['String'];
  stateTaxesPaid: MonetaryAmount;
  taxRate: Scalars['Float'];
  /**
   * Tax Rate over time — one point per tax year on file, ordered oldest to newest.
   * Each point is the rate for that year's return (federal + state taxes paid divided
   * by income), dated to the end of the tax year (Dec 31). Empty when the client has
   * no tax return on file. Tax data is annual, so this is the data's true resolution;
   * the consumer decides how many years to show (e.g. the last five).
   */
  taxRateHistory: Array<TaxRateHistoryItem>;
  /**
   * The tax year of the most recent tax return. Null when the client has no tax
   * return on file (the rate and tax amounts are then zero).
   */
  taxYear?: Maybe<Scalars['Int']>;
  totalAnnualIncome: MonetaryAmount;
  /**
   * Total federal + state income taxes paid. Excludes payroll and AMT, which are
   * not tracked on the tax return summary.
   */
  totalAnnualTaxes: MonetaryAmount;
  type: ReportType;
};

export type TaxReturnSummary = SynchronizedItem & {
  __typename?: 'TaxReturnSummary';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  federalTaxesPaid?: Maybe<MonetaryAmount>;
  filingStatus: TaxFilingStatus;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  income: MonetaryAmount;
  notes: Scalars['String'];
  stateTaxesPaid?: Maybe<MonetaryAmount>;
  stringifiedYear: Scalars['String'];
  updatedAt: Scalars['Time'];
  year: Scalars['Int'];
};

export type TaxReturnSummaryList = {
  __typename?: 'TaxReturnSummaryList';
  items: Array<TaxReturnSummary>;
  pageInfo: PageInfo;
};

export type TenantsInCommon = {
  __typename?: 'TenantsInCommon';
  interests?: Maybe<Array<OwnershipInterest>>;
};

export type TenantsInCommonInput = {
  interests: Array<OwnershipInterestInput>;
};

export type TokenSet = {
  __typename?: 'TokenSet';
  accessToken: Scalars['String'];
  idToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export type TotalTermHistoryItem = {
  __typename?: 'TotalTermHistoryItem';
  dateTime: Scalars['Time'];
  totalTerm: Scalars['Float'];
};

export type TotalTermReportData = {
  __typename?: 'TotalTermReportData';
  businessTerm: Scalars['Float'];
  currentEstimatedAnnualSpending: MonetaryAmount;
  currentNetWorth: MonetaryAmount;
  currentTotalBusinessEquity: MonetaryAmount;
  currentTotalLiquidAssets: MonetaryAmount;
  currentTotalQualifiedAssets: MonetaryAmount;
  currentTotalRealEstateEquity: MonetaryAmount;
  firmBranding: ReportFirmBranding;
  firmClientIndividuals: Array<ReportFirmClientIndividual>;
  liquidTerm: Scalars['Float'];
  otherTotalTermItemsValue: MonetaryAmount;
  qualifiedTerm: Scalars['Float'];
  realEstateTerm: Scalars['Float'];
  reportDisclosureText: Scalars['String'];
  totalTerm: Scalars['Float'];
  totalTermHistory: Array<TotalTermHistoryItem>;
  type: ReportType;
};

export type Trust = NetWorthItem & SynchronizedItem & {
  __typename?: 'Trust';
  changeToken: Scalars['String'];
  createdAt: Scalars['Time'];
  householdID: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes: Scalars['String'];
  /** Shorthand for getting at any of the owners through any of the `ownership` union type */
  owners: Array<Owner>;
  ownership: Ownership;
  trustType: TrustType;
  updatedAt: Scalars['Time'];
  value: MonetaryAmountDataPointGroup;
};

export type TrustList = {
  __typename?: 'TrustList';
  items: Array<Trust>;
  pageInfo: PageInfo;
};

export enum TrustType {
  AssetProtection = 'ASSET_PROTECTION',
  CharitableRemainder = 'CHARITABLE_REMAINDER',
  Constructive = 'CONSTRUCTIVE',
  Generic = 'GENERIC',
  Irrevocable = 'IRREVOCABLE',
  Revocable = 'REVOCABLE',
  SpecialNeeds = 'SPECIAL_NEEDS',
  Spendthrift = 'SPENDTHRIFT',
  TaxByPass = 'TAX_BY_PASS',
  Totten = 'TOTTEN'
}

export type TtAssetSummary = {
  __typename?: 'TtAssetSummary';
  afterTaxInvestments: Array<Investment>;
  businesses: Array<Business>;
  cashAccounts: Array<CashAccount>;
  investmentRealEstate: Array<RealEstate>;
  noteReceivables: Array<NoteReceivable>;
  personalPropertyItems: Array<PersonalPropertyItem>;
  personalRealEstate: Array<RealEstate>;
  preTaxInvestments: Array<Investment>;
  totalAfterTaxInvestments: MonetaryAmount;
  totalAssets: MonetaryAmount;
  totalBusinessValue: MonetaryAmount;
  totalCashAccounts: MonetaryAmount;
  totalInvestmentRealEstateValue: MonetaryAmount;
  totalOtherAssets: MonetaryAmount;
  totalPersonalRealEstateValue: MonetaryAmount;
  totalPreTaxInvestments: MonetaryAmount;
};

export type TtDebtSummary = {
  __typename?: 'TtDebtSummary';
  businessLoans: Array<Loan>;
  investmentRealEstateLoans: Array<Loan>;
  otherDebt: Array<Loan>;
  personalRealEstateLoans: Array<Loan>;
  studentLoans: Array<Loan>;
  totalBusinessLoans: MonetaryAmount;
  totalDebt: MonetaryAmount;
  totalInvestmentRealEstateLoans: MonetaryAmount;
  totalOtherDebt: MonetaryAmount;
  totalPersonalRealEstateLoans: MonetaryAmount;
  totalStudentLoans: MonetaryAmount;
};

export type TtDetails = {
  __typename?: 'TtDetails';
  annualExpenses: MonetaryAmount;
  assetSummary: TtAssetSummary;
  debtSummary: TtDebtSummary;
  netWorth: MonetaryAmount;
  totalBusinessEquity: MonetaryAmount;
  totalLiquidAssets: MonetaryAmount;
  totalOther: MonetaryAmount;
  totalQualifiedAssets: MonetaryAmount;
  totalRealEstateEquity: MonetaryAmount;
  tt?: Maybe<Scalars['Float']>;
};

export type UnassignClientFromAnyGroupInput = {
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
};

export type UnassignClientFromAnyGroupPayload = {
  __typename?: 'UnassignClientFromAnyGroupPayload';
  unassigned: Scalars['Boolean'];
};

export type UnassignedBaaAccount = {
  __typename?: 'UnassignedBaaAccount';
  BAAFinancialProfileID: Scalars['String'];
  accountNumber?: Maybe<Scalars['String']>;
  accountType?: Maybe<BaaAccountType>;
  financialInstitutionID: Scalars['String'];
  financialInstitutionName: Scalars['String'];
  firmMemberID: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: MappedAccountStatus;
  statusErrorCode: Scalars['String'];
  updatedAt?: Maybe<Scalars['Time']>;
  value: Scalars['Float'];
};

export type UnassignedBaaAccountList = {
  __typename?: 'UnassignedBaaAccountList';
  items: Array<UnassignedBaaAccount>;
  pageInfo: PageInfo;
};

export type UpdateAiClientSummaryInput = {
  changes: AiClientSummaryChanges;
  clientID: Scalars['ID'];
};

export type UpdateAiClientSummaryPayload = {
  __typename?: 'UpdateAiClientSummaryPayload';
  aiClientSummary?: Maybe<AiClientSummary>;
};

export type UpdateBusinessInput = {
  changeToken: Scalars['String'];
  changes: UpdateBusinessPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateBusinessPartial = {
  address?: InputMaybe<AddressInput>;
  entityTaxStructure?: InputMaybe<EntityTaxStructure>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
};

export type UpdateBusinessPayload = {
  __typename?: 'UpdateBusinessPayload';
  business: Business;
};

export type UpdateCashAccountInput = {
  changeToken: Scalars['String'];
  changes: UpdateCashAccountPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateCashAccountPartial = {
  cashAccountType?: InputMaybe<CashAccountType>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
};

export type UpdateCashAccountPayload = {
  __typename?: 'UpdateCashAccountPayload';
  cashAccount: CashAccount;
};

export type UpdateClientSmartGroupStatusInput = {
  clientSmartGroupID: Scalars['ID'];
  firmClientID: Scalars['ID'];
  status: ClientSmartGroupStatus;
};

export type UpdateClientSmartGroupStatusPayload = {
  __typename?: 'UpdateClientSmartGroupStatusPayload';
  status: ClientSmartGroupStatus;
};

export type UpdateDataPointGroupInput = {
  changeToken: Scalars['String'];
  changes: UpdateDataPointGroupPartial;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type UpdateDataPointGroupPartial = {
  valueExpirationExtension?: InputMaybe<Scalars['Float']>;
};

export type UpdateDataPointGroupPayload = {
  __typename?: 'UpdateDataPointGroupPayload';
  dataPointGroup: DataPointGroup;
};

export type UpdateDataPointInput = {
  changeToken: Scalars['String'];
  changes: UpdateDataPointPartial;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type UpdateDataPointPartial = {
  data?: InputMaybe<DataPointValueInput>;
  dateTime?: InputMaybe<Scalars['Time']>;
};

export type UpdateDataPointPayload = {
  __typename?: 'UpdateDataPointPayload';
  dataPoint: DataPoint;
};

export type UpdateEntityIdMappingInput = {
  householdID: Scalars['ID'];
  mapping: Array<InputMaybe<EntityIdMapInput>>;
};

export type UpdateEntityIdMappingPayload = {
  __typename?: 'UpdateEntityIDMappingPayload';
  mapping: Array<EntityIdMap>;
};

export type UpdateFinancialGoalInput = {
  changeToken: Scalars['String'];
  changes: UpdateFinancialGoalPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateFinancialGoalPartial = {
  achieved?: InputMaybe<Scalars['Boolean']>;
  aiSuggested?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
};

export type UpdateFinancialGoalPayload = {
  __typename?: 'UpdateFinancialGoalPayload';
  financialGoal?: Maybe<FinancialGoal>;
};

export type UpdateFinancialNextStepInput = {
  changeToken: Scalars['String'];
  changes: UpdateFinancialNextStepPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateFinancialNextStepPartial = {
  aiSuggested?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  done?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateFinancialNextStepPayload = {
  __typename?: 'UpdateFinancialNextStepPayload';
  financialNextStep: FinancialNextStep;
};

export type UpdateFirmClientGroupInput = {
  changes: UpdateFirmClientGroupPartial;
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateFirmClientGroupPartial = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateFirmClientGroupPayload = {
  __typename?: 'UpdateFirmClientGroupPayload';
  firmClientGroup: FirmClientGroup;
};

export type UpdateFirmClientInput = {
  changeToken: Scalars['String'];
  changes: UpdateFirmClientPartial;
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
};

export type UpdateFirmClientPartial = {
  elementVisibilityOverrides?: InputMaybe<Array<FirmClientElementVisibilityOverrideInput>>;
  /** When populated, only these firm members receive email notifications. When empty, all are notified. */
  emailNotificationFirmMemberIds?: InputMaybe<Array<Scalars['ID']>>;
  entitlements?: InputMaybe<FirmClientEntitlementsPartial>;
  selfDirectedOnboardingStatus?: InputMaybe<SelfDirectedOnboardingStatus>;
};

export type UpdateFirmClientPayload = {
  __typename?: 'UpdateFirmClientPayload';
  firmClient: FirmClient;
};

export type UpdateFirmInput = {
  changeToken: Scalars['String'];
  changes: UpdateFirmPartial;
  id: Scalars['ID'];
};

export type UpdateFirmInviteLinkInput = {
  changeToken: Scalars['String'];
  changes: UpdateFirmInviteLinkPartial;
  id: Scalars['ID'];
};

export type UpdateFirmInviteLinkPartial = {
  campaignName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disclosure?: InputMaybe<Scalars['String']>;
  firmClientEntitlements?: InputMaybe<FirmClientEntitlementsPartial>;
  primaryAdvisorFirmMemberID?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFirmMemberEmailNotificationSettingsInput = {
  /**
   * The current changeToken. Omit (or send empty) for the first write, when the
   * member has no stored settings yet.
   */
  changeToken?: InputMaybe<Scalars['String']>;
  clientAccountDeletions: Scalars['Boolean'];
  clientActivity: Scalars['Boolean'];
  firmMemberID: Scalars['ID'];
  newClientMessages: Scalars['Boolean'];
  newClientsAndProspects: Scalars['Boolean'];
  quarterlyReviewReminders: Scalars['Boolean'];
};

export type UpdateFirmMemberEmailNotificationSettingsPayload = {
  __typename?: 'UpdateFirmMemberEmailNotificationSettingsPayload';
  emailNotificationSettings: FirmMemberEmailNotificationSettings;
};

export type UpdateFirmMemberInput = {
  changeToken: Scalars['String'];
  changes: UpdateFirmMemberPartial;
  id: Scalars['ID'];
};

export type UpdateFirmMemberPartial = {
  calendarSchedulingLink?: InputMaybe<Scalars['String']>;
  emailSignature?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<FirmMemberRole>;
};

export type UpdateFirmMemberPayload = {
  __typename?: 'UpdateFirmMemberPayload';
  firmMember: FirmMember;
};

export type UpdateFirmPartial = {
  aiDisclosureText?: InputMaybe<Scalars['String']>;
  aiPromptAugmentation?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  disableEmailNotifications?: InputMaybe<Scalars['Boolean']>;
  elementCustomizationBetaEnabled?: InputMaybe<Scalars['Boolean']>;
  elementCustomizations?: InputMaybe<Array<FirmElementCustomizationInput>>;
  emailDisclosureText?: InputMaybe<Scalars['String']>;
  estateStatusBetaEnabled?: InputMaybe<Scalars['Boolean']>;
  logoFileID?: InputMaybe<Scalars['ID']>;
  mcpBetaEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  reportDisclosureText?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FirmType>;
};

export type UpdateFirmPayload = {
  __typename?: 'UpdateFirmPayload';
  firm: Firm;
};

export type UpdateIncomeAllocationInput = {
  changeToken: Scalars['String'];
  changes: UpdateIncomeAllocationPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateIncomeAllocationPartial = {
  dateTime?: InputMaybe<Scalars['Time']>;
  debtValue?: InputMaybe<MonetaryAmountInput>;
  income?: InputMaybe<MonetaryAmountInput>;
  savingsValue?: InputMaybe<MonetaryAmountInput>;
  spendingValue?: InputMaybe<MonetaryAmountInput>;
  taxValue?: InputMaybe<MonetaryAmountInput>;
  term?: InputMaybe<IncomeAllocationTerm>;
};

export type UpdateIncomeAllocationPayload = {
  __typename?: 'UpdateIncomeAllocationPayload';
  incomeAllocation?: Maybe<IncomeAllocation>;
};

export type UpdateIncomeSourceInput = {
  changeToken: Scalars['String'];
  changes: UpdateIncomeSourcePartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateIncomeSourcePartial = {
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  omitFromScorecard?: InputMaybe<Scalars['Boolean']>;
  personID?: InputMaybe<Scalars['ID']>;
  sourceType?: InputMaybe<IncomeSourceType>;
};

export type UpdateIncomeSourcePayload = {
  __typename?: 'UpdateIncomeSourcePayload';
  incomeSource: IncomeSource;
};

export type UpdateInsurancePolicyInput = {
  changeToken: Scalars['String'];
  changes: UpdateInsurancePolicyPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateInsurancePolicyPartial = {
  coverageAmount?: InputMaybe<MonetaryAmountInput>;
  expirationDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
  policySubtype?: InputMaybe<InsurancePolicySubtype>;
  policyType?: InputMaybe<InsurancePolicyType>;
  purchasedDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateInsurancePolicyPayload = {
  __typename?: 'UpdateInsurancePolicyPayload';
  insurancePolicy: InsurancePolicy;
};

export type UpdateInvestmentInput = {
  changeToken: Scalars['String'];
  changes: UpdateInvestmentPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateInvestmentPartial = {
  incomeSourceID?: InputMaybe<Scalars['ID']>;
  investmentType?: InputMaybe<InvestmentType>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
  recurringContributionPercentageDataPointGroup?: InputMaybe<Scalars['ID']>;
};

export type UpdateInvestmentPayload = {
  __typename?: 'UpdateInvestmentPayload';
  investment: Investment;
};

export type UpdateInvitationInput = {
  email: Scalars['String'];
  invitationID: Scalars['String'];
};

export type UpdateLoanInput = {
  changeToken: Scalars['String'];
  changes: UpdateLoanPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateLoanPartial = {
  balloonPaymentDate?: InputMaybe<Scalars['Date']>;
  collateralType?: InputMaybe<CollateralType>;
  interestRateDescription?: InputMaybe<Scalars['String']>;
  interestRateType?: InputMaybe<InterestRateType>;
  loanType?: InputMaybe<LoanType>;
  maturityDate?: InputMaybe<Scalars['Date']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  originalAmount?: InputMaybe<MonetaryAmountInput>;
  originalLoanLength?: InputMaybe<Scalars['Int']>;
  originationDate?: InputMaybe<Scalars['Date']>;
  ownership?: InputMaybe<OwnershipInput>;
  repaymentType?: InputMaybe<RepaymentType>;
};

export type UpdateLoanPayload = {
  __typename?: 'UpdateLoanPayload';
  loan: Loan;
};

export type UpdateMagicNumberInput = {
  changeToken: Scalars['String'];
  changes?: InputMaybe<UpdateMagicNumberPartial>;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateMagicNumberPartial = {
  annualWithdrawalRate?: InputMaybe<Scalars['Float']>;
  averageNetWorthGrowthNeeded?: InputMaybe<MonetaryAmountInput>;
  dateTime?: InputMaybe<Scalars['Time']>;
  magicNumber?: InputMaybe<MonetaryAmountInput>;
  monthlyLivingExpenses?: InputMaybe<MonetaryAmountInput>;
  retirementAge?: InputMaybe<Scalars['Int']>;
  targetTotalTermScore?: InputMaybe<Scalars['Float']>;
};

export type UpdateMagicNumberPayload = {
  __typename?: 'UpdateMagicNumberPayload';
  magicNumber: MagicNumber;
};

export type UpdateNoteReceivableInput = {
  changeToken: Scalars['String'];
  changes: UpdateNoteReceivablePartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateNoteReceivablePartial = {
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
};

export type UpdateNoteReceivablePayload = {
  __typename?: 'UpdateNoteReceivablePayload';
  noteReceivable: NoteReceivable;
};

export type UpdatePersonInput = {
  changeToken: Scalars['String'];
  changes: UpdatePersonPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdatePersonPartial = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  occupation?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<RelationshipType>;
  userID?: InputMaybe<Scalars['String']>;
};

export type UpdatePersonPayload = {
  __typename?: 'UpdatePersonPayload';
  person: Person;
};

export type UpdatePersonalPropertyItemInput = {
  changeToken: Scalars['String'];
  changes: UpdatePersonalPropertyItemPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdatePersonalPropertyItemPartial = {
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
};

export type UpdatePersonalPropertyItemPayload = {
  __typename?: 'UpdatePersonalPropertyItemPayload';
  personalPropertyItem: PersonalPropertyItem;
};

export type UpdatePlaidLinkAfterRefreshInput = {
  appType?: InputMaybe<AppType>;
  householdID: Scalars['ID'];
  plaidItemID: Scalars['String'];
};

export type UpdatePrimaryHouseholdInput = {
  householdID: Scalars['ID'];
};

export type UpdatePrimaryHouseholdPayload = {
  __typename?: 'UpdatePrimaryHouseholdPayload';
  updated: Scalars['Boolean'];
};

export type UpdateProfessionalInput = {
  changeToken: Scalars['String'];
  changes: UpdateProfessionalPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateProfessionalPartial = {
  emailAddress?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profileImage?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<ProfessionalRole>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateProfessionalPayload = {
  __typename?: 'UpdateProfessionalPayload';
  professional: Professional;
};

export type UpdateProfilePhotoInput = {
  profilePhoto: Scalars['Upload'];
};

export type UpdateRealEstateInput = {
  changeToken: Scalars['String'];
  changes: UpdateRealEstatePartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateRealEstatePartial = {
  address?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
  realEstateType?: InputMaybe<RealEstateType>;
};

export type UpdateRealEstatePayload = {
  __typename?: 'UpdateRealEstatePayload';
  realEstate: RealEstate;
};

export type UpdateSmartGroupInput = {
  firmID: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  smartGroupCriteria?: InputMaybe<Array<SmartGroupCriteriaTokenInput>>;
  smartGroupID: Scalars['ID'];
};

export type UpdateSpendingCategoryEstimateInput = {
  changeToken: Scalars['String'];
  changes: UpdateSpendingCategoryEstimatePartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateSpendingCategoryEstimatePartial = {
  categoryEstimates?: InputMaybe<Array<CategoryEstimateInput>>;
  dateTime?: InputMaybe<Scalars['Time']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateSpendingCategoryEstimatePayload = {
  __typename?: 'UpdateSpendingCategoryEstimatePayload';
  spendingCategoryEstimate: SpendingCategoryEstimate;
};

export type UpdateTargetScoreRangeTemplateInput = {
  changes: UpdateTargetScoreRangeTemplatePartial;
  firmID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateTargetScoreRangeTemplatePartial = {
  name?: InputMaybe<Scalars['String']>;
  overrides?: InputMaybe<TargetScoreRangesInput>;
};

export type UpdateTargetScoreRangeTemplatePayload = {
  __typename?: 'UpdateTargetScoreRangeTemplatePayload';
  template: TargetScoreRangeTemplate;
};

export type UpdateTargetScoreRangesForClientInput = {
  changes: TargetScoreRangesInput;
  clientID: Scalars['ID'];
};

export type UpdateTaxReturnSummaryInput = {
  changeToken: Scalars['String'];
  changes: UpdateTaxReturnSummaryPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateTaxReturnSummaryPartial = {
  federalTaxesPaid?: InputMaybe<MonetaryAmountInput>;
  filingStatus?: InputMaybe<TaxFilingStatus>;
  income?: InputMaybe<MonetaryAmountInput>;
  notes?: InputMaybe<Scalars['String']>;
  stateTaxesPaid?: InputMaybe<MonetaryAmountInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type UpdateTaxReturnSummaryPayload = {
  __typename?: 'UpdateTaxReturnSummaryPayload';
  taxReturnSummary: TaxReturnSummary;
};

export type UpdateTrustInput = {
  changeToken: Scalars['String'];
  changes: UpdateTrustPartial;
  householdID: Scalars['ID'];
  id: Scalars['ID'];
};

export type UpdateTrustPartial = {
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<OwnershipInput>;
  trustType?: InputMaybe<TrustType>;
};

export type UpdateTrustPayload = {
  __typename?: 'UpdateTrustPayload';
  trust: Trust;
};

export type UpdateUserInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type User = UserProfile & {
  __typename?: 'User';
  createdAt: Scalars['Time'];
  dateOfBirth?: Maybe<Scalars['Date']>;
  elementsID: Scalars['String'];
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  /** DEPRECATED. Please use occupation on Person */
  profession?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  /** DEPRECATED. Please use profileImage */
  profilePhoto?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Time'];
  username: Scalars['String'];
};

export type UserProfile = {
  elementsID?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  /** DEPRECATED. Please use profileImage */
  profilePhoto?: Maybe<Scalars['String']>;
};

export type ValueForDate = {
  __typename?: 'ValueForDate';
  dateTime: Scalars['Time'];
  value: MonetaryAmount;
};

export type VerifyEmailInput = {
  code: Scalars['String'];
  /** If not provided, this mutation will expect the user to have passed an auth token where it will get the email from */
  email?: InputMaybe<Scalars['String']>;
};

export type AdvisorClientAssessmentPageQueryVariables = Exact<{
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type AdvisorClientAssessmentPageQuery = { __typename?: 'Query', firmBranding: { __typename?: 'FirmBranding', color?: string | null }, firm?: { __typename?: 'Firm', entitlements: Array<Entitlement> } | null, latestAiClientSummaryVersion?: { __typename?: 'AiClientSummaryVersion', versionID: string } | null, aiClientSummaryVersions: Array<{ __typename?: 'AiClientSummaryVersion', versionID: string, publishedAt?: any | null, modelID?: ModelId | null, publishedBy: string }>, firmMembersForFirm: { __typename?: 'FirmMemberList', items: Array<{ __typename?: 'FirmMember', id: string, userID?: string | null, givenName: string, familyName: string, profileColor: string, profileImage?: string | null }> } };

export type AdvisorClientAssessmentVersionPageQueryVariables = Exact<{
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type AdvisorClientAssessmentVersionPageQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', givenNamesDisplay: string, familyNamesDisplay: string, individuals: Array<{ __typename?: 'Person', profileImage?: string | null, profileColor?: string | null, familyName?: string | null, givenName: string }>, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean }, household?: { __typename?: 'Household', id: string } | null } | null, latestAiClientSummaryVersion?: { __typename?: 'AiClientSummaryVersion', versionID: string } | null, firmMembersForFirm: { __typename?: 'FirmMemberList', items: Array<{ __typename?: 'FirmMember', id: string, userID?: string | null, givenName: string, familyName: string, profileImage?: string | null, profileColor: string }> }, aiClientSummaryVersions: Array<{ __typename?: 'AiClientSummaryVersion', versionID: string, publishedAt?: any | null, updatedAt: any, publishedBy: string, dataConfidenceLevel?: DataConfidenceLevel | null, dataConfidenceSummary?: string | null, aiResponses: { __typename?: 'AiResponses', shortCategoryExplanation: string, strengths: Array<string>, areasForImprovement: Array<{ __typename?: 'AreaForImprovement', body: string, goalBody: string }>, elementDetails: { __typename?: 'ElementDetails', Br: string, Bt: string, Dr: string, Er: string, Ir: string, Lt: string, Qt: string, Rt: string, Sr: string, Tr: string, Tt: string } } }> };

export type AdvisorClientOptionsQueryVariables = Exact<{
  firmID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type AdvisorClientOptionsQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', changeToken: string, emailNotificationFirmMemberIds: Array<string>, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean }, group?: { __typename?: 'FirmClientGroup', id: string } | null } | null, firm?: { __typename?: 'Firm', entitlements: Array<Entitlement>, disableEmailNotifications?: boolean | null } | null, firmClientForSelf: { __typename?: 'FirmClient', id: string } };

export type UpdateFirmClientMutationVariables = Exact<{
  input: UpdateFirmClientInput;
}>;


export type UpdateFirmClientMutation = { __typename?: 'Mutation', updateFirmClient: { __typename?: 'UpdateFirmClientPayload', firmClient: { __typename?: 'FirmClient', id: string } } };

export type RefreshAiClientSummaryMutationVariables = Exact<{
  input: RefreshAiClientSummaryInput;
}>;


export type RefreshAiClientSummaryMutation = { __typename?: 'Mutation', refreshAiClientSummary: { __typename?: 'RefreshAiClientSummaryPayload', success: boolean, executionID: string } };

export type PublishAiClientSummaryMutationVariables = Exact<{
  input: PublishAiClientSummaryInput;
}>;


export type PublishAiClientSummaryMutation = { __typename?: 'Mutation', publishAiClientSummary: { __typename?: 'PublishAiClientSummaryPayload', success: boolean, versionID: string } };

export type GetAiClientSummaryQueryVariables = Exact<{
  clientID: Scalars['ID'];
}>;


export type GetAiClientSummaryQuery = { __typename?: 'Query', aiClientSummary?: { __typename?: 'AiClientSummary', updatedAt: any, dataConfidenceLevel?: DataConfidenceLevel | null, dataConfidenceSummary?: string | null, summary: string, householdCategorySummary?: string | null, shortHouseholdCategorySummary?: string | null, advisorApproved: boolean, aiResponses: { __typename?: 'AiResponses', shortCategoryExplanation: string, strengths: Array<string>, areasForImprovement: Array<{ __typename?: 'AreaForImprovement', body: string, goalBody: string }>, elementDetails: { __typename?: 'ElementDetails', Er: string, Ir: string, Sr: string, Br: string, Dr: string, Tr: string, Lt: string, Qt: string, Rt: string, Bt: string, Tt: string } } } | null };

export type GetLatestAiClientSummaryVersionQueryVariables = Exact<{
  clientID: Scalars['ID'];
}>;


export type GetLatestAiClientSummaryVersionQuery = { __typename?: 'Query', latestAiClientSummaryVersion?: { __typename?: 'AiClientSummaryVersion', versionID: string, updatedAt: any, dataConfidenceLevel?: DataConfidenceLevel | null, dataConfidenceSummary?: string | null, summary: string, householdCategorySummary?: string | null, shortHouseholdCategorySummary?: string | null, aiResponses: { __typename?: 'AiResponses', shortCategoryExplanation: string, strengths: Array<string>, areasForImprovement: Array<{ __typename?: 'AreaForImprovement', body: string, goalBody: string }>, elementDetails: { __typename?: 'ElementDetails', Er: string, Ir: string, Sr: string, Br: string, Dr: string, Tr: string, Lt: string, Qt: string, Rt: string, Bt: string, Tt: string } } } | null };

export type CreateAiFeedbackMutationVariables = Exact<{
  input: CreateAiFeedbackInput;
}>;


export type CreateAiFeedbackMutation = { __typename?: 'Mutation', createAiFeedback: { __typename?: 'CreateAiFeedbackPayload', success: boolean } };

export type UpdateAiClientSummaryMutationVariables = Exact<{
  input: UpdateAiClientSummaryInput;
}>;


export type UpdateAiClientSummaryMutation = { __typename?: 'Mutation', updateAiClientSummary: { __typename: 'UpdateAiClientSummaryPayload' } };

export type CreateAssetLoanMutationVariables = Exact<{
  input: CreateAssetLoanInput;
}>;


export type CreateAssetLoanMutation = { __typename?: 'Mutation', createAssetLoan: { __typename?: 'CreateAssetLoanPayload', assetLoan: { __typename?: 'AssetLoan', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, assetID: string, loanID: string } } };

export type AssetLoansForAssetQueryVariables = Exact<{
  householdID: Scalars['ID'];
  assetID: Scalars['ID'];
}>;


export type AssetLoansForAssetQuery = { __typename?: 'Query', assetLoansForAsset: { __typename?: 'AssetLoanList', items: Array<{ __typename?: 'AssetLoan', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, assetID: string, loanID: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type AssetLoansForLoanQueryVariables = Exact<{
  householdID: Scalars['ID'];
  loanID: Scalars['ID'];
}>;


export type AssetLoansForLoanQuery = { __typename?: 'Query', assetLoansForLoan: { __typename?: 'AssetLoanList', items: Array<{ __typename?: 'AssetLoan', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, assetID: string, loanID: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type DeleteAssetLoanMutationVariables = Exact<{
  input: DeleteAssetLoanInput;
}>;


export type DeleteAssetLoanMutation = { __typename?: 'Mutation', deleteAssetLoan: { __typename?: 'DeleteAssetLoanPayload', changeToken: string } };

export type MagicLinkMutationVariables = Exact<{
  input: BeginPasswordlessSignInInput;
}>;


export type MagicLinkMutation = { __typename?: 'Mutation', beginPasswordlessSignIn: { __typename?: 'BeginPasswordlessSignInPayload', sent: boolean } };

export type CompleteMagicLinkSignInMutationVariables = Exact<{
  input: CompletePasswordlessSignInInput;
}>;


export type CompleteMagicLinkSignInMutation = { __typename?: 'Mutation', completePasswordlessSignIn: { __typename?: 'CompletePasswordlessSignInPayload', tokenSet: { __typename?: 'TokenSet', accessToken: string, refreshToken: string, idToken: string } } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type RefreshTokensMutationVariables = Exact<{
  input: RefreshTokensInput;
}>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'RefreshTokensPayload', tokenSet?: { __typename?: 'TokenSet', accessToken: string, refreshToken: string, idToken: string } | null } };

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: boolean };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type ResendEmailVerificationMutationVariables = Exact<{
  input: ResendEmailVerificationInput;
}>;


export type ResendEmailVerificationMutation = { __typename?: 'Mutation', resendEmailVerification: boolean };

export type ActiveMfaTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveMfaTypesQuery = { __typename?: 'Query', activeMFATypes: Array<MfaType> };

export type ExtendedSignInMutationVariables = Exact<{
  input: ExtendedSignInInput;
}>;


export type ExtendedSignInMutation = { __typename?: 'Mutation', extendedSignIn: { __typename?: 'SignInPayload', user?: { __typename?: 'User', id: string, elementsID: string, username: string, givenName?: string | null, familyName?: string | null, email: string, createdAt: any } | null, tokenSet?: { __typename?: 'TokenSet', idToken: string, accessToken: string, refreshToken: string } | null, firms?: { __typename?: 'FirmList', items: Array<{ __typename?: 'Firm', id: string, entitlements: Array<Entitlement>, name: string, createdAt: any }> } | null, primaryHousehold?: { __typename?: 'Household', id: string, householdID: string, changeToken: string, firmClients?: Array<{ __typename?: 'FirmClient', id: string, firmID: string }> | null } | null, authenticationChallenge?: { __typename?: 'AuthenticationChallenge', challenge: AuthenticationChallengeType, session: string, parameters: Array<{ __typename?: 'AuthenticationChallengeParameter', key: string, value: string }> } | null } };

export type SignInMutationVariables = Exact<{
  input: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInPayload', user?: { __typename?: 'User', id: string, elementsID: string, username: string, givenName?: string | null, familyName?: string | null, email: string, createdAt: any } | null, tokenSet?: { __typename?: 'TokenSet', idToken: string, accessToken: string, refreshToken: string } | null, firms?: { __typename?: 'FirmList', items: Array<{ __typename?: 'Firm', id: string, name: string, entitlements: Array<Entitlement>, createdAt: any }> } | null, primaryHousehold?: { __typename?: 'Household', id: string, householdID: string, changeToken: string, firmClients?: Array<{ __typename?: 'FirmClient', id: string, firmID: string }> | null } | null, authenticationChallenge?: { __typename?: 'AuthenticationChallenge', challenge: AuthenticationChallengeType, session: string, parameters: Array<{ __typename?: 'AuthenticationChallengeParameter', key: string, value: string }> } | null } };

export type UnassignedBaaAccountsForFirmMemberQueryVariables = Exact<{
  firmID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
}>;


export type UnassignedBaaAccountsForFirmMemberQuery = { __typename?: 'Query', unassignedBaaAccountsForFirmMember: { __typename?: 'UnassignedBaaAccountList', items: Array<{ __typename: 'UnassignedBaaAccount', id: string, name: string, value: number, accountType?: BaaAccountType | null, updatedAt?: any | null, status: MappedAccountStatus, firmMemberID: string, statusErrorCode: string, accountNumber?: string | null, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string }> } };

export type AssignedBaaAccountsForFirmMemberQueryVariables = Exact<{
  firmID: Scalars['ID'];
  firmMemberID: Scalars['ID'];
}>;


export type AssignedBaaAccountsForFirmMemberQuery = { __typename?: 'Query', assignedBaaAccountsForFirmMember: { __typename?: 'AssignedBaaAccountList', items: Array<{ __typename: 'BaaAccount', id: string, name: string, updatedAt: any, accountType: BaaAccountType, changeToken: string, createdAt: any, firmMemberID: string, BAAAccountID: string, householdID: string, firmClientID: string, accountNumber?: string | null, mappedEntityID: string, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string, value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> } };

export type RevokeUserAccessMutationVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type RevokeUserAccessMutation = { __typename?: 'Mutation', revokeUserAccess?: { __typename?: 'RevokeUserAccessPayload', revoked: boolean } | null };

export type CreateBaaAccountMutationVariables = Exact<{
  input: CreateBaaAccountInput;
}>;


export type CreateBaaAccountMutation = { __typename?: 'Mutation', createBaaAccount: { __typename?: 'CreateBaaAccountPayload', account: { __typename: 'BaaAccount', id: string, name: string, updatedAt: any, accountType: BaaAccountType, changeToken: string, createdAt: any, firmMemberID: string, BAAAccountID: string, householdID: string, firmClientID: string, accountNumber?: string | null, mappedEntityID: string, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string, value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } };

export type RemoveAssignedAccountMutationVariables = Exact<{
  input: RemoveAssignedAccountInput;
}>;


export type RemoveAssignedAccountMutation = { __typename?: 'Mutation', removeAssignedAccount: { __typename?: 'RemoveAssignedAccountPayload', deleted: boolean } };

export type BaaPersonForSelfQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type BaaPersonForSelfQuery = { __typename?: 'Query', baaPersonForSelf?: { __typename?: 'BaaPerson', id: string } | null };

export type CreateBaaPersonMutationVariables = Exact<{
  input: CreateBaaPersonInput;
}>;


export type CreateBaaPersonMutation = { __typename?: 'Mutation', createBaaPerson: { __typename?: 'CreateBaaPersonPayload', temporaryPassword: string, baaPerson: { __typename?: 'BaaPerson', username: string } } };

export type UnassignedBaaAccountsForFirmQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type UnassignedBaaAccountsForFirmQuery = { __typename?: 'Query', unassignedBaaAccountsForFirm: { __typename?: 'UnassignedBaaAccountList', items: Array<{ __typename: 'UnassignedBaaAccount', id: string, name: string, value: number, accountType?: BaaAccountType | null, updatedAt?: any | null, status: MappedAccountStatus, firmMemberID: string, statusErrorCode: string, accountNumber?: string | null, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string }> } };

export type AssignedBaaAccountsForFirmQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type AssignedBaaAccountsForFirmQuery = { __typename?: 'Query', assignedBaaAccountsForFirm: { __typename?: 'AssignedBaaAccountList', items: Array<{ __typename: 'BaaAccount', id: string, name: string, updatedAt: any, accountType: BaaAccountType, changeToken: string, createdAt: any, firmMemberID: string, BAAAccountID: string, householdID: string, firmClientID: string, accountNumber?: string | null, mappedEntityID: string, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string, value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> } };

export type RemoveBaaAccountsForNetWorthItemMutationVariables = Exact<{
  householdID: Scalars['ID'];
  mappedEntityID: Scalars['ID'];
}>;


export type RemoveBaaAccountsForNetWorthItemMutation = { __typename?: 'Mutation', removeBAAAccountsForNetWorthItem: boolean };

export type BrDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includeAnnualIncome: Scalars['Boolean'];
  includeSpendingUpdates: Scalars['Boolean'];
  includeIncomeUpdates: Scalars['Boolean'];
  includeTotalDebtPayments: Scalars['Boolean'];
  includeEstimatedSpendingMinusDebtPayments: Scalars['Boolean'];
}>;


export type BrDetailsQuery = { __typename?: 'Query', brDetails: { __typename?: 'BrDetails', br?: number | null, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualIncome?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, spendingUpdates?: Array<{ __typename?: 'SpendingChangeLineItem', dateTime: any, dataPointID: string, dataPointGroupID: string, monthlyAmount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }>, incomeUpdates?: Array<{ __typename?: 'IncomeChangeLineItem', dateTime: any, dataPointID: string, dataPointGroupID: string, annualAmount: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, delta: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }>, totalDebtPayments?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, estimatedSpendingMinusDebtPayments?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } };

export type BtDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeTotalBusinessEquity: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includeBusinesses: Scalars['Boolean'];
  includePrivateStock: Scalars['Boolean'];
  includeTotalPrivateStock: Scalars['Boolean'];
  includeTotalBusinessValue: Scalars['Boolean'];
  includeTotalBusinessDebt: Scalars['Boolean'];
}>;


export type BtDetailsQuery = { __typename?: 'Query', btDetails: { __typename?: 'BtDetails', bt?: number | null, totalBusinessEquity?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, businesses?: Array<{ __typename?: 'BusinessEquityLineItem', business: { __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }, loans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, ownedValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedDebt: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalOwnedEquity: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedCashAccounts: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalOwnedCashAccounts: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedQualifiedInvestments: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalOwnedQualifiedInvestments: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedNonQualifiedInvestments: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalOwnedNonQualifiedInvestments: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedRealEstate: Array<{ __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalOwnedRealEstate: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }>, privateStock?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalPrivateStock?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalBusinessValue?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalBusinessDebt?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } };

export type GetBusinessesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetBusinessesQuery = { __typename?: 'Query', businesses: { __typename?: 'BusinessList', items: Array<{ __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }> } };

export type CreateBusinessMutationVariables = Exact<{
  input: CreateBusinessInput;
}>;


export type CreateBusinessMutation = { __typename?: 'Mutation', createBusiness: { __typename?: 'CreateBusinessPayload', business: { __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type DeleteBusinessMutationVariables = Exact<{
  input: DeleteBusinessInput;
}>;


export type DeleteBusinessMutation = { __typename?: 'Mutation', deleteBusiness: { __typename?: 'DeleteBusinessPayload', changeToken: string } };

export type UpdateBusinessMutationVariables = Exact<{
  input: UpdateBusinessInput;
}>;


export type UpdateBusinessMutation = { __typename?: 'Mutation', updateBusiness: { __typename?: 'UpdateBusinessPayload', business: { __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type GetBusinessQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetBusinessQuery = { __typename?: 'Query', business?: { __typename: 'Business', closedAt?: any | null, id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type CloseBusinessMutationVariables = Exact<{
  input: CloseBusinessInput;
}>;


export type CloseBusinessMutation = { __typename?: 'Mutation', closeBusiness: { __typename?: 'CloseBusinessPayload', changeToken: string } };

export type MergeBusinessesMutationVariables = Exact<{
  input: MergeBusinessesInput;
}>;


export type MergeBusinessesMutation = { __typename?: 'Mutation', mergeBusinesses: { __typename?: 'MergeBusinessesPayload', merged: boolean } };

export type GetCashAccountsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetCashAccountsQuery = { __typename?: 'Query', cashAccounts: { __typename?: 'CashAccountList', items: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }> } };

export type CreateCashAccountMutationVariables = Exact<{
  input: CreateCashAccountInput;
}>;


export type CreateCashAccountMutation = { __typename?: 'Mutation', createCashAccount: { __typename?: 'CreateCashAccountPayload', cashAccount: { __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type UpdateCashAccountMutationVariables = Exact<{
  input: UpdateCashAccountInput;
}>;


export type UpdateCashAccountMutation = { __typename?: 'Mutation', updateCashAccount: { __typename?: 'UpdateCashAccountPayload', cashAccount: { __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type DeleteCashAccountMutationVariables = Exact<{
  input: DeleteCashAccountInput;
}>;


export type DeleteCashAccountMutation = { __typename?: 'Mutation', deleteCashAccount: { __typename?: 'DeleteCashAccountPayload', changeToken: string } };

export type GetCashAccountQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCashAccountQuery = { __typename?: 'Query', cashAccount?: { __typename: 'CashAccount', closedAt?: any | null, id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } | null };

export type CloseCashAccountMutationVariables = Exact<{
  input: CloseCashAccountInput;
}>;


export type CloseCashAccountMutation = { __typename?: 'Mutation', closeCashAccount: { __typename?: 'CloseCashAccountPayload', changeToken: string } };

export type MergeCashAccountsMutationVariables = Exact<{
  input: MergeCashAccountsInput;
}>;


export type MergeCashAccountsMutation = { __typename?: 'Mutation', mergeCashAccounts: { __typename?: 'MergeCashAccountsPayload', merged: boolean } };

export type ClientClientAssessmentPageQueryVariables = Exact<{
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type ClientClientAssessmentPageQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', id: string, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean } } | null, aiClientSummary?: { __typename?: 'AiClientSummary', advisorApproved: boolean } | null };

export type ClientClientLayoutPageQueryVariables = Exact<{
  clientID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type ClientClientLayoutPageQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', id: string, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean }, team: Array<{ __typename?: 'FirmClientTeamMember', member: { __typename?: 'FirmMember', calendarSchedulingLink?: string | null, id: string } }> } | null, aiClientSummary?: { __typename?: 'AiClientSummary', advisorApproved: boolean } | null };

export type ClientDetailPageQueryVariables = Exact<{
  firmClientID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type ClientDetailPageQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', household?: { __typename?: 'Household', financialCategorization?: FinancialCategory | null } | null } | null };

export type GetFirmClientGroupsQueryVariables = Exact<{
  firmID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetFirmClientGroupsQuery = { __typename?: 'Query', firmClientGroups: { __typename?: 'FirmClientGroupList', items: Array<{ __typename?: 'FirmClientGroup', id: string, name: string, count: number, createdAt: any, updatedAt: any }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CreateFirmClientGroupMutationVariables = Exact<{
  input: CreateFirmClientGroupInput;
}>;


export type CreateFirmClientGroupMutation = { __typename?: 'Mutation', createFirmClientGroup: { __typename?: 'CreateFirmClientGroupPayload', firmClientGroup: { __typename?: 'FirmClientGroup', id: string, name: string, count: number, createdAt: any, updatedAt: any } } };

export type UpdateFirmClientGroupMutationVariables = Exact<{
  input: UpdateFirmClientGroupInput;
}>;


export type UpdateFirmClientGroupMutation = { __typename?: 'Mutation', updateFirmClientGroup: { __typename?: 'UpdateFirmClientGroupPayload', firmClientGroup: { __typename?: 'FirmClientGroup', id: string, name: string, count: number, createdAt: any, updatedAt: any } } };

export type DeleteFirmClientGroupMutationVariables = Exact<{
  input: DeleteFirmClientGroupInput;
}>;


export type DeleteFirmClientGroupMutation = { __typename?: 'Mutation', deleteFirmClientGroup: { __typename?: 'DeleteFirmClientGroupPayload', deleted: boolean } };

export type AssignClientToGroupMutationVariables = Exact<{
  input: AssignClientToGroupInput;
}>;


export type AssignClientToGroupMutation = { __typename?: 'Mutation', assignClientToGroup: { __typename?: 'AssignClientToGroupPayload', assigned: boolean } };

export type UnassignClientFromAnyGroupMutationVariables = Exact<{
  input: UnassignClientFromAnyGroupInput;
}>;


export type UnassignClientFromAnyGroupMutation = { __typename?: 'Mutation', unassignClientFromAnyGroup: { __typename?: 'UnassignClientFromAnyGroupPayload', unassigned: boolean } };

export type HouseholdFirmClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type HouseholdFirmClientsQuery = { __typename?: 'Query', primaryHousehold: { __typename?: 'Household', id: string, firmClients?: Array<{ __typename?: 'FirmClient', firmID: string, activeFeatureDiscoveryTriggers: Array<FeatureDiscoveryTrigger>, id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string, createdAt: any, updatedAt: any, dateTime: any, type: InvitationType, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, acceptedAt?: any | null, status: InvitationStatus, firmID: string, firmName: string, clientID: string, personID?: string | null, householdID?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } }>, originFirmInviteLink?: { __typename: 'FirmInviteLink', id: string, campaignName: string, title: string, changeToken: string, description: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } } | null, notes: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, household?: { __typename?: 'Household', id: string, householdID: string, ownerID: string, financialCategorization?: FinancialCategory | null, financialCategoryScore?: number | null, financialPurpose: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, income: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint' } | { __typename?: 'InvestmentMixDataPoint' } | { __typename?: 'MonetaryAmountDataPoint' } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint' } | null }, spending: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any } | { __typename?: 'InvestmentMixDataPoint', dateTime: any } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', dateTime: any } | null } } | null, individuals: Array<{ __typename?: 'Person', relationship: RelationshipType, age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, team: Array<{ __typename: 'FirmClientTeamMember', role: FirmClientTeamMemberRole, member: { __typename?: 'FirmMember', id: string, calendarSchedulingLink?: string | null, familyName: string, givenName: string, profileColor: string } }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null }> | null } };

export type FirmClientsForFirmQueryVariables = Exact<{
  firmID: Scalars['ID'];
  mode?: InputMaybe<FirmClientMode>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FirmClientsForFirmQuery = { __typename?: 'Query', firmClientsForFirm: { __typename?: 'FirmClientList', items: Array<{ __typename?: 'FirmClient', id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string }>, originFirmInviteLink?: { __typename?: 'FirmInviteLink', id: string, campaignName: string } | null, household?: { __typename?: 'Household', id: string } | null, individuals: Array<{ __typename?: 'Person', age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type FirmClientsForGroupQueryVariables = Exact<{
  firmID: Scalars['ID'];
  groupID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FirmClientsForGroupQuery = { __typename?: 'Query', firmClientsForGroup: { __typename?: 'FirmClientList', items: Array<{ __typename?: 'FirmClient', id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string }>, originFirmInviteLink?: { __typename?: 'FirmInviteLink', id: string, campaignName: string } | null, household?: { __typename?: 'Household', id: string } | null, individuals: Array<{ __typename?: 'Person', age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type FirmClientQueryVariables = Exact<{
  firmID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type FirmClientQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', aiSummary?: string | null, householdCategorySummary?: string | null, shortHouseholdCategorySummary?: string | null, aiSummaryUpdatedAt?: any | null, firmID: string, activeFeatureDiscoveryTriggers: Array<FeatureDiscoveryTrigger>, id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean }, aiResponses: { __typename?: 'AiResponses', strengths: Array<string>, areasForImprovement: Array<{ __typename?: 'AreaForImprovement', body: string, goalBody: string }> }, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string, createdAt: any, updatedAt: any, dateTime: any, type: InvitationType, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, acceptedAt?: any | null, status: InvitationStatus, firmID: string, firmName: string, clientID: string, personID?: string | null, householdID?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } }>, originFirmInviteLink?: { __typename: 'FirmInviteLink', id: string, campaignName: string, title: string, changeToken: string, description: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } } | null, notes: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, household?: { __typename?: 'Household', id: string, householdID: string, ownerID: string, financialCategorization?: FinancialCategory | null, financialCategoryScore?: number | null, financialPurpose: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, income: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint' } | { __typename?: 'InvestmentMixDataPoint' } | { __typename?: 'MonetaryAmountDataPoint' } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint' } | null }, spending: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any } | { __typename?: 'InvestmentMixDataPoint', dateTime: any } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', dateTime: any } | null } } | null, individuals: Array<{ __typename?: 'Person', relationship: RelationshipType, age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, team: Array<{ __typename: 'FirmClientTeamMember', role: FirmClientTeamMemberRole, member: { __typename?: 'FirmMember', id: string, calendarSchedulingLink?: string | null, familyName: string, givenName: string, profileColor: string } }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null } | null };

export type FirmClientFeatureAccessQueryVariables = Exact<{
  firmID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type FirmClientFeatureAccessQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', id: string, featureAccess?: { __typename?: 'FirmClientFeatureAccess', estateStatus: boolean } | null } | null };

export type FirmClientForSelfQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type FirmClientForSelfQuery = { __typename?: 'Query', firmClientForSelf: { __typename?: 'FirmClient', firmID: string, activeFeatureDiscoveryTriggers: Array<FeatureDiscoveryTrigger>, id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string, createdAt: any, updatedAt: any, dateTime: any, type: InvitationType, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, acceptedAt?: any | null, status: InvitationStatus, firmID: string, firmName: string, clientID: string, personID?: string | null, householdID?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } }>, originFirmInviteLink?: { __typename: 'FirmInviteLink', id: string, campaignName: string, title: string, changeToken: string, description: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } } | null, notes: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, household?: { __typename?: 'Household', id: string, householdID: string, ownerID: string, financialCategorization?: FinancialCategory | null, financialCategoryScore?: number | null, financialPurpose: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, income: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint' } | { __typename?: 'InvestmentMixDataPoint' } | { __typename?: 'MonetaryAmountDataPoint' } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint' } | null }, spending: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any } | { __typename?: 'InvestmentMixDataPoint', dateTime: any } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', dateTime: any } | null } } | null, individuals: Array<{ __typename?: 'Person', relationship: RelationshipType, age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, team: Array<{ __typename: 'FirmClientTeamMember', role: FirmClientTeamMemberRole, member: { __typename?: 'FirmMember', id: string, calendarSchedulingLink?: string | null, familyName: string, givenName: string, profileColor: string } }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null } };

export type SwitchFirmClientModeMutationVariables = Exact<{
  input: SwitchFirmClientModeInput;
}>;


export type SwitchFirmClientModeMutation = { __typename?: 'Mutation', switchFirmClientMode: { __typename?: 'FirmClientPayload', firmClient: { __typename?: 'FirmClient', id: string } } };

export type ArchiveFirmClientMutationVariables = Exact<{
  input: ArchiveFirmClientInput;
}>;


export type ArchiveFirmClientMutation = { __typename?: 'Mutation', archiveFirmClient: { __typename?: 'ArchiveFirmClientPayload', archived: boolean } };

export type RemoveClientAccessMutationVariables = Exact<{
  input: RemoveClientAccessInput;
}>;


export type RemoveClientAccessMutation = { __typename?: 'Mutation', removeClientAccess: { __typename?: 'RemoveClientAccessPayload', removed: boolean } };

export type RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables = Exact<{
  input: RemoveFeatureDiscoveryTriggerFromFirmClientInput;
}>;


export type RemoveFeatureDiscoveryTriggerFromFirmClientMutation = { __typename?: 'Mutation', removeFeatureDiscoveryTriggerFromFirmClient: { __typename?: 'RemoveFeatureDiscoveryTriggerFromFirmClientPayload', removed: boolean } };

export type SwitchFirmClientOnboardingMutationVariables = Exact<{
  input: SwitchFirmClientOnboardingInput;
}>;


export type SwitchFirmClientOnboardingMutation = { __typename?: 'Mutation', switchFirmClientOnboarding: { __typename?: 'FirmClientPayload', firmClient: { __typename?: 'FirmClient', id: string } } };

export type ClientsLayoutPageQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type ClientsLayoutPageQuery = { __typename?: 'Query', smartGroupsForFirm: { __typename?: 'FirmSmartGroupList', items: Array<{ __typename?: 'SmartGroup', id: string, name: string, firmID: string, firmClients: Array<{ __typename?: 'FirmClient', id: string }>, smartGroupCriteria: Array<{ __typename?: 'SmartGroupCriteriaToken', type: SmartGroupCriteriaTokenType, value: { __typename?: 'SmartGroupCriteriaTokenValue', logicOperator?: SmartGroupLogicOperators | null, dataComparison?: { __typename?: 'SmartGroupDataComparisonTokenValue', comparisonData: SmartGroupComparisonData, operator: SmartGroupAssessmentCriteriaOperator, comparator: { __typename?: 'SmartGroupCriteriaComparator', floatValue?: number | null, comparisonData?: SmartGroupComparisonData | null, monetaryAmountInCents?: number | null, householdHealthValue?: FinancialCategory | null } } | null } }> }> } };

export type GetClosedCashAccountsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedCashAccountsQuery = { __typename?: 'Query', cashAccounts: { __typename?: 'CashAccountList', items: Array<{ __typename?: 'CashAccount', id: string, name: string, cashAccountType: CashAccountType, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedInvestmentsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedInvestmentsQuery = { __typename?: 'Query', investments: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: string, name: string, investmentType: InvestmentType, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedBusinessesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedBusinessesQuery = { __typename?: 'Query', businesses: { __typename?: 'BusinessList', items: Array<{ __typename?: 'Business', id: string, name: string, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedRealEstatePropertiesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedRealEstatePropertiesQuery = { __typename?: 'Query', realEstateProperties: { __typename?: 'RealEstateList', items: Array<{ __typename?: 'RealEstate', id: string, name: string, realEstateType: RealEstateType, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedLoansQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedLoansQuery = { __typename?: 'Query', loans: { __typename?: 'LoanList', items: Array<{ __typename?: 'Loan', id: string, name: string, loanType: LoanType, closedAt?: any | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedPersonalPropertyItemsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedPersonalPropertyItemsQuery = { __typename?: 'Query', personalPropertyItems: { __typename?: 'PersonalPropertyItemList', items: Array<{ __typename?: 'PersonalPropertyItem', id: string, name: string, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type GetClosedNoteReceivablesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetClosedNoteReceivablesQuery = { __typename?: 'Query', noteReceivables: { __typename?: 'NoteReceivableList', items: Array<{ __typename?: 'NoteReceivable', id: string, name: string, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string } }> } };

export type CustomGroupBasicLayoutPageQueryVariables = Exact<{
  groupID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type CustomGroupBasicLayoutPageQuery = { __typename?: 'Query', firmClientGroup?: { __typename?: 'FirmClientGroup', name: string } | null };

export type CustomGroupSaodLayoutPageQueryVariables = Exact<{
  groupID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type CustomGroupSaodLayoutPageQuery = { __typename?: 'Query', firmClientGroup?: { __typename?: 'FirmClientGroup', name: string } | null };

export type CreateDataPointMutationVariables = Exact<{
  input: CreateDataPointInput;
}>;


export type CreateDataPointMutation = { __typename?: 'Mutation', createDataPoint: { __typename?: 'CreateDataPointPayload', dataPoint: { __typename?: 'FloatDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'InvestmentMixDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'MonetaryAmountDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'StringDataPoint', id: string, tenantID: string, groupID: string } } };

export type UpdateDataPointMutationVariables = Exact<{
  input: UpdateDataPointInput;
}>;


export type UpdateDataPointMutation = { __typename?: 'Mutation', updateDataPoint: { __typename?: 'UpdateDataPointPayload', dataPoint: { __typename?: 'FloatDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'InvestmentMixDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'MonetaryAmountDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, groupID: string } | { __typename?: 'StringDataPoint', id: string, tenantID: string, groupID: string } } };

export type CreateDataPointGroupMutationVariables = Exact<{
  input: CreateDataPointGroupInput;
}>;


export type CreateDataPointGroupMutation = { __typename?: 'Mutation', createDataPointGroup: { __typename?: 'CreateDataPointGroupPayload', dataPointGroup: { __typename?: 'FloatDataPointGroup', id: string } | { __typename?: 'InvestmentMixDataPointGroup', id: string } | { __typename?: 'MonetaryAmountDataPointGroup', id: string } | { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string } | { __typename?: 'StringDataPointGroup', id: string } } };

export type DeleteDataPointMutationVariables = Exact<{
  input: DeleteDataPointInput;
}>;


export type DeleteDataPointMutation = { __typename?: 'Mutation', deleteDataPoint: { __typename?: 'DeleteDataPointPayload', changeToken: string } };

export type DataPointsInGroupQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  groupID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
}>;


export type DataPointsInGroupQuery = { __typename?: 'Query', dataPointsInGroup: { __typename: 'FloatDataPointList' } | { __typename: 'InvestmentMixDataPointList' } | { __typename: 'MonetaryAmountDataPointList', items: Array<{ __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } }> } | { __typename: 'RecurringMonetaryAmountDataPointList', items: Array<{ __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } }> } | { __typename: 'StringDataPointList' } };

export type StringDataPointsInGroupQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  groupID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
}>;


export type StringDataPointsInGroupQuery = { __typename?: 'Query', dataPointsInGroup: { __typename: 'FloatDataPointList', items: Array<{ __typename: 'FloatDataPoint' }> } | { __typename: 'InvestmentMixDataPointList', items: Array<{ __typename: 'InvestmentMixDataPoint' }> } | { __typename: 'MonetaryAmountDataPointList', items: Array<{ __typename: 'MonetaryAmountDataPoint' }> } | { __typename: 'RecurringMonetaryAmountDataPointList', items: Array<{ __typename: 'RecurringMonetaryAmountDataPoint' }> } | { __typename: 'StringDataPointList', items: Array<{ __typename: 'StringDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'StringDataPointValue', value: string } }> } };

export type DrDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeAnnualDebtPayments: Scalars['Boolean'];
  includeAnnualIncome: Scalars['Boolean'];
  includeTotalPersonalRealEstateLoans: Scalars['Boolean'];
  includeMonthlyPersonalRealEstatePayments: Scalars['Boolean'];
  includeTotalInvestmentRealEstateLoans: Scalars['Boolean'];
  includeMonthlyInvestmentRealEstatePayments: Scalars['Boolean'];
  includeTotalStudentLoans: Scalars['Boolean'];
  includeMonthlyStudentLoanPayments: Scalars['Boolean'];
  includeTotalOtherDebt: Scalars['Boolean'];
  includeMonthlyOtherDebtPayments: Scalars['Boolean'];
  includeTotalDebt: Scalars['Boolean'];
  includeTotalCreditCardDebt: Scalars['Boolean'];
  includeTotalAutoLoans: Scalars['Boolean'];
  includeMonthlyAutoLoanPayments: Scalars['Boolean'];
  includeMonthlyCreditCardPayments: Scalars['Boolean'];
}>;


export type DrDetailsQuery = { __typename?: 'Query', drDetails: { __typename?: 'DrDetails', dr?: number | null, annualDebtPayments?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualIncome?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalPersonalRealEstateLoans?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, monthlyPersonalRealEstatePayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, totalInvestmentRealEstateLoans?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, monthlyInvestmentRealEstatePayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, totalStudentLoans?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, monthlyStudentLoanPayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, totalOtherDebt?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, monthlyOtherDebtPayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, totalDebt?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalCreditCardDebt?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalAutoLoans?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, monthlyCreditCardPayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, monthlyAutoLoanPayments?: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } };

export type EditSmartGroupPageQueryVariables = Exact<{
  smartGroupID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type EditSmartGroupPageQuery = { __typename?: 'Query', smartGroup: { __typename?: 'SmartGroup', id: string, name: string, smartGroupCriteria: Array<{ __typename?: 'SmartGroupCriteriaToken', type: SmartGroupCriteriaTokenType, value: { __typename?: 'SmartGroupCriteriaTokenValue', logicOperator?: SmartGroupLogicOperators | null, dataComparison?: { __typename?: 'SmartGroupDataComparisonTokenValue', comparisonData: SmartGroupComparisonData, operator: SmartGroupAssessmentCriteriaOperator, comparator: { __typename?: 'SmartGroupCriteriaComparator', floatValue?: number | null, comparisonData?: SmartGroupComparisonData | null, monetaryAmountInCents?: number | null, householdHealthValue?: FinancialCategory | null } } | null } }> } };

export type ErDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeTotalEquityInvestments: Scalars['Boolean'];
  includeTotalInvestmentsAndCash: Scalars['Boolean'];
  includeInvestments: Scalars['Boolean'];
  includeTotalBondHoldings: Scalars['Boolean'];
  includeTotalCash: Scalars['Boolean'];
}>;


export type ErDetailsQuery = { __typename?: 'Query', erDetails: { __typename?: 'ErDetails', er?: number | null, totalEquityInvestments?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalInvestmentsAndCash?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, investments?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalBondHoldings?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalCash?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } };

export type CreateFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile: { __typename?: 'CreateFilePayload', file: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } } };

export type FileQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } };

export type DeleteFileMutationVariables = Exact<{
  input: DeleteFileInput;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: { __typename: 'DeleteFilePayload', changeToken: string } };

export type CreateFileAttachmentMutationVariables = Exact<{
  input: CreateFileAttachmentInput;
}>;


export type CreateFileAttachmentMutation = { __typename?: 'Mutation', createFileAttachment: { __typename?: 'CreateFileAttachmentPayload', fileAttachment: { __typename?: 'FileAttachment', id: string, fileID: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, itemID: string, file: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } } } };

export type FileAttachmentsForItemQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  id: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FileAttachmentsForItemQuery = { __typename?: 'Query', fileAttachmentsForItem: { __typename?: 'FileAttachmentList', items: Array<{ __typename?: 'FileAttachment', id: string, fileID: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, itemID: string, file: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } }> } };

export type DeleteFileAttachmentMutationVariables = Exact<{
  input: DeleteFileAttachmentInput;
}>;


export type DeleteFileAttachmentMutation = { __typename?: 'Mutation', deleteFileAttachment: { __typename?: 'DeleteFileAttachmentPayload', changeToken: string } };

export type FinancialGoalsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FinancialGoalsQuery = { __typename?: 'Query', financialGoals?: { __typename?: 'FinancialGoalList', items: Array<{ __typename: 'FinancialGoal', id: string, householdID: string, changeToken: string, body: string, achieved: boolean, order: number }> } | null };

export type CreateFinancialGoalMutationVariables = Exact<{
  input: CreateFinancialGoalInput;
}>;


export type CreateFinancialGoalMutation = { __typename?: 'Mutation', createFinancialGoal?: { __typename?: 'CreateFinancialGoalPayload', financialGoal: { __typename: 'FinancialGoal', id: string, householdID: string, changeToken: string, body: string, achieved: boolean, order: number } } | null };

export type UpdateFinancialGoalMutationVariables = Exact<{
  input: UpdateFinancialGoalInput;
}>;


export type UpdateFinancialGoalMutation = { __typename?: 'Mutation', updateFinancialGoal?: { __typename?: 'UpdateFinancialGoalPayload', financialGoal?: { __typename: 'FinancialGoal', id: string, householdID: string, changeToken: string, body: string, achieved: boolean, order: number } | null } | null };

export type ReorderFinancialGoalMutationVariables = Exact<{
  input: ReorderFinancialGoalInput;
}>;


export type ReorderFinancialGoalMutation = { __typename?: 'Mutation', reorderFinancialGoal?: { __typename?: 'ReorderFinancialGoalPayload', goals: Array<{ __typename: 'FinancialGoal', id: string, householdID: string, changeToken: string, body: string, achieved: boolean, order: number }> } | null };

export type DeleteFinancialGoalMutationVariables = Exact<{
  input: DeleteFinancialGoalInput;
}>;


export type DeleteFinancialGoalMutation = { __typename?: 'Mutation', deleteFinancialGoal?: { __typename?: 'DeleteFinancialGoalPayload', changeToken: string } | null };

export type FinancialNextStepsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FinancialNextStepsQuery = { __typename?: 'Query', financialNextSteps?: { __typename?: 'FinancialNextStepList', items: Array<{ __typename: 'FinancialNextStep', id: string, changeToken: string, body: string, done: boolean, householdID: string, order: number }> } | null };

export type CreateFinancialNextStepMutationVariables = Exact<{
  input: CreateFinancialNextStepInput;
}>;


export type CreateFinancialNextStepMutation = { __typename?: 'Mutation', createFinancialNextStep?: { __typename?: 'CreateFinancialNextStepPayload', financialNextStep: { __typename: 'FinancialNextStep', id: string, changeToken: string, body: string, done: boolean, householdID: string, order: number } } | null };

export type UpdateFinancialNextStepMutationVariables = Exact<{
  input: UpdateFinancialNextStepInput;
}>;


export type UpdateFinancialNextStepMutation = { __typename?: 'Mutation', updateFinancialNextStep?: { __typename?: 'UpdateFinancialNextStepPayload', financialNextStep: { __typename: 'FinancialNextStep', id: string, changeToken: string, body: string, done: boolean, householdID: string, order: number } } | null };

export type ReorderFinancialNextStepMutationVariables = Exact<{
  input: ReorderFinancialNextStepInput;
}>;


export type ReorderFinancialNextStepMutation = { __typename?: 'Mutation', reorderFinancialNextStep?: { __typename?: 'ReorderFinancialNextStepPayload', nextSteps: Array<{ __typename: 'FinancialNextStep', id: string, changeToken: string, body: string, done: boolean, householdID: string, order: number }> } | null };

export type DeleteFinancialNextStepMutationVariables = Exact<{
  input: DeleteFinancialNextStepInput;
}>;


export type DeleteFinancialNextStepMutation = { __typename?: 'Mutation', deleteFinancialNextStep?: { __typename?: 'DeleteFinancialNextStepPayload', changeToken: string } | null };

export type FirmQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FirmQuery = { __typename?: 'Query', firm?: { __typename: 'Firm', id: string, entitlements: Array<Entitlement>, createdAt: any, updatedAt: any, changeToken: string, name: string, color?: string | null, emailDisclosureText?: string | null, reportDisclosureText?: string | null, aiPromptAugmentation?: string | null, disableEmailNotifications?: boolean | null, estateStatusBetaEnabled?: boolean | null, mcpBetaEnabled?: boolean | null, elementCustomizationBetaEnabled?: boolean | null, delinquent: boolean, billingPortalLink?: string | null, type: FirmType, logo?: { __typename?: 'File', downloadURL?: string | null } | null, elementCustomizations: Array<{ __typename?: 'FirmElementCustomization', element: Element, customName?: string | null, shortName?: string | null, visibleByDefault: boolean }> } | null };

export type BillingPortalLinkQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type BillingPortalLinkQuery = { __typename?: 'Query', billingPortalLink?: string | null };

export type UpdateFirmMutationVariables = Exact<{
  input: UpdateFirmInput;
}>;


export type UpdateFirmMutation = { __typename?: 'Mutation', updateFirm: { __typename?: 'UpdateFirmPayload', firm: { __typename?: 'Firm', id: string } } };

export type FirmBrandingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FirmBrandingQuery = { __typename?: 'Query', firmBranding: { __typename?: 'FirmBranding', id: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', downloadURL?: string | null } | null } };

export type FirmsQueryVariables = Exact<{ [key: string]: never; }>;


export type FirmsQuery = { __typename?: 'Query', firms: { __typename?: 'FirmList', items: Array<{ __typename: 'Firm', id: string, entitlements: Array<Entitlement>, createdAt: any, updatedAt: any, changeToken: string, name: string, color?: string | null, emailDisclosureText?: string | null, reportDisclosureText?: string | null, aiPromptAugmentation?: string | null, disableEmailNotifications?: boolean | null, estateStatusBetaEnabled?: boolean | null, mcpBetaEnabled?: boolean | null, elementCustomizationBetaEnabled?: boolean | null, delinquent: boolean, billingPortalLink?: string | null, type: FirmType, logo?: { __typename?: 'File', downloadURL?: string | null } | null, elementCustomizations: Array<{ __typename?: 'FirmElementCustomization', element: Element, customName?: string | null, shortName?: string | null, visibleByDefault: boolean }> }> } };

export type FirmMembersForFirmQueryVariables = Exact<{
  firmID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type FirmMembersForFirmQuery = { __typename?: 'Query', firmMembersForFirm: { __typename?: 'FirmMemberList', items: Array<{ __typename: 'FirmMember', id: string, firmID: string, createdAt: any, updatedAt: any, changeToken: string, userID?: string | null, givenName: string, familyName: string, role: FirmMemberRole, emailSignature?: string | null, calendarSchedulingLink?: string | null }> } };

export type UpdateFirmMemberMutationVariables = Exact<{
  input: UpdateFirmMemberInput;
}>;


export type UpdateFirmMemberMutation = { __typename?: 'Mutation', updateFirmMember: { __typename?: 'UpdateFirmMemberPayload', firmMember: { __typename: 'FirmMember', id: string, firmID: string, createdAt: any, updatedAt: any, changeToken: string, userID?: string | null, givenName: string, familyName: string, role: FirmMemberRole, emailSignature?: string | null, calendarSchedulingLink?: string | null } } };

export type AssetLoanFragmentFragment = { __typename?: 'AssetLoan', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, assetID: string, loanID: string };

export type BaaAccountFragmentFragment = { __typename: 'BaaAccount', id: string, name: string, updatedAt: any, accountType: BaaAccountType, changeToken: string, createdAt: any, firmMemberID: string, BAAAccountID: string, householdID: string, firmClientID: string, accountNumber?: string | null, mappedEntityID: string, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string, value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } };

export type BusinessFragmentFragment = { __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } };

export type CashAccountFragmentFragment = { __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } };

export type ClientInvitationFragmentFragment = { __typename?: 'ClientInvitation', id: string, createdAt: any, updatedAt: any, dateTime: any, type: InvitationType, inviteeEmail: string, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, acceptedAt?: any | null, status: InvitationStatus, firmID: string, firmName: string, clientID: string, personID?: string | null, householdID?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } };

export type ConversationFragmentFragment = { __typename: 'Conversation', id: string, muted: boolean, createdAt: any, updatedAt: any, changeToken: string, firmClientID: string, hasUnreadMessages: boolean, latestMessagePreview?: string | null, latestMessageID?: string | null, lastMessageRead?: string | null, latestMessageDateTime?: any | null, participants: Array<{ __typename?: 'ConversationParticipant', id: string, type: ConversationParticipantType, userID: string, givenName: string, familyName: string, profileColor: string, profileImage?: string | null }> };

export type MonetaryAmountDataPointFragmentFragment = { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } };

export type StringDataPointFragmentFragment = { __typename: 'StringDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'StringDataPointValue', value: string } };

export type MonetaryAmountDataPointGroupFragmentFragment = { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null };

export type RecurringMonetaryAmountDataPointFragmentFragment = { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } };

export type RecurringMonetaryAmountDataPointGroupFragmentFragment = { __typename: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint' } | { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename: 'StringDataPoint' } | null };

export type FileAttachmentFragmentFragment = { __typename?: 'FileAttachment', id: string, fileID: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, itemID: string, file: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } };

export type FileFragmentFragment = { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } };

export type FinancialGoalFragmentFragment = { __typename: 'FinancialGoal', id: string, householdID: string, changeToken: string, body: string, achieved: boolean, order: number };

export type FinancialNextStepFragmentFragment = { __typename: 'FinancialNextStep', id: string, changeToken: string, body: string, done: boolean, householdID: string, order: number };

export type FirmBrandingFragmentFragment = { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null };

export type FirmClientFragmentFragment = { __typename?: 'FirmClient', firmID: string, activeFeatureDiscoveryTriggers: Array<FeatureDiscoveryTrigger>, id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string, createdAt: any, updatedAt: any, dateTime: any, type: InvitationType, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, acceptedAt?: any | null, status: InvitationStatus, firmID: string, firmName: string, clientID: string, personID?: string | null, householdID?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } }>, originFirmInviteLink?: { __typename: 'FirmInviteLink', id: string, campaignName: string, title: string, changeToken: string, description: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } } | null, notes: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, household?: { __typename?: 'Household', id: string, householdID: string, ownerID: string, financialCategorization?: FinancialCategory | null, financialCategoryScore?: number | null, financialPurpose: { __typename?: 'StringDataPointGroup', id: string, tenantID: string, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, data: { __typename: 'StringDataPointValue', value: string } } | null }, income: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint' } | { __typename?: 'InvestmentMixDataPoint' } | { __typename?: 'MonetaryAmountDataPoint' } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint' } | null }, spending: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any } | { __typename?: 'InvestmentMixDataPoint', dateTime: any } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', dateTime: any } | null } } | null, individuals: Array<{ __typename?: 'Person', relationship: RelationshipType, age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, team: Array<{ __typename: 'FirmClientTeamMember', role: FirmClientTeamMemberRole, member: { __typename?: 'FirmMember', id: string, calendarSchedulingLink?: string | null, familyName: string, givenName: string, profileColor: string } }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null };

export type FirmClientListItemFragmentFragment = { __typename?: 'FirmClient', id: string, mode: FirmClientMode, createdAt: any, givenNamesDisplay: string, familyNamesDisplay: string, pendingInvitations: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string }>, originFirmInviteLink?: { __typename?: 'FirmInviteLink', id: string, campaignName: string } | null, household?: { __typename?: 'Household', id: string } | null, individuals: Array<{ __typename?: 'Person', age?: number | null, emailAddress?: string | null, familyName?: string | null, givenName: string, profileColor?: string | null, phoneNumber?: string | null, profileImage?: string | null, userID?: string | null }>, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null };

export type FirmFragmentFragment = { __typename: 'Firm', id: string, entitlements: Array<Entitlement>, createdAt: any, updatedAt: any, changeToken: string, name: string, color?: string | null, emailDisclosureText?: string | null, reportDisclosureText?: string | null, aiPromptAugmentation?: string | null, disableEmailNotifications?: boolean | null, estateStatusBetaEnabled?: boolean | null, mcpBetaEnabled?: boolean | null, elementCustomizationBetaEnabled?: boolean | null, delinquent: boolean, billingPortalLink?: string | null, type: FirmType, logo?: { __typename?: 'File', downloadURL?: string | null } | null, elementCustomizations: Array<{ __typename?: 'FirmElementCustomization', element: Element, customName?: string | null, shortName?: string | null, visibleByDefault: boolean }> };

export type FirmMemberFragmentFragment = { __typename: 'FirmMember', id: string, firmID: string, createdAt: any, updatedAt: any, changeToken: string, userID?: string | null, givenName: string, familyName: string, role: FirmMemberRole, emailSignature?: string | null, calendarSchedulingLink?: string | null };

export type FloatRangeFragmentFragment = { __typename: 'FloatRange', max?: number | null, min?: number | null };

export type IncomeSourceFragmentFragment = { __typename?: 'IncomeSource', id: string, householdID: string, personID?: string | null, changeToken: string, createdAt: any, updatedAt: any, name: string, sourceType: IncomeSourceType, notes: string, archived: boolean, isFutureGuaranteedIncome: boolean, omitFromScorecard: boolean, person?: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } | null, amountDataPointGroup: { __typename: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint' } | { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename: 'StringDataPoint' } | null } };

export type InsuranceFragmentFragment = { __typename?: 'InsurancePolicy', name: string, notes: string, id: string, changeToken: string, householdID: string, createdAt: any, policyType: InsurancePolicyType, policySubtype: InsurancePolicySubtype, purchasedDate?: any | null, expirationDate?: any | null, updatedAt: any, coverageAmount: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null } };

export type InvestmentFragmentFragment = { __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } };

export type InviteLinkFragmentFragment = { __typename: 'FirmInviteLink', id: string, title: string, changeToken: string, description: string, campaignName: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } };

export type LoanFragmentFragment = { __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } };

export type MessageFragmentFragment = { __typename: 'FreeformMessage', message: string, hasOnboardingReminder?: boolean | null, suggestedResponses?: Array<string> | null, id: string, conversationID: string, createdAt: any, updatedAt: any, changeToken: string, sender: string, attachments?: Array<{ __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } }> | null };

export type NoteReceivableFragmentFragment = { __typename: 'NoteReceivable', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } };

type OwnerFragment_Business_Fragment = { __typename: 'Business', name: string, id: string, ownerType: OwnerType };

type OwnerFragment_Person_Fragment = { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType };

export type OwnerFragmentFragment = OwnerFragment_Business_Fragment | OwnerFragment_Person_Fragment;

type OwnershipFragment_CommunityProperty_Fragment = { __typename: 'CommunityProperty' };

type OwnershipFragment_JointWithRightsOfSurvivorship_Fragment = { __typename: 'JointWithRightsOfSurvivorship' };

type OwnershipFragment_SoleOwnership_Fragment = { __typename: 'SoleOwnership' };

type OwnershipFragment_TenantsInCommon_Fragment = { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null };

export type OwnershipFragmentFragment = OwnershipFragment_CommunityProperty_Fragment | OwnershipFragment_JointWithRightsOfSurvivorship_Fragment | OwnershipFragment_SoleOwnership_Fragment | OwnershipFragment_TenantsInCommon_Fragment;

export type PersonFragmentFragment = { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null };

export type PersonalPropertyItemFragmentFragment = { __typename: 'PersonalPropertyItem', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } };

export type RealEstateFragmentFragment = { __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } };

export type SpendingCategoryEstimateFragmentFragment = { __typename?: 'SpendingCategoryEstimate', id: string, householdID: string, changeToken: string, createdAt: any, updatedAt: any, dateTime: any, notes: string, categoryEstimates: Array<{ __typename?: 'CategoryEstimate', category: SpendingCategoryEstimateCategory, estimate: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> };

export type MonetaryAmountFragmentFragment = { __typename: 'MonetaryAmount', currencyCode: string, value: any };

export type RecurringTotalsFragmentFragment = { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } };

export type RecurringMonetaryAmountFragmentFragment = { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', currencyCode: string, value: any } };

export type TargetScoreRangeFragmentFragment = { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null };

export type TargetScoreRangeOverridesFragmentFragment = { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null };

export type TargetScoreRangeTemplateFragmentFragment = { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } };

export type TargetScoreRangesFragmentFragment = { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } };

export type TaxReturnSummaryFragmentFragment = { __typename?: 'TaxReturnSummary', id: string, year: number, householdID: string, changeToken: string, stringifiedYear: string, filingStatus: TaxFilingStatus, notes: string, income: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, federalTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null, stateTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null };

export type UnassignedBaaAccountFragmentFragment = { __typename: 'UnassignedBaaAccount', id: string, name: string, value: number, accountType?: BaaAccountType | null, updatedAt?: any | null, status: MappedAccountStatus, firmMemberID: string, statusErrorCode: string, accountNumber?: string | null, BAAFinancialProfileID: string, financialInstitutionID: string, financialInstitutionName: string };

export type UserProfileFragmentFragment = { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null };

export type GraphNetWorthQueryVariables = Exact<{
  householdID: Scalars['ID'];
  settings?: InputMaybe<GraphSettings>;
}>;


export type GraphNetWorthQuery = { __typename?: 'Query', graphNetWorth: Array<{ __typename: 'GraphPoint', dateTime: any, interpolated: boolean, value: { __typename: 'FloatGraphPointValue' } | { __typename: 'MonetaryAmountGraphPointValue', value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } }> };

export type GraphDataPointsInGroupQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  groupID: Scalars['ID'];
  settings?: InputMaybe<GraphSettings>;
}>;


export type GraphDataPointsInGroupQuery = { __typename?: 'Query', graphDataPointsInGroup: Array<{ __typename: 'GraphPoint', dateTime: any, interpolated: boolean, value: { __typename: 'FloatGraphPointValue' } | { __typename: 'MonetaryAmountGraphPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } }> };

export type CreateIncomeSourceMutationVariables = Exact<{
  input: CreateIncomeSourceInput;
}>;


export type CreateIncomeSourceMutation = { __typename?: 'Mutation', createIncomeSource: { __typename?: 'CreateIncomeSourcePayload', incomeSource: { __typename?: 'IncomeSource', id: string, householdID: string, personID?: string | null, changeToken: string, createdAt: any, updatedAt: any, name: string, sourceType: IncomeSourceType, notes: string, archived: boolean, isFutureGuaranteedIncome: boolean, omitFromScorecard: boolean, person?: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } | null, amountDataPointGroup: { __typename: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint' } | { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename: 'StringDataPoint' } | null } } } };

export type IncomeSourcesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type IncomeSourcesQuery = { __typename?: 'Query', incomeSources: { __typename?: 'IncomeSourceList', items: Array<{ __typename?: 'IncomeSource', id: string, householdID: string, personID?: string | null, changeToken: string, createdAt: any, updatedAt: any, name: string, sourceType: IncomeSourceType, notes: string, archived: boolean, isFutureGuaranteedIncome: boolean, omitFromScorecard: boolean, person?: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } | null, amountDataPointGroup: { __typename: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint' } | { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename: 'StringDataPoint' } | null } }> } };

export type UpdateIncomeSourceMutationVariables = Exact<{
  input: UpdateIncomeSourceInput;
}>;


export type UpdateIncomeSourceMutation = { __typename?: 'Mutation', updateIncomeSource: { __typename?: 'UpdateIncomeSourcePayload', incomeSource: { __typename?: 'IncomeSource', id: string, householdID: string, personID?: string | null, changeToken: string, createdAt: any, updatedAt: any, name: string, sourceType: IncomeSourceType, notes: string, archived: boolean, isFutureGuaranteedIncome: boolean, omitFromScorecard: boolean, person?: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } | null, amountDataPointGroup: { __typename: 'RecurringMonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint' } | { __typename: 'RecurringMonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename: 'StringDataPoint' } | null } } } };

export type ArchiveIncomeSourceMutationVariables = Exact<{
  input: ArchiveIncomeSourceInput;
}>;


export type ArchiveIncomeSourceMutation = { __typename?: 'Mutation', archiveIncomeSource: { __typename?: 'ArchiveIncomeSourcePayload', archived: boolean } };

export type CreateInsurancePolicyMutationVariables = Exact<{
  input: CreateInsurancePolicyInput;
}>;


export type CreateInsurancePolicyMutation = { __typename?: 'Mutation', createInsurancePolicy: { __typename?: 'CreateInsurancePolicyPayload', insurancePolicy: { __typename?: 'InsurancePolicy', name: string, notes: string, id: string, changeToken: string, householdID: string, createdAt: any, policyType: InsurancePolicyType, policySubtype: InsurancePolicySubtype, purchasedDate?: any | null, expirationDate?: any | null, updatedAt: any, coverageAmount: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null } } } };

export type InsurancePoliciesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type InsurancePoliciesQuery = { __typename?: 'Query', insurancePolicies: { __typename?: 'InsurancePolicyList', items: Array<{ __typename?: 'InsurancePolicy', name: string, notes: string, id: string, changeToken: string, householdID: string, createdAt: any, policyType: InsurancePolicyType, policySubtype: InsurancePolicySubtype, purchasedDate?: any | null, expirationDate?: any | null, updatedAt: any, coverageAmount: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type InsurancePolicyByIdQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type InsurancePolicyByIdQuery = { __typename?: 'Query', insurancePolicy?: { __typename?: 'InsurancePolicy', name: string, notes: string, id: string, changeToken: string, householdID: string, createdAt: any, policyType: InsurancePolicyType, policySubtype: InsurancePolicySubtype, purchasedDate?: any | null, expirationDate?: any | null, updatedAt: any, coverageAmount: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null } } | null };

export type UpdateInsurancePolicyMutationVariables = Exact<{
  input: UpdateInsurancePolicyInput;
}>;


export type UpdateInsurancePolicyMutation = { __typename?: 'Mutation', updateInsurancePolicy: { __typename?: 'UpdateInsurancePolicyPayload', insurancePolicy: { __typename?: 'InsurancePolicy', name: string, notes: string, id: string, changeToken: string, householdID: string, createdAt: any, policyType: InsurancePolicyType, policySubtype: InsurancePolicySubtype, purchasedDate?: any | null, expirationDate?: any | null, updatedAt: any, coverageAmount: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null } } } };

export type DeleteInsurancePolicyMutationVariables = Exact<{
  input: DeleteInsurancePolicyInput;
}>;


export type DeleteInsurancePolicyMutation = { __typename?: 'Mutation', deleteInsurancePolicy: { __typename?: 'DeleteInsurancePolicyPayload', changeToken: string } };

export type GetInvestmentsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetInvestmentsQuery = { __typename?: 'Query', investments: { __typename?: 'InvestmentList', items: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }> } };

export type CreateInvestmentMutationVariables = Exact<{
  input: CreateInvestmentInput;
}>;


export type CreateInvestmentMutation = { __typename?: 'Mutation', createInvestment: { __typename?: 'CreateInvestmentPayload', investment: { __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type UpdateInvestmentMutationVariables = Exact<{
  input: UpdateInvestmentInput;
}>;


export type UpdateInvestmentMutation = { __typename?: 'Mutation', updateInvestment: { __typename?: 'UpdateInvestmentPayload', investment: { __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type DeleteInvestmentMutationVariables = Exact<{
  input: DeleteInvestmentInput;
}>;


export type DeleteInvestmentMutation = { __typename?: 'Mutation', deleteInvestment: { __typename?: 'DeleteInvestmentPayload', changeToken: string } };

export type GetInvestmentQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetInvestmentQuery = { __typename?: 'Query', investment?: { __typename: 'Investment', closedAt?: any | null, id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type CloseInvestmentMutationVariables = Exact<{
  input: CloseInvestmentInput;
}>;


export type CloseInvestmentMutation = { __typename?: 'Mutation', closeInvestment: { __typename?: 'CloseInvestmentPayload', changeToken: string } };

export type MergeInvestmentsMutationVariables = Exact<{
  input: MergeInvestmentsInput;
}>;


export type MergeInvestmentsMutation = { __typename?: 'Mutation', mergeInvestments: { __typename?: 'MergeInvestmentsPayload', merged: boolean } };

export type ClientInvitationsForFirmQueryVariables = Exact<{
  firmID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type ClientInvitationsForFirmQuery = { __typename?: 'Query', clientInvitationsForFirm?: { __typename?: 'InvitationList', items: Array<{ __typename?: 'ClientInvitation', id: string, inviteeEmail: string, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, createdAt: any, updatedAt: any, inviter: { __typename?: 'User', elementsID: string } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type DeleteInvitationMutationVariables = Exact<{
  input: DeleteInvitationInput;
}>;


export type DeleteInvitationMutation = { __typename?: 'Mutation', deleteInvitation: boolean };

export type InvitationQueryVariables = Exact<{
  input: GetInvitationInput;
}>;


export type InvitationQuery = { __typename?: 'Query', invitation?: { __typename: 'ClientInvitation', firmID: string, clientID: string, firmName: string, personID?: string | null, householdID?: string | null, id: string, status: InvitationStatus, inviteeEmail: string, inviteeGivenName?: string | null, inviteeFamilyName?: string | null, inviter: { __typename?: 'User', elementsID: string, email: string, givenName?: string | null, familyName?: string | null, profession?: string | null, profileImage?: string | null, profileColor?: string | null } } | null };

export type UpdateInvitationMutationVariables = Exact<{
  input: UpdateInvitationInput;
}>;


export type UpdateInvitationMutation = { __typename?: 'Mutation', updateInvitation: boolean };

export type InviteFirmClientMutationVariables = Exact<{
  input: InviteFirmClientInput;
}>;


export type InviteFirmClientMutation = { __typename?: 'Mutation', inviteFirmClient: { __typename?: 'InviteFirmClientPayload', invitation: { __typename?: 'ClientInvitation', firmID: string, clientID: string, firmName: string, personID?: string | null, id: string, status: InvitationStatus, inviteeEmail: string, inviteeGivenName?: string | null, inviteeFamilyName?: string | null } } };

export type CreateFirmInviteLinkMutationVariables = Exact<{
  input: CreateFirmInviteLinkInput;
}>;


export type CreateFirmInviteLinkMutation = { __typename?: 'Mutation', createFirmInviteLink: { __typename?: 'FirmInviteLink', id: string } };

export type UpdateFirmInviteLinkMutationVariables = Exact<{
  input: UpdateFirmInviteLinkInput;
}>;


export type UpdateFirmInviteLinkMutation = { __typename?: 'Mutation', updateFirmInviteLink: { __typename?: 'FirmInviteLink', id: string } };

export type DeleteFirmInviteLinkMutationVariables = Exact<{
  firmInviteLinkID: Scalars['ID'];
}>;


export type DeleteFirmInviteLinkMutation = { __typename?: 'Mutation', deleteFirmInviteLink: boolean };

export type AdvisorInviteLinksIndexPageQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type AdvisorInviteLinksIndexPageQuery = { __typename?: 'Query', firmInviteLinks: { __typename?: 'FirmInviteLinkList', items: Array<{ __typename?: 'FirmInviteLink', id: string, campaignName: string, acceptFormURL: string, firmClientEntitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean } }> } };

export type AdvisorEditInviteLinkPageQueryVariables = Exact<{
  firmInviteLinkID: Scalars['ID'];
}>;


export type AdvisorEditInviteLinkPageQuery = { __typename?: 'Query', firmInviteLink: { __typename?: 'FirmInviteLink', id: string, title: string, changeToken: string, campaignName: string, description: string, disclosure?: string | null, acceptFormURL: string, firm: { __typename?: 'FirmBranding', color?: string | null, logo?: { __typename?: 'File', downloadURL?: string | null } | null }, firmClientEntitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean } } };

export type FirmInviteLinkQueryVariables = Exact<{
  firmInviteLinkID: Scalars['ID'];
}>;


export type FirmInviteLinkQuery = { __typename?: 'Query', firmInviteLink: { __typename: 'FirmInviteLink', id: string, title: string, changeToken: string, description: string, campaignName: string, acceptFormURL: string, status: FirmInviteLinkStatus, inviterUserID: string, primaryAdvisorFirmMemberID: string, disclosure?: string | null, firm: { __typename: 'FirmBranding', id: string, name: string, color?: string | null, type: FirmType, logo?: { __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } } | null } } };

export type ConfirmAccountMutationVariables = Exact<{
  input: ConfirmAccountInput;
}>;


export type ConfirmAccountMutation = { __typename?: 'Mutation', confirmAccount: { __typename?: 'ConfirmAccountPayload', tokenSet: { __typename?: 'TokenSet', idToken: string, accessToken: string, refreshToken: string } } };

export type AcceptFirmInviteLinkMutationVariables = Exact<{
  input: AcceptFirmInviteLinkInput;
}>;


export type AcceptFirmInviteLinkMutation = { __typename?: 'Mutation', acceptFirmInviteLink: { __typename?: 'AcceptFirmInviteLinkPayload', householdID: string, firmClientID: string, requiresConfirmation?: boolean | null } };

export type LoansQueryVariables = Exact<{
  householdID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type LoansQuery = { __typename?: 'Query', loans: { __typename?: 'LoanList', items: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }> } };

export type CreateLoanMutationVariables = Exact<{
  input: CreateLoanInput;
}>;


export type CreateLoanMutation = { __typename?: 'Mutation', createLoan: { __typename?: 'CreateLoanPayload', loan: { __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type DeleteLoanMutationVariables = Exact<{
  input: DeleteLoanInput;
}>;


export type DeleteLoanMutation = { __typename?: 'Mutation', deleteLoan: { __typename?: 'DeleteLoanPayload', changeToken: string } };

export type UpdateLoanMutationVariables = Exact<{
  input: UpdateLoanInput;
}>;


export type UpdateLoanMutation = { __typename?: 'Mutation', updateLoan: { __typename?: 'UpdateLoanPayload', loan: { __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type LoanQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type LoanQuery = { __typename?: 'Query', loan?: { __typename: 'Loan', closedAt?: any | null, id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type CloseLoanMutationVariables = Exact<{
  input: CloseLoanInput;
}>;


export type CloseLoanMutation = { __typename?: 'Mutation', closeLoan: { __typename?: 'CloseLoanPayload', changeToken: string } };

export type MergeLoansMutationVariables = Exact<{
  input: MergeLoansInput;
}>;


export type MergeLoansMutation = { __typename?: 'Mutation', mergeLoans: { __typename?: 'MergeLoansPayload', merged: boolean } };

export type LtDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeLiquidAssets: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includePersonalCashItems: Scalars['Boolean'];
  includeTotalPersonalCash: Scalars['Boolean'];
  includeBusinessCashItems: Scalars['Boolean'];
  includeTotalBusinessCash: Scalars['Boolean'];
  includeAfterTaxInvestments: Scalars['Boolean'];
  includeTotalAfterTaxInvestments: Scalars['Boolean'];
}>;


export type LtDetailsQuery = { __typename?: 'Query', ltDetails: { __typename?: 'LtDetails', lt?: number | null, totalLiquidAssets?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, personalCashItems?: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalPersonalCash?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, businessCashItems?: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalBusinessCash?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, afterTaxInvestmentItems?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalAfterTaxInvestments?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } };

export type ConversationsQueryVariables = Exact<{
  firmID?: InputMaybe<Scalars['ID']>;
}>;


export type ConversationsQuery = { __typename?: 'Query', conversations: { __typename?: 'ConversationList', items: Array<{ __typename: 'Conversation', id: string, muted: boolean, createdAt: any, updatedAt: any, changeToken: string, firmClientID: string, hasUnreadMessages: boolean, latestMessagePreview?: string | null, latestMessageID?: string | null, lastMessageRead?: string | null, latestMessageDateTime?: any | null, participants: Array<{ __typename?: 'ConversationParticipant', id: string, type: ConversationParticipantType, userID: string, givenName: string, familyName: string, profileColor: string, profileImage?: string | null }> }> } };

export type ConversationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  firmClientID?: InputMaybe<Scalars['ID']>;
}>;


export type ConversationQuery = { __typename?: 'Query', conversation: { __typename: 'Conversation', id: string, muted: boolean, createdAt: any, updatedAt: any, changeToken: string, firmClientID: string, hasUnreadMessages: boolean, latestMessagePreview?: string | null, latestMessageID?: string | null, lastMessageRead?: string | null, latestMessageDateTime?: any | null, participants: Array<{ __typename?: 'ConversationParticipant', id: string, type: ConversationParticipantType, userID: string, givenName: string, familyName: string, profileColor: string, profileImage?: string | null }> } };

export type MessagesQueryVariables = Exact<{
  conversationID: Scalars['ID'];
}>;


export type MessagesQuery = { __typename?: 'Query', messages: { __typename?: 'MessagesList', items: Array<{ __typename: 'FreeformMessage', message: string, hasOnboardingReminder?: boolean | null, suggestedResponses?: Array<string> | null, id: string, conversationID: string, createdAt: any, updatedAt: any, changeToken: string, sender: string, attachments?: Array<{ __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } }> | null }> } };

export type NumberOfUnreadConversationsQueryVariables = Exact<{
  firmID?: InputMaybe<Scalars['ID']>;
}>;


export type NumberOfUnreadConversationsQuery = { __typename?: 'Query', numberOfUnreadConversations: number };

export type MuteConversationMutationVariables = Exact<{
  input: MuteOrUnmuteConversationInput;
}>;


export type MuteConversationMutation = { __typename?: 'Mutation', muteConversation: { __typename?: 'MuteOrUnmuteConversationPayload', muted: boolean } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'CreateMessagePayload', message: { __typename: 'FreeformMessage', message: string, hasOnboardingReminder?: boolean | null, suggestedResponses?: Array<string> | null, id: string, conversationID: string, createdAt: any, updatedAt: any, changeToken: string, sender: string, attachments?: Array<{ __typename?: 'File', id: string, name: string, tenantID: string, contentType: string, createdAt: any, standalone: boolean, downloadURL?: string | null, uploadURL?: string | null, uploadStatus: FileUploadStatus, createdBy: { __typename?: 'User', email: string, givenName?: string | null, familyName?: string | null } }> | null } } };

export type MarkConversationReadMutationVariables = Exact<{
  input: MarkConversationReadInput;
}>;


export type MarkConversationReadMutation = { __typename?: 'Mutation', markConversationRead: { __typename?: 'MarkMessageReadPayload', read: boolean } };

export type AssociateSoftwareTokenMutationVariables = Exact<{
  input: AssociateSoftwareTokenInput;
}>;


export type AssociateSoftwareTokenMutation = { __typename?: 'Mutation', associateSoftwareToken: boolean };

export type DisassociateSoftwareTokenMutationVariables = Exact<{
  input: DisassociateSoftwareTokenInput;
}>;


export type DisassociateSoftwareTokenMutation = { __typename?: 'Mutation', disassociateSoftwareToken: boolean };

export type SuggestedFinancialNextStepsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type SuggestedFinancialNextStepsQuery = { __typename?: 'Query', suggestedFinancialNextSteps?: { __typename?: 'FinancialNextStepList', items: Array<{ __typename?: 'FinancialNextStep', id: string, body: string, changeToken: string }> } | null };

export type RefreshAiRecommendationsMutationVariables = Exact<{
  input: RefreshAiRecommendationsInput;
}>;


export type RefreshAiRecommendationsMutation = { __typename?: 'Mutation', refreshAIRecommendations?: { __typename?: 'RefreshAIRecommendationsPayload', success: boolean, executionID?: string | null } | null };

export type DeleteNoteReceivableMutationVariables = Exact<{
  input: DeleteNoteReceivableInput;
}>;


export type DeleteNoteReceivableMutation = { __typename?: 'Mutation', deleteNoteReceivable: { __typename?: 'DeleteNoteReceivablePayload', changeToken: string } };

export type GetNoteReceivableQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetNoteReceivableQuery = { __typename?: 'Query', noteReceivable?: { __typename: 'NoteReceivable', id: string, householdID: string, name: string, changeToken: string, notes: string, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type GetNoteReceivablesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetNoteReceivablesQuery = { __typename?: 'Query', noteReceivables: { __typename?: 'NoteReceivableList', items: Array<{ __typename?: 'NoteReceivable', id: string, householdID: string, name: string, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number }> | null }, ownedValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null } }> } };

export type CreateNoteReceivableMutationVariables = Exact<{
  input: CreateNoteReceivableInput;
}>;


export type CreateNoteReceivableMutation = { __typename?: 'Mutation', createNoteReceivable: { __typename?: 'CreateNoteReceivablePayload', noteReceivable: { __typename: 'NoteReceivable', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type CloseNoteReceivableMutationVariables = Exact<{
  input: CloseNoteReceivableInput;
}>;


export type CloseNoteReceivableMutation = { __typename?: 'Mutation', closeNoteReceivable: { __typename?: 'CloseNoteReceivablePayload', changeToken: string } };

export type MergeNoteReceivablesMutationVariables = Exact<{
  input: MergeNoteReceivablesInput;
}>;


export type MergeNoteReceivablesMutation = { __typename?: 'Mutation', mergeNoteReceivables: { __typename?: 'MergeNoteReceivablesPayload', merged: boolean } };

export type UpdateNoteReceivableMutationVariables = Exact<{
  input: UpdateNoteReceivableInput;
}>;


export type UpdateNoteReceivableMutation = { __typename?: 'Mutation', updateNoteReceivable: { __typename?: 'UpdateNoteReceivablePayload', noteReceivable: { __typename: 'NoteReceivable', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type CreatePersonalPropertyItemMutationVariables = Exact<{
  input: CreatePersonalPropertyItemInput;
}>;


export type CreatePersonalPropertyItemMutation = { __typename?: 'Mutation', createPersonalPropertyItem: { __typename?: 'CreatePersonalPropertyItemPayload', personalPropertyItem: { __typename: 'PersonalPropertyItem', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type DeletePersonalPropertyItemMutationVariables = Exact<{
  input: DeletePersonalPropertyItemInput;
}>;


export type DeletePersonalPropertyItemMutation = { __typename?: 'Mutation', deletePersonalPropertyItem: { __typename?: 'DeletePersonalPropertyItemPayload', changeToken: string } };

export type GetPersonalPropertyItemQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPersonalPropertyItemQuery = { __typename?: 'Query', personalPropertyItem?: { __typename: 'PersonalPropertyItem', id: string, householdID: string, name: string, changeToken: string, notes: string, closedAt?: any | null, ownedValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type GetPersonalPropertyItemsQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetPersonalPropertyItemsQuery = { __typename?: 'Query', personalPropertyItems: { __typename?: 'PersonalPropertyItemList', items: Array<{ __typename: 'PersonalPropertyItem', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }> } };

export type ClosePersonalPropertyItemMutationVariables = Exact<{
  input: ClosePersonalPropertyItemInput;
}>;


export type ClosePersonalPropertyItemMutation = { __typename?: 'Mutation', closePersonalPropertyItem: { __typename?: 'ClosePersonalPropertyItemPayload', changeToken: string } };

export type MergePersonalPropertyItemsMutationVariables = Exact<{
  input: MergePersonalPropertyItemsInput;
}>;


export type MergePersonalPropertyItemsMutation = { __typename?: 'Mutation', mergePersonalPropertyItems: { __typename?: 'MergePersonalPropertyItemsPayload', merged: boolean } };

export type UpdatePersonalPropertyItemMutationVariables = Exact<{
  input: UpdatePersonalPropertyItemInput;
}>;


export type UpdatePersonalPropertyItemMutation = { __typename?: 'Mutation', updatePersonalPropertyItem: { __typename?: 'UpdatePersonalPropertyItemPayload', personalPropertyItem: { __typename: 'PersonalPropertyItem', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } } } };

export type GetPersonsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetPersonsQuery = { __typename?: 'Query', persons: { __typename?: 'PersonList', items: Array<{ __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type GetPersonQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } | null };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson: { __typename?: 'CreatePersonPayload', person: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'UpdatePersonPayload', person: { __typename?: 'Person', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, givenName: string, familyName?: string | null, dateOfBirth?: any | null, relationship: RelationshipType, phoneNumber?: string | null, emailAddress?: string | null, userID?: string | null, profileColor?: string | null, profileImage?: string | null, occupation?: string | null } } };

export type DeletePersonMutationVariables = Exact<{
  input: DeletePersonInput;
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson: { __typename?: 'DeletePersonPayload', changeToken: string } };

export type GeneratePlaidLinkTokenMutationVariables = Exact<{
  input: GeneratePlaidLinkTokenInput;
}>;


export type GeneratePlaidLinkTokenMutation = { __typename?: 'Mutation', generatePlaidLinkToken: { __typename?: 'PlaidLinkTokenPayload', linkToken: string } };

export type ExchangePlaidPublicTokenMutationVariables = Exact<{
  input: ExchangePlaidPublicTokenInput;
}>;


export type ExchangePlaidPublicTokenMutation = { __typename?: 'Mutation', exchangePlaidPublicToken: { __typename?: 'PlaidItemsPayload', plaidItemID: string, accountsMapping: Array<{ __typename?: 'PlaidItemAccountMapping', plaidItemID: string, plaidItemAccountID: string, name: string, officialName: string, mappedEntityID?: string | null, mappedType?: MappedEntityType | null, mappedCashAccountType?: CashAccountType | null, mappedLoanType?: LoanType | null, mappedInvestmentType?: InvestmentType | null, mask: string, balance?: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } | null }> } };

export type ApplyPlaidItemAccountMappingMutationVariables = Exact<{
  input: ApplyPlaidItemAccountMappingInput;
}>;


export type ApplyPlaidItemAccountMappingMutation = { __typename?: 'Mutation', applyPlaidItemAccountMapping: boolean };

export type UpdatePlaidLinkAfterRefreshMutationVariables = Exact<{
  input: UpdatePlaidLinkAfterRefreshInput;
}>;


export type UpdatePlaidLinkAfterRefreshMutation = { __typename?: 'Mutation', updatePlaidLinkAfterRefresh: boolean };

export type DisconnectAccountLinkingMutationVariables = Exact<{
  input: DisconnectAccountLinking;
}>;


export type DisconnectAccountLinkingMutation = { __typename?: 'Mutation', disconnectAccountLinking: boolean };

export type GetProfileImageUploadUrlMutationVariables = Exact<{
  input: GetProfileImageUploadUrlInput;
}>;


export type GetProfileImageUploadUrlMutation = { __typename?: 'Mutation', getProfileImageUploadURL: { __typename?: 'GetProfileImageUploadURLPayload', uploadURL: string } };

export type StartProspectDiscoveryMutationVariables = Exact<{
  input: StartProspectDiscoveryInput;
}>;


export type StartProspectDiscoveryMutation = { __typename?: 'Mutation', startProspectDiscovery: { __typename?: 'StartProspectDiscoveryPayload', tokenSet: { __typename?: 'TokenSet', accessToken: string, refreshToken: string, idToken: string } } };

export type CompleteProspectDiscoveryMutationVariables = Exact<{
  input: CompleteProspectDiscoveryInput;
}>;


export type CompleteProspectDiscoveryMutation = { __typename?: 'Mutation', completeProspectDiscovery: { __typename?: 'CompleteProspectDiscoveryPayload', complete: boolean } };

export type ProspectDiscoveryAllDoneLoaderQueryQueryVariables = Exact<{
  firmID: Scalars['ID'];
  clientID: Scalars['ID'];
}>;


export type ProspectDiscoveryAllDoneLoaderQueryQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', id: string, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean } } | null, aiClientSummary?: { __typename?: 'AiClientSummary', advisorApproved: boolean } | null };

export type ProspectDiscoveryFormsLayoutPageQueryVariables = Exact<{
  firmID: Scalars['ID'];
  clientID: Scalars['ID'];
}>;


export type ProspectDiscoveryFormsLayoutPageQuery = { __typename?: 'Query', firmClient?: { __typename?: 'FirmClient', id: string, entitlements: { __typename?: 'FirmClientEntitlements', aiAssessment: boolean } } | null, aiClientSummary?: { __typename?: 'AiClientSummary', advisorApproved: boolean } | null };

export type QtDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeTotalRetirementAssets: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includeTaxFreeAccounts: Scalars['Boolean'];
  includeTotalTaxFree: Scalars['Boolean'];
  includeTaxDeferredAccounts: Scalars['Boolean'];
  includeTotalTaxDeferred: Scalars['Boolean'];
  includeOtherAccounts: Scalars['Boolean'];
  includeTotalOther: Scalars['Boolean'];
  includeTotalTaxFreeSavings: Scalars['Boolean'];
  includeTotalTaxDeferredSavings: Scalars['Boolean'];
  includeTotalOtherSavings: Scalars['Boolean'];
}>;


export type QtDetailsQuery = { __typename?: 'Query', qtDetails: { __typename?: 'QtDetails', qt?: number | null, totalRetirementAssets?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, taxFreeAccounts?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalTaxFree?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalTaxFreeSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, taxDeferredAccounts?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalTaxDeferred?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalTaxDeferredSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, otherAccounts?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalOther?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalOtherSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } };

export type GetRealEstatePropertiesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type GetRealEstatePropertiesQuery = { __typename?: 'Query', realEstateProperties: { __typename?: 'RealEstateList', items: Array<{ __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }> } };

export type CreateRealEstatePropertyMutationVariables = Exact<{
  input: CreateRealEstateInput;
}>;


export type CreateRealEstatePropertyMutation = { __typename?: 'Mutation', createRealEstateProperty: { __typename?: 'CreateRealEstatePayload', realEstate: { __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type DeleteRealEstatePropertyMutationVariables = Exact<{
  input: DeleteRealEstateInput;
}>;


export type DeleteRealEstatePropertyMutation = { __typename?: 'Mutation', deleteRealEstateProperty: { __typename?: 'DeleteRealEstatePayload', changeToken: string } };

export type UpdateRealEstatePropertyMutationVariables = Exact<{
  input: UpdateRealEstateInput;
}>;


export type UpdateRealEstatePropertyMutation = { __typename?: 'Mutation', updateRealEstateProperty: { __typename?: 'UpdateRealEstatePayload', realEstate: { __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } } };

export type GetRealEstatePropertyQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetRealEstatePropertyQuery = { __typename?: 'Query', realEstateProperty?: { __typename: 'RealEstate', closedAt?: any | null, id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } } | null };

export type CloseRealEstatePropertyMutationVariables = Exact<{
  input: CloseRealEstatePropertyInput;
}>;


export type CloseRealEstatePropertyMutation = { __typename?: 'Mutation', closeRealEstateProperty: { __typename?: 'CloseRealEstatePropertyPayload', changeToken: string } };

export type MergeRealEstatesMutationVariables = Exact<{
  input: MergeRealEstatesInput;
}>;


export type MergeRealEstatesMutation = { __typename?: 'Mutation', mergeRealEstates: { __typename?: 'MergeRealEstatesPayload', merged: boolean } };

export type RtDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeTotalRealEstateEquity: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includeRealEstate: Scalars['Boolean'];
  includeUnattachedLoans: Scalars['Boolean'];
  includeTotalUnattachedLoans: Scalars['Boolean'];
  includeTotalRealEstateValue: Scalars['Boolean'];
  includeTotalRealEstateDebt: Scalars['Boolean'];
}>;


export type RtDetailsQuery = { __typename?: 'Query', rtDetails: { __typename?: 'RtDetails', rt?: number | null, totalRealEstateEquity?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, realEstate?: Array<{ __typename?: 'RealEstateEquityLineItem', isBusinessOwned: boolean, realEstate: { __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }, loans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, ownedValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, ownedDebt: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalOwnedEquity: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }>, unattachedLoans?: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalUnattachedLoans?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalRealEstateValue?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalRealEstateDebt?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } };

export type GetSelfQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelfQuery = { __typename?: 'Query', self?: { __typename?: 'User', createdAt: any, elementsID: string, email: string, emailVerified: boolean, familyName?: string | null, givenName?: string | null, id: string, updatedAt: any, username: string, profileColor?: string | null, profileImage?: string | null } | null };

export type DeleteSmartGroupMutationVariables = Exact<{
  input: DeleteSmartGroupInput;
}>;


export type DeleteSmartGroupMutation = { __typename?: 'Mutation', deleteSmartGroup: boolean };

export type CreateSmartGroupMutationVariables = Exact<{
  input: CreateSmartGroupInput;
}>;


export type CreateSmartGroupMutation = { __typename?: 'Mutation', createSmartGroup: { __typename?: 'SmartGroup', id: string } };

export type UpdateSmartGroupMutationVariables = Exact<{
  input: UpdateSmartGroupInput;
}>;


export type UpdateSmartGroupMutation = { __typename?: 'Mutation', updateSmartGroup: { __typename?: 'SmartGroup', id: string } };

export type SmartGroupBasicLayoutPageQueryVariables = Exact<{
  smartGroupID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type SmartGroupBasicLayoutPageQuery = { __typename?: 'Query', smartGroup: { __typename?: 'SmartGroup', id: string, name: string, firmClients: Array<{ __typename?: 'FirmClient', id: string, createdAt: any, familyNamesDisplay: string, group?: { __typename?: 'FirmClientGroup', id: string, name: string } | null, individuals: Array<{ __typename?: 'Person', profileImage?: string | null, profileColor?: string | null, givenName: string, familyName?: string | null, age?: number | null }> }> } };

export type SmartGroupSaodLayoutPageQueryVariables = Exact<{
  smartGroupID: Scalars['ID'];
  firmID: Scalars['ID'];
}>;


export type SmartGroupSaodLayoutPageQuery = { __typename?: 'Query', smartGroup: { __typename?: 'SmartGroup', name: string, firmClients: Array<{ __typename?: 'FirmClient', id: string }> } };

export type SpendingCategoryEstimatesQueryVariables = Exact<{
  householdID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type SpendingCategoryEstimatesQuery = { __typename?: 'Query', spendingCategoryEstimates: { __typename?: 'SpendingCategoryEstimateList', items: Array<{ __typename?: 'SpendingCategoryEstimate', id: string, householdID: string, changeToken: string, createdAt: any, updatedAt: any, dateTime: any, notes: string, categoryEstimates: Array<{ __typename?: 'CategoryEstimate', category: SpendingCategoryEstimateCategory, estimate: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> }> } };

export type CreateSpendingCategoryEstimateMutationVariables = Exact<{
  input: CreateSpendingCategoryEstimateInput;
}>;


export type CreateSpendingCategoryEstimateMutation = { __typename?: 'Mutation', createSpendingCategoryEstimate: { __typename?: 'CreateSpendingCategoryEstimatePayload', spendingCategoryEstimate: { __typename?: 'SpendingCategoryEstimate', id: string, householdID: string, changeToken: string, createdAt: any, updatedAt: any, dateTime: any, notes: string, categoryEstimates: Array<{ __typename?: 'CategoryEstimate', category: SpendingCategoryEstimateCategory, estimate: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> } } };

export type UpdateSpendingCategoryEstimateMutationVariables = Exact<{
  input: UpdateSpendingCategoryEstimateInput;
}>;


export type UpdateSpendingCategoryEstimateMutation = { __typename?: 'Mutation', updateSpendingCategoryEstimate: { __typename?: 'UpdateSpendingCategoryEstimatePayload', spendingCategoryEstimate: { __typename?: 'SpendingCategoryEstimate', id: string, householdID: string, changeToken: string, createdAt: any, updatedAt: any, dateTime: any, notes: string, categoryEstimates: Array<{ __typename?: 'CategoryEstimate', category: SpendingCategoryEstimateCategory, estimate: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }> } } };

export type SrDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeAnnualSavings: Scalars['Boolean'];
  includeAnnualIncome: Scalars['Boolean'];
  includeCashSavings: Scalars['Boolean'];
  includeTotalCashSavings: Scalars['Boolean'];
  includePreTaxSavings: Scalars['Boolean'];
  includeTotalPreTaxSavings: Scalars['Boolean'];
  includeAfterTaxSavings: Scalars['Boolean'];
  includeTotalAfterTaxSavings: Scalars['Boolean'];
  includeEducationSavings: Scalars['Boolean'];
  includeTotalEducationSavings: Scalars['Boolean'];
}>;


export type SrDetailsQuery = { __typename?: 'Query', srDetails: { __typename?: 'SrDetails', sr?: number | null, annualSavings?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualIncome?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, cashSavings?: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalCashSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, preTaxSavings?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalPreTaxSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, afterTaxSavings?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalAfterTaxSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, educationSavings?: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalEducationSavings?: { __typename: 'RecurringTotals', monthly: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annual: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } } };

export type GetStepFunctionExecutionStatusQueryVariables = Exact<{
  executionArn: Scalars['String'];
  clientID: Scalars['ID'];
}>;


export type GetStepFunctionExecutionStatusQuery = { __typename?: 'Query', stepFunctionExecutionStatus: string };

export type TargetScoreRangesQueryVariables = Exact<{
  clientID: Scalars['ID'];
}>;


export type TargetScoreRangesQuery = { __typename?: 'Query', targetScoreRanges: { __typename?: 'TargetScoreRangesForClientPayload', ranges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, appliedTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type TargetScoreRangeTemplatesQueryVariables = Exact<{
  firmID: Scalars['ID'];
  includeDefaults: Scalars['Boolean'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type TargetScoreRangeTemplatesQuery = { __typename?: 'Query', targetScoreRangeTemplates: { __typename?: 'TargetScoreRangeTemplateList', items: Array<{ __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }> } };

export type TargetScoreRangeTemplateQueryVariables = Exact<{
  firmID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type TargetScoreRangeTemplateQuery = { __typename?: 'Query', targetScoreRangeTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } };

export type FirmDefaultsTargetScoreRangeTemplateQueryVariables = Exact<{
  firmID: Scalars['ID'];
}>;


export type FirmDefaultsTargetScoreRangeTemplateQuery = { __typename?: 'Query', firmDefaultsTargetScoreRangeTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } };

export type CreateTargetScoreRangeTemplateMutationVariables = Exact<{
  input: CreateTargetScoreRangeTemplateInput;
}>;


export type CreateTargetScoreRangeTemplateMutation = { __typename?: 'Mutation', createTargetScoreRangeTemplate: { __typename?: 'CreateTargetScoreRangeTemplatePayload', template: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type UpdateTargetScoreRangeTemplateMutationVariables = Exact<{
  input: UpdateTargetScoreRangeTemplateInput;
}>;


export type UpdateTargetScoreRangeTemplateMutation = { __typename?: 'Mutation', updateTargetScoreRangeTemplate: { __typename?: 'UpdateTargetScoreRangeTemplatePayload', template: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type ResetTargetScoreRangeTemplateValueMutationVariables = Exact<{
  input: ResetTargetScoreRangeTemplateValueInput;
}>;


export type ResetTargetScoreRangeTemplateValueMutation = { __typename?: 'Mutation', resetTargetScoreRangeTemplateValue: { __typename?: 'ResetTargetScoreRangeTemplateValuePayload', template: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type DeleteTargetScoreRangeTemplateMutationVariables = Exact<{
  input: DeleteTargetScoreRangeTemplateInput;
}>;


export type DeleteTargetScoreRangeTemplateMutation = { __typename?: 'Mutation', deleteTargetScoreRangeTemplate: { __typename?: 'DeleteTargetScoreRangeTemplatePayload', deleted: boolean } };

export type ApplyTargetScoreRangeTemplateToClientMutationVariables = Exact<{
  input: ApplyTargetScoreRangeTemplateToClientInput;
}>;


export type ApplyTargetScoreRangeTemplateToClientMutation = { __typename?: 'Mutation', applyTargetScoreRangeTemplateToClient: { __typename?: 'TargetScoreRangesForClientPayload', ranges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, appliedTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type UpdateTargetScoreRangesForClientMutationVariables = Exact<{
  input: UpdateTargetScoreRangesForClientInput;
}>;


export type UpdateTargetScoreRangesForClientMutation = { __typename?: 'Mutation', updateTargetScoreRangesForClient: { __typename?: 'TargetScoreRangesForClientPayload', ranges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, appliedTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type ResetTargetScoreRangeValueForClientMutationVariables = Exact<{
  input: ResetTargetScoreRangeValueForClientInput;
}>;


export type ResetTargetScoreRangeValueForClientMutation = { __typename?: 'Mutation', resetTargetScoreRangeValueForClient: { __typename?: 'TargetScoreRangesForClientPayload', ranges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, appliedTemplate: { __typename: 'TargetScoreRangeTemplate', createdAt: any, firmDefaults: boolean, firmID: string, id: string, name: string, updatedAt: any, derivedRanges: { __typename: 'TargetScoreRanges', br: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, bt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, btUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, dr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, er65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, erUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, es: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ir: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, lt: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, qtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, rtUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, sr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tr: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt35To44: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt45To54: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt55To64: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, tt65AndOver: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null }, ttUnder35: { __typename: 'TargetScoreRange', customized: boolean, customizedAt?: any | null, range?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, resetsTo?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } }, overrides: { __typename: 'TargetScoreRangeOverrides', br?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, bt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, btUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, dr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, er65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, erUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, es?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ir?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, lt?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, qtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, rtUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, sr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tr?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt35To44?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt45To54?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt55To64?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, tt65AndOver?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null, ttUnder35?: { __typename: 'FloatRange', max?: number | null, min?: number | null } | null } } } };

export type TaxReturnSummariesQueryVariables = Exact<{
  householdID: Scalars['ID'];
}>;


export type TaxReturnSummariesQuery = { __typename?: 'Query', taxReturnSummaries: { __typename?: 'TaxReturnSummaryList', items: Array<{ __typename?: 'TaxReturnSummary', id: string, year: number, householdID: string, changeToken: string, stringifiedYear: string, filingStatus: TaxFilingStatus, notes: string, income: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, federalTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null, stateTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type CreateTaxReturnSummaryMutationVariables = Exact<{
  input: CreateTaxReturnSummaryInput;
}>;


export type CreateTaxReturnSummaryMutation = { __typename?: 'Mutation', createTaxReturnSummary: { __typename?: 'CreateTaxReturnSummaryPayload', taxReturnSummary: { __typename?: 'TaxReturnSummary', id: string, householdID: string } } };

export type DeleteTaxReturnSummaryMutationVariables = Exact<{
  input: DeleteTaxReturnSummaryInput;
}>;


export type DeleteTaxReturnSummaryMutation = { __typename?: 'Mutation', deleteTaxReturnSummary: { __typename?: 'DeleteTaxReturnSummaryPayload', changeToken: string } };

export type UpdateTaxReturnSummaryMutationVariables = Exact<{
  input: UpdateTaxReturnSummaryInput;
}>;


export type UpdateTaxReturnSummaryMutation = { __typename?: 'Mutation', updateTaxReturnSummary: { __typename?: 'UpdateTaxReturnSummaryPayload', taxReturnSummary: { __typename?: 'TaxReturnSummary', id: string, householdID: string } } };

export type GetTaxReturnSummaryQueryVariables = Exact<{
  householdID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetTaxReturnSummaryQuery = { __typename?: 'Query', taxReturnSummary?: { __typename?: 'TaxReturnSummary', id: string, year: number, householdID: string, changeToken: string, stringifiedYear: string, filingStatus: TaxFilingStatus, notes: string, income: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, federalTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null, stateTaxesPaid?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } | null } | null };

export type TtDetailsQueryVariables = Exact<{
  householdID: Scalars['ID'];
  includeScore: Scalars['Boolean'];
  includeNetWorth: Scalars['Boolean'];
  includeAnnualExpenses: Scalars['Boolean'];
  includeAssetSummary: Scalars['Boolean'];
  includeDebtSummary: Scalars['Boolean'];
  includeTotalLiquidAssets: Scalars['Boolean'];
  includeTotalQualifiedAssets: Scalars['Boolean'];
  includeTotalRealEstateEquity: Scalars['Boolean'];
  includeTotalBusinessEquity: Scalars['Boolean'];
  includeTotalOther: Scalars['Boolean'];
}>;


export type TtDetailsQuery = { __typename?: 'Query', ttDetails: { __typename?: 'TtDetails', tt?: number | null, netWorth?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, annualExpenses?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, assetSummary?: { __typename?: 'TtAssetSummary', cashAccounts: Array<{ __typename: 'CashAccount', id: string, changeToken: string, householdID: string, name: string, notes: string, updatedAt: any, linkStatus?: MappedAccountStatus | null, cashAccountType: CashAccountType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalCashAccounts: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, preTaxInvestments: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalPreTaxInvestments: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, afterTaxInvestments: Array<{ __typename: 'Investment', id: string, name: string, notes: string, linkID?: string | null, linkStatus?: MappedAccountStatus | null, changeToken: string, householdID: string, investmentType: InvestmentType, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, recurringContribution: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename?: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, investmentMix: { __typename?: 'InvestmentMixDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue', value: InvestmentMix } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalAfterTaxInvestments: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, personalRealEstate: Array<{ __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalPersonalRealEstateValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, investmentRealEstate: Array<{ __typename: 'RealEstate', id: string, name: string, notes: string, householdID: string, changeToken: string, realEstateType: RealEstateType, address?: { __typename?: 'Address', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null } | null, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalInvestmentRealEstateValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, businesses: Array<{ __typename: 'Business', id: string, name: string, notes: string, changeToken: string, householdID: string, entityTaxStructure: EntityTaxStructure, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename?: 'MonetaryAmountDataPointGroup', tenantID: string, id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalBusinessValue: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, noteReceivables: Array<{ __typename: 'NoteReceivable', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, personalPropertyItems: Array<{ __typename: 'PersonalPropertyItem', id: string, householdID: string, createdAt: any, updatedAt: any, changeToken: string, name: string, notes: string, ownedValue: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, value: { __typename: 'MonetaryAmountDataPointGroup', id: string, tenantID: string, parentEntityID?: string | null, createdAt: any, updatedAt: any, changeToken: string, valueExpirationExtension: number, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> }, latestDataPoint?: { __typename: 'FloatDataPoint' } | { __typename: 'InvestmentMixDataPoint' } | { __typename: 'MonetaryAmountDataPoint', id: string, tenantID: string, createdAt: any, updatedAt: any, changeToken: string, dateTime: any, groupID: string, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } | { __typename: 'RecurringMonetaryAmountDataPoint' } | { __typename: 'StringDataPoint' } | null } }>, totalOtherAssets: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalAssets: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, debtSummary?: { __typename?: 'TtDebtSummary', personalRealEstateLoans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalPersonalRealEstateLoans: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, investmentRealEstateLoans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalInvestmentRealEstateLoans: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, studentLoans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalStudentLoans: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, otherDebt: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalOtherDebt: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalDebt: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, businessLoans: Array<{ __typename: 'Loan', id: string, name: string, notes: string, loanType: LoanType, householdID: string, changeToken: string, maturityDate?: any | null, repaymentType?: RepaymentType | null, interestRateDescription?: string | null, originationDate?: any | null, balloonPaymentDate?: any | null, interestRateType?: InterestRateType | null, linkStatus?: MappedAccountStatus | null, accountLinkProvider?: MappedAccountProvider | null, linkedInstitutionName?: string | null, linkID?: string | null, originalAmount?: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } | null, ownedBalance: { __typename: 'MonetaryAmount', value: any, currencyCode: string }, owners: Array<{ __typename?: 'Business', id: string, ownerType: OwnerType } | { __typename?: 'Person', id: string, ownerType: OwnerType }>, ownership: { __typename: 'CommunityProperty' } | { __typename: 'JointWithRightsOfSurvivorship' } | { __typename: 'SoleOwnership' } | { __typename: 'TenantsInCommon', interests?: Array<{ __typename?: 'OwnershipInterest', percentage: number, owner: { __typename: 'Business', name: string, id: string, ownerType: OwnerType } | { __typename: 'Person', givenName: string, familyName?: string | null, id: string, ownerType: OwnerType } }> | null }, paymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, interestRate: { __typename?: 'FloatDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue', value: number } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, extraPaymentAmount: { __typename?: 'RecurringMonetaryAmountDataPointGroup', id: string, latestDataPoint?: { __typename?: 'FloatDataPoint', data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', data: { __typename: 'MonetaryAmountDataPointValue' } } | { __typename?: 'RecurringMonetaryAmountDataPoint', data: { __typename: 'RecurringMonetaryAmountDataPointValue', value: { __typename: 'RecurringMonetaryAmount', frequency: RecurringFrequency, amount: { __typename?: 'MonetaryAmount', value: any, currencyCode: string } } } } | { __typename?: 'StringDataPoint', data: { __typename: 'StringDataPointValue' } } | null }, balance: { __typename?: 'MonetaryAmountDataPointGroup', id: string, updatedAt: any, latestDataPoint?: { __typename?: 'FloatDataPoint', id: string, dateTime: any, data: { __typename: 'FloatDataPointValue' } } | { __typename?: 'InvestmentMixDataPoint', id: string, dateTime: any, data: { __typename: 'InvestmentMixDataPointValue' } } | { __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } } | { __typename?: 'RecurringMonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename: 'RecurringMonetaryAmountDataPointValue' } } | { __typename?: 'StringDataPoint', id: string, dateTime: any, data: { __typename: 'StringDataPointValue' } } | null, dataPoints: { __typename?: 'MonetaryAmountDataPointList', items: Array<{ __typename?: 'MonetaryAmountDataPoint', id: string, dateTime: any, data: { __typename?: 'MonetaryAmountDataPointValue', value: { __typename?: 'MonetaryAmount', currencyCode: string, value: any } } }> } } }>, totalBusinessLoans: { __typename: 'MonetaryAmount', currencyCode: string, value: any } }, totalLiquidAssets?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalQualifiedAssets?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalRealEstateEquity?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalBusinessEquity?: { __typename: 'MonetaryAmount', currencyCode: string, value: any }, totalOther?: { __typename: 'MonetaryAmount', currencyCode: string, value: any } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: boolean };

export const AssetLoanFragmentFragmentDoc = `
    fragment AssetLoanFragment on AssetLoan {
  id
  householdID
  createdAt
  updatedAt
  changeToken
  assetID
  loanID
}
    `;
export const MonetaryAmountFragmentFragmentDoc = `
    fragment MonetaryAmountFragment on MonetaryAmount {
  __typename
  currencyCode
  value
}
    `;
export const BaaAccountFragmentFragmentDoc = `
    fragment BaaAccountFragment on BaaAccount {
  __typename
  id
  name
  value {
    ...MonetaryAmountFragment
  }
  updatedAt
  accountType
  changeToken
  createdAt
  firmMemberID
  BAAAccountID
  householdID
  firmClientID
  accountNumber
  mappedEntityID
  BAAFinancialProfileID
  financialInstitutionID
  financialInstitutionName
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const OwnerFragmentFragmentDoc = `
    fragment OwnerFragment on Owner {
  __typename
  id
  ownerType
  ... on Person {
    givenName
    familyName
  }
  ... on Business {
    name
  }
}
    `;
export const BusinessFragmentFragmentDoc = `
    fragment BusinessFragment on Business {
  id
  name
  notes
  __typename
  changeToken
  householdID
  entityTaxStructure
  ownedValue {
    __typename
    value
    currencyCode
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  value {
    tenantID
    id
    updatedAt
    latestDataPoint {
      dateTime
      data {
        __typename
        ... on MonetaryAmountDataPointValue {
          value {
            currencyCode
            value
          }
        }
      }
    }
    dataPoints {
      items {
        id
        dateTime
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
    }
  }
}
    ${OwnerFragmentFragmentDoc}`;
export const MonetaryAmountDataPointFragmentFragmentDoc = `
    fragment MonetaryAmountDataPointFragment on MonetaryAmountDataPoint {
  __typename
  id
  tenantID
  createdAt
  updatedAt
  changeToken
  dateTime
  groupID
  data {
    __typename
    ... on MonetaryAmountDataPointValue {
      value {
        value
        currencyCode
      }
    }
  }
}
    `;
export const MonetaryAmountDataPointGroupFragmentFragmentDoc = `
    fragment MonetaryAmountDataPointGroupFragment on MonetaryAmountDataPointGroup {
  __typename
  id
  tenantID
  parentEntityID
  createdAt
  updatedAt
  changeToken
  valueExpirationExtension
  dataPoints {
    items {
      id
      dateTime
      data {
        __typename
        ... on MonetaryAmountDataPointValue {
          value {
            currencyCode
            value
          }
        }
      }
    }
  }
  latestDataPoint {
    __typename
    ... on MonetaryAmountDataPoint {
      ...MonetaryAmountDataPointFragment
    }
  }
}
    ${MonetaryAmountDataPointFragmentFragmentDoc}`;
export const CashAccountFragmentFragmentDoc = `
    fragment CashAccountFragment on CashAccount {
  id
  changeToken
  __typename
  householdID
  name
  notes
  updatedAt
  linkStatus
  cashAccountType
  accountLinkProvider
  linkedInstitutionName
  linkID
  ownedValue {
    __typename
    value
    currencyCode
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  recurringContribution {
    id
    latestDataPoint {
      data {
        __typename
        ... on RecurringMonetaryAmountDataPointValue {
          value {
            amount {
              value
              currencyCode
            }
            frequency
          }
        }
      }
    }
  }
  value {
    ...MonetaryAmountDataPointGroupFragment
  }
}
    ${OwnerFragmentFragmentDoc}
${MonetaryAmountDataPointGroupFragmentFragmentDoc}`;
export const ConversationFragmentFragmentDoc = `
    fragment ConversationFragment on Conversation {
  __typename
  id
  muted
  createdAt
  updatedAt
  changeToken
  firmClientID
  hasUnreadMessages
  latestMessagePreview
  latestMessageID
  lastMessageRead
  latestMessageDateTime
  participants {
    id
    type
    userID
    givenName
    familyName
    profileColor
    profileImage
  }
}
    `;
export const StringDataPointFragmentFragmentDoc = `
    fragment StringDataPointFragment on StringDataPoint {
  __typename
  id
  tenantID
  createdAt
  updatedAt
  changeToken
  dateTime
  groupID
  data {
    __typename
    ... on StringDataPointValue {
      value
    }
  }
}
    `;
export const FileFragmentFragmentDoc = `
    fragment FileFragment on File {
  id
  name
  tenantID
  contentType
  createdAt
  standalone
  downloadURL
  uploadURL
  uploadStatus
  createdBy {
    email
    givenName
    familyName
  }
}
    `;
export const FileAttachmentFragmentFragmentDoc = `
    fragment FileAttachmentFragment on FileAttachment {
  id
  fileID
  tenantID
  createdAt
  updatedAt
  changeToken
  itemID
  file {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;
export const FinancialGoalFragmentFragmentDoc = `
    fragment FinancialGoalFragment on FinancialGoal {
  __typename
  id
  householdID
  changeToken
  body
  achieved
  changeToken
  order
}
    `;
export const FinancialNextStepFragmentFragmentDoc = `
    fragment FinancialNextStepFragment on FinancialNextStep {
  __typename
  id
  changeToken
  body
  done
  changeToken
  householdID
  order
}
    `;
export const FirmClientListItemFragmentFragmentDoc = `
    fragment FirmClientListItemFragment on FirmClient {
  id
  mode
  createdAt
  givenNamesDisplay
  familyNamesDisplay
  pendingInvitations {
    id
    inviteeEmail
  }
  originFirmInviteLink {
    id
    campaignName
  }
  household {
    id
  }
  individuals {
    age
    emailAddress
    familyName
    givenName
    profileColor
    phoneNumber
    profileImage
    userID
  }
  group {
    id
    name
  }
}
    `;
export const UserProfileFragmentFragmentDoc = `
    fragment UserProfileFragment on UserProfile {
  elementsID
  email
  givenName
  familyName
  profession
  profileImage
  profileColor
}
    `;
export const ClientInvitationFragmentFragmentDoc = `
    fragment ClientInvitationFragment on ClientInvitation {
  id
  createdAt
  updatedAt
  dateTime
  type
  inviteeEmail
  inviteeGivenName
  inviteeFamilyName
  inviter {
    ...UserProfileFragment
  }
  acceptedAt
  status
  firmID
  firmName
  clientID
  personID
  householdID
}
    ${UserProfileFragmentFragmentDoc}`;
export const FirmBrandingFragmentFragmentDoc = `
    fragment FirmBrandingFragment on FirmBranding {
  __typename
  id
  name
  color
  type
  logo {
    id
    name
    tenantID
    contentType
    createdAt
    standalone
    downloadURL
    uploadURL
    uploadStatus
    createdBy {
      email
      givenName
      familyName
    }
  }
}
    `;
export const InviteLinkFragmentFragmentDoc = `
    fragment InviteLinkFragment on FirmInviteLink {
  __typename
  id
  title
  changeToken
  description
  campaignName
  acceptFormURL
  status
  inviterUserID
  primaryAdvisorFirmMemberID
  disclosure
  firm {
    ...FirmBrandingFragment
  }
}
    ${FirmBrandingFragmentFragmentDoc}`;
export const FirmClientFragmentFragmentDoc = `
    fragment FirmClientFragment on FirmClient {
  ...FirmClientListItemFragment
  firmID
  activeFeatureDiscoveryTriggers
  pendingInvitations {
    ...ClientInvitationFragment
  }
  originFirmInviteLink {
    ...InviteLinkFragment
  }
  notes {
    id
    tenantID
    latestDataPoint {
      id
      data {
        __typename
        ... on StringDataPointValue {
          value
        }
      }
    }
  }
  household {
    id
    householdID
    ownerID
    financialCategorization
    financialCategoryScore
    financialPurpose {
      id
      tenantID
      latestDataPoint {
        id
        data {
          __typename
          ... on StringDataPointValue {
            value
          }
        }
      }
    }
    income {
      id
      latestDataPoint {
        ... on RecurringMonetaryAmountDataPoint {
          data {
            __typename
            value {
              amount {
                value
                currencyCode
              }
              frequency
            }
          }
        }
      }
    }
    spending {
      id
      tenantID
      updatedAt
      latestDataPoint {
        dateTime
        ... on RecurringMonetaryAmountDataPoint {
          data {
            __typename
            value {
              amount {
                value
                currencyCode
              }
              frequency
            }
          }
        }
      }
    }
  }
  individuals {
    relationship
  }
  team {
    role
    __typename
    member {
      id
      calendarSchedulingLink
      familyName
      givenName
      profileColor
    }
  }
}
    ${FirmClientListItemFragmentFragmentDoc}
${ClientInvitationFragmentFragmentDoc}
${InviteLinkFragmentFragmentDoc}`;
export const FirmFragmentFragmentDoc = `
    fragment FirmFragment on Firm {
  __typename
  id
  entitlements
  createdAt
  updatedAt
  changeToken
  name
  logo {
    downloadURL
  }
  color
  emailDisclosureText
  reportDisclosureText
  aiPromptAugmentation
  disableEmailNotifications
  estateStatusBetaEnabled
  mcpBetaEnabled
  elementCustomizationBetaEnabled
  elementCustomizations {
    element
    customName
    shortName
    visibleByDefault
  }
  delinquent
  billingPortalLink
  type
}
    `;
export const FirmMemberFragmentFragmentDoc = `
    fragment FirmMemberFragment on FirmMember {
  __typename
  id
  firmID
  createdAt
  updatedAt
  changeToken
  userID
  givenName
  familyName
  role
  emailSignature
  calendarSchedulingLink
}
    `;
export const PersonFragmentFragmentDoc = `
    fragment PersonFragment on Person {
  id
  householdID
  createdAt
  updatedAt
  changeToken
  givenName
  familyName
  dateOfBirth
  relationship
  phoneNumber
  emailAddress
  userID
  profileColor
  profileImage
  occupation
}
    `;
export const RecurringMonetaryAmountDataPointFragmentFragmentDoc = `
    fragment RecurringMonetaryAmountDataPointFragment on RecurringMonetaryAmountDataPoint {
  __typename
  id
  tenantID
  createdAt
  updatedAt
  changeToken
  dateTime
  groupID
  data {
    __typename
    ... on RecurringMonetaryAmountDataPointValue {
      value {
        __typename
        amount {
          __typename
          value
          currencyCode
        }
        frequency
      }
    }
  }
}
    `;
export const RecurringMonetaryAmountDataPointGroupFragmentFragmentDoc = `
    fragment RecurringMonetaryAmountDataPointGroupFragment on RecurringMonetaryAmountDataPointGroup {
  __typename
  id
  tenantID
  parentEntityID
  createdAt
  updatedAt
  changeToken
  valueExpirationExtension
  latestDataPoint {
    __typename
    ... on RecurringMonetaryAmountDataPoint {
      ...RecurringMonetaryAmountDataPointFragment
    }
  }
}
    ${RecurringMonetaryAmountDataPointFragmentFragmentDoc}`;
export const IncomeSourceFragmentFragmentDoc = `
    fragment IncomeSourceFragment on IncomeSource {
  id
  householdID
  personID
  person {
    ...PersonFragment
  }
  changeToken
  createdAt
  updatedAt
  name
  sourceType
  amountDataPointGroup {
    ...RecurringMonetaryAmountDataPointGroupFragment
  }
  notes
  archived
  isFutureGuaranteedIncome
  omitFromScorecard
}
    ${PersonFragmentFragmentDoc}
${RecurringMonetaryAmountDataPointGroupFragmentFragmentDoc}`;
export const InsuranceFragmentFragmentDoc = `
    fragment InsuranceFragment on InsurancePolicy {
  name
  notes
  id
  changeToken
  householdID
  createdAt
  policyType
  policySubtype
  coverageAmount {
    value
    currencyCode
    __typename
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  purchasedDate
  expirationDate
  updatedAt
}
    ${OwnerFragmentFragmentDoc}`;
export const InvestmentFragmentFragmentDoc = `
    fragment InvestmentFragment on Investment {
  id
  name
  notes
  linkID
  __typename
  linkStatus
  changeToken
  householdID
  investmentType
  accountLinkProvider
  linkedInstitutionName
  notes
  ownedValue {
    __typename
    value
    currencyCode
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  recurringContribution {
    id
    latestDataPoint {
      data {
        __typename
        ... on RecurringMonetaryAmountDataPointValue {
          value {
            amount {
              value
              currencyCode
            }
            frequency
          }
        }
      }
    }
  }
  investmentMix {
    id
    latestDataPoint {
      data {
        __typename
        ... on InvestmentMixDataPointValue {
          value
        }
      }
    }
  }
  value {
    id
    latestDataPoint {
      dateTime
      data {
        __typename
        ... on MonetaryAmountDataPointValue {
          value {
            currencyCode
            value
          }
        }
      }
    }
    tenantID
    id
    updatedAt
    dataPoints {
      items {
        id
        dateTime
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
    }
  }
}
    ${OwnerFragmentFragmentDoc}`;
export const LoanFragmentFragmentDoc = `
    fragment LoanFragment on Loan {
  id
  name
  notes
  __typename
  loanType
  householdID
  changeToken
  maturityDate
  repaymentType
  interestRateDescription
  originalAmount {
    value
    currencyCode
  }
  ownedBalance {
    __typename
    value
    currencyCode
  }
  originationDate
  balloonPaymentDate
  interestRateType
  linkStatus
  accountLinkProvider
  linkedInstitutionName
  linkID
  owners {
    id
    ownerType
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  paymentAmount {
    id
    latestDataPoint {
      data {
        __typename
        ... on RecurringMonetaryAmountDataPointValue {
          value {
            __typename
            amount {
              __typename
              value
              currencyCode
            }
            frequency
          }
        }
      }
    }
  }
  interestRate {
    id
    latestDataPoint {
      data {
        __typename
        ... on FloatDataPointValue {
          value
        }
      }
    }
  }
  extraPaymentAmount {
    id
    latestDataPoint {
      data {
        __typename
        ... on RecurringMonetaryAmountDataPointValue {
          value {
            __typename
            amount {
              value
              currencyCode
            }
            frequency
          }
        }
      }
    }
  }
  balance {
    id
    updatedAt
    latestDataPoint {
      id
      dateTime
      data {
        __typename
        ... on MonetaryAmountDataPointValue {
          value {
            currencyCode
            value
          }
        }
      }
    }
    dataPoints {
      items {
        id
        dateTime
        data {
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
    }
  }
}
    ${OwnerFragmentFragmentDoc}`;
export const MessageFragmentFragmentDoc = `
    fragment MessageFragment on Message {
  id
  conversationID
  createdAt
  updatedAt
  changeToken
  sender
  __typename
  hasOnboardingReminder
  ... on FreeformMessage {
    message
    hasOnboardingReminder
    suggestedResponses
    attachments {
      ...FileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;
export const OwnershipFragmentFragmentDoc = `
    fragment OwnershipFragment on Ownership {
  __typename
  ... on TenantsInCommon {
    interests {
      owner {
        ...OwnerFragment
      }
      percentage
    }
  }
}
    ${OwnerFragmentFragmentDoc}`;
export const NoteReceivableFragmentFragmentDoc = `
    fragment NoteReceivableFragment on NoteReceivable {
  __typename
  id
  householdID
  createdAt
  updatedAt
  changeToken
  name
  notes
  ownedValue {
    __typename
    value
    currencyCode
  }
  owners {
    __typename
    id
    ownerType
    ... on Person {
      givenName
      familyName
    }
    ... on Business {
      name
    }
  }
  ownership {
    ...OwnershipFragment
  }
  value {
    ...MonetaryAmountDataPointGroupFragment
  }
}
    ${OwnershipFragmentFragmentDoc}
${MonetaryAmountDataPointGroupFragmentFragmentDoc}`;
export const PersonalPropertyItemFragmentFragmentDoc = `
    fragment PersonalPropertyItemFragment on PersonalPropertyItem {
  __typename
  id
  householdID
  createdAt
  updatedAt
  changeToken
  name
  notes
  ownedValue {
    __typename
    value
    currencyCode
  }
  owners {
    __typename
    id
    ownerType
    ... on Person {
      givenName
      familyName
    }
    ... on Business {
      name
    }
  }
  ownership {
    ...OwnershipFragment
  }
  value {
    ...MonetaryAmountDataPointGroupFragment
  }
}
    ${OwnershipFragmentFragmentDoc}
${MonetaryAmountDataPointGroupFragmentFragmentDoc}`;
export const RealEstateFragmentFragmentDoc = `
    fragment RealEstateFragment on RealEstate {
  id
  name
  notes
  householdID
  __typename
  changeToken
  realEstateType
  address {
    street1
    street2
    city
    state
    country
    postalCode
  }
  ownedValue {
    __typename
    value
    currencyCode
  }
  ownership {
    __typename
    ... on TenantsInCommon {
      interests {
        owner {
          ...OwnerFragment
        }
        percentage
      }
    }
  }
  value {
    id
    tenantID
    updatedAt
    latestDataPoint {
      id
      dateTime
      data {
        __typename
        ... on MonetaryAmountDataPointValue {
          value {
            currencyCode
            value
          }
        }
      }
    }
    dataPoints {
      items {
        id
        dateTime
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
    }
  }
}
    ${OwnerFragmentFragmentDoc}`;
export const SpendingCategoryEstimateFragmentFragmentDoc = `
    fragment SpendingCategoryEstimateFragment on SpendingCategoryEstimate {
  id
  householdID
  changeToken
  createdAt
  updatedAt
  dateTime
  notes
  categoryEstimates {
    category
    estimate {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const RecurringTotalsFragmentFragmentDoc = `
    fragment RecurringTotalsFragment on RecurringTotals {
  __typename
  monthly {
    __typename
    currencyCode
    value
  }
  annual {
    __typename
    currencyCode
    value
  }
}
    `;
export const RecurringMonetaryAmountFragmentFragmentDoc = `
    fragment RecurringMonetaryAmountFragment on RecurringMonetaryAmount {
  __typename
  amount {
    ...MonetaryAmountFragment
  }
  frequency
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const FloatRangeFragmentFragmentDoc = `
    fragment FloatRangeFragment on FloatRange {
  __typename
  max
  min
}
    `;
export const TargetScoreRangeFragmentFragmentDoc = `
    fragment TargetScoreRangeFragment on TargetScoreRange {
  __typename
  customized
  customizedAt
  range {
    ...FloatRangeFragment
  }
  resetsTo {
    ...FloatRangeFragment
  }
}
    ${FloatRangeFragmentFragmentDoc}`;
export const TargetScoreRangesFragmentFragmentDoc = `
    fragment TargetScoreRangesFragment on TargetScoreRanges {
  __typename
  br {
    ...TargetScoreRangeFragment
  }
  bt35To44 {
    ...TargetScoreRangeFragment
  }
  bt45To54 {
    ...TargetScoreRangeFragment
  }
  bt55To64 {
    ...TargetScoreRangeFragment
  }
  bt65AndOver {
    ...TargetScoreRangeFragment
  }
  btUnder35 {
    ...TargetScoreRangeFragment
  }
  dr {
    ...TargetScoreRangeFragment
  }
  er35To44 {
    ...TargetScoreRangeFragment
  }
  er45To54 {
    ...TargetScoreRangeFragment
  }
  er55To64 {
    ...TargetScoreRangeFragment
  }
  er65AndOver {
    ...TargetScoreRangeFragment
  }
  erUnder35 {
    ...TargetScoreRangeFragment
  }
  es {
    ...TargetScoreRangeFragment
  }
  ir {
    ...TargetScoreRangeFragment
  }
  lt {
    ...TargetScoreRangeFragment
  }
  qt35To44 {
    ...TargetScoreRangeFragment
  }
  qt45To54 {
    ...TargetScoreRangeFragment
  }
  qt55To64 {
    ...TargetScoreRangeFragment
  }
  qt65AndOver {
    ...TargetScoreRangeFragment
  }
  qtUnder35 {
    ...TargetScoreRangeFragment
  }
  rt35To44 {
    ...TargetScoreRangeFragment
  }
  rt45To54 {
    ...TargetScoreRangeFragment
  }
  rt55To64 {
    ...TargetScoreRangeFragment
  }
  rt65AndOver {
    ...TargetScoreRangeFragment
  }
  rtUnder35 {
    ...TargetScoreRangeFragment
  }
  sr {
    ...TargetScoreRangeFragment
  }
  tr {
    ...TargetScoreRangeFragment
  }
  tt35To44 {
    ...TargetScoreRangeFragment
  }
  tt45To54 {
    ...TargetScoreRangeFragment
  }
  tt55To64 {
    ...TargetScoreRangeFragment
  }
  tt65AndOver {
    ...TargetScoreRangeFragment
  }
  ttUnder35 {
    ...TargetScoreRangeFragment
  }
}
    ${TargetScoreRangeFragmentFragmentDoc}`;
export const TargetScoreRangeOverridesFragmentFragmentDoc = `
    fragment TargetScoreRangeOverridesFragment on TargetScoreRangeOverrides {
  __typename
  br {
    ...FloatRangeFragment
  }
  bt35To44 {
    ...FloatRangeFragment
  }
  bt45To54 {
    ...FloatRangeFragment
  }
  bt55To64 {
    ...FloatRangeFragment
  }
  bt65AndOver {
    ...FloatRangeFragment
  }
  btUnder35 {
    ...FloatRangeFragment
  }
  dr {
    ...FloatRangeFragment
  }
  er35To44 {
    ...FloatRangeFragment
  }
  er45To54 {
    ...FloatRangeFragment
  }
  er55To64 {
    ...FloatRangeFragment
  }
  er65AndOver {
    ...FloatRangeFragment
  }
  erUnder35 {
    ...FloatRangeFragment
  }
  es {
    ...FloatRangeFragment
  }
  ir {
    ...FloatRangeFragment
  }
  lt {
    ...FloatRangeFragment
  }
  qt35To44 {
    ...FloatRangeFragment
  }
  qt45To54 {
    ...FloatRangeFragment
  }
  qt55To64 {
    ...FloatRangeFragment
  }
  qt65AndOver {
    ...FloatRangeFragment
  }
  qtUnder35 {
    ...FloatRangeFragment
  }
  rt35To44 {
    ...FloatRangeFragment
  }
  rt45To54 {
    ...FloatRangeFragment
  }
  rt55To64 {
    ...FloatRangeFragment
  }
  rt65AndOver {
    ...FloatRangeFragment
  }
  rtUnder35 {
    ...FloatRangeFragment
  }
  sr {
    ...FloatRangeFragment
  }
  tr {
    ...FloatRangeFragment
  }
  tt35To44 {
    ...FloatRangeFragment
  }
  tt45To54 {
    ...FloatRangeFragment
  }
  tt55To64 {
    ...FloatRangeFragment
  }
  tt65AndOver {
    ...FloatRangeFragment
  }
  ttUnder35 {
    ...FloatRangeFragment
  }
}
    ${FloatRangeFragmentFragmentDoc}`;
export const TargetScoreRangeTemplateFragmentFragmentDoc = `
    fragment TargetScoreRangeTemplateFragment on TargetScoreRangeTemplate {
  __typename
  createdAt
  derivedRanges {
    ...TargetScoreRangesFragment
  }
  firmDefaults
  firmID
  id
  name
  overrides {
    ...TargetScoreRangeOverridesFragment
  }
  updatedAt
}
    ${TargetScoreRangesFragmentFragmentDoc}
${TargetScoreRangeOverridesFragmentFragmentDoc}`;
export const TaxReturnSummaryFragmentFragmentDoc = `
    fragment TaxReturnSummaryFragment on TaxReturnSummary {
  id
  year
  householdID
  changeToken
  stringifiedYear
  filingStatus
  notes
  income {
    ...MonetaryAmountFragment
  }
  federalTaxesPaid {
    ...MonetaryAmountFragment
  }
  stateTaxesPaid {
    ...MonetaryAmountFragment
  }
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const UnassignedBaaAccountFragmentFragmentDoc = `
    fragment UnassignedBaaAccountFragment on UnassignedBaaAccount {
  __typename
  id
  name
  value
  accountType
  updatedAt
  status
  firmMemberID
  statusErrorCode
  accountNumber
  BAAFinancialProfileID
  financialInstitutionID
  financialInstitutionName
}
    `;
export const AdvisorClientAssessmentPageDocument = `
    query AdvisorClientAssessmentPage($clientID: ID!, $firmID: ID!) {
  firmBranding(id: $firmID) {
    color
  }
  firm(id: $firmID) {
    entitlements
  }
  latestAiClientSummaryVersion(clientID: $clientID) {
    versionID
  }
  aiClientSummaryVersions(clientID: $clientID) {
    versionID
    publishedAt
    modelID
    publishedBy
  }
  firmMembersForFirm(firmID: $firmID) {
    items {
      id
      userID
      givenName
      familyName
      profileColor
      profileImage
    }
  }
}
    `;
export const useAdvisorClientAssessmentPageQuery = <
      TData = AdvisorClientAssessmentPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AdvisorClientAssessmentPageQueryVariables,
      options?: UseQueryOptions<AdvisorClientAssessmentPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AdvisorClientAssessmentPageQuery, TError, TData>(
      ['AdvisorClientAssessmentPage', variables],
      fetcher<AdvisorClientAssessmentPageQuery, AdvisorClientAssessmentPageQueryVariables>(client, AdvisorClientAssessmentPageDocument, variables, headers),
      options
    );

useAdvisorClientAssessmentPageQuery.getKey = (variables: AdvisorClientAssessmentPageQueryVariables) => ['AdvisorClientAssessmentPage', variables];
;

useAdvisorClientAssessmentPageQuery.fetcher = (client: GraphQLClient, variables: AdvisorClientAssessmentPageQueryVariables, headers?: RequestInit['headers']) => fetcher<AdvisorClientAssessmentPageQuery, AdvisorClientAssessmentPageQueryVariables>(client, AdvisorClientAssessmentPageDocument, variables, headers);
export const AdvisorClientAssessmentVersionPageDocument = `
    query AdvisorClientAssessmentVersionPage($clientID: ID!, $firmID: ID!) {
  firmClient(firmID: $firmID, id: $clientID) {
    givenNamesDisplay
    familyNamesDisplay
    individuals {
      profileImage
      profileColor
      familyName
      givenName
    }
    entitlements {
      aiAssessment
    }
    household {
      id
    }
  }
  latestAiClientSummaryVersion(clientID: $clientID) {
    versionID
  }
  firmMembersForFirm(firmID: $firmID) {
    items {
      id
      userID
      givenName
      familyName
      profileImage
      profileColor
    }
  }
  aiClientSummaryVersions(clientID: $clientID) {
    versionID
    publishedAt
    updatedAt
    publishedBy
    aiResponses {
      shortCategoryExplanation
      strengths
      areasForImprovement {
        body
        goalBody
      }
      elementDetails {
        Br
        Bt
        Dr
        Er
        Ir
        Lt
        Qt
        Rt
        Sr
        Tr
        Tt
      }
    }
    dataConfidenceLevel
    dataConfidenceSummary
  }
}
    `;
export const useAdvisorClientAssessmentVersionPageQuery = <
      TData = AdvisorClientAssessmentVersionPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AdvisorClientAssessmentVersionPageQueryVariables,
      options?: UseQueryOptions<AdvisorClientAssessmentVersionPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AdvisorClientAssessmentVersionPageQuery, TError, TData>(
      ['AdvisorClientAssessmentVersionPage', variables],
      fetcher<AdvisorClientAssessmentVersionPageQuery, AdvisorClientAssessmentVersionPageQueryVariables>(client, AdvisorClientAssessmentVersionPageDocument, variables, headers),
      options
    );

useAdvisorClientAssessmentVersionPageQuery.getKey = (variables: AdvisorClientAssessmentVersionPageQueryVariables) => ['AdvisorClientAssessmentVersionPage', variables];
;

useAdvisorClientAssessmentVersionPageQuery.fetcher = (client: GraphQLClient, variables: AdvisorClientAssessmentVersionPageQueryVariables, headers?: RequestInit['headers']) => fetcher<AdvisorClientAssessmentVersionPageQuery, AdvisorClientAssessmentVersionPageQueryVariables>(client, AdvisorClientAssessmentVersionPageDocument, variables, headers);
export const AdvisorClientOptionsDocument = `
    query AdvisorClientOptions($firmID: ID!, $id: ID!) {
  firmClient(firmID: $firmID, id: $id) {
    changeToken
    emailNotificationFirmMemberIds
    entitlements {
      aiAssessment
    }
    group {
      id
    }
  }
  firm(id: $firmID) {
    entitlements
    disableEmailNotifications
  }
  firmClientForSelf(firmID: $firmID) {
    id
  }
}
    `;
export const useAdvisorClientOptionsQuery = <
      TData = AdvisorClientOptionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AdvisorClientOptionsQueryVariables,
      options?: UseQueryOptions<AdvisorClientOptionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AdvisorClientOptionsQuery, TError, TData>(
      ['AdvisorClientOptions', variables],
      fetcher<AdvisorClientOptionsQuery, AdvisorClientOptionsQueryVariables>(client, AdvisorClientOptionsDocument, variables, headers),
      options
    );

useAdvisorClientOptionsQuery.getKey = (variables: AdvisorClientOptionsQueryVariables) => ['AdvisorClientOptions', variables];
;

useAdvisorClientOptionsQuery.fetcher = (client: GraphQLClient, variables: AdvisorClientOptionsQueryVariables, headers?: RequestInit['headers']) => fetcher<AdvisorClientOptionsQuery, AdvisorClientOptionsQueryVariables>(client, AdvisorClientOptionsDocument, variables, headers);
export const UpdateFirmClientDocument = `
    mutation updateFirmClient($input: UpdateFirmClientInput!) {
  updateFirmClient(input: $input) {
    firmClient {
      id
    }
  }
}
    `;
export const useUpdateFirmClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFirmClientMutation, TError, UpdateFirmClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFirmClientMutation, TError, UpdateFirmClientMutationVariables, TContext>(
      ['updateFirmClient'],
      (variables?: UpdateFirmClientMutationVariables) => fetcher<UpdateFirmClientMutation, UpdateFirmClientMutationVariables>(client, UpdateFirmClientDocument, variables, headers)(),
      options
    );
useUpdateFirmClientMutation.getKey = () => ['updateFirmClient'];

useUpdateFirmClientMutation.fetcher = (client: GraphQLClient, variables: UpdateFirmClientMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFirmClientMutation, UpdateFirmClientMutationVariables>(client, UpdateFirmClientDocument, variables, headers);
export const RefreshAiClientSummaryDocument = `
    mutation refreshAiClientSummary($input: RefreshAiClientSummaryInput!) {
  refreshAiClientSummary(input: $input) {
    success
    executionID
  }
}
    `;
export const useRefreshAiClientSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefreshAiClientSummaryMutation, TError, RefreshAiClientSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefreshAiClientSummaryMutation, TError, RefreshAiClientSummaryMutationVariables, TContext>(
      ['refreshAiClientSummary'],
      (variables?: RefreshAiClientSummaryMutationVariables) => fetcher<RefreshAiClientSummaryMutation, RefreshAiClientSummaryMutationVariables>(client, RefreshAiClientSummaryDocument, variables, headers)(),
      options
    );
useRefreshAiClientSummaryMutation.getKey = () => ['refreshAiClientSummary'];

useRefreshAiClientSummaryMutation.fetcher = (client: GraphQLClient, variables: RefreshAiClientSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<RefreshAiClientSummaryMutation, RefreshAiClientSummaryMutationVariables>(client, RefreshAiClientSummaryDocument, variables, headers);
export const PublishAiClientSummaryDocument = `
    mutation publishAiClientSummary($input: PublishAiClientSummaryInput!) {
  publishAiClientSummary(input: $input) {
    success
    versionID
  }
}
    `;
export const usePublishAiClientSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<PublishAiClientSummaryMutation, TError, PublishAiClientSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<PublishAiClientSummaryMutation, TError, PublishAiClientSummaryMutationVariables, TContext>(
      ['publishAiClientSummary'],
      (variables?: PublishAiClientSummaryMutationVariables) => fetcher<PublishAiClientSummaryMutation, PublishAiClientSummaryMutationVariables>(client, PublishAiClientSummaryDocument, variables, headers)(),
      options
    );
usePublishAiClientSummaryMutation.getKey = () => ['publishAiClientSummary'];

usePublishAiClientSummaryMutation.fetcher = (client: GraphQLClient, variables: PublishAiClientSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<PublishAiClientSummaryMutation, PublishAiClientSummaryMutationVariables>(client, PublishAiClientSummaryDocument, variables, headers);
export const GetAiClientSummaryDocument = `
    query getAiClientSummary($clientID: ID!) {
  aiClientSummary(clientID: $clientID) {
    updatedAt
    dataConfidenceLevel
    dataConfidenceSummary
    summary
    householdCategorySummary
    shortHouseholdCategorySummary
    advisorApproved
    aiResponses {
      shortCategoryExplanation
      strengths
      areasForImprovement {
        body
        goalBody
      }
      elementDetails {
        Er
        Ir
        Sr
        Br
        Dr
        Tr
        Lt
        Qt
        Rt
        Bt
        Tt
      }
    }
  }
}
    `;
export const useGetAiClientSummaryQuery = <
      TData = GetAiClientSummaryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAiClientSummaryQueryVariables,
      options?: UseQueryOptions<GetAiClientSummaryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAiClientSummaryQuery, TError, TData>(
      ['getAiClientSummary', variables],
      fetcher<GetAiClientSummaryQuery, GetAiClientSummaryQueryVariables>(client, GetAiClientSummaryDocument, variables, headers),
      options
    );

useGetAiClientSummaryQuery.getKey = (variables: GetAiClientSummaryQueryVariables) => ['getAiClientSummary', variables];
;

useGetAiClientSummaryQuery.fetcher = (client: GraphQLClient, variables: GetAiClientSummaryQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAiClientSummaryQuery, GetAiClientSummaryQueryVariables>(client, GetAiClientSummaryDocument, variables, headers);
export const GetLatestAiClientSummaryVersionDocument = `
    query getLatestAiClientSummaryVersion($clientID: ID!) {
  latestAiClientSummaryVersion(clientID: $clientID) {
    versionID
    updatedAt
    dataConfidenceLevel
    dataConfidenceSummary
    summary
    householdCategorySummary
    shortHouseholdCategorySummary
    aiResponses {
      shortCategoryExplanation
      strengths
      areasForImprovement {
        body
        goalBody
      }
      elementDetails {
        Er
        Ir
        Sr
        Br
        Dr
        Tr
        Lt
        Qt
        Rt
        Bt
        Tt
      }
    }
  }
}
    `;
export const useGetLatestAiClientSummaryVersionQuery = <
      TData = GetLatestAiClientSummaryVersionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLatestAiClientSummaryVersionQueryVariables,
      options?: UseQueryOptions<GetLatestAiClientSummaryVersionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetLatestAiClientSummaryVersionQuery, TError, TData>(
      ['getLatestAiClientSummaryVersion', variables],
      fetcher<GetLatestAiClientSummaryVersionQuery, GetLatestAiClientSummaryVersionQueryVariables>(client, GetLatestAiClientSummaryVersionDocument, variables, headers),
      options
    );

useGetLatestAiClientSummaryVersionQuery.getKey = (variables: GetLatestAiClientSummaryVersionQueryVariables) => ['getLatestAiClientSummaryVersion', variables];
;

useGetLatestAiClientSummaryVersionQuery.fetcher = (client: GraphQLClient, variables: GetLatestAiClientSummaryVersionQueryVariables, headers?: RequestInit['headers']) => fetcher<GetLatestAiClientSummaryVersionQuery, GetLatestAiClientSummaryVersionQueryVariables>(client, GetLatestAiClientSummaryVersionDocument, variables, headers);
export const CreateAiFeedbackDocument = `
    mutation createAIFeedback($input: CreateAiFeedbackInput!) {
  createAiFeedback(input: $input) {
    success
  }
}
    `;
export const useCreateAiFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAiFeedbackMutation, TError, CreateAiFeedbackMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAiFeedbackMutation, TError, CreateAiFeedbackMutationVariables, TContext>(
      ['createAIFeedback'],
      (variables?: CreateAiFeedbackMutationVariables) => fetcher<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>(client, CreateAiFeedbackDocument, variables, headers)(),
      options
    );
useCreateAiFeedbackMutation.getKey = () => ['createAIFeedback'];

useCreateAiFeedbackMutation.fetcher = (client: GraphQLClient, variables: CreateAiFeedbackMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAiFeedbackMutation, CreateAiFeedbackMutationVariables>(client, CreateAiFeedbackDocument, variables, headers);
export const UpdateAiClientSummaryDocument = `
    mutation updateAiClientSummary($input: UpdateAiClientSummaryInput!) {
  updateAiClientSummary(input: $input) {
    __typename
  }
}
    `;
export const useUpdateAiClientSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateAiClientSummaryMutation, TError, UpdateAiClientSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateAiClientSummaryMutation, TError, UpdateAiClientSummaryMutationVariables, TContext>(
      ['updateAiClientSummary'],
      (variables?: UpdateAiClientSummaryMutationVariables) => fetcher<UpdateAiClientSummaryMutation, UpdateAiClientSummaryMutationVariables>(client, UpdateAiClientSummaryDocument, variables, headers)(),
      options
    );
useUpdateAiClientSummaryMutation.getKey = () => ['updateAiClientSummary'];

useUpdateAiClientSummaryMutation.fetcher = (client: GraphQLClient, variables: UpdateAiClientSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateAiClientSummaryMutation, UpdateAiClientSummaryMutationVariables>(client, UpdateAiClientSummaryDocument, variables, headers);
export const CreateAssetLoanDocument = `
    mutation createAssetLoan($input: CreateAssetLoanInput!) {
  createAssetLoan(input: $input) {
    assetLoan {
      ...AssetLoanFragment
    }
  }
}
    ${AssetLoanFragmentFragmentDoc}`;
export const useCreateAssetLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateAssetLoanMutation, TError, CreateAssetLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateAssetLoanMutation, TError, CreateAssetLoanMutationVariables, TContext>(
      ['createAssetLoan'],
      (variables?: CreateAssetLoanMutationVariables) => fetcher<CreateAssetLoanMutation, CreateAssetLoanMutationVariables>(client, CreateAssetLoanDocument, variables, headers)(),
      options
    );
useCreateAssetLoanMutation.getKey = () => ['createAssetLoan'];

useCreateAssetLoanMutation.fetcher = (client: GraphQLClient, variables: CreateAssetLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateAssetLoanMutation, CreateAssetLoanMutationVariables>(client, CreateAssetLoanDocument, variables, headers);
export const AssetLoansForAssetDocument = `
    query assetLoansForAsset($householdID: ID!, $assetID: ID!) {
  assetLoansForAsset(householdID: $householdID, assetID: $assetID) {
    items {
      ...AssetLoanFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${AssetLoanFragmentFragmentDoc}`;
export const useAssetLoansForAssetQuery = <
      TData = AssetLoansForAssetQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AssetLoansForAssetQueryVariables,
      options?: UseQueryOptions<AssetLoansForAssetQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssetLoansForAssetQuery, TError, TData>(
      ['assetLoansForAsset', variables],
      fetcher<AssetLoansForAssetQuery, AssetLoansForAssetQueryVariables>(client, AssetLoansForAssetDocument, variables, headers),
      options
    );

useAssetLoansForAssetQuery.getKey = (variables: AssetLoansForAssetQueryVariables) => ['assetLoansForAsset', variables];
;

useAssetLoansForAssetQuery.fetcher = (client: GraphQLClient, variables: AssetLoansForAssetQueryVariables, headers?: RequestInit['headers']) => fetcher<AssetLoansForAssetQuery, AssetLoansForAssetQueryVariables>(client, AssetLoansForAssetDocument, variables, headers);
export const AssetLoansForLoanDocument = `
    query assetLoansForLoan($householdID: ID!, $loanID: ID!) {
  assetLoansForLoan(householdID: $householdID, loanID: $loanID) {
    items {
      ...AssetLoanFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${AssetLoanFragmentFragmentDoc}`;
export const useAssetLoansForLoanQuery = <
      TData = AssetLoansForLoanQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AssetLoansForLoanQueryVariables,
      options?: UseQueryOptions<AssetLoansForLoanQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssetLoansForLoanQuery, TError, TData>(
      ['assetLoansForLoan', variables],
      fetcher<AssetLoansForLoanQuery, AssetLoansForLoanQueryVariables>(client, AssetLoansForLoanDocument, variables, headers),
      options
    );

useAssetLoansForLoanQuery.getKey = (variables: AssetLoansForLoanQueryVariables) => ['assetLoansForLoan', variables];
;

useAssetLoansForLoanQuery.fetcher = (client: GraphQLClient, variables: AssetLoansForLoanQueryVariables, headers?: RequestInit['headers']) => fetcher<AssetLoansForLoanQuery, AssetLoansForLoanQueryVariables>(client, AssetLoansForLoanDocument, variables, headers);
export const DeleteAssetLoanDocument = `
    mutation deleteAssetLoan($input: DeleteAssetLoanInput!) {
  deleteAssetLoan(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteAssetLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAssetLoanMutation, TError, DeleteAssetLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAssetLoanMutation, TError, DeleteAssetLoanMutationVariables, TContext>(
      ['deleteAssetLoan'],
      (variables?: DeleteAssetLoanMutationVariables) => fetcher<DeleteAssetLoanMutation, DeleteAssetLoanMutationVariables>(client, DeleteAssetLoanDocument, variables, headers)(),
      options
    );
useDeleteAssetLoanMutation.getKey = () => ['deleteAssetLoan'];

useDeleteAssetLoanMutation.fetcher = (client: GraphQLClient, variables: DeleteAssetLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteAssetLoanMutation, DeleteAssetLoanMutationVariables>(client, DeleteAssetLoanDocument, variables, headers);
export const MagicLinkDocument = `
    mutation MagicLink($input: BeginPasswordlessSignInInput!) {
  beginPasswordlessSignIn(input: $input) {
    sent
  }
}
    `;
export const useMagicLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MagicLinkMutation, TError, MagicLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MagicLinkMutation, TError, MagicLinkMutationVariables, TContext>(
      ['MagicLink'],
      (variables?: MagicLinkMutationVariables) => fetcher<MagicLinkMutation, MagicLinkMutationVariables>(client, MagicLinkDocument, variables, headers)(),
      options
    );
useMagicLinkMutation.getKey = () => ['MagicLink'];

useMagicLinkMutation.fetcher = (client: GraphQLClient, variables: MagicLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<MagicLinkMutation, MagicLinkMutationVariables>(client, MagicLinkDocument, variables, headers);
export const CompleteMagicLinkSignInDocument = `
    mutation CompleteMagicLinkSignIn($input: CompletePasswordlessSignInInput!) {
  completePasswordlessSignIn(input: $input) {
    tokenSet {
      accessToken
      refreshToken
      idToken
    }
  }
}
    `;
export const useCompleteMagicLinkSignInMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteMagicLinkSignInMutation, TError, CompleteMagicLinkSignInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CompleteMagicLinkSignInMutation, TError, CompleteMagicLinkSignInMutationVariables, TContext>(
      ['CompleteMagicLinkSignIn'],
      (variables?: CompleteMagicLinkSignInMutationVariables) => fetcher<CompleteMagicLinkSignInMutation, CompleteMagicLinkSignInMutationVariables>(client, CompleteMagicLinkSignInDocument, variables, headers)(),
      options
    );
useCompleteMagicLinkSignInMutation.getKey = () => ['CompleteMagicLinkSignIn'];

useCompleteMagicLinkSignInMutation.fetcher = (client: GraphQLClient, variables: CompleteMagicLinkSignInMutationVariables, headers?: RequestInit['headers']) => fetcher<CompleteMagicLinkSignInMutation, CompleteMagicLinkSignInMutationVariables>(client, CompleteMagicLinkSignInDocument, variables, headers);
export const ChangePasswordDocument = `
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export const useChangePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>(
      ['ChangePassword'],
      (variables?: ChangePasswordMutationVariables) => fetcher<ChangePasswordMutation, ChangePasswordMutationVariables>(client, ChangePasswordDocument, variables, headers)(),
      options
    );
useChangePasswordMutation.getKey = () => ['ChangePassword'];

useChangePasswordMutation.fetcher = (client: GraphQLClient, variables: ChangePasswordMutationVariables, headers?: RequestInit['headers']) => fetcher<ChangePasswordMutation, ChangePasswordMutationVariables>(client, ChangePasswordDocument, variables, headers);
export const RefreshTokensDocument = `
    mutation RefreshTokens($input: RefreshTokensInput!) {
  refreshTokens(input: $input) {
    tokenSet {
      accessToken
      refreshToken
      idToken
    }
  }
}
    `;
export const useRefreshTokensMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefreshTokensMutation, TError, RefreshTokensMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefreshTokensMutation, TError, RefreshTokensMutationVariables, TContext>(
      ['RefreshTokens'],
      (variables?: RefreshTokensMutationVariables) => fetcher<RefreshTokensMutation, RefreshTokensMutationVariables>(client, RefreshTokensDocument, variables, headers)(),
      options
    );
useRefreshTokensMutation.getKey = () => ['RefreshTokens'];

useRefreshTokensMutation.fetcher = (client: GraphQLClient, variables: RefreshTokensMutationVariables, headers?: RequestInit['headers']) => fetcher<RefreshTokensMutation, RefreshTokensMutationVariables>(client, RefreshTokensDocument, variables, headers);
export const ChangeEmailDocument = `
    mutation ChangeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input)
}
    `;
export const useChangeEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ChangeEmailMutation, TError, ChangeEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ChangeEmailMutation, TError, ChangeEmailMutationVariables, TContext>(
      ['ChangeEmail'],
      (variables?: ChangeEmailMutationVariables) => fetcher<ChangeEmailMutation, ChangeEmailMutationVariables>(client, ChangeEmailDocument, variables, headers)(),
      options
    );
useChangeEmailMutation.getKey = () => ['ChangeEmail'];

useChangeEmailMutation.fetcher = (client: GraphQLClient, variables: ChangeEmailMutationVariables, headers?: RequestInit['headers']) => fetcher<ChangeEmailMutation, ChangeEmailMutationVariables>(client, ChangeEmailDocument, variables, headers);
export const VerifyEmailDocument = `
    mutation VerifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input)
}
    `;
export const useVerifyEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>(
      ['VerifyEmail'],
      (variables?: VerifyEmailMutationVariables) => fetcher<VerifyEmailMutation, VerifyEmailMutationVariables>(client, VerifyEmailDocument, variables, headers)(),
      options
    );
useVerifyEmailMutation.getKey = () => ['VerifyEmail'];

useVerifyEmailMutation.fetcher = (client: GraphQLClient, variables: VerifyEmailMutationVariables, headers?: RequestInit['headers']) => fetcher<VerifyEmailMutation, VerifyEmailMutationVariables>(client, VerifyEmailDocument, variables, headers);
export const ResendEmailVerificationDocument = `
    mutation ResendEmailVerification($input: ResendEmailVerificationInput!) {
  resendEmailVerification(input: $input)
}
    `;
export const useResendEmailVerificationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendEmailVerificationMutation, TError, ResendEmailVerificationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendEmailVerificationMutation, TError, ResendEmailVerificationMutationVariables, TContext>(
      ['ResendEmailVerification'],
      (variables?: ResendEmailVerificationMutationVariables) => fetcher<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(client, ResendEmailVerificationDocument, variables, headers)(),
      options
    );
useResendEmailVerificationMutation.getKey = () => ['ResendEmailVerification'];

useResendEmailVerificationMutation.fetcher = (client: GraphQLClient, variables: ResendEmailVerificationMutationVariables, headers?: RequestInit['headers']) => fetcher<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(client, ResendEmailVerificationDocument, variables, headers);
export const ActiveMfaTypesDocument = `
    query ActiveMFATypes {
  activeMFATypes
}
    `;
export const useActiveMfaTypesQuery = <
      TData = ActiveMfaTypesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ActiveMfaTypesQueryVariables,
      options?: UseQueryOptions<ActiveMfaTypesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ActiveMfaTypesQuery, TError, TData>(
      variables === undefined ? ['ActiveMFATypes'] : ['ActiveMFATypes', variables],
      fetcher<ActiveMfaTypesQuery, ActiveMfaTypesQueryVariables>(client, ActiveMfaTypesDocument, variables, headers),
      options
    );

useActiveMfaTypesQuery.getKey = (variables?: ActiveMfaTypesQueryVariables) => variables === undefined ? ['ActiveMFATypes'] : ['ActiveMFATypes', variables];
;

useActiveMfaTypesQuery.fetcher = (client: GraphQLClient, variables?: ActiveMfaTypesQueryVariables, headers?: RequestInit['headers']) => fetcher<ActiveMfaTypesQuery, ActiveMfaTypesQueryVariables>(client, ActiveMfaTypesDocument, variables, headers);
export const ExtendedSignInDocument = `
    mutation ExtendedSignIn($input: ExtendedSignInInput!) {
  extendedSignIn(input: $input) {
    user {
      id
      elementsID
      username
      givenName
      familyName
      email
      createdAt
    }
    tokenSet {
      idToken
      accessToken
      refreshToken
    }
    firms {
      items {
        id
        entitlements
        name
        createdAt
      }
    }
    primaryHousehold {
      id
      householdID
      changeToken
      firmClients {
        id
        firmID
      }
    }
    authenticationChallenge {
      challenge
      session
      parameters {
        key
        value
      }
    }
  }
}
    `;
export const useExtendedSignInMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ExtendedSignInMutation, TError, ExtendedSignInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ExtendedSignInMutation, TError, ExtendedSignInMutationVariables, TContext>(
      ['ExtendedSignIn'],
      (variables?: ExtendedSignInMutationVariables) => fetcher<ExtendedSignInMutation, ExtendedSignInMutationVariables>(client, ExtendedSignInDocument, variables, headers)(),
      options
    );
useExtendedSignInMutation.getKey = () => ['ExtendedSignIn'];

useExtendedSignInMutation.fetcher = (client: GraphQLClient, variables: ExtendedSignInMutationVariables, headers?: RequestInit['headers']) => fetcher<ExtendedSignInMutation, ExtendedSignInMutationVariables>(client, ExtendedSignInDocument, variables, headers);
export const SignInDocument = `
    mutation SignIn($input: SignInInput!) {
  signIn(input: $input) {
    user {
      id
      elementsID
      username
      givenName
      familyName
      email
      createdAt
    }
    tokenSet {
      idToken
      accessToken
      refreshToken
    }
    firms {
      items {
        id
        name
        entitlements
        createdAt
      }
    }
    primaryHousehold {
      id
      householdID
      changeToken
      firmClients {
        id
        firmID
      }
    }
    authenticationChallenge {
      challenge
      session
      parameters {
        key
        value
      }
    }
  }
}
    `;
export const useSignInMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SignInMutation, TError, SignInMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SignInMutation, TError, SignInMutationVariables, TContext>(
      ['SignIn'],
      (variables?: SignInMutationVariables) => fetcher<SignInMutation, SignInMutationVariables>(client, SignInDocument, variables, headers)(),
      options
    );
useSignInMutation.getKey = () => ['SignIn'];

useSignInMutation.fetcher = (client: GraphQLClient, variables: SignInMutationVariables, headers?: RequestInit['headers']) => fetcher<SignInMutation, SignInMutationVariables>(client, SignInDocument, variables, headers);
export const UnassignedBaaAccountsForFirmMemberDocument = `
    query UnassignedBaaAccountsForFirmMember($firmID: ID!, $firmMemberID: ID!) {
  unassignedBaaAccountsForFirmMember(firmID: $firmID, firmMemberID: $firmMemberID) {
    items {
      ...UnassignedBaaAccountFragment
    }
  }
}
    ${UnassignedBaaAccountFragmentFragmentDoc}`;
export const useUnassignedBaaAccountsForFirmMemberQuery = <
      TData = UnassignedBaaAccountsForFirmMemberQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UnassignedBaaAccountsForFirmMemberQueryVariables,
      options?: UseQueryOptions<UnassignedBaaAccountsForFirmMemberQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UnassignedBaaAccountsForFirmMemberQuery, TError, TData>(
      ['UnassignedBaaAccountsForFirmMember', variables],
      fetcher<UnassignedBaaAccountsForFirmMemberQuery, UnassignedBaaAccountsForFirmMemberQueryVariables>(client, UnassignedBaaAccountsForFirmMemberDocument, variables, headers),
      options
    );

useUnassignedBaaAccountsForFirmMemberQuery.getKey = (variables: UnassignedBaaAccountsForFirmMemberQueryVariables) => ['UnassignedBaaAccountsForFirmMember', variables];
;

useUnassignedBaaAccountsForFirmMemberQuery.fetcher = (client: GraphQLClient, variables: UnassignedBaaAccountsForFirmMemberQueryVariables, headers?: RequestInit['headers']) => fetcher<UnassignedBaaAccountsForFirmMemberQuery, UnassignedBaaAccountsForFirmMemberQueryVariables>(client, UnassignedBaaAccountsForFirmMemberDocument, variables, headers);
export const AssignedBaaAccountsForFirmMemberDocument = `
    query AssignedBaaAccountsForFirmMember($firmID: ID!, $firmMemberID: ID!) {
  assignedBaaAccountsForFirmMember(firmID: $firmID, firmMemberID: $firmMemberID) {
    items {
      ...BaaAccountFragment
    }
  }
}
    ${BaaAccountFragmentFragmentDoc}`;
export const useAssignedBaaAccountsForFirmMemberQuery = <
      TData = AssignedBaaAccountsForFirmMemberQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AssignedBaaAccountsForFirmMemberQueryVariables,
      options?: UseQueryOptions<AssignedBaaAccountsForFirmMemberQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssignedBaaAccountsForFirmMemberQuery, TError, TData>(
      ['AssignedBaaAccountsForFirmMember', variables],
      fetcher<AssignedBaaAccountsForFirmMemberQuery, AssignedBaaAccountsForFirmMemberQueryVariables>(client, AssignedBaaAccountsForFirmMemberDocument, variables, headers),
      options
    );

useAssignedBaaAccountsForFirmMemberQuery.getKey = (variables: AssignedBaaAccountsForFirmMemberQueryVariables) => ['AssignedBaaAccountsForFirmMember', variables];
;

useAssignedBaaAccountsForFirmMemberQuery.fetcher = (client: GraphQLClient, variables: AssignedBaaAccountsForFirmMemberQueryVariables, headers?: RequestInit['headers']) => fetcher<AssignedBaaAccountsForFirmMemberQuery, AssignedBaaAccountsForFirmMemberQueryVariables>(client, AssignedBaaAccountsForFirmMemberDocument, variables, headers);
export const RevokeUserAccessDocument = `
    mutation RevokeUserAccess($firmID: ID!) {
  revokeUserAccess(firmID: $firmID) {
    revoked
  }
}
    `;
export const useRevokeUserAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RevokeUserAccessMutation, TError, RevokeUserAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RevokeUserAccessMutation, TError, RevokeUserAccessMutationVariables, TContext>(
      ['RevokeUserAccess'],
      (variables?: RevokeUserAccessMutationVariables) => fetcher<RevokeUserAccessMutation, RevokeUserAccessMutationVariables>(client, RevokeUserAccessDocument, variables, headers)(),
      options
    );
useRevokeUserAccessMutation.getKey = () => ['RevokeUserAccess'];

useRevokeUserAccessMutation.fetcher = (client: GraphQLClient, variables: RevokeUserAccessMutationVariables, headers?: RequestInit['headers']) => fetcher<RevokeUserAccessMutation, RevokeUserAccessMutationVariables>(client, RevokeUserAccessDocument, variables, headers);
export const CreateBaaAccountDocument = `
    mutation CreateBaaAccount($input: CreateBaaAccountInput!) {
  createBaaAccount(input: $input) {
    account {
      ...BaaAccountFragment
    }
  }
}
    ${BaaAccountFragmentFragmentDoc}`;
export const useCreateBaaAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateBaaAccountMutation, TError, CreateBaaAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateBaaAccountMutation, TError, CreateBaaAccountMutationVariables, TContext>(
      ['CreateBaaAccount'],
      (variables?: CreateBaaAccountMutationVariables) => fetcher<CreateBaaAccountMutation, CreateBaaAccountMutationVariables>(client, CreateBaaAccountDocument, variables, headers)(),
      options
    );
useCreateBaaAccountMutation.getKey = () => ['CreateBaaAccount'];

useCreateBaaAccountMutation.fetcher = (client: GraphQLClient, variables: CreateBaaAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateBaaAccountMutation, CreateBaaAccountMutationVariables>(client, CreateBaaAccountDocument, variables, headers);
export const RemoveAssignedAccountDocument = `
    mutation RemoveAssignedAccount($input: RemoveAssignedAccountInput!) {
  removeAssignedAccount(input: $input) {
    deleted
  }
}
    `;
export const useRemoveAssignedAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveAssignedAccountMutation, TError, RemoveAssignedAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveAssignedAccountMutation, TError, RemoveAssignedAccountMutationVariables, TContext>(
      ['RemoveAssignedAccount'],
      (variables?: RemoveAssignedAccountMutationVariables) => fetcher<RemoveAssignedAccountMutation, RemoveAssignedAccountMutationVariables>(client, RemoveAssignedAccountDocument, variables, headers)(),
      options
    );
useRemoveAssignedAccountMutation.getKey = () => ['RemoveAssignedAccount'];

useRemoveAssignedAccountMutation.fetcher = (client: GraphQLClient, variables: RemoveAssignedAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<RemoveAssignedAccountMutation, RemoveAssignedAccountMutationVariables>(client, RemoveAssignedAccountDocument, variables, headers);
export const BaaPersonForSelfDocument = `
    query BaaPersonForSelf($firmID: ID!) {
  baaPersonForSelf(firmID: $firmID) {
    id
  }
}
    `;
export const useBaaPersonForSelfQuery = <
      TData = BaaPersonForSelfQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BaaPersonForSelfQueryVariables,
      options?: UseQueryOptions<BaaPersonForSelfQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BaaPersonForSelfQuery, TError, TData>(
      ['BaaPersonForSelf', variables],
      fetcher<BaaPersonForSelfQuery, BaaPersonForSelfQueryVariables>(client, BaaPersonForSelfDocument, variables, headers),
      options
    );

useBaaPersonForSelfQuery.getKey = (variables: BaaPersonForSelfQueryVariables) => ['BaaPersonForSelf', variables];
;

useBaaPersonForSelfQuery.fetcher = (client: GraphQLClient, variables: BaaPersonForSelfQueryVariables, headers?: RequestInit['headers']) => fetcher<BaaPersonForSelfQuery, BaaPersonForSelfQueryVariables>(client, BaaPersonForSelfDocument, variables, headers);
export const CreateBaaPersonDocument = `
    mutation CreateBaaPerson($input: CreateBaaPersonInput!) {
  createBaaPerson(input: $input) {
    baaPerson {
      username
    }
    temporaryPassword
  }
}
    `;
export const useCreateBaaPersonMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateBaaPersonMutation, TError, CreateBaaPersonMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateBaaPersonMutation, TError, CreateBaaPersonMutationVariables, TContext>(
      ['CreateBaaPerson'],
      (variables?: CreateBaaPersonMutationVariables) => fetcher<CreateBaaPersonMutation, CreateBaaPersonMutationVariables>(client, CreateBaaPersonDocument, variables, headers)(),
      options
    );
useCreateBaaPersonMutation.getKey = () => ['CreateBaaPerson'];

useCreateBaaPersonMutation.fetcher = (client: GraphQLClient, variables: CreateBaaPersonMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateBaaPersonMutation, CreateBaaPersonMutationVariables>(client, CreateBaaPersonDocument, variables, headers);
export const UnassignedBaaAccountsForFirmDocument = `
    query UnassignedBaaAccountsForFirm($firmID: ID!) {
  unassignedBaaAccountsForFirm(firmID: $firmID) {
    items {
      ...UnassignedBaaAccountFragment
    }
  }
}
    ${UnassignedBaaAccountFragmentFragmentDoc}`;
export const useUnassignedBaaAccountsForFirmQuery = <
      TData = UnassignedBaaAccountsForFirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UnassignedBaaAccountsForFirmQueryVariables,
      options?: UseQueryOptions<UnassignedBaaAccountsForFirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UnassignedBaaAccountsForFirmQuery, TError, TData>(
      ['UnassignedBaaAccountsForFirm', variables],
      fetcher<UnassignedBaaAccountsForFirmQuery, UnassignedBaaAccountsForFirmQueryVariables>(client, UnassignedBaaAccountsForFirmDocument, variables, headers),
      options
    );

useUnassignedBaaAccountsForFirmQuery.getKey = (variables: UnassignedBaaAccountsForFirmQueryVariables) => ['UnassignedBaaAccountsForFirm', variables];
;

useUnassignedBaaAccountsForFirmQuery.fetcher = (client: GraphQLClient, variables: UnassignedBaaAccountsForFirmQueryVariables, headers?: RequestInit['headers']) => fetcher<UnassignedBaaAccountsForFirmQuery, UnassignedBaaAccountsForFirmQueryVariables>(client, UnassignedBaaAccountsForFirmDocument, variables, headers);
export const AssignedBaaAccountsForFirmDocument = `
    query AssignedBaaAccountsForFirm($firmID: ID!) {
  assignedBaaAccountsForFirm(firmID: $firmID) {
    items {
      ...BaaAccountFragment
    }
  }
}
    ${BaaAccountFragmentFragmentDoc}`;
export const useAssignedBaaAccountsForFirmQuery = <
      TData = AssignedBaaAccountsForFirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AssignedBaaAccountsForFirmQueryVariables,
      options?: UseQueryOptions<AssignedBaaAccountsForFirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AssignedBaaAccountsForFirmQuery, TError, TData>(
      ['AssignedBaaAccountsForFirm', variables],
      fetcher<AssignedBaaAccountsForFirmQuery, AssignedBaaAccountsForFirmQueryVariables>(client, AssignedBaaAccountsForFirmDocument, variables, headers),
      options
    );

useAssignedBaaAccountsForFirmQuery.getKey = (variables: AssignedBaaAccountsForFirmQueryVariables) => ['AssignedBaaAccountsForFirm', variables];
;

useAssignedBaaAccountsForFirmQuery.fetcher = (client: GraphQLClient, variables: AssignedBaaAccountsForFirmQueryVariables, headers?: RequestInit['headers']) => fetcher<AssignedBaaAccountsForFirmQuery, AssignedBaaAccountsForFirmQueryVariables>(client, AssignedBaaAccountsForFirmDocument, variables, headers);
export const RemoveBaaAccountsForNetWorthItemDocument = `
    mutation RemoveBAAAccountsForNetWorthItem($householdID: ID!, $mappedEntityID: ID!) {
  removeBAAAccountsForNetWorthItem(
    householdID: $householdID
    mappedEntityID: $mappedEntityID
  )
}
    `;
export const useRemoveBaaAccountsForNetWorthItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveBaaAccountsForNetWorthItemMutation, TError, RemoveBaaAccountsForNetWorthItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveBaaAccountsForNetWorthItemMutation, TError, RemoveBaaAccountsForNetWorthItemMutationVariables, TContext>(
      ['RemoveBAAAccountsForNetWorthItem'],
      (variables?: RemoveBaaAccountsForNetWorthItemMutationVariables) => fetcher<RemoveBaaAccountsForNetWorthItemMutation, RemoveBaaAccountsForNetWorthItemMutationVariables>(client, RemoveBaaAccountsForNetWorthItemDocument, variables, headers)(),
      options
    );
useRemoveBaaAccountsForNetWorthItemMutation.getKey = () => ['RemoveBAAAccountsForNetWorthItem'];

useRemoveBaaAccountsForNetWorthItemMutation.fetcher = (client: GraphQLClient, variables: RemoveBaaAccountsForNetWorthItemMutationVariables, headers?: RequestInit['headers']) => fetcher<RemoveBaaAccountsForNetWorthItemMutation, RemoveBaaAccountsForNetWorthItemMutationVariables>(client, RemoveBaaAccountsForNetWorthItemDocument, variables, headers);
export const BrDetailsDocument = `
    query BrDetails($householdID: ID!, $includeScore: Boolean!, $includeAnnualExpenses: Boolean!, $includeAnnualIncome: Boolean!, $includeSpendingUpdates: Boolean!, $includeIncomeUpdates: Boolean!, $includeTotalDebtPayments: Boolean!, $includeEstimatedSpendingMinusDebtPayments: Boolean!) {
  brDetails(householdID: $householdID) {
    br @include(if: $includeScore)
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    annualIncome @include(if: $includeAnnualIncome) {
      ...MonetaryAmountFragment
    }
    spendingUpdates @include(if: $includeSpendingUpdates) {
      dateTime
      monthlyAmount {
        ...MonetaryAmountFragment
      }
      dataPointID
      dataPointGroupID
    }
    incomeUpdates @include(if: $includeIncomeUpdates) {
      dateTime
      annualAmount {
        ...MonetaryAmountFragment
      }
      delta {
        ...MonetaryAmountFragment
      }
      dataPointID
      dataPointGroupID
    }
    totalDebtPayments @include(if: $includeTotalDebtPayments) {
      ...RecurringTotalsFragment
    }
    estimatedSpendingMinusDebtPayments @include(if: $includeEstimatedSpendingMinusDebtPayments) {
      ...RecurringTotalsFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${RecurringTotalsFragmentFragmentDoc}`;
export const useBrDetailsQuery = <
      TData = BrDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BrDetailsQueryVariables,
      options?: UseQueryOptions<BrDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BrDetailsQuery, TError, TData>(
      ['BrDetails', variables],
      fetcher<BrDetailsQuery, BrDetailsQueryVariables>(client, BrDetailsDocument, variables, headers),
      options
    );

useBrDetailsQuery.getKey = (variables: BrDetailsQueryVariables) => ['BrDetails', variables];
;

useBrDetailsQuery.fetcher = (client: GraphQLClient, variables: BrDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<BrDetailsQuery, BrDetailsQueryVariables>(client, BrDetailsDocument, variables, headers);
export const BtDetailsDocument = `
    query BtDetails($householdID: ID!, $includeScore: Boolean!, $includeTotalBusinessEquity: Boolean!, $includeAnnualExpenses: Boolean!, $includeBusinesses: Boolean!, $includePrivateStock: Boolean!, $includeTotalPrivateStock: Boolean!, $includeTotalBusinessValue: Boolean!, $includeTotalBusinessDebt: Boolean!) {
  btDetails(householdID: $householdID) {
    bt @include(if: $includeScore)
    totalBusinessEquity @include(if: $includeTotalBusinessEquity) {
      ...MonetaryAmountFragment
    }
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    businesses @include(if: $includeBusinesses) {
      business {
        ...BusinessFragment
      }
      loans {
        ...LoanFragment
      }
      ownedValue {
        ...MonetaryAmountFragment
      }
      ownedDebt {
        ...MonetaryAmountFragment
      }
      totalOwnedEquity {
        ...MonetaryAmountFragment
      }
      ownedCashAccounts {
        ...CashAccountFragment
      }
      totalOwnedCashAccounts {
        ...MonetaryAmountFragment
      }
      ownedQualifiedInvestments {
        ...InvestmentFragment
      }
      totalOwnedQualifiedInvestments {
        ...MonetaryAmountFragment
      }
      ownedNonQualifiedInvestments {
        ...InvestmentFragment
      }
      totalOwnedNonQualifiedInvestments {
        ...MonetaryAmountFragment
      }
      ownedRealEstate {
        ...RealEstateFragment
      }
      totalOwnedRealEstate {
        ...MonetaryAmountFragment
      }
    }
    privateStock @include(if: $includePrivateStock) {
      ...InvestmentFragment
    }
    totalPrivateStock @include(if: $includeTotalPrivateStock) {
      ...MonetaryAmountFragment
    }
    totalBusinessValue @include(if: $includeTotalBusinessValue) {
      ...MonetaryAmountFragment
    }
    totalBusinessDebt @include(if: $includeTotalBusinessDebt) {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${BusinessFragmentFragmentDoc}
${LoanFragmentFragmentDoc}
${CashAccountFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}
${RealEstateFragmentFragmentDoc}`;
export const useBtDetailsQuery = <
      TData = BtDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BtDetailsQueryVariables,
      options?: UseQueryOptions<BtDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BtDetailsQuery, TError, TData>(
      ['BtDetails', variables],
      fetcher<BtDetailsQuery, BtDetailsQueryVariables>(client, BtDetailsDocument, variables, headers),
      options
    );

useBtDetailsQuery.getKey = (variables: BtDetailsQueryVariables) => ['BtDetails', variables];
;

useBtDetailsQuery.fetcher = (client: GraphQLClient, variables: BtDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<BtDetailsQuery, BtDetailsQueryVariables>(client, BtDetailsDocument, variables, headers);
export const GetBusinessesDocument = `
    query GetBusinesses($householdID: ID!) {
  businesses(householdID: $householdID) {
    items {
      ...BusinessFragment
    }
  }
}
    ${BusinessFragmentFragmentDoc}`;
export const useGetBusinessesQuery = <
      TData = GetBusinessesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBusinessesQueryVariables,
      options?: UseQueryOptions<GetBusinessesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetBusinessesQuery, TError, TData>(
      ['GetBusinesses', variables],
      fetcher<GetBusinessesQuery, GetBusinessesQueryVariables>(client, GetBusinessesDocument, variables, headers),
      options
    );

useGetBusinessesQuery.getKey = (variables: GetBusinessesQueryVariables) => ['GetBusinesses', variables];
;

useGetBusinessesQuery.fetcher = (client: GraphQLClient, variables: GetBusinessesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBusinessesQuery, GetBusinessesQueryVariables>(client, GetBusinessesDocument, variables, headers);
export const CreateBusinessDocument = `
    mutation createBusiness($input: CreateBusinessInput!) {
  createBusiness(input: $input) {
    business {
      ...BusinessFragment
    }
  }
}
    ${BusinessFragmentFragmentDoc}`;
export const useCreateBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateBusinessMutation, TError, CreateBusinessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateBusinessMutation, TError, CreateBusinessMutationVariables, TContext>(
      ['createBusiness'],
      (variables?: CreateBusinessMutationVariables) => fetcher<CreateBusinessMutation, CreateBusinessMutationVariables>(client, CreateBusinessDocument, variables, headers)(),
      options
    );
useCreateBusinessMutation.getKey = () => ['createBusiness'];

useCreateBusinessMutation.fetcher = (client: GraphQLClient, variables: CreateBusinessMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateBusinessMutation, CreateBusinessMutationVariables>(client, CreateBusinessDocument, variables, headers);
export const DeleteBusinessDocument = `
    mutation DeleteBusiness($input: DeleteBusinessInput!) {
  deleteBusiness(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteBusinessMutation, TError, DeleteBusinessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteBusinessMutation, TError, DeleteBusinessMutationVariables, TContext>(
      ['DeleteBusiness'],
      (variables?: DeleteBusinessMutationVariables) => fetcher<DeleteBusinessMutation, DeleteBusinessMutationVariables>(client, DeleteBusinessDocument, variables, headers)(),
      options
    );
useDeleteBusinessMutation.getKey = () => ['DeleteBusiness'];

useDeleteBusinessMutation.fetcher = (client: GraphQLClient, variables: DeleteBusinessMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteBusinessMutation, DeleteBusinessMutationVariables>(client, DeleteBusinessDocument, variables, headers);
export const UpdateBusinessDocument = `
    mutation UpdateBusiness($input: UpdateBusinessInput!) {
  updateBusiness(input: $input) {
    business {
      ...BusinessFragment
    }
  }
}
    ${BusinessFragmentFragmentDoc}`;
export const useUpdateBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBusinessMutation, TError, UpdateBusinessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateBusinessMutation, TError, UpdateBusinessMutationVariables, TContext>(
      ['UpdateBusiness'],
      (variables?: UpdateBusinessMutationVariables) => fetcher<UpdateBusinessMutation, UpdateBusinessMutationVariables>(client, UpdateBusinessDocument, variables, headers)(),
      options
    );
useUpdateBusinessMutation.getKey = () => ['UpdateBusiness'];

useUpdateBusinessMutation.fetcher = (client: GraphQLClient, variables: UpdateBusinessMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateBusinessMutation, UpdateBusinessMutationVariables>(client, UpdateBusinessDocument, variables, headers);
export const GetBusinessDocument = `
    query GetBusiness($householdID: ID!, $id: ID!) {
  business(householdID: $householdID, id: $id) {
    ...BusinessFragment
    closedAt
  }
}
    ${BusinessFragmentFragmentDoc}`;
export const useGetBusinessQuery = <
      TData = GetBusinessQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBusinessQueryVariables,
      options?: UseQueryOptions<GetBusinessQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetBusinessQuery, TError, TData>(
      ['GetBusiness', variables],
      fetcher<GetBusinessQuery, GetBusinessQueryVariables>(client, GetBusinessDocument, variables, headers),
      options
    );

useGetBusinessQuery.getKey = (variables: GetBusinessQueryVariables) => ['GetBusiness', variables];
;

useGetBusinessQuery.fetcher = (client: GraphQLClient, variables: GetBusinessQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBusinessQuery, GetBusinessQueryVariables>(client, GetBusinessDocument, variables, headers);
export const CloseBusinessDocument = `
    mutation CloseBusiness($input: CloseBusinessInput!) {
  closeBusiness(input: $input) {
    changeToken
  }
}
    `;
export const useCloseBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseBusinessMutation, TError, CloseBusinessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseBusinessMutation, TError, CloseBusinessMutationVariables, TContext>(
      ['CloseBusiness'],
      (variables?: CloseBusinessMutationVariables) => fetcher<CloseBusinessMutation, CloseBusinessMutationVariables>(client, CloseBusinessDocument, variables, headers)(),
      options
    );
useCloseBusinessMutation.getKey = () => ['CloseBusiness'];

useCloseBusinessMutation.fetcher = (client: GraphQLClient, variables: CloseBusinessMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseBusinessMutation, CloseBusinessMutationVariables>(client, CloseBusinessDocument, variables, headers);
export const MergeBusinessesDocument = `
    mutation MergeBusinesses($input: MergeBusinessesInput!) {
  mergeBusinesses(input: $input) {
    merged
  }
}
    `;
export const useMergeBusinessesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeBusinessesMutation, TError, MergeBusinessesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeBusinessesMutation, TError, MergeBusinessesMutationVariables, TContext>(
      ['MergeBusinesses'],
      (variables?: MergeBusinessesMutationVariables) => fetcher<MergeBusinessesMutation, MergeBusinessesMutationVariables>(client, MergeBusinessesDocument, variables, headers)(),
      options
    );
useMergeBusinessesMutation.getKey = () => ['MergeBusinesses'];

useMergeBusinessesMutation.fetcher = (client: GraphQLClient, variables: MergeBusinessesMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeBusinessesMutation, MergeBusinessesMutationVariables>(client, MergeBusinessesDocument, variables, headers);
export const GetCashAccountsDocument = `
    query GetCashAccounts($householdID: ID!) {
  cashAccounts(householdID: $householdID) {
    items {
      ...CashAccountFragment
    }
  }
}
    ${CashAccountFragmentFragmentDoc}`;
export const useGetCashAccountsQuery = <
      TData = GetCashAccountsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCashAccountsQueryVariables,
      options?: UseQueryOptions<GetCashAccountsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCashAccountsQuery, TError, TData>(
      ['GetCashAccounts', variables],
      fetcher<GetCashAccountsQuery, GetCashAccountsQueryVariables>(client, GetCashAccountsDocument, variables, headers),
      options
    );

useGetCashAccountsQuery.getKey = (variables: GetCashAccountsQueryVariables) => ['GetCashAccounts', variables];
;

useGetCashAccountsQuery.fetcher = (client: GraphQLClient, variables: GetCashAccountsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetCashAccountsQuery, GetCashAccountsQueryVariables>(client, GetCashAccountsDocument, variables, headers);
export const CreateCashAccountDocument = `
    mutation CreateCashAccount($input: CreateCashAccountInput!) {
  createCashAccount(input: $input) {
    cashAccount {
      ...CashAccountFragment
    }
  }
}
    ${CashAccountFragmentFragmentDoc}`;
export const useCreateCashAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateCashAccountMutation, TError, CreateCashAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateCashAccountMutation, TError, CreateCashAccountMutationVariables, TContext>(
      ['CreateCashAccount'],
      (variables?: CreateCashAccountMutationVariables) => fetcher<CreateCashAccountMutation, CreateCashAccountMutationVariables>(client, CreateCashAccountDocument, variables, headers)(),
      options
    );
useCreateCashAccountMutation.getKey = () => ['CreateCashAccount'];

useCreateCashAccountMutation.fetcher = (client: GraphQLClient, variables: CreateCashAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateCashAccountMutation, CreateCashAccountMutationVariables>(client, CreateCashAccountDocument, variables, headers);
export const UpdateCashAccountDocument = `
    mutation UpdateCashAccount($input: UpdateCashAccountInput!) {
  updateCashAccount(input: $input) {
    cashAccount {
      ...CashAccountFragment
    }
  }
}
    ${CashAccountFragmentFragmentDoc}`;
export const useUpdateCashAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateCashAccountMutation, TError, UpdateCashAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateCashAccountMutation, TError, UpdateCashAccountMutationVariables, TContext>(
      ['UpdateCashAccount'],
      (variables?: UpdateCashAccountMutationVariables) => fetcher<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>(client, UpdateCashAccountDocument, variables, headers)(),
      options
    );
useUpdateCashAccountMutation.getKey = () => ['UpdateCashAccount'];

useUpdateCashAccountMutation.fetcher = (client: GraphQLClient, variables: UpdateCashAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateCashAccountMutation, UpdateCashAccountMutationVariables>(client, UpdateCashAccountDocument, variables, headers);
export const DeleteCashAccountDocument = `
    mutation DeleteCashAccount($input: DeleteCashAccountInput!) {
  deleteCashAccount(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteCashAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCashAccountMutation, TError, DeleteCashAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCashAccountMutation, TError, DeleteCashAccountMutationVariables, TContext>(
      ['DeleteCashAccount'],
      (variables?: DeleteCashAccountMutationVariables) => fetcher<DeleteCashAccountMutation, DeleteCashAccountMutationVariables>(client, DeleteCashAccountDocument, variables, headers)(),
      options
    );
useDeleteCashAccountMutation.getKey = () => ['DeleteCashAccount'];

useDeleteCashAccountMutation.fetcher = (client: GraphQLClient, variables: DeleteCashAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteCashAccountMutation, DeleteCashAccountMutationVariables>(client, DeleteCashAccountDocument, variables, headers);
export const GetCashAccountDocument = `
    query GetCashAccount($householdID: ID!, $id: ID!) {
  cashAccount(householdID: $householdID, id: $id) {
    ...CashAccountFragment
    closedAt
  }
}
    ${CashAccountFragmentFragmentDoc}`;
export const useGetCashAccountQuery = <
      TData = GetCashAccountQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCashAccountQueryVariables,
      options?: UseQueryOptions<GetCashAccountQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCashAccountQuery, TError, TData>(
      ['GetCashAccount', variables],
      fetcher<GetCashAccountQuery, GetCashAccountQueryVariables>(client, GetCashAccountDocument, variables, headers),
      options
    );

useGetCashAccountQuery.getKey = (variables: GetCashAccountQueryVariables) => ['GetCashAccount', variables];
;

useGetCashAccountQuery.fetcher = (client: GraphQLClient, variables: GetCashAccountQueryVariables, headers?: RequestInit['headers']) => fetcher<GetCashAccountQuery, GetCashAccountQueryVariables>(client, GetCashAccountDocument, variables, headers);
export const CloseCashAccountDocument = `
    mutation CloseCashAccount($input: CloseCashAccountInput!) {
  closeCashAccount(input: $input) {
    changeToken
  }
}
    `;
export const useCloseCashAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseCashAccountMutation, TError, CloseCashAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseCashAccountMutation, TError, CloseCashAccountMutationVariables, TContext>(
      ['CloseCashAccount'],
      (variables?: CloseCashAccountMutationVariables) => fetcher<CloseCashAccountMutation, CloseCashAccountMutationVariables>(client, CloseCashAccountDocument, variables, headers)(),
      options
    );
useCloseCashAccountMutation.getKey = () => ['CloseCashAccount'];

useCloseCashAccountMutation.fetcher = (client: GraphQLClient, variables: CloseCashAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseCashAccountMutation, CloseCashAccountMutationVariables>(client, CloseCashAccountDocument, variables, headers);
export const MergeCashAccountsDocument = `
    mutation MergeCashAccounts($input: MergeCashAccountsInput!) {
  mergeCashAccounts(input: $input) {
    merged
  }
}
    `;
export const useMergeCashAccountsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeCashAccountsMutation, TError, MergeCashAccountsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeCashAccountsMutation, TError, MergeCashAccountsMutationVariables, TContext>(
      ['MergeCashAccounts'],
      (variables?: MergeCashAccountsMutationVariables) => fetcher<MergeCashAccountsMutation, MergeCashAccountsMutationVariables>(client, MergeCashAccountsDocument, variables, headers)(),
      options
    );
useMergeCashAccountsMutation.getKey = () => ['MergeCashAccounts'];

useMergeCashAccountsMutation.fetcher = (client: GraphQLClient, variables: MergeCashAccountsMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeCashAccountsMutation, MergeCashAccountsMutationVariables>(client, MergeCashAccountsDocument, variables, headers);
export const ClientClientAssessmentPageDocument = `
    query ClientClientAssessmentPage($clientID: ID!, $firmID: ID!) {
  firmClient(id: $clientID, firmID: $firmID) {
    id
    entitlements {
      aiAssessment
    }
  }
  aiClientSummary(clientID: $clientID) {
    advisorApproved
  }
}
    `;
export const useClientClientAssessmentPageQuery = <
      TData = ClientClientAssessmentPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ClientClientAssessmentPageQueryVariables,
      options?: UseQueryOptions<ClientClientAssessmentPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientClientAssessmentPageQuery, TError, TData>(
      ['ClientClientAssessmentPage', variables],
      fetcher<ClientClientAssessmentPageQuery, ClientClientAssessmentPageQueryVariables>(client, ClientClientAssessmentPageDocument, variables, headers),
      options
    );

useClientClientAssessmentPageQuery.getKey = (variables: ClientClientAssessmentPageQueryVariables) => ['ClientClientAssessmentPage', variables];
;

useClientClientAssessmentPageQuery.fetcher = (client: GraphQLClient, variables: ClientClientAssessmentPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ClientClientAssessmentPageQuery, ClientClientAssessmentPageQueryVariables>(client, ClientClientAssessmentPageDocument, variables, headers);
export const ClientClientLayoutPageDocument = `
    query ClientClientLayoutPage($clientID: ID!, $firmID: ID!) {
  firmClient(id: $clientID, firmID: $firmID) {
    id
    entitlements {
      aiAssessment
    }
    team {
      member {
        calendarSchedulingLink
        id
      }
    }
  }
  aiClientSummary(clientID: $clientID) {
    advisorApproved
  }
}
    `;
export const useClientClientLayoutPageQuery = <
      TData = ClientClientLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ClientClientLayoutPageQueryVariables,
      options?: UseQueryOptions<ClientClientLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientClientLayoutPageQuery, TError, TData>(
      ['ClientClientLayoutPage', variables],
      fetcher<ClientClientLayoutPageQuery, ClientClientLayoutPageQueryVariables>(client, ClientClientLayoutPageDocument, variables, headers),
      options
    );

useClientClientLayoutPageQuery.getKey = (variables: ClientClientLayoutPageQueryVariables) => ['ClientClientLayoutPage', variables];
;

useClientClientLayoutPageQuery.fetcher = (client: GraphQLClient, variables: ClientClientLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ClientClientLayoutPageQuery, ClientClientLayoutPageQueryVariables>(client, ClientClientLayoutPageDocument, variables, headers);
export const ClientDetailPageDocument = `
    query ClientDetailPage($firmClientID: ID!, $firmID: ID!) {
  firmClient(firmID: $firmID, id: $firmClientID) {
    household {
      financialCategorization
    }
  }
}
    `;
export const useClientDetailPageQuery = <
      TData = ClientDetailPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ClientDetailPageQueryVariables,
      options?: UseQueryOptions<ClientDetailPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientDetailPageQuery, TError, TData>(
      ['ClientDetailPage', variables],
      fetcher<ClientDetailPageQuery, ClientDetailPageQueryVariables>(client, ClientDetailPageDocument, variables, headers),
      options
    );

useClientDetailPageQuery.getKey = (variables: ClientDetailPageQueryVariables) => ['ClientDetailPage', variables];
;

useClientDetailPageQuery.fetcher = (client: GraphQLClient, variables: ClientDetailPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ClientDetailPageQuery, ClientDetailPageQueryVariables>(client, ClientDetailPageDocument, variables, headers);
export const GetFirmClientGroupsDocument = `
    query GetFirmClientGroups($firmID: ID!, $cursor: String) {
  firmClientGroups(firmID: $firmID, cursor: $cursor) {
    items {
      id
      name
      count
      createdAt
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const useGetFirmClientGroupsQuery = <
      TData = GetFirmClientGroupsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFirmClientGroupsQueryVariables,
      options?: UseQueryOptions<GetFirmClientGroupsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetFirmClientGroupsQuery, TError, TData>(
      ['GetFirmClientGroups', variables],
      fetcher<GetFirmClientGroupsQuery, GetFirmClientGroupsQueryVariables>(client, GetFirmClientGroupsDocument, variables, headers),
      options
    );

useGetFirmClientGroupsQuery.getKey = (variables: GetFirmClientGroupsQueryVariables) => ['GetFirmClientGroups', variables];
;

useGetFirmClientGroupsQuery.fetcher = (client: GraphQLClient, variables: GetFirmClientGroupsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFirmClientGroupsQuery, GetFirmClientGroupsQueryVariables>(client, GetFirmClientGroupsDocument, variables, headers);
export const CreateFirmClientGroupDocument = `
    mutation CreateFirmClientGroup($input: CreateFirmClientGroupInput!) {
  createFirmClientGroup(input: $input) {
    firmClientGroup {
      id
      name
      count
      createdAt
      updatedAt
    }
  }
}
    `;
export const useCreateFirmClientGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFirmClientGroupMutation, TError, CreateFirmClientGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFirmClientGroupMutation, TError, CreateFirmClientGroupMutationVariables, TContext>(
      ['CreateFirmClientGroup'],
      (variables?: CreateFirmClientGroupMutationVariables) => fetcher<CreateFirmClientGroupMutation, CreateFirmClientGroupMutationVariables>(client, CreateFirmClientGroupDocument, variables, headers)(),
      options
    );
useCreateFirmClientGroupMutation.getKey = () => ['CreateFirmClientGroup'];

useCreateFirmClientGroupMutation.fetcher = (client: GraphQLClient, variables: CreateFirmClientGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFirmClientGroupMutation, CreateFirmClientGroupMutationVariables>(client, CreateFirmClientGroupDocument, variables, headers);
export const UpdateFirmClientGroupDocument = `
    mutation UpdateFirmClientGroup($input: UpdateFirmClientGroupInput!) {
  updateFirmClientGroup(input: $input) {
    firmClientGroup {
      id
      name
      count
      createdAt
      updatedAt
    }
  }
}
    `;
export const useUpdateFirmClientGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFirmClientGroupMutation, TError, UpdateFirmClientGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFirmClientGroupMutation, TError, UpdateFirmClientGroupMutationVariables, TContext>(
      ['UpdateFirmClientGroup'],
      (variables?: UpdateFirmClientGroupMutationVariables) => fetcher<UpdateFirmClientGroupMutation, UpdateFirmClientGroupMutationVariables>(client, UpdateFirmClientGroupDocument, variables, headers)(),
      options
    );
useUpdateFirmClientGroupMutation.getKey = () => ['UpdateFirmClientGroup'];

useUpdateFirmClientGroupMutation.fetcher = (client: GraphQLClient, variables: UpdateFirmClientGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFirmClientGroupMutation, UpdateFirmClientGroupMutationVariables>(client, UpdateFirmClientGroupDocument, variables, headers);
export const DeleteFirmClientGroupDocument = `
    mutation DeleteFirmClientGroup($input: DeleteFirmClientGroupInput!) {
  deleteFirmClientGroup(input: $input) {
    deleted
  }
}
    `;
export const useDeleteFirmClientGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFirmClientGroupMutation, TError, DeleteFirmClientGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFirmClientGroupMutation, TError, DeleteFirmClientGroupMutationVariables, TContext>(
      ['DeleteFirmClientGroup'],
      (variables?: DeleteFirmClientGroupMutationVariables) => fetcher<DeleteFirmClientGroupMutation, DeleteFirmClientGroupMutationVariables>(client, DeleteFirmClientGroupDocument, variables, headers)(),
      options
    );
useDeleteFirmClientGroupMutation.getKey = () => ['DeleteFirmClientGroup'];

useDeleteFirmClientGroupMutation.fetcher = (client: GraphQLClient, variables: DeleteFirmClientGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFirmClientGroupMutation, DeleteFirmClientGroupMutationVariables>(client, DeleteFirmClientGroupDocument, variables, headers);
export const AssignClientToGroupDocument = `
    mutation AssignClientToGroup($input: AssignClientToGroupInput!) {
  assignClientToGroup(input: $input) {
    assigned
  }
}
    `;
export const useAssignClientToGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AssignClientToGroupMutation, TError, AssignClientToGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AssignClientToGroupMutation, TError, AssignClientToGroupMutationVariables, TContext>(
      ['AssignClientToGroup'],
      (variables?: AssignClientToGroupMutationVariables) => fetcher<AssignClientToGroupMutation, AssignClientToGroupMutationVariables>(client, AssignClientToGroupDocument, variables, headers)(),
      options
    );
useAssignClientToGroupMutation.getKey = () => ['AssignClientToGroup'];

useAssignClientToGroupMutation.fetcher = (client: GraphQLClient, variables: AssignClientToGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<AssignClientToGroupMutation, AssignClientToGroupMutationVariables>(client, AssignClientToGroupDocument, variables, headers);
export const UnassignClientFromAnyGroupDocument = `
    mutation UnassignClientFromAnyGroup($input: UnassignClientFromAnyGroupInput!) {
  unassignClientFromAnyGroup(input: $input) {
    unassigned
  }
}
    `;
export const useUnassignClientFromAnyGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UnassignClientFromAnyGroupMutation, TError, UnassignClientFromAnyGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UnassignClientFromAnyGroupMutation, TError, UnassignClientFromAnyGroupMutationVariables, TContext>(
      ['UnassignClientFromAnyGroup'],
      (variables?: UnassignClientFromAnyGroupMutationVariables) => fetcher<UnassignClientFromAnyGroupMutation, UnassignClientFromAnyGroupMutationVariables>(client, UnassignClientFromAnyGroupDocument, variables, headers)(),
      options
    );
useUnassignClientFromAnyGroupMutation.getKey = () => ['UnassignClientFromAnyGroup'];

useUnassignClientFromAnyGroupMutation.fetcher = (client: GraphQLClient, variables: UnassignClientFromAnyGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<UnassignClientFromAnyGroupMutation, UnassignClientFromAnyGroupMutationVariables>(client, UnassignClientFromAnyGroupDocument, variables, headers);
export const HouseholdFirmClientsDocument = `
    query HouseholdFirmClients {
  primaryHousehold {
    id
    firmClients {
      ...FirmClientFragment
    }
  }
}
    ${FirmClientFragmentFragmentDoc}`;
export const useHouseholdFirmClientsQuery = <
      TData = HouseholdFirmClientsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: HouseholdFirmClientsQueryVariables,
      options?: UseQueryOptions<HouseholdFirmClientsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HouseholdFirmClientsQuery, TError, TData>(
      variables === undefined ? ['HouseholdFirmClients'] : ['HouseholdFirmClients', variables],
      fetcher<HouseholdFirmClientsQuery, HouseholdFirmClientsQueryVariables>(client, HouseholdFirmClientsDocument, variables, headers),
      options
    );

useHouseholdFirmClientsQuery.getKey = (variables?: HouseholdFirmClientsQueryVariables) => variables === undefined ? ['HouseholdFirmClients'] : ['HouseholdFirmClients', variables];
;

useHouseholdFirmClientsQuery.fetcher = (client: GraphQLClient, variables?: HouseholdFirmClientsQueryVariables, headers?: RequestInit['headers']) => fetcher<HouseholdFirmClientsQuery, HouseholdFirmClientsQueryVariables>(client, HouseholdFirmClientsDocument, variables, headers);
export const FirmClientsForFirmDocument = `
    query FirmClientsForFirm($firmID: ID!, $mode: FirmClientMode, $cursor: String) {
  firmClientsForFirm(firmID: $firmID, mode: $mode, cursor: $cursor) {
    items {
      ...FirmClientListItemFragment
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FirmClientListItemFragmentFragmentDoc}`;
export const useFirmClientsForFirmQuery = <
      TData = FirmClientsForFirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmClientsForFirmQueryVariables,
      options?: UseQueryOptions<FirmClientsForFirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmClientsForFirmQuery, TError, TData>(
      ['FirmClientsForFirm', variables],
      fetcher<FirmClientsForFirmQuery, FirmClientsForFirmQueryVariables>(client, FirmClientsForFirmDocument, variables, headers),
      options
    );

useFirmClientsForFirmQuery.getKey = (variables: FirmClientsForFirmQueryVariables) => ['FirmClientsForFirm', variables];
;

useFirmClientsForFirmQuery.fetcher = (client: GraphQLClient, variables: FirmClientsForFirmQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmClientsForFirmQuery, FirmClientsForFirmQueryVariables>(client, FirmClientsForFirmDocument, variables, headers);
export const FirmClientsForGroupDocument = `
    query FirmClientsForGroup($firmID: ID!, $groupID: ID!, $cursor: String) {
  firmClientsForGroup(firmID: $firmID, groupID: $groupID, cursor: $cursor) {
    items {
      ...FirmClientListItemFragment
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${FirmClientListItemFragmentFragmentDoc}`;
export const useFirmClientsForGroupQuery = <
      TData = FirmClientsForGroupQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmClientsForGroupQueryVariables,
      options?: UseQueryOptions<FirmClientsForGroupQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmClientsForGroupQuery, TError, TData>(
      ['FirmClientsForGroup', variables],
      fetcher<FirmClientsForGroupQuery, FirmClientsForGroupQueryVariables>(client, FirmClientsForGroupDocument, variables, headers),
      options
    );

useFirmClientsForGroupQuery.getKey = (variables: FirmClientsForGroupQueryVariables) => ['FirmClientsForGroup', variables];
;

useFirmClientsForGroupQuery.fetcher = (client: GraphQLClient, variables: FirmClientsForGroupQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmClientsForGroupQuery, FirmClientsForGroupQueryVariables>(client, FirmClientsForGroupDocument, variables, headers);
export const FirmClientDocument = `
    query FirmClient($firmID: ID!, $id: ID!) {
  firmClient(firmID: $firmID, id: $id) {
    ...FirmClientFragment
    aiSummary
    householdCategorySummary
    shortHouseholdCategorySummary
    entitlements {
      aiAssessment
    }
    aiSummaryUpdatedAt
    aiResponses {
      strengths
      areasForImprovement {
        body
        goalBody
      }
    }
  }
}
    ${FirmClientFragmentFragmentDoc}`;
export const useFirmClientQuery = <
      TData = FirmClientQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmClientQueryVariables,
      options?: UseQueryOptions<FirmClientQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmClientQuery, TError, TData>(
      ['FirmClient', variables],
      fetcher<FirmClientQuery, FirmClientQueryVariables>(client, FirmClientDocument, variables, headers),
      options
    );

useFirmClientQuery.getKey = (variables: FirmClientQueryVariables) => ['FirmClient', variables];
;

useFirmClientQuery.fetcher = (client: GraphQLClient, variables: FirmClientQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmClientQuery, FirmClientQueryVariables>(client, FirmClientDocument, variables, headers);
export const FirmClientFeatureAccessDocument = `
    query FirmClientFeatureAccess($firmID: ID!, $id: ID!) {
  firmClient(firmID: $firmID, id: $id) {
    id
    featureAccess {
      estateStatus
    }
  }
}
    `;
export const useFirmClientFeatureAccessQuery = <
      TData = FirmClientFeatureAccessQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmClientFeatureAccessQueryVariables,
      options?: UseQueryOptions<FirmClientFeatureAccessQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmClientFeatureAccessQuery, TError, TData>(
      ['FirmClientFeatureAccess', variables],
      fetcher<FirmClientFeatureAccessQuery, FirmClientFeatureAccessQueryVariables>(client, FirmClientFeatureAccessDocument, variables, headers),
      options
    );

useFirmClientFeatureAccessQuery.getKey = (variables: FirmClientFeatureAccessQueryVariables) => ['FirmClientFeatureAccess', variables];
;

useFirmClientFeatureAccessQuery.fetcher = (client: GraphQLClient, variables: FirmClientFeatureAccessQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmClientFeatureAccessQuery, FirmClientFeatureAccessQueryVariables>(client, FirmClientFeatureAccessDocument, variables, headers);
export const FirmClientForSelfDocument = `
    query FirmClientForSelf($firmID: ID!) {
  firmClientForSelf(firmID: $firmID) {
    ...FirmClientFragment
  }
}
    ${FirmClientFragmentFragmentDoc}`;
export const useFirmClientForSelfQuery = <
      TData = FirmClientForSelfQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmClientForSelfQueryVariables,
      options?: UseQueryOptions<FirmClientForSelfQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmClientForSelfQuery, TError, TData>(
      ['FirmClientForSelf', variables],
      fetcher<FirmClientForSelfQuery, FirmClientForSelfQueryVariables>(client, FirmClientForSelfDocument, variables, headers),
      options
    );

useFirmClientForSelfQuery.getKey = (variables: FirmClientForSelfQueryVariables) => ['FirmClientForSelf', variables];
;

useFirmClientForSelfQuery.fetcher = (client: GraphQLClient, variables: FirmClientForSelfQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmClientForSelfQuery, FirmClientForSelfQueryVariables>(client, FirmClientForSelfDocument, variables, headers);
export const SwitchFirmClientModeDocument = `
    mutation SwitchFirmClientMode($input: SwitchFirmClientModeInput!) {
  switchFirmClientMode(input: $input) {
    firmClient {
      id
    }
  }
}
    `;
export const useSwitchFirmClientModeMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SwitchFirmClientModeMutation, TError, SwitchFirmClientModeMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SwitchFirmClientModeMutation, TError, SwitchFirmClientModeMutationVariables, TContext>(
      ['SwitchFirmClientMode'],
      (variables?: SwitchFirmClientModeMutationVariables) => fetcher<SwitchFirmClientModeMutation, SwitchFirmClientModeMutationVariables>(client, SwitchFirmClientModeDocument, variables, headers)(),
      options
    );
useSwitchFirmClientModeMutation.getKey = () => ['SwitchFirmClientMode'];

useSwitchFirmClientModeMutation.fetcher = (client: GraphQLClient, variables: SwitchFirmClientModeMutationVariables, headers?: RequestInit['headers']) => fetcher<SwitchFirmClientModeMutation, SwitchFirmClientModeMutationVariables>(client, SwitchFirmClientModeDocument, variables, headers);
export const ArchiveFirmClientDocument = `
    mutation ArchiveFirmClient($input: ArchiveFirmClientInput!) {
  archiveFirmClient(input: $input) {
    archived
  }
}
    `;
export const useArchiveFirmClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveFirmClientMutation, TError, ArchiveFirmClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ArchiveFirmClientMutation, TError, ArchiveFirmClientMutationVariables, TContext>(
      ['ArchiveFirmClient'],
      (variables?: ArchiveFirmClientMutationVariables) => fetcher<ArchiveFirmClientMutation, ArchiveFirmClientMutationVariables>(client, ArchiveFirmClientDocument, variables, headers)(),
      options
    );
useArchiveFirmClientMutation.getKey = () => ['ArchiveFirmClient'];

useArchiveFirmClientMutation.fetcher = (client: GraphQLClient, variables: ArchiveFirmClientMutationVariables, headers?: RequestInit['headers']) => fetcher<ArchiveFirmClientMutation, ArchiveFirmClientMutationVariables>(client, ArchiveFirmClientDocument, variables, headers);
export const RemoveClientAccessDocument = `
    mutation RemoveClientAccess($input: RemoveClientAccessInput!) {
  removeClientAccess(input: $input) {
    removed
  }
}
    `;
export const useRemoveClientAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveClientAccessMutation, TError, RemoveClientAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveClientAccessMutation, TError, RemoveClientAccessMutationVariables, TContext>(
      ['RemoveClientAccess'],
      (variables?: RemoveClientAccessMutationVariables) => fetcher<RemoveClientAccessMutation, RemoveClientAccessMutationVariables>(client, RemoveClientAccessDocument, variables, headers)(),
      options
    );
useRemoveClientAccessMutation.getKey = () => ['RemoveClientAccess'];

useRemoveClientAccessMutation.fetcher = (client: GraphQLClient, variables: RemoveClientAccessMutationVariables, headers?: RequestInit['headers']) => fetcher<RemoveClientAccessMutation, RemoveClientAccessMutationVariables>(client, RemoveClientAccessDocument, variables, headers);
export const RemoveFeatureDiscoveryTriggerFromFirmClientDocument = `
    mutation RemoveFeatureDiscoveryTriggerFromFirmClient($input: RemoveFeatureDiscoveryTriggerFromFirmClientInput!) {
  removeFeatureDiscoveryTriggerFromFirmClient(input: $input) {
    removed
  }
}
    `;
export const useRemoveFeatureDiscoveryTriggerFromFirmClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveFeatureDiscoveryTriggerFromFirmClientMutation, TError, RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveFeatureDiscoveryTriggerFromFirmClientMutation, TError, RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables, TContext>(
      ['RemoveFeatureDiscoveryTriggerFromFirmClient'],
      (variables?: RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables) => fetcher<RemoveFeatureDiscoveryTriggerFromFirmClientMutation, RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables>(client, RemoveFeatureDiscoveryTriggerFromFirmClientDocument, variables, headers)(),
      options
    );
useRemoveFeatureDiscoveryTriggerFromFirmClientMutation.getKey = () => ['RemoveFeatureDiscoveryTriggerFromFirmClient'];

useRemoveFeatureDiscoveryTriggerFromFirmClientMutation.fetcher = (client: GraphQLClient, variables: RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables, headers?: RequestInit['headers']) => fetcher<RemoveFeatureDiscoveryTriggerFromFirmClientMutation, RemoveFeatureDiscoveryTriggerFromFirmClientMutationVariables>(client, RemoveFeatureDiscoveryTriggerFromFirmClientDocument, variables, headers);
export const SwitchFirmClientOnboardingDocument = `
    mutation SwitchFirmClientOnboarding($input: SwitchFirmClientOnboardingInput!) {
  switchFirmClientOnboarding(input: $input) {
    firmClient {
      id
    }
  }
}
    `;
export const useSwitchFirmClientOnboardingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SwitchFirmClientOnboardingMutation, TError, SwitchFirmClientOnboardingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SwitchFirmClientOnboardingMutation, TError, SwitchFirmClientOnboardingMutationVariables, TContext>(
      ['SwitchFirmClientOnboarding'],
      (variables?: SwitchFirmClientOnboardingMutationVariables) => fetcher<SwitchFirmClientOnboardingMutation, SwitchFirmClientOnboardingMutationVariables>(client, SwitchFirmClientOnboardingDocument, variables, headers)(),
      options
    );
useSwitchFirmClientOnboardingMutation.getKey = () => ['SwitchFirmClientOnboarding'];

useSwitchFirmClientOnboardingMutation.fetcher = (client: GraphQLClient, variables: SwitchFirmClientOnboardingMutationVariables, headers?: RequestInit['headers']) => fetcher<SwitchFirmClientOnboardingMutation, SwitchFirmClientOnboardingMutationVariables>(client, SwitchFirmClientOnboardingDocument, variables, headers);
export const ClientsLayoutPageDocument = `
    query ClientsLayoutPage($firmID: ID!) {
  smartGroupsForFirm(input: {firmID: $firmID}) {
    items {
      id
      name
      firmID
      firmClients {
        id
      }
      smartGroupCriteria {
        type
        value {
          logicOperator
          dataComparison {
            comparisonData
            operator
            comparator {
              floatValue
              comparisonData
              monetaryAmountInCents
              householdHealthValue
            }
          }
        }
      }
    }
  }
}
    `;
export const useClientsLayoutPageQuery = <
      TData = ClientsLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ClientsLayoutPageQueryVariables,
      options?: UseQueryOptions<ClientsLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientsLayoutPageQuery, TError, TData>(
      ['ClientsLayoutPage', variables],
      fetcher<ClientsLayoutPageQuery, ClientsLayoutPageQueryVariables>(client, ClientsLayoutPageDocument, variables, headers),
      options
    );

useClientsLayoutPageQuery.getKey = (variables: ClientsLayoutPageQueryVariables) => ['ClientsLayoutPage', variables];
;

useClientsLayoutPageQuery.fetcher = (client: GraphQLClient, variables: ClientsLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ClientsLayoutPageQuery, ClientsLayoutPageQueryVariables>(client, ClientsLayoutPageDocument, variables, headers);
export const GetClosedCashAccountsDocument = `
    query GetClosedCashAccounts($householdID: ID!) {
  cashAccounts(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      cashAccountType
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedCashAccountsQuery = <
      TData = GetClosedCashAccountsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedCashAccountsQueryVariables,
      options?: UseQueryOptions<GetClosedCashAccountsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedCashAccountsQuery, TError, TData>(
      ['GetClosedCashAccounts', variables],
      fetcher<GetClosedCashAccountsQuery, GetClosedCashAccountsQueryVariables>(client, GetClosedCashAccountsDocument, variables, headers),
      options
    );

useGetClosedCashAccountsQuery.getKey = (variables: GetClosedCashAccountsQueryVariables) => ['GetClosedCashAccounts', variables];
;

useGetClosedCashAccountsQuery.fetcher = (client: GraphQLClient, variables: GetClosedCashAccountsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedCashAccountsQuery, GetClosedCashAccountsQueryVariables>(client, GetClosedCashAccountsDocument, variables, headers);
export const GetClosedInvestmentsDocument = `
    query GetClosedInvestments($householdID: ID!) {
  investments(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      investmentType
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedInvestmentsQuery = <
      TData = GetClosedInvestmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedInvestmentsQueryVariables,
      options?: UseQueryOptions<GetClosedInvestmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedInvestmentsQuery, TError, TData>(
      ['GetClosedInvestments', variables],
      fetcher<GetClosedInvestmentsQuery, GetClosedInvestmentsQueryVariables>(client, GetClosedInvestmentsDocument, variables, headers),
      options
    );

useGetClosedInvestmentsQuery.getKey = (variables: GetClosedInvestmentsQueryVariables) => ['GetClosedInvestments', variables];
;

useGetClosedInvestmentsQuery.fetcher = (client: GraphQLClient, variables: GetClosedInvestmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedInvestmentsQuery, GetClosedInvestmentsQueryVariables>(client, GetClosedInvestmentsDocument, variables, headers);
export const GetClosedBusinessesDocument = `
    query GetClosedBusinesses($householdID: ID!) {
  businesses(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedBusinessesQuery = <
      TData = GetClosedBusinessesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedBusinessesQueryVariables,
      options?: UseQueryOptions<GetClosedBusinessesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedBusinessesQuery, TError, TData>(
      ['GetClosedBusinesses', variables],
      fetcher<GetClosedBusinessesQuery, GetClosedBusinessesQueryVariables>(client, GetClosedBusinessesDocument, variables, headers),
      options
    );

useGetClosedBusinessesQuery.getKey = (variables: GetClosedBusinessesQueryVariables) => ['GetClosedBusinesses', variables];
;

useGetClosedBusinessesQuery.fetcher = (client: GraphQLClient, variables: GetClosedBusinessesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedBusinessesQuery, GetClosedBusinessesQueryVariables>(client, GetClosedBusinessesDocument, variables, headers);
export const GetClosedRealEstatePropertiesDocument = `
    query GetClosedRealEstateProperties($householdID: ID!) {
  realEstateProperties(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      realEstateType
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedRealEstatePropertiesQuery = <
      TData = GetClosedRealEstatePropertiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedRealEstatePropertiesQueryVariables,
      options?: UseQueryOptions<GetClosedRealEstatePropertiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedRealEstatePropertiesQuery, TError, TData>(
      ['GetClosedRealEstateProperties', variables],
      fetcher<GetClosedRealEstatePropertiesQuery, GetClosedRealEstatePropertiesQueryVariables>(client, GetClosedRealEstatePropertiesDocument, variables, headers),
      options
    );

useGetClosedRealEstatePropertiesQuery.getKey = (variables: GetClosedRealEstatePropertiesQueryVariables) => ['GetClosedRealEstateProperties', variables];
;

useGetClosedRealEstatePropertiesQuery.fetcher = (client: GraphQLClient, variables: GetClosedRealEstatePropertiesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedRealEstatePropertiesQuery, GetClosedRealEstatePropertiesQueryVariables>(client, GetClosedRealEstatePropertiesDocument, variables, headers);
export const GetClosedLoansDocument = `
    query GetClosedLoans($householdID: ID!) {
  loans(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      loanType
      ownedBalance {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedLoansQuery = <
      TData = GetClosedLoansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedLoansQueryVariables,
      options?: UseQueryOptions<GetClosedLoansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedLoansQuery, TError, TData>(
      ['GetClosedLoans', variables],
      fetcher<GetClosedLoansQuery, GetClosedLoansQueryVariables>(client, GetClosedLoansDocument, variables, headers),
      options
    );

useGetClosedLoansQuery.getKey = (variables: GetClosedLoansQueryVariables) => ['GetClosedLoans', variables];
;

useGetClosedLoansQuery.fetcher = (client: GraphQLClient, variables: GetClosedLoansQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedLoansQuery, GetClosedLoansQueryVariables>(client, GetClosedLoansDocument, variables, headers);
export const GetClosedPersonalPropertyItemsDocument = `
    query GetClosedPersonalPropertyItems($householdID: ID!) {
  personalPropertyItems(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedPersonalPropertyItemsQuery = <
      TData = GetClosedPersonalPropertyItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedPersonalPropertyItemsQueryVariables,
      options?: UseQueryOptions<GetClosedPersonalPropertyItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedPersonalPropertyItemsQuery, TError, TData>(
      ['GetClosedPersonalPropertyItems', variables],
      fetcher<GetClosedPersonalPropertyItemsQuery, GetClosedPersonalPropertyItemsQueryVariables>(client, GetClosedPersonalPropertyItemsDocument, variables, headers),
      options
    );

useGetClosedPersonalPropertyItemsQuery.getKey = (variables: GetClosedPersonalPropertyItemsQueryVariables) => ['GetClosedPersonalPropertyItems', variables];
;

useGetClosedPersonalPropertyItemsQuery.fetcher = (client: GraphQLClient, variables: GetClosedPersonalPropertyItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedPersonalPropertyItemsQuery, GetClosedPersonalPropertyItemsQueryVariables>(client, GetClosedPersonalPropertyItemsDocument, variables, headers);
export const GetClosedNoteReceivablesDocument = `
    query GetClosedNoteReceivables($householdID: ID!) {
  noteReceivables(householdID: $householdID, includeClosedAccounts: true) {
    items {
      id
      name
      ownedValue {
        __typename
        value
        currencyCode
      }
      closedAt
    }
  }
}
    `;
export const useGetClosedNoteReceivablesQuery = <
      TData = GetClosedNoteReceivablesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetClosedNoteReceivablesQueryVariables,
      options?: UseQueryOptions<GetClosedNoteReceivablesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetClosedNoteReceivablesQuery, TError, TData>(
      ['GetClosedNoteReceivables', variables],
      fetcher<GetClosedNoteReceivablesQuery, GetClosedNoteReceivablesQueryVariables>(client, GetClosedNoteReceivablesDocument, variables, headers),
      options
    );

useGetClosedNoteReceivablesQuery.getKey = (variables: GetClosedNoteReceivablesQueryVariables) => ['GetClosedNoteReceivables', variables];
;

useGetClosedNoteReceivablesQuery.fetcher = (client: GraphQLClient, variables: GetClosedNoteReceivablesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetClosedNoteReceivablesQuery, GetClosedNoteReceivablesQueryVariables>(client, GetClosedNoteReceivablesDocument, variables, headers);
export const CustomGroupBasicLayoutPageDocument = `
    query CustomGroupBasicLayoutPage($groupID: ID!, $firmID: ID!) {
  firmClientGroup(firmID: $firmID, id: $groupID) {
    name
  }
}
    `;
export const useCustomGroupBasicLayoutPageQuery = <
      TData = CustomGroupBasicLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomGroupBasicLayoutPageQueryVariables,
      options?: UseQueryOptions<CustomGroupBasicLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomGroupBasicLayoutPageQuery, TError, TData>(
      ['CustomGroupBasicLayoutPage', variables],
      fetcher<CustomGroupBasicLayoutPageQuery, CustomGroupBasicLayoutPageQueryVariables>(client, CustomGroupBasicLayoutPageDocument, variables, headers),
      options
    );

useCustomGroupBasicLayoutPageQuery.getKey = (variables: CustomGroupBasicLayoutPageQueryVariables) => ['CustomGroupBasicLayoutPage', variables];
;

useCustomGroupBasicLayoutPageQuery.fetcher = (client: GraphQLClient, variables: CustomGroupBasicLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<CustomGroupBasicLayoutPageQuery, CustomGroupBasicLayoutPageQueryVariables>(client, CustomGroupBasicLayoutPageDocument, variables, headers);
export const CustomGroupSaodLayoutPageDocument = `
    query CustomGroupSAODLayoutPage($groupID: ID!, $firmID: ID!) {
  firmClientGroup(firmID: $firmID, id: $groupID) {
    name
  }
}
    `;
export const useCustomGroupSaodLayoutPageQuery = <
      TData = CustomGroupSaodLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CustomGroupSaodLayoutPageQueryVariables,
      options?: UseQueryOptions<CustomGroupSaodLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CustomGroupSaodLayoutPageQuery, TError, TData>(
      ['CustomGroupSAODLayoutPage', variables],
      fetcher<CustomGroupSaodLayoutPageQuery, CustomGroupSaodLayoutPageQueryVariables>(client, CustomGroupSaodLayoutPageDocument, variables, headers),
      options
    );

useCustomGroupSaodLayoutPageQuery.getKey = (variables: CustomGroupSaodLayoutPageQueryVariables) => ['CustomGroupSAODLayoutPage', variables];
;

useCustomGroupSaodLayoutPageQuery.fetcher = (client: GraphQLClient, variables: CustomGroupSaodLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<CustomGroupSaodLayoutPageQuery, CustomGroupSaodLayoutPageQueryVariables>(client, CustomGroupSaodLayoutPageDocument, variables, headers);
export const CreateDataPointDocument = `
    mutation CreateDataPoint($input: CreateDataPointInput!) {
  createDataPoint(input: $input) {
    dataPoint {
      id
      tenantID
      groupID
    }
  }
}
    `;
export const useCreateDataPointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateDataPointMutation, TError, CreateDataPointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateDataPointMutation, TError, CreateDataPointMutationVariables, TContext>(
      ['CreateDataPoint'],
      (variables?: CreateDataPointMutationVariables) => fetcher<CreateDataPointMutation, CreateDataPointMutationVariables>(client, CreateDataPointDocument, variables, headers)(),
      options
    );
useCreateDataPointMutation.getKey = () => ['CreateDataPoint'];

useCreateDataPointMutation.fetcher = (client: GraphQLClient, variables: CreateDataPointMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateDataPointMutation, CreateDataPointMutationVariables>(client, CreateDataPointDocument, variables, headers);
export const UpdateDataPointDocument = `
    mutation UpdateDataPoint($input: UpdateDataPointInput!) {
  updateDataPoint(input: $input) {
    dataPoint {
      id
      tenantID
      groupID
    }
  }
}
    `;
export const useUpdateDataPointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateDataPointMutation, TError, UpdateDataPointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateDataPointMutation, TError, UpdateDataPointMutationVariables, TContext>(
      ['UpdateDataPoint'],
      (variables?: UpdateDataPointMutationVariables) => fetcher<UpdateDataPointMutation, UpdateDataPointMutationVariables>(client, UpdateDataPointDocument, variables, headers)(),
      options
    );
useUpdateDataPointMutation.getKey = () => ['UpdateDataPoint'];

useUpdateDataPointMutation.fetcher = (client: GraphQLClient, variables: UpdateDataPointMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateDataPointMutation, UpdateDataPointMutationVariables>(client, UpdateDataPointDocument, variables, headers);
export const CreateDataPointGroupDocument = `
    mutation CreateDataPointGroup($input: CreateDataPointGroupInput!) {
  createDataPointGroup(input: $input) {
    dataPointGroup {
      id
    }
  }
}
    `;
export const useCreateDataPointGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateDataPointGroupMutation, TError, CreateDataPointGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateDataPointGroupMutation, TError, CreateDataPointGroupMutationVariables, TContext>(
      ['CreateDataPointGroup'],
      (variables?: CreateDataPointGroupMutationVariables) => fetcher<CreateDataPointGroupMutation, CreateDataPointGroupMutationVariables>(client, CreateDataPointGroupDocument, variables, headers)(),
      options
    );
useCreateDataPointGroupMutation.getKey = () => ['CreateDataPointGroup'];

useCreateDataPointGroupMutation.fetcher = (client: GraphQLClient, variables: CreateDataPointGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateDataPointGroupMutation, CreateDataPointGroupMutationVariables>(client, CreateDataPointGroupDocument, variables, headers);
export const DeleteDataPointDocument = `
    mutation DeleteDataPoint($input: DeleteDataPointInput!) {
  deleteDataPoint(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteDataPointMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteDataPointMutation, TError, DeleteDataPointMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteDataPointMutation, TError, DeleteDataPointMutationVariables, TContext>(
      ['DeleteDataPoint'],
      (variables?: DeleteDataPointMutationVariables) => fetcher<DeleteDataPointMutation, DeleteDataPointMutationVariables>(client, DeleteDataPointDocument, variables, headers)(),
      options
    );
useDeleteDataPointMutation.getKey = () => ['DeleteDataPoint'];

useDeleteDataPointMutation.fetcher = (client: GraphQLClient, variables: DeleteDataPointMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteDataPointMutation, DeleteDataPointMutationVariables>(client, DeleteDataPointDocument, variables, headers);
export const DataPointsInGroupDocument = `
    query DataPointsInGroup($tenantID: ID!, $groupID: ID!, $cursor: String, $from: Date, $to: Date) {
  dataPointsInGroup(
    tenantID: $tenantID
    groupID: $groupID
    cursor: $cursor
    from: $from
    to: $to
  ) {
    __typename
    ... on RecurringMonetaryAmountDataPointList {
      items {
        ...RecurringMonetaryAmountDataPointFragment
      }
    }
    ... on MonetaryAmountDataPointList {
      items {
        ...MonetaryAmountDataPointFragment
      }
    }
  }
}
    ${RecurringMonetaryAmountDataPointFragmentFragmentDoc}
${MonetaryAmountDataPointFragmentFragmentDoc}`;
export const useDataPointsInGroupQuery = <
      TData = DataPointsInGroupQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DataPointsInGroupQueryVariables,
      options?: UseQueryOptions<DataPointsInGroupQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DataPointsInGroupQuery, TError, TData>(
      ['DataPointsInGroup', variables],
      fetcher<DataPointsInGroupQuery, DataPointsInGroupQueryVariables>(client, DataPointsInGroupDocument, variables, headers),
      options
    );

useDataPointsInGroupQuery.getKey = (variables: DataPointsInGroupQueryVariables) => ['DataPointsInGroup', variables];
;

useDataPointsInGroupQuery.fetcher = (client: GraphQLClient, variables: DataPointsInGroupQueryVariables, headers?: RequestInit['headers']) => fetcher<DataPointsInGroupQuery, DataPointsInGroupQueryVariables>(client, DataPointsInGroupDocument, variables, headers);
export const StringDataPointsInGroupDocument = `
    query StringDataPointsInGroup($tenantID: ID!, $groupID: ID!, $cursor: String, $from: Date, $to: Date) {
  dataPointsInGroup(
    tenantID: $tenantID
    groupID: $groupID
    cursor: $cursor
    from: $from
    to: $to
  ) {
    __typename
    ... on FloatDataPointList {
      items {
        __typename
      }
    }
    ... on InvestmentMixDataPointList {
      items {
        __typename
      }
    }
    ... on MonetaryAmountDataPointList {
      items {
        __typename
      }
    }
    ... on RecurringMonetaryAmountDataPointList {
      items {
        __typename
      }
    }
    ... on StringDataPointList {
      items {
        ...StringDataPointFragment
      }
    }
  }
}
    ${StringDataPointFragmentFragmentDoc}`;
export const useStringDataPointsInGroupQuery = <
      TData = StringDataPointsInGroupQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: StringDataPointsInGroupQueryVariables,
      options?: UseQueryOptions<StringDataPointsInGroupQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StringDataPointsInGroupQuery, TError, TData>(
      ['StringDataPointsInGroup', variables],
      fetcher<StringDataPointsInGroupQuery, StringDataPointsInGroupQueryVariables>(client, StringDataPointsInGroupDocument, variables, headers),
      options
    );

useStringDataPointsInGroupQuery.getKey = (variables: StringDataPointsInGroupQueryVariables) => ['StringDataPointsInGroup', variables];
;

useStringDataPointsInGroupQuery.fetcher = (client: GraphQLClient, variables: StringDataPointsInGroupQueryVariables, headers?: RequestInit['headers']) => fetcher<StringDataPointsInGroupQuery, StringDataPointsInGroupQueryVariables>(client, StringDataPointsInGroupDocument, variables, headers);
export const DrDetailsDocument = `
    query DrDetails($householdID: ID!, $includeScore: Boolean!, $includeAnnualDebtPayments: Boolean!, $includeAnnualIncome: Boolean!, $includeTotalPersonalRealEstateLoans: Boolean!, $includeMonthlyPersonalRealEstatePayments: Boolean!, $includeTotalInvestmentRealEstateLoans: Boolean!, $includeMonthlyInvestmentRealEstatePayments: Boolean!, $includeTotalStudentLoans: Boolean!, $includeMonthlyStudentLoanPayments: Boolean!, $includeTotalOtherDebt: Boolean!, $includeMonthlyOtherDebtPayments: Boolean!, $includeTotalDebt: Boolean!, $includeTotalCreditCardDebt: Boolean!, $includeTotalAutoLoans: Boolean!, $includeMonthlyAutoLoanPayments: Boolean!, $includeMonthlyCreditCardPayments: Boolean!) {
  drDetails(householdID: $householdID) {
    dr @include(if: $includeScore)
    annualDebtPayments @include(if: $includeAnnualDebtPayments) {
      ...MonetaryAmountFragment
    }
    annualIncome @include(if: $includeAnnualIncome) {
      ...MonetaryAmountFragment
    }
    totalPersonalRealEstateLoans @include(if: $includeTotalPersonalRealEstateLoans) {
      ...MonetaryAmountFragment
    }
    monthlyPersonalRealEstatePayments @include(if: $includeMonthlyPersonalRealEstatePayments) {
      ...RecurringMonetaryAmountFragment
    }
    totalInvestmentRealEstateLoans @include(if: $includeTotalInvestmentRealEstateLoans) {
      ...MonetaryAmountFragment
    }
    monthlyInvestmentRealEstatePayments @include(if: $includeMonthlyInvestmentRealEstatePayments) {
      ...RecurringMonetaryAmountFragment
    }
    totalStudentLoans @include(if: $includeTotalStudentLoans) {
      ...MonetaryAmountFragment
    }
    monthlyStudentLoanPayments @include(if: $includeMonthlyStudentLoanPayments) {
      ...RecurringMonetaryAmountFragment
    }
    totalOtherDebt @include(if: $includeTotalOtherDebt) {
      ...MonetaryAmountFragment
    }
    monthlyOtherDebtPayments @include(if: $includeMonthlyOtherDebtPayments) {
      ...RecurringMonetaryAmountFragment
    }
    totalDebt @include(if: $includeTotalDebt) {
      ...MonetaryAmountFragment
    }
    totalCreditCardDebt @include(if: $includeTotalCreditCardDebt) {
      ...MonetaryAmountFragment
    }
    totalAutoLoans @include(if: $includeTotalAutoLoans) {
      ...MonetaryAmountFragment
    }
    monthlyCreditCardPayments @include(if: $includeMonthlyCreditCardPayments) {
      ...RecurringMonetaryAmountFragment
    }
    monthlyAutoLoanPayments @include(if: $includeMonthlyAutoLoanPayments) {
      ...RecurringMonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${RecurringMonetaryAmountFragmentFragmentDoc}`;
export const useDrDetailsQuery = <
      TData = DrDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: DrDetailsQueryVariables,
      options?: UseQueryOptions<DrDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<DrDetailsQuery, TError, TData>(
      ['DrDetails', variables],
      fetcher<DrDetailsQuery, DrDetailsQueryVariables>(client, DrDetailsDocument, variables, headers),
      options
    );

useDrDetailsQuery.getKey = (variables: DrDetailsQueryVariables) => ['DrDetails', variables];
;

useDrDetailsQuery.fetcher = (client: GraphQLClient, variables: DrDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<DrDetailsQuery, DrDetailsQueryVariables>(client, DrDetailsDocument, variables, headers);
export const EditSmartGroupPageDocument = `
    query EditSmartGroupPage($smartGroupID: ID!, $firmID: ID!) {
  smartGroup(input: {smartGroupID: $smartGroupID, firmID: $firmID}) {
    id
    name
    smartGroupCriteria {
      type
      value {
        logicOperator
        dataComparison {
          comparisonData
          operator
          comparator {
            floatValue
            comparisonData
            monetaryAmountInCents
            householdHealthValue
          }
        }
      }
    }
  }
}
    `;
export const useEditSmartGroupPageQuery = <
      TData = EditSmartGroupPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EditSmartGroupPageQueryVariables,
      options?: UseQueryOptions<EditSmartGroupPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EditSmartGroupPageQuery, TError, TData>(
      ['EditSmartGroupPage', variables],
      fetcher<EditSmartGroupPageQuery, EditSmartGroupPageQueryVariables>(client, EditSmartGroupPageDocument, variables, headers),
      options
    );

useEditSmartGroupPageQuery.getKey = (variables: EditSmartGroupPageQueryVariables) => ['EditSmartGroupPage', variables];
;

useEditSmartGroupPageQuery.fetcher = (client: GraphQLClient, variables: EditSmartGroupPageQueryVariables, headers?: RequestInit['headers']) => fetcher<EditSmartGroupPageQuery, EditSmartGroupPageQueryVariables>(client, EditSmartGroupPageDocument, variables, headers);
export const ErDetailsDocument = `
    query ErDetails($householdID: ID!, $includeScore: Boolean!, $includeTotalEquityInvestments: Boolean!, $includeTotalInvestmentsAndCash: Boolean!, $includeInvestments: Boolean!, $includeTotalBondHoldings: Boolean!, $includeTotalCash: Boolean!) {
  erDetails(householdID: $householdID) {
    er @include(if: $includeScore)
    totalEquityInvestments @include(if: $includeTotalEquityInvestments) {
      ...MonetaryAmountFragment
    }
    totalInvestmentsAndCash @include(if: $includeTotalInvestmentsAndCash) {
      ...MonetaryAmountFragment
    }
    investments @include(if: $includeInvestments) {
      ...InvestmentFragment
    }
    totalBondHoldings @include(if: $includeTotalBondHoldings) {
      ...MonetaryAmountFragment
    }
    totalCash @include(if: $includeTotalCash) {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}`;
export const useErDetailsQuery = <
      TData = ErDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ErDetailsQueryVariables,
      options?: UseQueryOptions<ErDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ErDetailsQuery, TError, TData>(
      ['ErDetails', variables],
      fetcher<ErDetailsQuery, ErDetailsQueryVariables>(client, ErDetailsDocument, variables, headers),
      options
    );

useErDetailsQuery.getKey = (variables: ErDetailsQueryVariables) => ['ErDetails', variables];
;

useErDetailsQuery.fetcher = (client: GraphQLClient, variables: ErDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<ErDetailsQuery, ErDetailsQueryVariables>(client, ErDetailsDocument, variables, headers);
export const CreateFileDocument = `
    mutation CreateFile($input: CreateFileInput!) {
  createFile(input: $input) {
    file {
      ...FileFragment
    }
  }
}
    ${FileFragmentFragmentDoc}`;
export const useCreateFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFileMutation, TError, CreateFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFileMutation, TError, CreateFileMutationVariables, TContext>(
      ['CreateFile'],
      (variables?: CreateFileMutationVariables) => fetcher<CreateFileMutation, CreateFileMutationVariables>(client, CreateFileDocument, variables, headers)(),
      options
    );
useCreateFileMutation.getKey = () => ['CreateFile'];

useCreateFileMutation.fetcher = (client: GraphQLClient, variables: CreateFileMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFileMutation, CreateFileMutationVariables>(client, CreateFileDocument, variables, headers);
export const FileDocument = `
    query File($tenantID: ID!, $id: ID!) {
  file(tenantID: $tenantID, id: $id) {
    ...FileFragment
  }
}
    ${FileFragmentFragmentDoc}`;
export const useFileQuery = <
      TData = FileQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FileQueryVariables,
      options?: UseQueryOptions<FileQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FileQuery, TError, TData>(
      ['File', variables],
      fetcher<FileQuery, FileQueryVariables>(client, FileDocument, variables, headers),
      options
    );

useFileQuery.getKey = (variables: FileQueryVariables) => ['File', variables];
;

useFileQuery.fetcher = (client: GraphQLClient, variables: FileQueryVariables, headers?: RequestInit['headers']) => fetcher<FileQuery, FileQueryVariables>(client, FileDocument, variables, headers);
export const DeleteFileDocument = `
    mutation DeleteFile($input: DeleteFileInput!) {
  deleteFile(input: $input) {
    changeToken
    __typename
  }
}
    `;
export const useDeleteFileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFileMutation, TError, DeleteFileMutationVariables, TContext>(
      ['DeleteFile'],
      (variables?: DeleteFileMutationVariables) => fetcher<DeleteFileMutation, DeleteFileMutationVariables>(client, DeleteFileDocument, variables, headers)(),
      options
    );
useDeleteFileMutation.getKey = () => ['DeleteFile'];

useDeleteFileMutation.fetcher = (client: GraphQLClient, variables: DeleteFileMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFileMutation, DeleteFileMutationVariables>(client, DeleteFileDocument, variables, headers);
export const CreateFileAttachmentDocument = `
    mutation CreateFileAttachment($input: CreateFileAttachmentInput!) {
  createFileAttachment(input: $input) {
    fileAttachment {
      ...FileAttachmentFragment
    }
  }
}
    ${FileAttachmentFragmentFragmentDoc}`;
export const useCreateFileAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFileAttachmentMutation, TError, CreateFileAttachmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFileAttachmentMutation, TError, CreateFileAttachmentMutationVariables, TContext>(
      ['CreateFileAttachment'],
      (variables?: CreateFileAttachmentMutationVariables) => fetcher<CreateFileAttachmentMutation, CreateFileAttachmentMutationVariables>(client, CreateFileAttachmentDocument, variables, headers)(),
      options
    );
useCreateFileAttachmentMutation.getKey = () => ['CreateFileAttachment'];

useCreateFileAttachmentMutation.fetcher = (client: GraphQLClient, variables: CreateFileAttachmentMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFileAttachmentMutation, CreateFileAttachmentMutationVariables>(client, CreateFileAttachmentDocument, variables, headers);
export const FileAttachmentsForItemDocument = `
    query FileAttachmentsForItem($tenantID: ID!, $id: ID!, $cursor: String) {
  fileAttachmentsForItem(tenantID: $tenantID, id: $id, cursor: $cursor) {
    items {
      ...FileAttachmentFragment
    }
  }
}
    ${FileAttachmentFragmentFragmentDoc}`;
export const useFileAttachmentsForItemQuery = <
      TData = FileAttachmentsForItemQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FileAttachmentsForItemQueryVariables,
      options?: UseQueryOptions<FileAttachmentsForItemQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FileAttachmentsForItemQuery, TError, TData>(
      ['FileAttachmentsForItem', variables],
      fetcher<FileAttachmentsForItemQuery, FileAttachmentsForItemQueryVariables>(client, FileAttachmentsForItemDocument, variables, headers),
      options
    );

useFileAttachmentsForItemQuery.getKey = (variables: FileAttachmentsForItemQueryVariables) => ['FileAttachmentsForItem', variables];
;

useFileAttachmentsForItemQuery.fetcher = (client: GraphQLClient, variables: FileAttachmentsForItemQueryVariables, headers?: RequestInit['headers']) => fetcher<FileAttachmentsForItemQuery, FileAttachmentsForItemQueryVariables>(client, FileAttachmentsForItemDocument, variables, headers);
export const DeleteFileAttachmentDocument = `
    mutation DeleteFileAttachment($input: DeleteFileAttachmentInput!) {
  deleteFileAttachment(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteFileAttachmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFileAttachmentMutation, TError, DeleteFileAttachmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFileAttachmentMutation, TError, DeleteFileAttachmentMutationVariables, TContext>(
      ['DeleteFileAttachment'],
      (variables?: DeleteFileAttachmentMutationVariables) => fetcher<DeleteFileAttachmentMutation, DeleteFileAttachmentMutationVariables>(client, DeleteFileAttachmentDocument, variables, headers)(),
      options
    );
useDeleteFileAttachmentMutation.getKey = () => ['DeleteFileAttachment'];

useDeleteFileAttachmentMutation.fetcher = (client: GraphQLClient, variables: DeleteFileAttachmentMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFileAttachmentMutation, DeleteFileAttachmentMutationVariables>(client, DeleteFileAttachmentDocument, variables, headers);
export const FinancialGoalsDocument = `
    query FinancialGoals($householdID: ID!, $cursor: String) {
  financialGoals(householdID: $householdID, cursor: $cursor) {
    items {
      ...FinancialGoalFragment
    }
  }
}
    ${FinancialGoalFragmentFragmentDoc}`;
export const useFinancialGoalsQuery = <
      TData = FinancialGoalsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FinancialGoalsQueryVariables,
      options?: UseQueryOptions<FinancialGoalsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FinancialGoalsQuery, TError, TData>(
      ['FinancialGoals', variables],
      fetcher<FinancialGoalsQuery, FinancialGoalsQueryVariables>(client, FinancialGoalsDocument, variables, headers),
      options
    );

useFinancialGoalsQuery.getKey = (variables: FinancialGoalsQueryVariables) => ['FinancialGoals', variables];
;

useFinancialGoalsQuery.fetcher = (client: GraphQLClient, variables: FinancialGoalsQueryVariables, headers?: RequestInit['headers']) => fetcher<FinancialGoalsQuery, FinancialGoalsQueryVariables>(client, FinancialGoalsDocument, variables, headers);
export const CreateFinancialGoalDocument = `
    mutation createFinancialGoal($input: CreateFinancialGoalInput!) {
  createFinancialGoal(input: $input) {
    financialGoal {
      ...FinancialGoalFragment
    }
  }
}
    ${FinancialGoalFragmentFragmentDoc}`;
export const useCreateFinancialGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFinancialGoalMutation, TError, CreateFinancialGoalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFinancialGoalMutation, TError, CreateFinancialGoalMutationVariables, TContext>(
      ['createFinancialGoal'],
      (variables?: CreateFinancialGoalMutationVariables) => fetcher<CreateFinancialGoalMutation, CreateFinancialGoalMutationVariables>(client, CreateFinancialGoalDocument, variables, headers)(),
      options
    );
useCreateFinancialGoalMutation.getKey = () => ['createFinancialGoal'];

useCreateFinancialGoalMutation.fetcher = (client: GraphQLClient, variables: CreateFinancialGoalMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFinancialGoalMutation, CreateFinancialGoalMutationVariables>(client, CreateFinancialGoalDocument, variables, headers);
export const UpdateFinancialGoalDocument = `
    mutation updateFinancialGoal($input: UpdateFinancialGoalInput!) {
  updateFinancialGoal(input: $input) {
    financialGoal {
      ...FinancialGoalFragment
    }
  }
}
    ${FinancialGoalFragmentFragmentDoc}`;
export const useUpdateFinancialGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFinancialGoalMutation, TError, UpdateFinancialGoalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFinancialGoalMutation, TError, UpdateFinancialGoalMutationVariables, TContext>(
      ['updateFinancialGoal'],
      (variables?: UpdateFinancialGoalMutationVariables) => fetcher<UpdateFinancialGoalMutation, UpdateFinancialGoalMutationVariables>(client, UpdateFinancialGoalDocument, variables, headers)(),
      options
    );
useUpdateFinancialGoalMutation.getKey = () => ['updateFinancialGoal'];

useUpdateFinancialGoalMutation.fetcher = (client: GraphQLClient, variables: UpdateFinancialGoalMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFinancialGoalMutation, UpdateFinancialGoalMutationVariables>(client, UpdateFinancialGoalDocument, variables, headers);
export const ReorderFinancialGoalDocument = `
    mutation reorderFinancialGoal($input: ReorderFinancialGoalInput!) {
  reorderFinancialGoal(input: $input) {
    goals {
      ...FinancialGoalFragment
    }
  }
}
    ${FinancialGoalFragmentFragmentDoc}`;
export const useReorderFinancialGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReorderFinancialGoalMutation, TError, ReorderFinancialGoalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReorderFinancialGoalMutation, TError, ReorderFinancialGoalMutationVariables, TContext>(
      ['reorderFinancialGoal'],
      (variables?: ReorderFinancialGoalMutationVariables) => fetcher<ReorderFinancialGoalMutation, ReorderFinancialGoalMutationVariables>(client, ReorderFinancialGoalDocument, variables, headers)(),
      options
    );
useReorderFinancialGoalMutation.getKey = () => ['reorderFinancialGoal'];

useReorderFinancialGoalMutation.fetcher = (client: GraphQLClient, variables: ReorderFinancialGoalMutationVariables, headers?: RequestInit['headers']) => fetcher<ReorderFinancialGoalMutation, ReorderFinancialGoalMutationVariables>(client, ReorderFinancialGoalDocument, variables, headers);
export const DeleteFinancialGoalDocument = `
    mutation deleteFinancialGoal($input: DeleteFinancialGoalInput!) {
  deleteFinancialGoal(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteFinancialGoalMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFinancialGoalMutation, TError, DeleteFinancialGoalMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFinancialGoalMutation, TError, DeleteFinancialGoalMutationVariables, TContext>(
      ['deleteFinancialGoal'],
      (variables?: DeleteFinancialGoalMutationVariables) => fetcher<DeleteFinancialGoalMutation, DeleteFinancialGoalMutationVariables>(client, DeleteFinancialGoalDocument, variables, headers)(),
      options
    );
useDeleteFinancialGoalMutation.getKey = () => ['deleteFinancialGoal'];

useDeleteFinancialGoalMutation.fetcher = (client: GraphQLClient, variables: DeleteFinancialGoalMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFinancialGoalMutation, DeleteFinancialGoalMutationVariables>(client, DeleteFinancialGoalDocument, variables, headers);
export const FinancialNextStepsDocument = `
    query FinancialNextSteps($householdID: ID!, $cursor: String) {
  financialNextSteps(householdID: $householdID, cursor: $cursor) {
    items {
      ...FinancialNextStepFragment
    }
  }
}
    ${FinancialNextStepFragmentFragmentDoc}`;
export const useFinancialNextStepsQuery = <
      TData = FinancialNextStepsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FinancialNextStepsQueryVariables,
      options?: UseQueryOptions<FinancialNextStepsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FinancialNextStepsQuery, TError, TData>(
      ['FinancialNextSteps', variables],
      fetcher<FinancialNextStepsQuery, FinancialNextStepsQueryVariables>(client, FinancialNextStepsDocument, variables, headers),
      options
    );

useFinancialNextStepsQuery.getKey = (variables: FinancialNextStepsQueryVariables) => ['FinancialNextSteps', variables];
;

useFinancialNextStepsQuery.fetcher = (client: GraphQLClient, variables: FinancialNextStepsQueryVariables, headers?: RequestInit['headers']) => fetcher<FinancialNextStepsQuery, FinancialNextStepsQueryVariables>(client, FinancialNextStepsDocument, variables, headers);
export const CreateFinancialNextStepDocument = `
    mutation createFinancialNextStep($input: CreateFinancialNextStepInput!) {
  createFinancialNextStep(input: $input) {
    financialNextStep {
      ...FinancialNextStepFragment
    }
  }
}
    ${FinancialNextStepFragmentFragmentDoc}`;
export const useCreateFinancialNextStepMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFinancialNextStepMutation, TError, CreateFinancialNextStepMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFinancialNextStepMutation, TError, CreateFinancialNextStepMutationVariables, TContext>(
      ['createFinancialNextStep'],
      (variables?: CreateFinancialNextStepMutationVariables) => fetcher<CreateFinancialNextStepMutation, CreateFinancialNextStepMutationVariables>(client, CreateFinancialNextStepDocument, variables, headers)(),
      options
    );
useCreateFinancialNextStepMutation.getKey = () => ['createFinancialNextStep'];

useCreateFinancialNextStepMutation.fetcher = (client: GraphQLClient, variables: CreateFinancialNextStepMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFinancialNextStepMutation, CreateFinancialNextStepMutationVariables>(client, CreateFinancialNextStepDocument, variables, headers);
export const UpdateFinancialNextStepDocument = `
    mutation updateFinancialNextStep($input: UpdateFinancialNextStepInput!) {
  updateFinancialNextStep(input: $input) {
    financialNextStep {
      ...FinancialNextStepFragment
    }
  }
}
    ${FinancialNextStepFragmentFragmentDoc}`;
export const useUpdateFinancialNextStepMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFinancialNextStepMutation, TError, UpdateFinancialNextStepMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFinancialNextStepMutation, TError, UpdateFinancialNextStepMutationVariables, TContext>(
      ['updateFinancialNextStep'],
      (variables?: UpdateFinancialNextStepMutationVariables) => fetcher<UpdateFinancialNextStepMutation, UpdateFinancialNextStepMutationVariables>(client, UpdateFinancialNextStepDocument, variables, headers)(),
      options
    );
useUpdateFinancialNextStepMutation.getKey = () => ['updateFinancialNextStep'];

useUpdateFinancialNextStepMutation.fetcher = (client: GraphQLClient, variables: UpdateFinancialNextStepMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFinancialNextStepMutation, UpdateFinancialNextStepMutationVariables>(client, UpdateFinancialNextStepDocument, variables, headers);
export const ReorderFinancialNextStepDocument = `
    mutation reorderFinancialNextStep($input: ReorderFinancialNextStepInput!) {
  reorderFinancialNextStep(input: $input) {
    nextSteps {
      ...FinancialNextStepFragment
    }
  }
}
    ${FinancialNextStepFragmentFragmentDoc}`;
export const useReorderFinancialNextStepMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReorderFinancialNextStepMutation, TError, ReorderFinancialNextStepMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReorderFinancialNextStepMutation, TError, ReorderFinancialNextStepMutationVariables, TContext>(
      ['reorderFinancialNextStep'],
      (variables?: ReorderFinancialNextStepMutationVariables) => fetcher<ReorderFinancialNextStepMutation, ReorderFinancialNextStepMutationVariables>(client, ReorderFinancialNextStepDocument, variables, headers)(),
      options
    );
useReorderFinancialNextStepMutation.getKey = () => ['reorderFinancialNextStep'];

useReorderFinancialNextStepMutation.fetcher = (client: GraphQLClient, variables: ReorderFinancialNextStepMutationVariables, headers?: RequestInit['headers']) => fetcher<ReorderFinancialNextStepMutation, ReorderFinancialNextStepMutationVariables>(client, ReorderFinancialNextStepDocument, variables, headers);
export const DeleteFinancialNextStepDocument = `
    mutation deleteFinancialNextStep($input: DeleteFinancialNextStepInput!) {
  deleteFinancialNextStep(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteFinancialNextStepMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFinancialNextStepMutation, TError, DeleteFinancialNextStepMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFinancialNextStepMutation, TError, DeleteFinancialNextStepMutationVariables, TContext>(
      ['deleteFinancialNextStep'],
      (variables?: DeleteFinancialNextStepMutationVariables) => fetcher<DeleteFinancialNextStepMutation, DeleteFinancialNextStepMutationVariables>(client, DeleteFinancialNextStepDocument, variables, headers)(),
      options
    );
useDeleteFinancialNextStepMutation.getKey = () => ['deleteFinancialNextStep'];

useDeleteFinancialNextStepMutation.fetcher = (client: GraphQLClient, variables: DeleteFinancialNextStepMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFinancialNextStepMutation, DeleteFinancialNextStepMutationVariables>(client, DeleteFinancialNextStepDocument, variables, headers);
export const FirmDocument = `
    query Firm($id: ID!) {
  firm(id: $id) {
    ...FirmFragment
  }
}
    ${FirmFragmentFragmentDoc}`;
export const useFirmQuery = <
      TData = FirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmQueryVariables,
      options?: UseQueryOptions<FirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmQuery, TError, TData>(
      ['Firm', variables],
      fetcher<FirmQuery, FirmQueryVariables>(client, FirmDocument, variables, headers),
      options
    );

useFirmQuery.getKey = (variables: FirmQueryVariables) => ['Firm', variables];
;

useFirmQuery.fetcher = (client: GraphQLClient, variables: FirmQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmQuery, FirmQueryVariables>(client, FirmDocument, variables, headers);
export const BillingPortalLinkDocument = `
    query BillingPortalLink($firmID: ID!) {
  billingPortalLink(firmID: $firmID)
}
    `;
export const useBillingPortalLinkQuery = <
      TData = BillingPortalLinkQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: BillingPortalLinkQueryVariables,
      options?: UseQueryOptions<BillingPortalLinkQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BillingPortalLinkQuery, TError, TData>(
      ['BillingPortalLink', variables],
      fetcher<BillingPortalLinkQuery, BillingPortalLinkQueryVariables>(client, BillingPortalLinkDocument, variables, headers),
      options
    );

useBillingPortalLinkQuery.getKey = (variables: BillingPortalLinkQueryVariables) => ['BillingPortalLink', variables];
;

useBillingPortalLinkQuery.fetcher = (client: GraphQLClient, variables: BillingPortalLinkQueryVariables, headers?: RequestInit['headers']) => fetcher<BillingPortalLinkQuery, BillingPortalLinkQueryVariables>(client, BillingPortalLinkDocument, variables, headers);
export const UpdateFirmDocument = `
    mutation UpdateFirm($input: UpdateFirmInput!) {
  updateFirm(input: $input) {
    firm {
      id
    }
  }
}
    `;
export const useUpdateFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFirmMutation, TError, UpdateFirmMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFirmMutation, TError, UpdateFirmMutationVariables, TContext>(
      ['UpdateFirm'],
      (variables?: UpdateFirmMutationVariables) => fetcher<UpdateFirmMutation, UpdateFirmMutationVariables>(client, UpdateFirmDocument, variables, headers)(),
      options
    );
useUpdateFirmMutation.getKey = () => ['UpdateFirm'];

useUpdateFirmMutation.fetcher = (client: GraphQLClient, variables: UpdateFirmMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFirmMutation, UpdateFirmMutationVariables>(client, UpdateFirmDocument, variables, headers);
export const FirmBrandingDocument = `
    query FirmBranding($id: ID!) {
  firmBranding(id: $id) {
    id
    color
    type
    logo {
      downloadURL
    }
  }
}
    `;
export const useFirmBrandingQuery = <
      TData = FirmBrandingQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmBrandingQueryVariables,
      options?: UseQueryOptions<FirmBrandingQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmBrandingQuery, TError, TData>(
      ['FirmBranding', variables],
      fetcher<FirmBrandingQuery, FirmBrandingQueryVariables>(client, FirmBrandingDocument, variables, headers),
      options
    );

useFirmBrandingQuery.getKey = (variables: FirmBrandingQueryVariables) => ['FirmBranding', variables];
;

useFirmBrandingQuery.fetcher = (client: GraphQLClient, variables: FirmBrandingQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmBrandingQuery, FirmBrandingQueryVariables>(client, FirmBrandingDocument, variables, headers);
export const FirmsDocument = `
    query Firms {
  firms {
    items {
      ...FirmFragment
    }
  }
}
    ${FirmFragmentFragmentDoc}`;
export const useFirmsQuery = <
      TData = FirmsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: FirmsQueryVariables,
      options?: UseQueryOptions<FirmsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmsQuery, TError, TData>(
      variables === undefined ? ['Firms'] : ['Firms', variables],
      fetcher<FirmsQuery, FirmsQueryVariables>(client, FirmsDocument, variables, headers),
      options
    );

useFirmsQuery.getKey = (variables?: FirmsQueryVariables) => variables === undefined ? ['Firms'] : ['Firms', variables];
;

useFirmsQuery.fetcher = (client: GraphQLClient, variables?: FirmsQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmsQuery, FirmsQueryVariables>(client, FirmsDocument, variables, headers);
export const FirmMembersForFirmDocument = `
    query FirmMembersForFirm($firmID: ID!, $cursor: String) {
  firmMembersForFirm(firmID: $firmID, cursor: $cursor) {
    items {
      ...FirmMemberFragment
    }
  }
}
    ${FirmMemberFragmentFragmentDoc}`;
export const useFirmMembersForFirmQuery = <
      TData = FirmMembersForFirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmMembersForFirmQueryVariables,
      options?: UseQueryOptions<FirmMembersForFirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmMembersForFirmQuery, TError, TData>(
      ['FirmMembersForFirm', variables],
      fetcher<FirmMembersForFirmQuery, FirmMembersForFirmQueryVariables>(client, FirmMembersForFirmDocument, variables, headers),
      options
    );

useFirmMembersForFirmQuery.getKey = (variables: FirmMembersForFirmQueryVariables) => ['FirmMembersForFirm', variables];
;

useFirmMembersForFirmQuery.fetcher = (client: GraphQLClient, variables: FirmMembersForFirmQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmMembersForFirmQuery, FirmMembersForFirmQueryVariables>(client, FirmMembersForFirmDocument, variables, headers);
export const UpdateFirmMemberDocument = `
    mutation UpdateFirmMember($input: UpdateFirmMemberInput!) {
  updateFirmMember(input: $input) {
    firmMember {
      ...FirmMemberFragment
    }
  }
}
    ${FirmMemberFragmentFragmentDoc}`;
export const useUpdateFirmMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFirmMemberMutation, TError, UpdateFirmMemberMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFirmMemberMutation, TError, UpdateFirmMemberMutationVariables, TContext>(
      ['UpdateFirmMember'],
      (variables?: UpdateFirmMemberMutationVariables) => fetcher<UpdateFirmMemberMutation, UpdateFirmMemberMutationVariables>(client, UpdateFirmMemberDocument, variables, headers)(),
      options
    );
useUpdateFirmMemberMutation.getKey = () => ['UpdateFirmMember'];

useUpdateFirmMemberMutation.fetcher = (client: GraphQLClient, variables: UpdateFirmMemberMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFirmMemberMutation, UpdateFirmMemberMutationVariables>(client, UpdateFirmMemberDocument, variables, headers);
export const GraphNetWorthDocument = `
    query graphNetWorth($householdID: ID!, $settings: GraphSettings) {
  graphNetWorth(householdID: $householdID, settings: $settings) {
    __typename
    dateTime
    interpolated
    value {
      __typename
      ... on MonetaryAmountGraphPointValue {
        value {
          ...MonetaryAmountFragment
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const useGraphNetWorthQuery = <
      TData = GraphNetWorthQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GraphNetWorthQueryVariables,
      options?: UseQueryOptions<GraphNetWorthQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GraphNetWorthQuery, TError, TData>(
      ['graphNetWorth', variables],
      fetcher<GraphNetWorthQuery, GraphNetWorthQueryVariables>(client, GraphNetWorthDocument, variables, headers),
      options
    );

useGraphNetWorthQuery.getKey = (variables: GraphNetWorthQueryVariables) => ['graphNetWorth', variables];
;

useGraphNetWorthQuery.fetcher = (client: GraphQLClient, variables: GraphNetWorthQueryVariables, headers?: RequestInit['headers']) => fetcher<GraphNetWorthQuery, GraphNetWorthQueryVariables>(client, GraphNetWorthDocument, variables, headers);
export const GraphDataPointsInGroupDocument = `
    query GraphDataPointsInGroup($tenantID: ID!, $groupID: ID!, $settings: GraphSettings) {
  graphDataPointsInGroup(
    tenantID: $tenantID
    groupID: $groupID
    settings: $settings
  ) {
    __typename
    dateTime
    interpolated
    value {
      __typename
      ... on MonetaryAmountGraphPointValue {
        value {
          value
          currencyCode
        }
      }
    }
  }
}
    `;
export const useGraphDataPointsInGroupQuery = <
      TData = GraphDataPointsInGroupQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GraphDataPointsInGroupQueryVariables,
      options?: UseQueryOptions<GraphDataPointsInGroupQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GraphDataPointsInGroupQuery, TError, TData>(
      ['GraphDataPointsInGroup', variables],
      fetcher<GraphDataPointsInGroupQuery, GraphDataPointsInGroupQueryVariables>(client, GraphDataPointsInGroupDocument, variables, headers),
      options
    );

useGraphDataPointsInGroupQuery.getKey = (variables: GraphDataPointsInGroupQueryVariables) => ['GraphDataPointsInGroup', variables];
;

useGraphDataPointsInGroupQuery.fetcher = (client: GraphQLClient, variables: GraphDataPointsInGroupQueryVariables, headers?: RequestInit['headers']) => fetcher<GraphDataPointsInGroupQuery, GraphDataPointsInGroupQueryVariables>(client, GraphDataPointsInGroupDocument, variables, headers);
export const CreateIncomeSourceDocument = `
    mutation CreateIncomeSource($input: CreateIncomeSourceInput!) {
  createIncomeSource(input: $input) {
    incomeSource {
      ...IncomeSourceFragment
    }
  }
}
    ${IncomeSourceFragmentFragmentDoc}`;
export const useCreateIncomeSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateIncomeSourceMutation, TError, CreateIncomeSourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateIncomeSourceMutation, TError, CreateIncomeSourceMutationVariables, TContext>(
      ['CreateIncomeSource'],
      (variables?: CreateIncomeSourceMutationVariables) => fetcher<CreateIncomeSourceMutation, CreateIncomeSourceMutationVariables>(client, CreateIncomeSourceDocument, variables, headers)(),
      options
    );
useCreateIncomeSourceMutation.getKey = () => ['CreateIncomeSource'];

useCreateIncomeSourceMutation.fetcher = (client: GraphQLClient, variables: CreateIncomeSourceMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateIncomeSourceMutation, CreateIncomeSourceMutationVariables>(client, CreateIncomeSourceDocument, variables, headers);
export const IncomeSourcesDocument = `
    query IncomeSources($householdID: ID!) {
  incomeSources(householdID: $householdID) {
    items {
      ...IncomeSourceFragment
    }
  }
}
    ${IncomeSourceFragmentFragmentDoc}`;
export const useIncomeSourcesQuery = <
      TData = IncomeSourcesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: IncomeSourcesQueryVariables,
      options?: UseQueryOptions<IncomeSourcesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<IncomeSourcesQuery, TError, TData>(
      ['IncomeSources', variables],
      fetcher<IncomeSourcesQuery, IncomeSourcesQueryVariables>(client, IncomeSourcesDocument, variables, headers),
      options
    );

useIncomeSourcesQuery.getKey = (variables: IncomeSourcesQueryVariables) => ['IncomeSources', variables];
;

useIncomeSourcesQuery.fetcher = (client: GraphQLClient, variables: IncomeSourcesQueryVariables, headers?: RequestInit['headers']) => fetcher<IncomeSourcesQuery, IncomeSourcesQueryVariables>(client, IncomeSourcesDocument, variables, headers);
export const UpdateIncomeSourceDocument = `
    mutation UpdateIncomeSource($input: UpdateIncomeSourceInput!) {
  updateIncomeSource(input: $input) {
    incomeSource {
      ...IncomeSourceFragment
    }
  }
}
    ${IncomeSourceFragmentFragmentDoc}`;
export const useUpdateIncomeSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateIncomeSourceMutation, TError, UpdateIncomeSourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateIncomeSourceMutation, TError, UpdateIncomeSourceMutationVariables, TContext>(
      ['UpdateIncomeSource'],
      (variables?: UpdateIncomeSourceMutationVariables) => fetcher<UpdateIncomeSourceMutation, UpdateIncomeSourceMutationVariables>(client, UpdateIncomeSourceDocument, variables, headers)(),
      options
    );
useUpdateIncomeSourceMutation.getKey = () => ['UpdateIncomeSource'];

useUpdateIncomeSourceMutation.fetcher = (client: GraphQLClient, variables: UpdateIncomeSourceMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateIncomeSourceMutation, UpdateIncomeSourceMutationVariables>(client, UpdateIncomeSourceDocument, variables, headers);
export const ArchiveIncomeSourceDocument = `
    mutation ArchiveIncomeSource($input: ArchiveIncomeSourceInput!) {
  archiveIncomeSource(input: $input) {
    archived
  }
}
    `;
export const useArchiveIncomeSourceMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ArchiveIncomeSourceMutation, TError, ArchiveIncomeSourceMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ArchiveIncomeSourceMutation, TError, ArchiveIncomeSourceMutationVariables, TContext>(
      ['ArchiveIncomeSource'],
      (variables?: ArchiveIncomeSourceMutationVariables) => fetcher<ArchiveIncomeSourceMutation, ArchiveIncomeSourceMutationVariables>(client, ArchiveIncomeSourceDocument, variables, headers)(),
      options
    );
useArchiveIncomeSourceMutation.getKey = () => ['ArchiveIncomeSource'];

useArchiveIncomeSourceMutation.fetcher = (client: GraphQLClient, variables: ArchiveIncomeSourceMutationVariables, headers?: RequestInit['headers']) => fetcher<ArchiveIncomeSourceMutation, ArchiveIncomeSourceMutationVariables>(client, ArchiveIncomeSourceDocument, variables, headers);
export const CreateInsurancePolicyDocument = `
    mutation createInsurancePolicy($input: CreateInsurancePolicyInput!) {
  createInsurancePolicy(input: $input) {
    insurancePolicy {
      ...InsuranceFragment
    }
  }
}
    ${InsuranceFragmentFragmentDoc}`;
export const useCreateInsurancePolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateInsurancePolicyMutation, TError, CreateInsurancePolicyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateInsurancePolicyMutation, TError, CreateInsurancePolicyMutationVariables, TContext>(
      ['createInsurancePolicy'],
      (variables?: CreateInsurancePolicyMutationVariables) => fetcher<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>(client, CreateInsurancePolicyDocument, variables, headers)(),
      options
    );
useCreateInsurancePolicyMutation.getKey = () => ['createInsurancePolicy'];

useCreateInsurancePolicyMutation.fetcher = (client: GraphQLClient, variables: CreateInsurancePolicyMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateInsurancePolicyMutation, CreateInsurancePolicyMutationVariables>(client, CreateInsurancePolicyDocument, variables, headers);
export const InsurancePoliciesDocument = `
    query insurancePolicies($householdID: ID!) {
  insurancePolicies(householdID: $householdID) {
    items {
      ...InsuranceFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${InsuranceFragmentFragmentDoc}`;
export const useInsurancePoliciesQuery = <
      TData = InsurancePoliciesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InsurancePoliciesQueryVariables,
      options?: UseQueryOptions<InsurancePoliciesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InsurancePoliciesQuery, TError, TData>(
      ['insurancePolicies', variables],
      fetcher<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(client, InsurancePoliciesDocument, variables, headers),
      options
    );

useInsurancePoliciesQuery.getKey = (variables: InsurancePoliciesQueryVariables) => ['insurancePolicies', variables];
;

useInsurancePoliciesQuery.fetcher = (client: GraphQLClient, variables: InsurancePoliciesQueryVariables, headers?: RequestInit['headers']) => fetcher<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(client, InsurancePoliciesDocument, variables, headers);
export const InsurancePolicyByIdDocument = `
    query insurancePolicyById($householdID: ID!, $id: ID!) {
  insurancePolicy(householdID: $householdID, id: $id) {
    ...InsuranceFragment
  }
}
    ${InsuranceFragmentFragmentDoc}`;
export const useInsurancePolicyByIdQuery = <
      TData = InsurancePolicyByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InsurancePolicyByIdQueryVariables,
      options?: UseQueryOptions<InsurancePolicyByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InsurancePolicyByIdQuery, TError, TData>(
      ['insurancePolicyById', variables],
      fetcher<InsurancePolicyByIdQuery, InsurancePolicyByIdQueryVariables>(client, InsurancePolicyByIdDocument, variables, headers),
      options
    );

useInsurancePolicyByIdQuery.getKey = (variables: InsurancePolicyByIdQueryVariables) => ['insurancePolicyById', variables];
;

useInsurancePolicyByIdQuery.fetcher = (client: GraphQLClient, variables: InsurancePolicyByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<InsurancePolicyByIdQuery, InsurancePolicyByIdQueryVariables>(client, InsurancePolicyByIdDocument, variables, headers);
export const UpdateInsurancePolicyDocument = `
    mutation UpdateInsurancePolicy($input: UpdateInsurancePolicyInput!) {
  updateInsurancePolicy(input: $input) {
    insurancePolicy {
      ...InsuranceFragment
    }
  }
}
    ${InsuranceFragmentFragmentDoc}`;
export const useUpdateInsurancePolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInsurancePolicyMutation, TError, UpdateInsurancePolicyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateInsurancePolicyMutation, TError, UpdateInsurancePolicyMutationVariables, TContext>(
      ['UpdateInsurancePolicy'],
      (variables?: UpdateInsurancePolicyMutationVariables) => fetcher<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>(client, UpdateInsurancePolicyDocument, variables, headers)(),
      options
    );
useUpdateInsurancePolicyMutation.getKey = () => ['UpdateInsurancePolicy'];

useUpdateInsurancePolicyMutation.fetcher = (client: GraphQLClient, variables: UpdateInsurancePolicyMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateInsurancePolicyMutation, UpdateInsurancePolicyMutationVariables>(client, UpdateInsurancePolicyDocument, variables, headers);
export const DeleteInsurancePolicyDocument = `
    mutation DeleteInsurancePolicy($input: DeleteInsurancePolicyInput!) {
  deleteInsurancePolicy(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteInsurancePolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInsurancePolicyMutation, TError, DeleteInsurancePolicyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteInsurancePolicyMutation, TError, DeleteInsurancePolicyMutationVariables, TContext>(
      ['DeleteInsurancePolicy'],
      (variables?: DeleteInsurancePolicyMutationVariables) => fetcher<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>(client, DeleteInsurancePolicyDocument, variables, headers)(),
      options
    );
useDeleteInsurancePolicyMutation.getKey = () => ['DeleteInsurancePolicy'];

useDeleteInsurancePolicyMutation.fetcher = (client: GraphQLClient, variables: DeleteInsurancePolicyMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteInsurancePolicyMutation, DeleteInsurancePolicyMutationVariables>(client, DeleteInsurancePolicyDocument, variables, headers);
export const GetInvestmentsDocument = `
    query GetInvestments($householdID: ID!) {
  investments(householdID: $householdID) {
    items {
      ...InvestmentFragment
    }
  }
}
    ${InvestmentFragmentFragmentDoc}`;
export const useGetInvestmentsQuery = <
      TData = GetInvestmentsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInvestmentsQueryVariables,
      options?: UseQueryOptions<GetInvestmentsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestmentsQuery, TError, TData>(
      ['GetInvestments', variables],
      fetcher<GetInvestmentsQuery, GetInvestmentsQueryVariables>(client, GetInvestmentsDocument, variables, headers),
      options
    );

useGetInvestmentsQuery.getKey = (variables: GetInvestmentsQueryVariables) => ['GetInvestments', variables];
;

useGetInvestmentsQuery.fetcher = (client: GraphQLClient, variables: GetInvestmentsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetInvestmentsQuery, GetInvestmentsQueryVariables>(client, GetInvestmentsDocument, variables, headers);
export const CreateInvestmentDocument = `
    mutation createInvestment($input: CreateInvestmentInput!) {
  createInvestment(input: $input) {
    investment {
      ...InvestmentFragment
    }
  }
}
    ${InvestmentFragmentFragmentDoc}`;
export const useCreateInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateInvestmentMutation, TError, CreateInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateInvestmentMutation, TError, CreateInvestmentMutationVariables, TContext>(
      ['createInvestment'],
      (variables?: CreateInvestmentMutationVariables) => fetcher<CreateInvestmentMutation, CreateInvestmentMutationVariables>(client, CreateInvestmentDocument, variables, headers)(),
      options
    );
useCreateInvestmentMutation.getKey = () => ['createInvestment'];

useCreateInvestmentMutation.fetcher = (client: GraphQLClient, variables: CreateInvestmentMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateInvestmentMutation, CreateInvestmentMutationVariables>(client, CreateInvestmentDocument, variables, headers);
export const UpdateInvestmentDocument = `
    mutation UpdateInvestment($input: UpdateInvestmentInput!) {
  updateInvestment(input: $input) {
    investment {
      ...InvestmentFragment
    }
  }
}
    ${InvestmentFragmentFragmentDoc}`;
export const useUpdateInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInvestmentMutation, TError, UpdateInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateInvestmentMutation, TError, UpdateInvestmentMutationVariables, TContext>(
      ['UpdateInvestment'],
      (variables?: UpdateInvestmentMutationVariables) => fetcher<UpdateInvestmentMutation, UpdateInvestmentMutationVariables>(client, UpdateInvestmentDocument, variables, headers)(),
      options
    );
useUpdateInvestmentMutation.getKey = () => ['UpdateInvestment'];

useUpdateInvestmentMutation.fetcher = (client: GraphQLClient, variables: UpdateInvestmentMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateInvestmentMutation, UpdateInvestmentMutationVariables>(client, UpdateInvestmentDocument, variables, headers);
export const DeleteInvestmentDocument = `
    mutation DeleteInvestment($input: DeleteInvestmentInput!) {
  deleteInvestment(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInvestmentMutation, TError, DeleteInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteInvestmentMutation, TError, DeleteInvestmentMutationVariables, TContext>(
      ['DeleteInvestment'],
      (variables?: DeleteInvestmentMutationVariables) => fetcher<DeleteInvestmentMutation, DeleteInvestmentMutationVariables>(client, DeleteInvestmentDocument, variables, headers)(),
      options
    );
useDeleteInvestmentMutation.getKey = () => ['DeleteInvestment'];

useDeleteInvestmentMutation.fetcher = (client: GraphQLClient, variables: DeleteInvestmentMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteInvestmentMutation, DeleteInvestmentMutationVariables>(client, DeleteInvestmentDocument, variables, headers);
export const GetInvestmentDocument = `
    query GetInvestment($householdID: ID!, $id: ID!) {
  investment(householdID: $householdID, id: $id) {
    ...InvestmentFragment
    closedAt
  }
}
    ${InvestmentFragmentFragmentDoc}`;
export const useGetInvestmentQuery = <
      TData = GetInvestmentQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInvestmentQueryVariables,
      options?: UseQueryOptions<GetInvestmentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvestmentQuery, TError, TData>(
      ['GetInvestment', variables],
      fetcher<GetInvestmentQuery, GetInvestmentQueryVariables>(client, GetInvestmentDocument, variables, headers),
      options
    );

useGetInvestmentQuery.getKey = (variables: GetInvestmentQueryVariables) => ['GetInvestment', variables];
;

useGetInvestmentQuery.fetcher = (client: GraphQLClient, variables: GetInvestmentQueryVariables, headers?: RequestInit['headers']) => fetcher<GetInvestmentQuery, GetInvestmentQueryVariables>(client, GetInvestmentDocument, variables, headers);
export const CloseInvestmentDocument = `
    mutation CloseInvestment($input: CloseInvestmentInput!) {
  closeInvestment(input: $input) {
    changeToken
  }
}
    `;
export const useCloseInvestmentMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseInvestmentMutation, TError, CloseInvestmentMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseInvestmentMutation, TError, CloseInvestmentMutationVariables, TContext>(
      ['CloseInvestment'],
      (variables?: CloseInvestmentMutationVariables) => fetcher<CloseInvestmentMutation, CloseInvestmentMutationVariables>(client, CloseInvestmentDocument, variables, headers)(),
      options
    );
useCloseInvestmentMutation.getKey = () => ['CloseInvestment'];

useCloseInvestmentMutation.fetcher = (client: GraphQLClient, variables: CloseInvestmentMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseInvestmentMutation, CloseInvestmentMutationVariables>(client, CloseInvestmentDocument, variables, headers);
export const MergeInvestmentsDocument = `
    mutation MergeInvestments($input: MergeInvestmentsInput!) {
  mergeInvestments(input: $input) {
    merged
  }
}
    `;
export const useMergeInvestmentsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeInvestmentsMutation, TError, MergeInvestmentsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeInvestmentsMutation, TError, MergeInvestmentsMutationVariables, TContext>(
      ['MergeInvestments'],
      (variables?: MergeInvestmentsMutationVariables) => fetcher<MergeInvestmentsMutation, MergeInvestmentsMutationVariables>(client, MergeInvestmentsDocument, variables, headers)(),
      options
    );
useMergeInvestmentsMutation.getKey = () => ['MergeInvestments'];

useMergeInvestmentsMutation.fetcher = (client: GraphQLClient, variables: MergeInvestmentsMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeInvestmentsMutation, MergeInvestmentsMutationVariables>(client, MergeInvestmentsDocument, variables, headers);
export const ClientInvitationsForFirmDocument = `
    query ClientInvitationsForFirm($firmID: ID!, $cursor: String) {
  clientInvitationsForFirm(firmID: $firmID, cursor: $cursor) {
    items {
      id
      inviteeEmail
      inviteeGivenName
      inviteeFamilyName
      createdAt
      updatedAt
      inviter {
        elementsID
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const useClientInvitationsForFirmQuery = <
      TData = ClientInvitationsForFirmQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ClientInvitationsForFirmQueryVariables,
      options?: UseQueryOptions<ClientInvitationsForFirmQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ClientInvitationsForFirmQuery, TError, TData>(
      ['ClientInvitationsForFirm', variables],
      fetcher<ClientInvitationsForFirmQuery, ClientInvitationsForFirmQueryVariables>(client, ClientInvitationsForFirmDocument, variables, headers),
      options
    );

useClientInvitationsForFirmQuery.getKey = (variables: ClientInvitationsForFirmQueryVariables) => ['ClientInvitationsForFirm', variables];
;

useClientInvitationsForFirmQuery.fetcher = (client: GraphQLClient, variables: ClientInvitationsForFirmQueryVariables, headers?: RequestInit['headers']) => fetcher<ClientInvitationsForFirmQuery, ClientInvitationsForFirmQueryVariables>(client, ClientInvitationsForFirmDocument, variables, headers);
export const DeleteInvitationDocument = `
    mutation DeleteInvitation($input: DeleteInvitationInput!) {
  deleteInvitation(input: $input)
}
    `;
export const useDeleteInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInvitationMutation, TError, DeleteInvitationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteInvitationMutation, TError, DeleteInvitationMutationVariables, TContext>(
      ['DeleteInvitation'],
      (variables?: DeleteInvitationMutationVariables) => fetcher<DeleteInvitationMutation, DeleteInvitationMutationVariables>(client, DeleteInvitationDocument, variables, headers)(),
      options
    );
useDeleteInvitationMutation.getKey = () => ['DeleteInvitation'];

useDeleteInvitationMutation.fetcher = (client: GraphQLClient, variables: DeleteInvitationMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteInvitationMutation, DeleteInvitationMutationVariables>(client, DeleteInvitationDocument, variables, headers);
export const InvitationDocument = `
    query Invitation($input: GetInvitationInput!) {
  invitation(input: $input) {
    __typename
    id
    status
    inviteeEmail
    inviteeGivenName
    inviteeFamilyName
    ... on ClientInvitation {
      firmID
      clientID
      firmName
      personID
      householdID
      inviter {
        elementsID
        email
        givenName
        familyName
        profession
        profileImage
        profileColor
      }
    }
  }
}
    `;
export const useInvitationQuery = <
      TData = InvitationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: InvitationQueryVariables,
      options?: UseQueryOptions<InvitationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InvitationQuery, TError, TData>(
      ['Invitation', variables],
      fetcher<InvitationQuery, InvitationQueryVariables>(client, InvitationDocument, variables, headers),
      options
    );

useInvitationQuery.getKey = (variables: InvitationQueryVariables) => ['Invitation', variables];
;

useInvitationQuery.fetcher = (client: GraphQLClient, variables: InvitationQueryVariables, headers?: RequestInit['headers']) => fetcher<InvitationQuery, InvitationQueryVariables>(client, InvitationDocument, variables, headers);
export const UpdateInvitationDocument = `
    mutation UpdateInvitation($input: UpdateInvitationInput!) {
  updateInvitation(input: $input)
}
    `;
export const useUpdateInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateInvitationMutation, TError, UpdateInvitationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateInvitationMutation, TError, UpdateInvitationMutationVariables, TContext>(
      ['UpdateInvitation'],
      (variables?: UpdateInvitationMutationVariables) => fetcher<UpdateInvitationMutation, UpdateInvitationMutationVariables>(client, UpdateInvitationDocument, variables, headers)(),
      options
    );
useUpdateInvitationMutation.getKey = () => ['UpdateInvitation'];

useUpdateInvitationMutation.fetcher = (client: GraphQLClient, variables: UpdateInvitationMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateInvitationMutation, UpdateInvitationMutationVariables>(client, UpdateInvitationDocument, variables, headers);
export const InviteFirmClientDocument = `
    mutation InviteFirmClient($input: InviteFirmClientInput!) {
  inviteFirmClient(input: $input) {
    invitation {
      id
      status
      inviteeEmail
      inviteeGivenName
      inviteeFamilyName
      ... on ClientInvitation {
        firmID
        clientID
        firmName
        personID
      }
    }
  }
}
    `;
export const useInviteFirmClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<InviteFirmClientMutation, TError, InviteFirmClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<InviteFirmClientMutation, TError, InviteFirmClientMutationVariables, TContext>(
      ['InviteFirmClient'],
      (variables?: InviteFirmClientMutationVariables) => fetcher<InviteFirmClientMutation, InviteFirmClientMutationVariables>(client, InviteFirmClientDocument, variables, headers)(),
      options
    );
useInviteFirmClientMutation.getKey = () => ['InviteFirmClient'];

useInviteFirmClientMutation.fetcher = (client: GraphQLClient, variables: InviteFirmClientMutationVariables, headers?: RequestInit['headers']) => fetcher<InviteFirmClientMutation, InviteFirmClientMutationVariables>(client, InviteFirmClientDocument, variables, headers);
export const CreateFirmInviteLinkDocument = `
    mutation CreateFirmInviteLink($input: CreateFirmInviteLinkInput!) {
  createFirmInviteLink(input: $input) {
    id
  }
}
    `;
export const useCreateFirmInviteLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFirmInviteLinkMutation, TError, CreateFirmInviteLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateFirmInviteLinkMutation, TError, CreateFirmInviteLinkMutationVariables, TContext>(
      ['CreateFirmInviteLink'],
      (variables?: CreateFirmInviteLinkMutationVariables) => fetcher<CreateFirmInviteLinkMutation, CreateFirmInviteLinkMutationVariables>(client, CreateFirmInviteLinkDocument, variables, headers)(),
      options
    );
useCreateFirmInviteLinkMutation.getKey = () => ['CreateFirmInviteLink'];

useCreateFirmInviteLinkMutation.fetcher = (client: GraphQLClient, variables: CreateFirmInviteLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFirmInviteLinkMutation, CreateFirmInviteLinkMutationVariables>(client, CreateFirmInviteLinkDocument, variables, headers);
export const UpdateFirmInviteLinkDocument = `
    mutation UpdateFirmInviteLink($input: UpdateFirmInviteLinkInput!) {
  updateFirmInviteLink(input: $input) {
    id
  }
}
    `;
export const useUpdateFirmInviteLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFirmInviteLinkMutation, TError, UpdateFirmInviteLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateFirmInviteLinkMutation, TError, UpdateFirmInviteLinkMutationVariables, TContext>(
      ['UpdateFirmInviteLink'],
      (variables?: UpdateFirmInviteLinkMutationVariables) => fetcher<UpdateFirmInviteLinkMutation, UpdateFirmInviteLinkMutationVariables>(client, UpdateFirmInviteLinkDocument, variables, headers)(),
      options
    );
useUpdateFirmInviteLinkMutation.getKey = () => ['UpdateFirmInviteLink'];

useUpdateFirmInviteLinkMutation.fetcher = (client: GraphQLClient, variables: UpdateFirmInviteLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFirmInviteLinkMutation, UpdateFirmInviteLinkMutationVariables>(client, UpdateFirmInviteLinkDocument, variables, headers);
export const DeleteFirmInviteLinkDocument = `
    mutation DeleteFirmInviteLink($firmInviteLinkID: ID!) {
  deleteFirmInviteLink(firmInviteLinkID: $firmInviteLinkID)
}
    `;
export const useDeleteFirmInviteLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteFirmInviteLinkMutation, TError, DeleteFirmInviteLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteFirmInviteLinkMutation, TError, DeleteFirmInviteLinkMutationVariables, TContext>(
      ['DeleteFirmInviteLink'],
      (variables?: DeleteFirmInviteLinkMutationVariables) => fetcher<DeleteFirmInviteLinkMutation, DeleteFirmInviteLinkMutationVariables>(client, DeleteFirmInviteLinkDocument, variables, headers)(),
      options
    );
useDeleteFirmInviteLinkMutation.getKey = () => ['DeleteFirmInviteLink'];

useDeleteFirmInviteLinkMutation.fetcher = (client: GraphQLClient, variables: DeleteFirmInviteLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteFirmInviteLinkMutation, DeleteFirmInviteLinkMutationVariables>(client, DeleteFirmInviteLinkDocument, variables, headers);
export const AdvisorInviteLinksIndexPageDocument = `
    query AdvisorInviteLinksIndexPage($firmID: ID!) {
  firmInviteLinks(firmID: $firmID) {
    items {
      id
      campaignName
      acceptFormURL
      firmClientEntitlements {
        aiAssessment
      }
    }
  }
}
    `;
export const useAdvisorInviteLinksIndexPageQuery = <
      TData = AdvisorInviteLinksIndexPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AdvisorInviteLinksIndexPageQueryVariables,
      options?: UseQueryOptions<AdvisorInviteLinksIndexPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AdvisorInviteLinksIndexPageQuery, TError, TData>(
      ['AdvisorInviteLinksIndexPage', variables],
      fetcher<AdvisorInviteLinksIndexPageQuery, AdvisorInviteLinksIndexPageQueryVariables>(client, AdvisorInviteLinksIndexPageDocument, variables, headers),
      options
    );

useAdvisorInviteLinksIndexPageQuery.getKey = (variables: AdvisorInviteLinksIndexPageQueryVariables) => ['AdvisorInviteLinksIndexPage', variables];
;

useAdvisorInviteLinksIndexPageQuery.fetcher = (client: GraphQLClient, variables: AdvisorInviteLinksIndexPageQueryVariables, headers?: RequestInit['headers']) => fetcher<AdvisorInviteLinksIndexPageQuery, AdvisorInviteLinksIndexPageQueryVariables>(client, AdvisorInviteLinksIndexPageDocument, variables, headers);
export const AdvisorEditInviteLinkPageDocument = `
    query AdvisorEditInviteLinkPage($firmInviteLinkID: ID!) {
  firmInviteLink(firmInviteLinkID: $firmInviteLinkID) {
    id
    title
    changeToken
    firm {
      logo {
        downloadURL
      }
      color
    }
    campaignName
    description
    disclosure
    acceptFormURL
    firmClientEntitlements {
      aiAssessment
    }
  }
}
    `;
export const useAdvisorEditInviteLinkPageQuery = <
      TData = AdvisorEditInviteLinkPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: AdvisorEditInviteLinkPageQueryVariables,
      options?: UseQueryOptions<AdvisorEditInviteLinkPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AdvisorEditInviteLinkPageQuery, TError, TData>(
      ['AdvisorEditInviteLinkPage', variables],
      fetcher<AdvisorEditInviteLinkPageQuery, AdvisorEditInviteLinkPageQueryVariables>(client, AdvisorEditInviteLinkPageDocument, variables, headers),
      options
    );

useAdvisorEditInviteLinkPageQuery.getKey = (variables: AdvisorEditInviteLinkPageQueryVariables) => ['AdvisorEditInviteLinkPage', variables];
;

useAdvisorEditInviteLinkPageQuery.fetcher = (client: GraphQLClient, variables: AdvisorEditInviteLinkPageQueryVariables, headers?: RequestInit['headers']) => fetcher<AdvisorEditInviteLinkPageQuery, AdvisorEditInviteLinkPageQueryVariables>(client, AdvisorEditInviteLinkPageDocument, variables, headers);
export const FirmInviteLinkDocument = `
    query FirmInviteLink($firmInviteLinkID: ID!) {
  firmInviteLink(firmInviteLinkID: $firmInviteLinkID) {
    ...InviteLinkFragment
  }
}
    ${InviteLinkFragmentFragmentDoc}`;
export const useFirmInviteLinkQuery = <
      TData = FirmInviteLinkQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmInviteLinkQueryVariables,
      options?: UseQueryOptions<FirmInviteLinkQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmInviteLinkQuery, TError, TData>(
      ['FirmInviteLink', variables],
      fetcher<FirmInviteLinkQuery, FirmInviteLinkQueryVariables>(client, FirmInviteLinkDocument, variables, headers),
      options
    );

useFirmInviteLinkQuery.getKey = (variables: FirmInviteLinkQueryVariables) => ['FirmInviteLink', variables];
;

useFirmInviteLinkQuery.fetcher = (client: GraphQLClient, variables: FirmInviteLinkQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmInviteLinkQuery, FirmInviteLinkQueryVariables>(client, FirmInviteLinkDocument, variables, headers);
export const ConfirmAccountDocument = `
    mutation ConfirmAccount($input: ConfirmAccountInput!) {
  confirmAccount(input: $input) {
    tokenSet {
      idToken
      accessToken
      refreshToken
    }
  }
}
    `;
export const useConfirmAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ConfirmAccountMutation, TError, ConfirmAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ConfirmAccountMutation, TError, ConfirmAccountMutationVariables, TContext>(
      ['ConfirmAccount'],
      (variables?: ConfirmAccountMutationVariables) => fetcher<ConfirmAccountMutation, ConfirmAccountMutationVariables>(client, ConfirmAccountDocument, variables, headers)(),
      options
    );
useConfirmAccountMutation.getKey = () => ['ConfirmAccount'];

useConfirmAccountMutation.fetcher = (client: GraphQLClient, variables: ConfirmAccountMutationVariables, headers?: RequestInit['headers']) => fetcher<ConfirmAccountMutation, ConfirmAccountMutationVariables>(client, ConfirmAccountDocument, variables, headers);
export const AcceptFirmInviteLinkDocument = `
    mutation AcceptFirmInviteLink($input: AcceptFirmInviteLinkInput!) {
  acceptFirmInviteLink(input: $input) {
    householdID
    firmClientID
    requiresConfirmation
  }
}
    `;
export const useAcceptFirmInviteLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AcceptFirmInviteLinkMutation, TError, AcceptFirmInviteLinkMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AcceptFirmInviteLinkMutation, TError, AcceptFirmInviteLinkMutationVariables, TContext>(
      ['AcceptFirmInviteLink'],
      (variables?: AcceptFirmInviteLinkMutationVariables) => fetcher<AcceptFirmInviteLinkMutation, AcceptFirmInviteLinkMutationVariables>(client, AcceptFirmInviteLinkDocument, variables, headers)(),
      options
    );
useAcceptFirmInviteLinkMutation.getKey = () => ['AcceptFirmInviteLink'];

useAcceptFirmInviteLinkMutation.fetcher = (client: GraphQLClient, variables: AcceptFirmInviteLinkMutationVariables, headers?: RequestInit['headers']) => fetcher<AcceptFirmInviteLinkMutation, AcceptFirmInviteLinkMutationVariables>(client, AcceptFirmInviteLinkDocument, variables, headers);
export const LoansDocument = `
    query Loans($householdID: ID!, $cursor: String) {
  loans(householdID: $householdID, cursor: $cursor) {
    items {
      ...LoanFragment
    }
  }
}
    ${LoanFragmentFragmentDoc}`;
export const useLoansQuery = <
      TData = LoansQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LoansQueryVariables,
      options?: UseQueryOptions<LoansQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LoansQuery, TError, TData>(
      ['Loans', variables],
      fetcher<LoansQuery, LoansQueryVariables>(client, LoansDocument, variables, headers),
      options
    );

useLoansQuery.getKey = (variables: LoansQueryVariables) => ['Loans', variables];
;

useLoansQuery.fetcher = (client: GraphQLClient, variables: LoansQueryVariables, headers?: RequestInit['headers']) => fetcher<LoansQuery, LoansQueryVariables>(client, LoansDocument, variables, headers);
export const CreateLoanDocument = `
    mutation createLoan($input: CreateLoanInput!) {
  createLoan(input: $input) {
    loan {
      ...LoanFragment
    }
  }
}
    ${LoanFragmentFragmentDoc}`;
export const useCreateLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateLoanMutation, TError, CreateLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateLoanMutation, TError, CreateLoanMutationVariables, TContext>(
      ['createLoan'],
      (variables?: CreateLoanMutationVariables) => fetcher<CreateLoanMutation, CreateLoanMutationVariables>(client, CreateLoanDocument, variables, headers)(),
      options
    );
useCreateLoanMutation.getKey = () => ['createLoan'];

useCreateLoanMutation.fetcher = (client: GraphQLClient, variables: CreateLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateLoanMutation, CreateLoanMutationVariables>(client, CreateLoanDocument, variables, headers);
export const DeleteLoanDocument = `
    mutation DeleteLoan($input: DeleteLoanInput!) {
  deleteLoan(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteLoanMutation, TError, DeleteLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteLoanMutation, TError, DeleteLoanMutationVariables, TContext>(
      ['DeleteLoan'],
      (variables?: DeleteLoanMutationVariables) => fetcher<DeleteLoanMutation, DeleteLoanMutationVariables>(client, DeleteLoanDocument, variables, headers)(),
      options
    );
useDeleteLoanMutation.getKey = () => ['DeleteLoan'];

useDeleteLoanMutation.fetcher = (client: GraphQLClient, variables: DeleteLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteLoanMutation, DeleteLoanMutationVariables>(client, DeleteLoanDocument, variables, headers);
export const UpdateLoanDocument = `
    mutation UpdateLoan($input: UpdateLoanInput!) {
  updateLoan(input: $input) {
    loan {
      ...LoanFragment
    }
  }
}
    ${LoanFragmentFragmentDoc}`;
export const useUpdateLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateLoanMutation, TError, UpdateLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateLoanMutation, TError, UpdateLoanMutationVariables, TContext>(
      ['UpdateLoan'],
      (variables?: UpdateLoanMutationVariables) => fetcher<UpdateLoanMutation, UpdateLoanMutationVariables>(client, UpdateLoanDocument, variables, headers)(),
      options
    );
useUpdateLoanMutation.getKey = () => ['UpdateLoan'];

useUpdateLoanMutation.fetcher = (client: GraphQLClient, variables: UpdateLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateLoanMutation, UpdateLoanMutationVariables>(client, UpdateLoanDocument, variables, headers);
export const LoanDocument = `
    query Loan($householdID: ID!, $id: ID!) {
  loan(householdID: $householdID, id: $id) {
    ...LoanFragment
    closedAt
  }
}
    ${LoanFragmentFragmentDoc}`;
export const useLoanQuery = <
      TData = LoanQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LoanQueryVariables,
      options?: UseQueryOptions<LoanQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LoanQuery, TError, TData>(
      ['Loan', variables],
      fetcher<LoanQuery, LoanQueryVariables>(client, LoanDocument, variables, headers),
      options
    );

useLoanQuery.getKey = (variables: LoanQueryVariables) => ['Loan', variables];
;

useLoanQuery.fetcher = (client: GraphQLClient, variables: LoanQueryVariables, headers?: RequestInit['headers']) => fetcher<LoanQuery, LoanQueryVariables>(client, LoanDocument, variables, headers);
export const CloseLoanDocument = `
    mutation CloseLoan($input: CloseLoanInput!) {
  closeLoan(input: $input) {
    changeToken
  }
}
    `;
export const useCloseLoanMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseLoanMutation, TError, CloseLoanMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseLoanMutation, TError, CloseLoanMutationVariables, TContext>(
      ['CloseLoan'],
      (variables?: CloseLoanMutationVariables) => fetcher<CloseLoanMutation, CloseLoanMutationVariables>(client, CloseLoanDocument, variables, headers)(),
      options
    );
useCloseLoanMutation.getKey = () => ['CloseLoan'];

useCloseLoanMutation.fetcher = (client: GraphQLClient, variables: CloseLoanMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseLoanMutation, CloseLoanMutationVariables>(client, CloseLoanDocument, variables, headers);
export const MergeLoansDocument = `
    mutation MergeLoans($input: MergeLoansInput!) {
  mergeLoans(input: $input) {
    merged
  }
}
    `;
export const useMergeLoansMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeLoansMutation, TError, MergeLoansMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeLoansMutation, TError, MergeLoansMutationVariables, TContext>(
      ['MergeLoans'],
      (variables?: MergeLoansMutationVariables) => fetcher<MergeLoansMutation, MergeLoansMutationVariables>(client, MergeLoansDocument, variables, headers)(),
      options
    );
useMergeLoansMutation.getKey = () => ['MergeLoans'];

useMergeLoansMutation.fetcher = (client: GraphQLClient, variables: MergeLoansMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeLoansMutation, MergeLoansMutationVariables>(client, MergeLoansDocument, variables, headers);
export const LtDetailsDocument = `
    query LtDetails($householdID: ID!, $includeScore: Boolean!, $includeLiquidAssets: Boolean!, $includeAnnualExpenses: Boolean!, $includePersonalCashItems: Boolean!, $includeTotalPersonalCash: Boolean!, $includeBusinessCashItems: Boolean!, $includeTotalBusinessCash: Boolean!, $includeAfterTaxInvestments: Boolean!, $includeTotalAfterTaxInvestments: Boolean!) {
  ltDetails(householdID: $householdID) {
    lt @include(if: $includeScore)
    totalLiquidAssets @include(if: $includeLiquidAssets) {
      ...MonetaryAmountFragment
    }
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    personalCashItems @include(if: $includePersonalCashItems) {
      ...CashAccountFragment
    }
    totalPersonalCash @include(if: $includeTotalPersonalCash) {
      ...MonetaryAmountFragment
    }
    businessCashItems @include(if: $includeBusinessCashItems) {
      ...CashAccountFragment
    }
    totalBusinessCash @include(if: $includeTotalBusinessCash) {
      ...MonetaryAmountFragment
    }
    afterTaxInvestmentItems @include(if: $includeAfterTaxInvestments) {
      ...InvestmentFragment
    }
    totalAfterTaxInvestments @include(if: $includeTotalAfterTaxInvestments) {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${CashAccountFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}`;
export const useLtDetailsQuery = <
      TData = LtDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: LtDetailsQueryVariables,
      options?: UseQueryOptions<LtDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LtDetailsQuery, TError, TData>(
      ['LtDetails', variables],
      fetcher<LtDetailsQuery, LtDetailsQueryVariables>(client, LtDetailsDocument, variables, headers),
      options
    );

useLtDetailsQuery.getKey = (variables: LtDetailsQueryVariables) => ['LtDetails', variables];
;

useLtDetailsQuery.fetcher = (client: GraphQLClient, variables: LtDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<LtDetailsQuery, LtDetailsQueryVariables>(client, LtDetailsDocument, variables, headers);
export const ConversationsDocument = `
    query Conversations($firmID: ID) {
  conversations(firmID: $firmID) {
    items {
      ...ConversationFragment
    }
  }
}
    ${ConversationFragmentFragmentDoc}`;
export const useConversationsQuery = <
      TData = ConversationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ConversationsQueryVariables,
      options?: UseQueryOptions<ConversationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ConversationsQuery, TError, TData>(
      variables === undefined ? ['Conversations'] : ['Conversations', variables],
      fetcher<ConversationsQuery, ConversationsQueryVariables>(client, ConversationsDocument, variables, headers),
      options
    );

useConversationsQuery.getKey = (variables?: ConversationsQueryVariables) => variables === undefined ? ['Conversations'] : ['Conversations', variables];
;

useConversationsQuery.fetcher = (client: GraphQLClient, variables?: ConversationsQueryVariables, headers?: RequestInit['headers']) => fetcher<ConversationsQuery, ConversationsQueryVariables>(client, ConversationsDocument, variables, headers);
export const ConversationDocument = `
    query Conversation($id: ID, $firmClientID: ID) {
  conversation(id: $id, firmClientID: $firmClientID) {
    ...ConversationFragment
  }
}
    ${ConversationFragmentFragmentDoc}`;
export const useConversationQuery = <
      TData = ConversationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ConversationQueryVariables,
      options?: UseQueryOptions<ConversationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ConversationQuery, TError, TData>(
      variables === undefined ? ['Conversation'] : ['Conversation', variables],
      fetcher<ConversationQuery, ConversationQueryVariables>(client, ConversationDocument, variables, headers),
      options
    );

useConversationQuery.getKey = (variables?: ConversationQueryVariables) => variables === undefined ? ['Conversation'] : ['Conversation', variables];
;

useConversationQuery.fetcher = (client: GraphQLClient, variables?: ConversationQueryVariables, headers?: RequestInit['headers']) => fetcher<ConversationQuery, ConversationQueryVariables>(client, ConversationDocument, variables, headers);
export const MessagesDocument = `
    query Messages($conversationID: ID!) {
  messages(conversationID: $conversationID) {
    items {
      ...MessageFragment
    }
  }
}
    ${MessageFragmentFragmentDoc}`;
export const useMessagesQuery = <
      TData = MessagesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: MessagesQueryVariables,
      options?: UseQueryOptions<MessagesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MessagesQuery, TError, TData>(
      ['Messages', variables],
      fetcher<MessagesQuery, MessagesQueryVariables>(client, MessagesDocument, variables, headers),
      options
    );

useMessagesQuery.getKey = (variables: MessagesQueryVariables) => ['Messages', variables];
;

useMessagesQuery.fetcher = (client: GraphQLClient, variables: MessagesQueryVariables, headers?: RequestInit['headers']) => fetcher<MessagesQuery, MessagesQueryVariables>(client, MessagesDocument, variables, headers);
export const NumberOfUnreadConversationsDocument = `
    query numberOfUnreadConversations($firmID: ID) {
  numberOfUnreadConversations(firmID: $firmID)
}
    `;
export const useNumberOfUnreadConversationsQuery = <
      TData = NumberOfUnreadConversationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: NumberOfUnreadConversationsQueryVariables,
      options?: UseQueryOptions<NumberOfUnreadConversationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<NumberOfUnreadConversationsQuery, TError, TData>(
      variables === undefined ? ['numberOfUnreadConversations'] : ['numberOfUnreadConversations', variables],
      fetcher<NumberOfUnreadConversationsQuery, NumberOfUnreadConversationsQueryVariables>(client, NumberOfUnreadConversationsDocument, variables, headers),
      options
    );

useNumberOfUnreadConversationsQuery.getKey = (variables?: NumberOfUnreadConversationsQueryVariables) => variables === undefined ? ['numberOfUnreadConversations'] : ['numberOfUnreadConversations', variables];
;

useNumberOfUnreadConversationsQuery.fetcher = (client: GraphQLClient, variables?: NumberOfUnreadConversationsQueryVariables, headers?: RequestInit['headers']) => fetcher<NumberOfUnreadConversationsQuery, NumberOfUnreadConversationsQueryVariables>(client, NumberOfUnreadConversationsDocument, variables, headers);
export const MuteConversationDocument = `
    mutation MuteConversation($input: MuteOrUnmuteConversationInput!) {
  muteConversation(input: $input) {
    muted
  }
}
    `;
export const useMuteConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MuteConversationMutation, TError, MuteConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MuteConversationMutation, TError, MuteConversationMutationVariables, TContext>(
      ['MuteConversation'],
      (variables?: MuteConversationMutationVariables) => fetcher<MuteConversationMutation, MuteConversationMutationVariables>(client, MuteConversationDocument, variables, headers)(),
      options
    );
useMuteConversationMutation.getKey = () => ['MuteConversation'];

useMuteConversationMutation.fetcher = (client: GraphQLClient, variables: MuteConversationMutationVariables, headers?: RequestInit['headers']) => fetcher<MuteConversationMutation, MuteConversationMutationVariables>(client, MuteConversationDocument, variables, headers);
export const CreateMessageDocument = `
    mutation CreateMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    message {
      ...MessageFragment
    }
  }
}
    ${MessageFragmentFragmentDoc}`;
export const useCreateMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateMessageMutation, TError, CreateMessageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateMessageMutation, TError, CreateMessageMutationVariables, TContext>(
      ['CreateMessage'],
      (variables?: CreateMessageMutationVariables) => fetcher<CreateMessageMutation, CreateMessageMutationVariables>(client, CreateMessageDocument, variables, headers)(),
      options
    );
useCreateMessageMutation.getKey = () => ['CreateMessage'];

useCreateMessageMutation.fetcher = (client: GraphQLClient, variables: CreateMessageMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateMessageMutation, CreateMessageMutationVariables>(client, CreateMessageDocument, variables, headers);
export const MarkConversationReadDocument = `
    mutation MarkConversationRead($input: MarkConversationReadInput!) {
  markConversationRead(input: $input) {
    read
  }
}
    `;
export const useMarkConversationReadMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MarkConversationReadMutation, TError, MarkConversationReadMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MarkConversationReadMutation, TError, MarkConversationReadMutationVariables, TContext>(
      ['MarkConversationRead'],
      (variables?: MarkConversationReadMutationVariables) => fetcher<MarkConversationReadMutation, MarkConversationReadMutationVariables>(client, MarkConversationReadDocument, variables, headers)(),
      options
    );
useMarkConversationReadMutation.getKey = () => ['MarkConversationRead'];

useMarkConversationReadMutation.fetcher = (client: GraphQLClient, variables: MarkConversationReadMutationVariables, headers?: RequestInit['headers']) => fetcher<MarkConversationReadMutation, MarkConversationReadMutationVariables>(client, MarkConversationReadDocument, variables, headers);
export const AssociateSoftwareTokenDocument = `
    mutation AssociateSoftwareToken($input: AssociateSoftwareTokenInput!) {
  associateSoftwareToken(input: $input)
}
    `;
export const useAssociateSoftwareTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AssociateSoftwareTokenMutation, TError, AssociateSoftwareTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AssociateSoftwareTokenMutation, TError, AssociateSoftwareTokenMutationVariables, TContext>(
      ['AssociateSoftwareToken'],
      (variables?: AssociateSoftwareTokenMutationVariables) => fetcher<AssociateSoftwareTokenMutation, AssociateSoftwareTokenMutationVariables>(client, AssociateSoftwareTokenDocument, variables, headers)(),
      options
    );
useAssociateSoftwareTokenMutation.getKey = () => ['AssociateSoftwareToken'];

useAssociateSoftwareTokenMutation.fetcher = (client: GraphQLClient, variables: AssociateSoftwareTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<AssociateSoftwareTokenMutation, AssociateSoftwareTokenMutationVariables>(client, AssociateSoftwareTokenDocument, variables, headers);
export const DisassociateSoftwareTokenDocument = `
    mutation DisassociateSoftwareToken($input: DisassociateSoftwareTokenInput!) {
  disassociateSoftwareToken(input: $input)
}
    `;
export const useDisassociateSoftwareTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DisassociateSoftwareTokenMutation, TError, DisassociateSoftwareTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DisassociateSoftwareTokenMutation, TError, DisassociateSoftwareTokenMutationVariables, TContext>(
      ['DisassociateSoftwareToken'],
      (variables?: DisassociateSoftwareTokenMutationVariables) => fetcher<DisassociateSoftwareTokenMutation, DisassociateSoftwareTokenMutationVariables>(client, DisassociateSoftwareTokenDocument, variables, headers)(),
      options
    );
useDisassociateSoftwareTokenMutation.getKey = () => ['DisassociateSoftwareToken'];

useDisassociateSoftwareTokenMutation.fetcher = (client: GraphQLClient, variables: DisassociateSoftwareTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<DisassociateSoftwareTokenMutation, DisassociateSoftwareTokenMutationVariables>(client, DisassociateSoftwareTokenDocument, variables, headers);
export const SuggestedFinancialNextStepsDocument = `
    query SuggestedFinancialNextSteps($householdID: ID!) {
  suggestedFinancialNextSteps(householdID: $householdID) {
    items {
      id
      body
      changeToken
    }
  }
}
    `;
export const useSuggestedFinancialNextStepsQuery = <
      TData = SuggestedFinancialNextStepsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SuggestedFinancialNextStepsQueryVariables,
      options?: UseQueryOptions<SuggestedFinancialNextStepsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SuggestedFinancialNextStepsQuery, TError, TData>(
      ['SuggestedFinancialNextSteps', variables],
      fetcher<SuggestedFinancialNextStepsQuery, SuggestedFinancialNextStepsQueryVariables>(client, SuggestedFinancialNextStepsDocument, variables, headers),
      options
    );

useSuggestedFinancialNextStepsQuery.getKey = (variables: SuggestedFinancialNextStepsQueryVariables) => ['SuggestedFinancialNextSteps', variables];
;

useSuggestedFinancialNextStepsQuery.fetcher = (client: GraphQLClient, variables: SuggestedFinancialNextStepsQueryVariables, headers?: RequestInit['headers']) => fetcher<SuggestedFinancialNextStepsQuery, SuggestedFinancialNextStepsQueryVariables>(client, SuggestedFinancialNextStepsDocument, variables, headers);
export const RefreshAiRecommendationsDocument = `
    mutation RefreshAiRecommendations($input: RefreshAIRecommendationsInput!) {
  refreshAIRecommendations(input: $input) {
    success
    executionID
  }
}
    `;
export const useRefreshAiRecommendationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RefreshAiRecommendationsMutation, TError, RefreshAiRecommendationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RefreshAiRecommendationsMutation, TError, RefreshAiRecommendationsMutationVariables, TContext>(
      ['RefreshAiRecommendations'],
      (variables?: RefreshAiRecommendationsMutationVariables) => fetcher<RefreshAiRecommendationsMutation, RefreshAiRecommendationsMutationVariables>(client, RefreshAiRecommendationsDocument, variables, headers)(),
      options
    );
useRefreshAiRecommendationsMutation.getKey = () => ['RefreshAiRecommendations'];

useRefreshAiRecommendationsMutation.fetcher = (client: GraphQLClient, variables: RefreshAiRecommendationsMutationVariables, headers?: RequestInit['headers']) => fetcher<RefreshAiRecommendationsMutation, RefreshAiRecommendationsMutationVariables>(client, RefreshAiRecommendationsDocument, variables, headers);
export const DeleteNoteReceivableDocument = `
    mutation deleteNoteReceivable($input: DeleteNoteReceivableInput!) {
  deleteNoteReceivable(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteNoteReceivableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteNoteReceivableMutation, TError, DeleteNoteReceivableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteNoteReceivableMutation, TError, DeleteNoteReceivableMutationVariables, TContext>(
      ['deleteNoteReceivable'],
      (variables?: DeleteNoteReceivableMutationVariables) => fetcher<DeleteNoteReceivableMutation, DeleteNoteReceivableMutationVariables>(client, DeleteNoteReceivableDocument, variables, headers)(),
      options
    );
useDeleteNoteReceivableMutation.getKey = () => ['deleteNoteReceivable'];

useDeleteNoteReceivableMutation.fetcher = (client: GraphQLClient, variables: DeleteNoteReceivableMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteNoteReceivableMutation, DeleteNoteReceivableMutationVariables>(client, DeleteNoteReceivableDocument, variables, headers);
export const GetNoteReceivableDocument = `
    query GetNoteReceivable($householdID: ID!, $id: ID!) {
  noteReceivable(householdID: $householdID, id: $id) {
    __typename
    id
    householdID
    name
    changeToken
    notes
    closedAt
    ownedValue {
      ...MonetaryAmountFragment
    }
    ownership {
      __typename
      ... on TenantsInCommon {
        interests {
          owner {
            ...OwnerFragment
          }
          percentage
        }
      }
    }
    value {
      tenantID
      id
      updatedAt
      latestDataPoint {
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
      dataPoints {
        items {
          id
          dateTime
          data {
            __typename
            ... on MonetaryAmountDataPointValue {
              value {
                currencyCode
                value
              }
            }
          }
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${OwnerFragmentFragmentDoc}`;
export const useGetNoteReceivableQuery = <
      TData = GetNoteReceivableQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetNoteReceivableQueryVariables,
      options?: UseQueryOptions<GetNoteReceivableQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNoteReceivableQuery, TError, TData>(
      ['GetNoteReceivable', variables],
      fetcher<GetNoteReceivableQuery, GetNoteReceivableQueryVariables>(client, GetNoteReceivableDocument, variables, headers),
      options
    );

useGetNoteReceivableQuery.getKey = (variables: GetNoteReceivableQueryVariables) => ['GetNoteReceivable', variables];
;

useGetNoteReceivableQuery.fetcher = (client: GraphQLClient, variables: GetNoteReceivableQueryVariables, headers?: RequestInit['headers']) => fetcher<GetNoteReceivableQuery, GetNoteReceivableQueryVariables>(client, GetNoteReceivableDocument, variables, headers);
export const GetNoteReceivablesDocument = `
    query GetNoteReceivables($householdID: ID!) {
  noteReceivables(householdID: $householdID) {
    items {
      id
      householdID
      name
      ownership {
        __typename
        ... on TenantsInCommon {
          interests {
            percentage
          }
        }
      }
      ownedValue {
        ...MonetaryAmountFragment
      }
      value {
        tenantID
        id
        updatedAt
        latestDataPoint {
          id
          dateTime
          data {
            __typename
            ... on MonetaryAmountDataPointValue {
              value {
                __typename
                currencyCode
                value
              }
            }
          }
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}`;
export const useGetNoteReceivablesQuery = <
      TData = GetNoteReceivablesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetNoteReceivablesQueryVariables,
      options?: UseQueryOptions<GetNoteReceivablesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetNoteReceivablesQuery, TError, TData>(
      ['GetNoteReceivables', variables],
      fetcher<GetNoteReceivablesQuery, GetNoteReceivablesQueryVariables>(client, GetNoteReceivablesDocument, variables, headers),
      options
    );

useGetNoteReceivablesQuery.getKey = (variables: GetNoteReceivablesQueryVariables) => ['GetNoteReceivables', variables];
;

useGetNoteReceivablesQuery.fetcher = (client: GraphQLClient, variables: GetNoteReceivablesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetNoteReceivablesQuery, GetNoteReceivablesQueryVariables>(client, GetNoteReceivablesDocument, variables, headers);
export const CreateNoteReceivableDocument = `
    mutation createNoteReceivable($input: CreateNoteReceivableInput!) {
  createNoteReceivable(input: $input) {
    noteReceivable {
      __typename
      id
      householdID
      createdAt
      updatedAt
      changeToken
      name
      notes
      ownedValue {
        __typename
        value
        currencyCode
      }
      owners {
        __typename
        id
        ownerType
        ... on Person {
          givenName
          familyName
        }
        ... on Business {
          name
        }
      }
      ownership {
        ...OwnershipFragment
      }
      value {
        ...MonetaryAmountDataPointGroupFragment
      }
    }
  }
}
    ${OwnershipFragmentFragmentDoc}
${MonetaryAmountDataPointGroupFragmentFragmentDoc}`;
export const useCreateNoteReceivableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateNoteReceivableMutation, TError, CreateNoteReceivableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateNoteReceivableMutation, TError, CreateNoteReceivableMutationVariables, TContext>(
      ['createNoteReceivable'],
      (variables?: CreateNoteReceivableMutationVariables) => fetcher<CreateNoteReceivableMutation, CreateNoteReceivableMutationVariables>(client, CreateNoteReceivableDocument, variables, headers)(),
      options
    );
useCreateNoteReceivableMutation.getKey = () => ['createNoteReceivable'];

useCreateNoteReceivableMutation.fetcher = (client: GraphQLClient, variables: CreateNoteReceivableMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateNoteReceivableMutation, CreateNoteReceivableMutationVariables>(client, CreateNoteReceivableDocument, variables, headers);
export const CloseNoteReceivableDocument = `
    mutation CloseNoteReceivable($input: CloseNoteReceivableInput!) {
  closeNoteReceivable(input: $input) {
    changeToken
  }
}
    `;
export const useCloseNoteReceivableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseNoteReceivableMutation, TError, CloseNoteReceivableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseNoteReceivableMutation, TError, CloseNoteReceivableMutationVariables, TContext>(
      ['CloseNoteReceivable'],
      (variables?: CloseNoteReceivableMutationVariables) => fetcher<CloseNoteReceivableMutation, CloseNoteReceivableMutationVariables>(client, CloseNoteReceivableDocument, variables, headers)(),
      options
    );
useCloseNoteReceivableMutation.getKey = () => ['CloseNoteReceivable'];

useCloseNoteReceivableMutation.fetcher = (client: GraphQLClient, variables: CloseNoteReceivableMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseNoteReceivableMutation, CloseNoteReceivableMutationVariables>(client, CloseNoteReceivableDocument, variables, headers);
export const MergeNoteReceivablesDocument = `
    mutation MergeNoteReceivables($input: MergeNoteReceivablesInput!) {
  mergeNoteReceivables(input: $input) {
    merged
  }
}
    `;
export const useMergeNoteReceivablesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeNoteReceivablesMutation, TError, MergeNoteReceivablesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeNoteReceivablesMutation, TError, MergeNoteReceivablesMutationVariables, TContext>(
      ['MergeNoteReceivables'],
      (variables?: MergeNoteReceivablesMutationVariables) => fetcher<MergeNoteReceivablesMutation, MergeNoteReceivablesMutationVariables>(client, MergeNoteReceivablesDocument, variables, headers)(),
      options
    );
useMergeNoteReceivablesMutation.getKey = () => ['MergeNoteReceivables'];

useMergeNoteReceivablesMutation.fetcher = (client: GraphQLClient, variables: MergeNoteReceivablesMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeNoteReceivablesMutation, MergeNoteReceivablesMutationVariables>(client, MergeNoteReceivablesDocument, variables, headers);
export const UpdateNoteReceivableDocument = `
    mutation UpdateNoteReceivable($input: UpdateNoteReceivableInput!) {
  updateNoteReceivable(input: $input) {
    noteReceivable {
      ...NoteReceivableFragment
    }
  }
}
    ${NoteReceivableFragmentFragmentDoc}`;
export const useUpdateNoteReceivableMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateNoteReceivableMutation, TError, UpdateNoteReceivableMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateNoteReceivableMutation, TError, UpdateNoteReceivableMutationVariables, TContext>(
      ['UpdateNoteReceivable'],
      (variables?: UpdateNoteReceivableMutationVariables) => fetcher<UpdateNoteReceivableMutation, UpdateNoteReceivableMutationVariables>(client, UpdateNoteReceivableDocument, variables, headers)(),
      options
    );
useUpdateNoteReceivableMutation.getKey = () => ['UpdateNoteReceivable'];

useUpdateNoteReceivableMutation.fetcher = (client: GraphQLClient, variables: UpdateNoteReceivableMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateNoteReceivableMutation, UpdateNoteReceivableMutationVariables>(client, UpdateNoteReceivableDocument, variables, headers);
export const CreatePersonalPropertyItemDocument = `
    mutation createPersonalPropertyItem($input: CreatePersonalPropertyItemInput!) {
  createPersonalPropertyItem(input: $input) {
    personalPropertyItem {
      ...PersonalPropertyItemFragment
    }
  }
}
    ${PersonalPropertyItemFragmentFragmentDoc}`;
export const useCreatePersonalPropertyItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePersonalPropertyItemMutation, TError, CreatePersonalPropertyItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePersonalPropertyItemMutation, TError, CreatePersonalPropertyItemMutationVariables, TContext>(
      ['createPersonalPropertyItem'],
      (variables?: CreatePersonalPropertyItemMutationVariables) => fetcher<CreatePersonalPropertyItemMutation, CreatePersonalPropertyItemMutationVariables>(client, CreatePersonalPropertyItemDocument, variables, headers)(),
      options
    );
useCreatePersonalPropertyItemMutation.getKey = () => ['createPersonalPropertyItem'];

useCreatePersonalPropertyItemMutation.fetcher = (client: GraphQLClient, variables: CreatePersonalPropertyItemMutationVariables, headers?: RequestInit['headers']) => fetcher<CreatePersonalPropertyItemMutation, CreatePersonalPropertyItemMutationVariables>(client, CreatePersonalPropertyItemDocument, variables, headers);
export const DeletePersonalPropertyItemDocument = `
    mutation deletePersonalPropertyItem($input: DeletePersonalPropertyItemInput!) {
  deletePersonalPropertyItem(input: $input) {
    changeToken
  }
}
    `;
export const useDeletePersonalPropertyItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePersonalPropertyItemMutation, TError, DeletePersonalPropertyItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePersonalPropertyItemMutation, TError, DeletePersonalPropertyItemMutationVariables, TContext>(
      ['deletePersonalPropertyItem'],
      (variables?: DeletePersonalPropertyItemMutationVariables) => fetcher<DeletePersonalPropertyItemMutation, DeletePersonalPropertyItemMutationVariables>(client, DeletePersonalPropertyItemDocument, variables, headers)(),
      options
    );
useDeletePersonalPropertyItemMutation.getKey = () => ['deletePersonalPropertyItem'];

useDeletePersonalPropertyItemMutation.fetcher = (client: GraphQLClient, variables: DeletePersonalPropertyItemMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePersonalPropertyItemMutation, DeletePersonalPropertyItemMutationVariables>(client, DeletePersonalPropertyItemDocument, variables, headers);
export const GetPersonalPropertyItemDocument = `
    query GetPersonalPropertyItem($householdID: ID!, $id: ID!) {
  personalPropertyItem(householdID: $householdID, id: $id) {
    __typename
    id
    householdID
    name
    changeToken
    notes
    closedAt
    ownedValue {
      ...MonetaryAmountFragment
    }
    ownership {
      __typename
      ... on TenantsInCommon {
        interests {
          owner {
            ...OwnerFragment
          }
          percentage
        }
      }
    }
    value {
      tenantID
      id
      updatedAt
      latestDataPoint {
        data {
          __typename
          ... on MonetaryAmountDataPointValue {
            value {
              currencyCode
              value
            }
          }
        }
      }
      dataPoints {
        items {
          id
          dateTime
          data {
            __typename
            ... on MonetaryAmountDataPointValue {
              value {
                currencyCode
                value
              }
            }
          }
        }
      }
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${OwnerFragmentFragmentDoc}`;
export const useGetPersonalPropertyItemQuery = <
      TData = GetPersonalPropertyItemQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPersonalPropertyItemQueryVariables,
      options?: UseQueryOptions<GetPersonalPropertyItemQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPersonalPropertyItemQuery, TError, TData>(
      ['GetPersonalPropertyItem', variables],
      fetcher<GetPersonalPropertyItemQuery, GetPersonalPropertyItemQueryVariables>(client, GetPersonalPropertyItemDocument, variables, headers),
      options
    );

useGetPersonalPropertyItemQuery.getKey = (variables: GetPersonalPropertyItemQueryVariables) => ['GetPersonalPropertyItem', variables];
;

useGetPersonalPropertyItemQuery.fetcher = (client: GraphQLClient, variables: GetPersonalPropertyItemQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPersonalPropertyItemQuery, GetPersonalPropertyItemQueryVariables>(client, GetPersonalPropertyItemDocument, variables, headers);
export const GetPersonalPropertyItemsDocument = `
    query GetPersonalPropertyItems($householdID: ID!) {
  personalPropertyItems(householdID: $householdID) {
    items {
      ...PersonalPropertyItemFragment
    }
  }
}
    ${PersonalPropertyItemFragmentFragmentDoc}`;
export const useGetPersonalPropertyItemsQuery = <
      TData = GetPersonalPropertyItemsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPersonalPropertyItemsQueryVariables,
      options?: UseQueryOptions<GetPersonalPropertyItemsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPersonalPropertyItemsQuery, TError, TData>(
      ['GetPersonalPropertyItems', variables],
      fetcher<GetPersonalPropertyItemsQuery, GetPersonalPropertyItemsQueryVariables>(client, GetPersonalPropertyItemsDocument, variables, headers),
      options
    );

useGetPersonalPropertyItemsQuery.getKey = (variables: GetPersonalPropertyItemsQueryVariables) => ['GetPersonalPropertyItems', variables];
;

useGetPersonalPropertyItemsQuery.fetcher = (client: GraphQLClient, variables: GetPersonalPropertyItemsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPersonalPropertyItemsQuery, GetPersonalPropertyItemsQueryVariables>(client, GetPersonalPropertyItemsDocument, variables, headers);
export const ClosePersonalPropertyItemDocument = `
    mutation ClosePersonalPropertyItem($input: ClosePersonalPropertyItemInput!) {
  closePersonalPropertyItem(input: $input) {
    changeToken
  }
}
    `;
export const useClosePersonalPropertyItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ClosePersonalPropertyItemMutation, TError, ClosePersonalPropertyItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ClosePersonalPropertyItemMutation, TError, ClosePersonalPropertyItemMutationVariables, TContext>(
      ['ClosePersonalPropertyItem'],
      (variables?: ClosePersonalPropertyItemMutationVariables) => fetcher<ClosePersonalPropertyItemMutation, ClosePersonalPropertyItemMutationVariables>(client, ClosePersonalPropertyItemDocument, variables, headers)(),
      options
    );
useClosePersonalPropertyItemMutation.getKey = () => ['ClosePersonalPropertyItem'];

useClosePersonalPropertyItemMutation.fetcher = (client: GraphQLClient, variables: ClosePersonalPropertyItemMutationVariables, headers?: RequestInit['headers']) => fetcher<ClosePersonalPropertyItemMutation, ClosePersonalPropertyItemMutationVariables>(client, ClosePersonalPropertyItemDocument, variables, headers);
export const MergePersonalPropertyItemsDocument = `
    mutation MergePersonalPropertyItems($input: MergePersonalPropertyItemsInput!) {
  mergePersonalPropertyItems(input: $input) {
    merged
  }
}
    `;
export const useMergePersonalPropertyItemsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergePersonalPropertyItemsMutation, TError, MergePersonalPropertyItemsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergePersonalPropertyItemsMutation, TError, MergePersonalPropertyItemsMutationVariables, TContext>(
      ['MergePersonalPropertyItems'],
      (variables?: MergePersonalPropertyItemsMutationVariables) => fetcher<MergePersonalPropertyItemsMutation, MergePersonalPropertyItemsMutationVariables>(client, MergePersonalPropertyItemsDocument, variables, headers)(),
      options
    );
useMergePersonalPropertyItemsMutation.getKey = () => ['MergePersonalPropertyItems'];

useMergePersonalPropertyItemsMutation.fetcher = (client: GraphQLClient, variables: MergePersonalPropertyItemsMutationVariables, headers?: RequestInit['headers']) => fetcher<MergePersonalPropertyItemsMutation, MergePersonalPropertyItemsMutationVariables>(client, MergePersonalPropertyItemsDocument, variables, headers);
export const UpdatePersonalPropertyItemDocument = `
    mutation UpdatePersonalPropertyItem($input: UpdatePersonalPropertyItemInput!) {
  updatePersonalPropertyItem(input: $input) {
    personalPropertyItem {
      ...PersonalPropertyItemFragment
    }
  }
}
    ${PersonalPropertyItemFragmentFragmentDoc}`;
export const useUpdatePersonalPropertyItemMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePersonalPropertyItemMutation, TError, UpdatePersonalPropertyItemMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePersonalPropertyItemMutation, TError, UpdatePersonalPropertyItemMutationVariables, TContext>(
      ['UpdatePersonalPropertyItem'],
      (variables?: UpdatePersonalPropertyItemMutationVariables) => fetcher<UpdatePersonalPropertyItemMutation, UpdatePersonalPropertyItemMutationVariables>(client, UpdatePersonalPropertyItemDocument, variables, headers)(),
      options
    );
useUpdatePersonalPropertyItemMutation.getKey = () => ['UpdatePersonalPropertyItem'];

useUpdatePersonalPropertyItemMutation.fetcher = (client: GraphQLClient, variables: UpdatePersonalPropertyItemMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdatePersonalPropertyItemMutation, UpdatePersonalPropertyItemMutationVariables>(client, UpdatePersonalPropertyItemDocument, variables, headers);
export const GetPersonsDocument = `
    query GetPersons($householdID: ID!, $cursor: String) {
  persons(householdID: $householdID, cursor: $cursor) {
    items {
      ...PersonFragment
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PersonFragmentFragmentDoc}`;
export const useGetPersonsQuery = <
      TData = GetPersonsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPersonsQueryVariables,
      options?: UseQueryOptions<GetPersonsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPersonsQuery, TError, TData>(
      ['GetPersons', variables],
      fetcher<GetPersonsQuery, GetPersonsQueryVariables>(client, GetPersonsDocument, variables, headers),
      options
    );

useGetPersonsQuery.getKey = (variables: GetPersonsQueryVariables) => ['GetPersons', variables];
;

useGetPersonsQuery.fetcher = (client: GraphQLClient, variables: GetPersonsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPersonsQuery, GetPersonsQueryVariables>(client, GetPersonsDocument, variables, headers);
export const GetPersonDocument = `
    query GetPerson($householdID: ID!, $id: ID!) {
  person(householdID: $householdID, id: $id) {
    ...PersonFragment
  }
}
    ${PersonFragmentFragmentDoc}`;
export const useGetPersonQuery = <
      TData = GetPersonQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPersonQueryVariables,
      options?: UseQueryOptions<GetPersonQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPersonQuery, TError, TData>(
      ['GetPerson', variables],
      fetcher<GetPersonQuery, GetPersonQueryVariables>(client, GetPersonDocument, variables, headers),
      options
    );

useGetPersonQuery.getKey = (variables: GetPersonQueryVariables) => ['GetPerson', variables];
;

useGetPersonQuery.fetcher = (client: GraphQLClient, variables: GetPersonQueryVariables, headers?: RequestInit['headers']) => fetcher<GetPersonQuery, GetPersonQueryVariables>(client, GetPersonDocument, variables, headers);
export const CreatePersonDocument = `
    mutation CreatePerson($input: CreatePersonInput!) {
  createPerson(input: $input) {
    person {
      ...PersonFragment
    }
  }
}
    ${PersonFragmentFragmentDoc}`;
export const useCreatePersonMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreatePersonMutation, TError, CreatePersonMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreatePersonMutation, TError, CreatePersonMutationVariables, TContext>(
      ['CreatePerson'],
      (variables?: CreatePersonMutationVariables) => fetcher<CreatePersonMutation, CreatePersonMutationVariables>(client, CreatePersonDocument, variables, headers)(),
      options
    );
useCreatePersonMutation.getKey = () => ['CreatePerson'];

useCreatePersonMutation.fetcher = (client: GraphQLClient, variables: CreatePersonMutationVariables, headers?: RequestInit['headers']) => fetcher<CreatePersonMutation, CreatePersonMutationVariables>(client, CreatePersonDocument, variables, headers);
export const UpdatePersonDocument = `
    mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    person {
      ...PersonFragment
    }
  }
}
    ${PersonFragmentFragmentDoc}`;
export const useUpdatePersonMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePersonMutation, TError, UpdatePersonMutationVariables, TContext>(
      ['UpdatePerson'],
      (variables?: UpdatePersonMutationVariables) => fetcher<UpdatePersonMutation, UpdatePersonMutationVariables>(client, UpdatePersonDocument, variables, headers)(),
      options
    );
useUpdatePersonMutation.getKey = () => ['UpdatePerson'];

useUpdatePersonMutation.fetcher = (client: GraphQLClient, variables: UpdatePersonMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdatePersonMutation, UpdatePersonMutationVariables>(client, UpdatePersonDocument, variables, headers);
export const DeletePersonDocument = `
    mutation DeletePerson($input: DeletePersonInput!) {
  deletePerson(input: $input) {
    changeToken
  }
}
    `;
export const useDeletePersonMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeletePersonMutation, TError, DeletePersonMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeletePersonMutation, TError, DeletePersonMutationVariables, TContext>(
      ['DeletePerson'],
      (variables?: DeletePersonMutationVariables) => fetcher<DeletePersonMutation, DeletePersonMutationVariables>(client, DeletePersonDocument, variables, headers)(),
      options
    );
useDeletePersonMutation.getKey = () => ['DeletePerson'];

useDeletePersonMutation.fetcher = (client: GraphQLClient, variables: DeletePersonMutationVariables, headers?: RequestInit['headers']) => fetcher<DeletePersonMutation, DeletePersonMutationVariables>(client, DeletePersonDocument, variables, headers);
export const GeneratePlaidLinkTokenDocument = `
    mutation GeneratePlaidLinkToken($input: GeneratePlaidLinkTokenInput!) {
  generatePlaidLinkToken(input: $input) {
    linkToken
  }
}
    `;
export const useGeneratePlaidLinkTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GeneratePlaidLinkTokenMutation, TError, GeneratePlaidLinkTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GeneratePlaidLinkTokenMutation, TError, GeneratePlaidLinkTokenMutationVariables, TContext>(
      ['GeneratePlaidLinkToken'],
      (variables?: GeneratePlaidLinkTokenMutationVariables) => fetcher<GeneratePlaidLinkTokenMutation, GeneratePlaidLinkTokenMutationVariables>(client, GeneratePlaidLinkTokenDocument, variables, headers)(),
      options
    );
useGeneratePlaidLinkTokenMutation.getKey = () => ['GeneratePlaidLinkToken'];

useGeneratePlaidLinkTokenMutation.fetcher = (client: GraphQLClient, variables: GeneratePlaidLinkTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<GeneratePlaidLinkTokenMutation, GeneratePlaidLinkTokenMutationVariables>(client, GeneratePlaidLinkTokenDocument, variables, headers);
export const ExchangePlaidPublicTokenDocument = `
    mutation ExchangePlaidPublicToken($input: ExchangePlaidPublicTokenInput!) {
  exchangePlaidPublicToken(input: $input) {
    plaidItemID
    accountsMapping {
      plaidItemID
      plaidItemAccountID
      name
      officialName
      mappedEntityID
      mappedType
      mappedCashAccountType
      mappedLoanType
      mappedInvestmentType
      balance {
        currencyCode
        value
      }
      mask
    }
  }
}
    `;
export const useExchangePlaidPublicTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ExchangePlaidPublicTokenMutation, TError, ExchangePlaidPublicTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ExchangePlaidPublicTokenMutation, TError, ExchangePlaidPublicTokenMutationVariables, TContext>(
      ['ExchangePlaidPublicToken'],
      (variables?: ExchangePlaidPublicTokenMutationVariables) => fetcher<ExchangePlaidPublicTokenMutation, ExchangePlaidPublicTokenMutationVariables>(client, ExchangePlaidPublicTokenDocument, variables, headers)(),
      options
    );
useExchangePlaidPublicTokenMutation.getKey = () => ['ExchangePlaidPublicToken'];

useExchangePlaidPublicTokenMutation.fetcher = (client: GraphQLClient, variables: ExchangePlaidPublicTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<ExchangePlaidPublicTokenMutation, ExchangePlaidPublicTokenMutationVariables>(client, ExchangePlaidPublicTokenDocument, variables, headers);
export const ApplyPlaidItemAccountMappingDocument = `
    mutation ApplyPlaidItemAccountMapping($input: ApplyPlaidItemAccountMappingInput!) {
  applyPlaidItemAccountMapping(input: $input)
}
    `;
export const useApplyPlaidItemAccountMappingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyPlaidItemAccountMappingMutation, TError, ApplyPlaidItemAccountMappingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyPlaidItemAccountMappingMutation, TError, ApplyPlaidItemAccountMappingMutationVariables, TContext>(
      ['ApplyPlaidItemAccountMapping'],
      (variables?: ApplyPlaidItemAccountMappingMutationVariables) => fetcher<ApplyPlaidItemAccountMappingMutation, ApplyPlaidItemAccountMappingMutationVariables>(client, ApplyPlaidItemAccountMappingDocument, variables, headers)(),
      options
    );
useApplyPlaidItemAccountMappingMutation.getKey = () => ['ApplyPlaidItemAccountMapping'];

useApplyPlaidItemAccountMappingMutation.fetcher = (client: GraphQLClient, variables: ApplyPlaidItemAccountMappingMutationVariables, headers?: RequestInit['headers']) => fetcher<ApplyPlaidItemAccountMappingMutation, ApplyPlaidItemAccountMappingMutationVariables>(client, ApplyPlaidItemAccountMappingDocument, variables, headers);
export const UpdatePlaidLinkAfterRefreshDocument = `
    mutation updatePlaidLinkAfterRefresh($input: UpdatePlaidLinkAfterRefreshInput!) {
  updatePlaidLinkAfterRefresh(input: $input)
}
    `;
export const useUpdatePlaidLinkAfterRefreshMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePlaidLinkAfterRefreshMutation, TError, UpdatePlaidLinkAfterRefreshMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePlaidLinkAfterRefreshMutation, TError, UpdatePlaidLinkAfterRefreshMutationVariables, TContext>(
      ['updatePlaidLinkAfterRefresh'],
      (variables?: UpdatePlaidLinkAfterRefreshMutationVariables) => fetcher<UpdatePlaidLinkAfterRefreshMutation, UpdatePlaidLinkAfterRefreshMutationVariables>(client, UpdatePlaidLinkAfterRefreshDocument, variables, headers)(),
      options
    );
useUpdatePlaidLinkAfterRefreshMutation.getKey = () => ['updatePlaidLinkAfterRefresh'];

useUpdatePlaidLinkAfterRefreshMutation.fetcher = (client: GraphQLClient, variables: UpdatePlaidLinkAfterRefreshMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdatePlaidLinkAfterRefreshMutation, UpdatePlaidLinkAfterRefreshMutationVariables>(client, UpdatePlaidLinkAfterRefreshDocument, variables, headers);
export const DisconnectAccountLinkingDocument = `
    mutation DisconnectAccountLinking($input: DisconnectAccountLinking!) {
  disconnectAccountLinking(input: $input)
}
    `;
export const useDisconnectAccountLinkingMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DisconnectAccountLinkingMutation, TError, DisconnectAccountLinkingMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DisconnectAccountLinkingMutation, TError, DisconnectAccountLinkingMutationVariables, TContext>(
      ['DisconnectAccountLinking'],
      (variables?: DisconnectAccountLinkingMutationVariables) => fetcher<DisconnectAccountLinkingMutation, DisconnectAccountLinkingMutationVariables>(client, DisconnectAccountLinkingDocument, variables, headers)(),
      options
    );
useDisconnectAccountLinkingMutation.getKey = () => ['DisconnectAccountLinking'];

useDisconnectAccountLinkingMutation.fetcher = (client: GraphQLClient, variables: DisconnectAccountLinkingMutationVariables, headers?: RequestInit['headers']) => fetcher<DisconnectAccountLinkingMutation, DisconnectAccountLinkingMutationVariables>(client, DisconnectAccountLinkingDocument, variables, headers);
export const GetProfileImageUploadUrlDocument = `
    mutation GetProfileImageUploadUrl($input: GetProfileImageUploadURLInput!) {
  getProfileImageUploadURL(input: $input) {
    uploadURL
  }
}
    `;
export const useGetProfileImageUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetProfileImageUploadUrlMutation, TError, GetProfileImageUploadUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetProfileImageUploadUrlMutation, TError, GetProfileImageUploadUrlMutationVariables, TContext>(
      ['GetProfileImageUploadUrl'],
      (variables?: GetProfileImageUploadUrlMutationVariables) => fetcher<GetProfileImageUploadUrlMutation, GetProfileImageUploadUrlMutationVariables>(client, GetProfileImageUploadUrlDocument, variables, headers)(),
      options
    );
useGetProfileImageUploadUrlMutation.getKey = () => ['GetProfileImageUploadUrl'];

useGetProfileImageUploadUrlMutation.fetcher = (client: GraphQLClient, variables: GetProfileImageUploadUrlMutationVariables, headers?: RequestInit['headers']) => fetcher<GetProfileImageUploadUrlMutation, GetProfileImageUploadUrlMutationVariables>(client, GetProfileImageUploadUrlDocument, variables, headers);
export const StartProspectDiscoveryDocument = `
    mutation StartProspectDiscovery($input: StartProspectDiscoveryInput!) {
  startProspectDiscovery(input: $input) {
    tokenSet {
      accessToken
      refreshToken
      idToken
    }
  }
}
    `;
export const useStartProspectDiscoveryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<StartProspectDiscoveryMutation, TError, StartProspectDiscoveryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<StartProspectDiscoveryMutation, TError, StartProspectDiscoveryMutationVariables, TContext>(
      ['StartProspectDiscovery'],
      (variables?: StartProspectDiscoveryMutationVariables) => fetcher<StartProspectDiscoveryMutation, StartProspectDiscoveryMutationVariables>(client, StartProspectDiscoveryDocument, variables, headers)(),
      options
    );
useStartProspectDiscoveryMutation.getKey = () => ['StartProspectDiscovery'];

useStartProspectDiscoveryMutation.fetcher = (client: GraphQLClient, variables: StartProspectDiscoveryMutationVariables, headers?: RequestInit['headers']) => fetcher<StartProspectDiscoveryMutation, StartProspectDiscoveryMutationVariables>(client, StartProspectDiscoveryDocument, variables, headers);
export const CompleteProspectDiscoveryDocument = `
    mutation CompleteProspectDiscovery($input: CompleteProspectDiscoveryInput!) {
  completeProspectDiscovery(input: $input) {
    complete
  }
}
    `;
export const useCompleteProspectDiscoveryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteProspectDiscoveryMutation, TError, CompleteProspectDiscoveryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CompleteProspectDiscoveryMutation, TError, CompleteProspectDiscoveryMutationVariables, TContext>(
      ['CompleteProspectDiscovery'],
      (variables?: CompleteProspectDiscoveryMutationVariables) => fetcher<CompleteProspectDiscoveryMutation, CompleteProspectDiscoveryMutationVariables>(client, CompleteProspectDiscoveryDocument, variables, headers)(),
      options
    );
useCompleteProspectDiscoveryMutation.getKey = () => ['CompleteProspectDiscovery'];

useCompleteProspectDiscoveryMutation.fetcher = (client: GraphQLClient, variables: CompleteProspectDiscoveryMutationVariables, headers?: RequestInit['headers']) => fetcher<CompleteProspectDiscoveryMutation, CompleteProspectDiscoveryMutationVariables>(client, CompleteProspectDiscoveryDocument, variables, headers);
export const ProspectDiscoveryAllDoneLoaderQueryDocument = `
    query ProspectDiscoveryAllDoneLoaderQuery($firmID: ID!, $clientID: ID!) {
  firmClient(firmID: $firmID, id: $clientID) {
    id
    entitlements {
      aiAssessment
    }
  }
  aiClientSummary(clientID: $clientID) {
    advisorApproved
  }
}
    `;
export const useProspectDiscoveryAllDoneLoaderQueryQuery = <
      TData = ProspectDiscoveryAllDoneLoaderQueryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ProspectDiscoveryAllDoneLoaderQueryQueryVariables,
      options?: UseQueryOptions<ProspectDiscoveryAllDoneLoaderQueryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProspectDiscoveryAllDoneLoaderQueryQuery, TError, TData>(
      ['ProspectDiscoveryAllDoneLoaderQuery', variables],
      fetcher<ProspectDiscoveryAllDoneLoaderQueryQuery, ProspectDiscoveryAllDoneLoaderQueryQueryVariables>(client, ProspectDiscoveryAllDoneLoaderQueryDocument, variables, headers),
      options
    );

useProspectDiscoveryAllDoneLoaderQueryQuery.getKey = (variables: ProspectDiscoveryAllDoneLoaderQueryQueryVariables) => ['ProspectDiscoveryAllDoneLoaderQuery', variables];
;

useProspectDiscoveryAllDoneLoaderQueryQuery.fetcher = (client: GraphQLClient, variables: ProspectDiscoveryAllDoneLoaderQueryQueryVariables, headers?: RequestInit['headers']) => fetcher<ProspectDiscoveryAllDoneLoaderQueryQuery, ProspectDiscoveryAllDoneLoaderQueryQueryVariables>(client, ProspectDiscoveryAllDoneLoaderQueryDocument, variables, headers);
export const ProspectDiscoveryFormsLayoutPageDocument = `
    query ProspectDiscoveryFormsLayoutPage($firmID: ID!, $clientID: ID!) {
  firmClient(firmID: $firmID, id: $clientID) {
    id
    entitlements {
      aiAssessment
    }
  }
  aiClientSummary(clientID: $clientID) {
    advisorApproved
  }
}
    `;
export const useProspectDiscoveryFormsLayoutPageQuery = <
      TData = ProspectDiscoveryFormsLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ProspectDiscoveryFormsLayoutPageQueryVariables,
      options?: UseQueryOptions<ProspectDiscoveryFormsLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProspectDiscoveryFormsLayoutPageQuery, TError, TData>(
      ['ProspectDiscoveryFormsLayoutPage', variables],
      fetcher<ProspectDiscoveryFormsLayoutPageQuery, ProspectDiscoveryFormsLayoutPageQueryVariables>(client, ProspectDiscoveryFormsLayoutPageDocument, variables, headers),
      options
    );

useProspectDiscoveryFormsLayoutPageQuery.getKey = (variables: ProspectDiscoveryFormsLayoutPageQueryVariables) => ['ProspectDiscoveryFormsLayoutPage', variables];
;

useProspectDiscoveryFormsLayoutPageQuery.fetcher = (client: GraphQLClient, variables: ProspectDiscoveryFormsLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ProspectDiscoveryFormsLayoutPageQuery, ProspectDiscoveryFormsLayoutPageQueryVariables>(client, ProspectDiscoveryFormsLayoutPageDocument, variables, headers);
export const QtDetailsDocument = `
    query QtDetails($householdID: ID!, $includeScore: Boolean!, $includeTotalRetirementAssets: Boolean!, $includeAnnualExpenses: Boolean!, $includeTaxFreeAccounts: Boolean!, $includeTotalTaxFree: Boolean!, $includeTaxDeferredAccounts: Boolean!, $includeTotalTaxDeferred: Boolean!, $includeOtherAccounts: Boolean!, $includeTotalOther: Boolean!, $includeTotalTaxFreeSavings: Boolean!, $includeTotalTaxDeferredSavings: Boolean!, $includeTotalOtherSavings: Boolean!) {
  qtDetails(householdID: $householdID) {
    qt @include(if: $includeScore)
    totalRetirementAssets @include(if: $includeTotalRetirementAssets) {
      ...MonetaryAmountFragment
    }
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    taxFreeAccounts @include(if: $includeTaxFreeAccounts) {
      ...InvestmentFragment
    }
    totalTaxFree @include(if: $includeTotalTaxFree) {
      ...MonetaryAmountFragment
    }
    totalTaxFreeSavings @include(if: $includeTotalTaxFreeSavings) {
      ...RecurringTotalsFragment
    }
    taxDeferredAccounts @include(if: $includeTaxDeferredAccounts) {
      ...InvestmentFragment
    }
    totalTaxDeferred @include(if: $includeTotalTaxDeferred) {
      ...MonetaryAmountFragment
    }
    totalTaxDeferredSavings @include(if: $includeTotalTaxDeferredSavings) {
      ...RecurringTotalsFragment
    }
    otherAccounts @include(if: $includeOtherAccounts) {
      ...InvestmentFragment
    }
    totalOther @include(if: $includeTotalOther) {
      ...MonetaryAmountFragment
    }
    totalOtherSavings @include(if: $includeTotalOtherSavings) {
      ...RecurringTotalsFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}
${RecurringTotalsFragmentFragmentDoc}`;
export const useQtDetailsQuery = <
      TData = QtDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: QtDetailsQueryVariables,
      options?: UseQueryOptions<QtDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<QtDetailsQuery, TError, TData>(
      ['QtDetails', variables],
      fetcher<QtDetailsQuery, QtDetailsQueryVariables>(client, QtDetailsDocument, variables, headers),
      options
    );

useQtDetailsQuery.getKey = (variables: QtDetailsQueryVariables) => ['QtDetails', variables];
;

useQtDetailsQuery.fetcher = (client: GraphQLClient, variables: QtDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<QtDetailsQuery, QtDetailsQueryVariables>(client, QtDetailsDocument, variables, headers);
export const GetRealEstatePropertiesDocument = `
    query GetRealEstateProperties($householdID: ID!) {
  realEstateProperties(householdID: $householdID) {
    items {
      ...RealEstateFragment
    }
  }
}
    ${RealEstateFragmentFragmentDoc}`;
export const useGetRealEstatePropertiesQuery = <
      TData = GetRealEstatePropertiesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRealEstatePropertiesQueryVariables,
      options?: UseQueryOptions<GetRealEstatePropertiesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRealEstatePropertiesQuery, TError, TData>(
      ['GetRealEstateProperties', variables],
      fetcher<GetRealEstatePropertiesQuery, GetRealEstatePropertiesQueryVariables>(client, GetRealEstatePropertiesDocument, variables, headers),
      options
    );

useGetRealEstatePropertiesQuery.getKey = (variables: GetRealEstatePropertiesQueryVariables) => ['GetRealEstateProperties', variables];
;

useGetRealEstatePropertiesQuery.fetcher = (client: GraphQLClient, variables: GetRealEstatePropertiesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRealEstatePropertiesQuery, GetRealEstatePropertiesQueryVariables>(client, GetRealEstatePropertiesDocument, variables, headers);
export const CreateRealEstatePropertyDocument = `
    mutation createRealEstateProperty($input: CreateRealEstateInput!) {
  createRealEstateProperty(input: $input) {
    realEstate {
      ...RealEstateFragment
    }
  }
}
    ${RealEstateFragmentFragmentDoc}`;
export const useCreateRealEstatePropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateRealEstatePropertyMutation, TError, CreateRealEstatePropertyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateRealEstatePropertyMutation, TError, CreateRealEstatePropertyMutationVariables, TContext>(
      ['createRealEstateProperty'],
      (variables?: CreateRealEstatePropertyMutationVariables) => fetcher<CreateRealEstatePropertyMutation, CreateRealEstatePropertyMutationVariables>(client, CreateRealEstatePropertyDocument, variables, headers)(),
      options
    );
useCreateRealEstatePropertyMutation.getKey = () => ['createRealEstateProperty'];

useCreateRealEstatePropertyMutation.fetcher = (client: GraphQLClient, variables: CreateRealEstatePropertyMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateRealEstatePropertyMutation, CreateRealEstatePropertyMutationVariables>(client, CreateRealEstatePropertyDocument, variables, headers);
export const DeleteRealEstatePropertyDocument = `
    mutation DeleteRealEstateProperty($input: DeleteRealEstateInput!) {
  deleteRealEstateProperty(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteRealEstatePropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteRealEstatePropertyMutation, TError, DeleteRealEstatePropertyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteRealEstatePropertyMutation, TError, DeleteRealEstatePropertyMutationVariables, TContext>(
      ['DeleteRealEstateProperty'],
      (variables?: DeleteRealEstatePropertyMutationVariables) => fetcher<DeleteRealEstatePropertyMutation, DeleteRealEstatePropertyMutationVariables>(client, DeleteRealEstatePropertyDocument, variables, headers)(),
      options
    );
useDeleteRealEstatePropertyMutation.getKey = () => ['DeleteRealEstateProperty'];

useDeleteRealEstatePropertyMutation.fetcher = (client: GraphQLClient, variables: DeleteRealEstatePropertyMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteRealEstatePropertyMutation, DeleteRealEstatePropertyMutationVariables>(client, DeleteRealEstatePropertyDocument, variables, headers);
export const UpdateRealEstatePropertyDocument = `
    mutation UpdateRealEstateProperty($input: UpdateRealEstateInput!) {
  updateRealEstateProperty(input: $input) {
    realEstate {
      ...RealEstateFragment
    }
  }
}
    ${RealEstateFragmentFragmentDoc}`;
export const useUpdateRealEstatePropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateRealEstatePropertyMutation, TError, UpdateRealEstatePropertyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateRealEstatePropertyMutation, TError, UpdateRealEstatePropertyMutationVariables, TContext>(
      ['UpdateRealEstateProperty'],
      (variables?: UpdateRealEstatePropertyMutationVariables) => fetcher<UpdateRealEstatePropertyMutation, UpdateRealEstatePropertyMutationVariables>(client, UpdateRealEstatePropertyDocument, variables, headers)(),
      options
    );
useUpdateRealEstatePropertyMutation.getKey = () => ['UpdateRealEstateProperty'];

useUpdateRealEstatePropertyMutation.fetcher = (client: GraphQLClient, variables: UpdateRealEstatePropertyMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateRealEstatePropertyMutation, UpdateRealEstatePropertyMutationVariables>(client, UpdateRealEstatePropertyDocument, variables, headers);
export const GetRealEstatePropertyDocument = `
    query GetRealEstateProperty($householdID: ID!, $id: ID!) {
  realEstateProperty(householdID: $householdID, id: $id) {
    ...RealEstateFragment
    closedAt
  }
}
    ${RealEstateFragmentFragmentDoc}`;
export const useGetRealEstatePropertyQuery = <
      TData = GetRealEstatePropertyQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetRealEstatePropertyQueryVariables,
      options?: UseQueryOptions<GetRealEstatePropertyQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetRealEstatePropertyQuery, TError, TData>(
      ['GetRealEstateProperty', variables],
      fetcher<GetRealEstatePropertyQuery, GetRealEstatePropertyQueryVariables>(client, GetRealEstatePropertyDocument, variables, headers),
      options
    );

useGetRealEstatePropertyQuery.getKey = (variables: GetRealEstatePropertyQueryVariables) => ['GetRealEstateProperty', variables];
;

useGetRealEstatePropertyQuery.fetcher = (client: GraphQLClient, variables: GetRealEstatePropertyQueryVariables, headers?: RequestInit['headers']) => fetcher<GetRealEstatePropertyQuery, GetRealEstatePropertyQueryVariables>(client, GetRealEstatePropertyDocument, variables, headers);
export const CloseRealEstatePropertyDocument = `
    mutation CloseRealEstateProperty($input: CloseRealEstatePropertyInput!) {
  closeRealEstateProperty(input: $input) {
    changeToken
  }
}
    `;
export const useCloseRealEstatePropertyMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CloseRealEstatePropertyMutation, TError, CloseRealEstatePropertyMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CloseRealEstatePropertyMutation, TError, CloseRealEstatePropertyMutationVariables, TContext>(
      ['CloseRealEstateProperty'],
      (variables?: CloseRealEstatePropertyMutationVariables) => fetcher<CloseRealEstatePropertyMutation, CloseRealEstatePropertyMutationVariables>(client, CloseRealEstatePropertyDocument, variables, headers)(),
      options
    );
useCloseRealEstatePropertyMutation.getKey = () => ['CloseRealEstateProperty'];

useCloseRealEstatePropertyMutation.fetcher = (client: GraphQLClient, variables: CloseRealEstatePropertyMutationVariables, headers?: RequestInit['headers']) => fetcher<CloseRealEstatePropertyMutation, CloseRealEstatePropertyMutationVariables>(client, CloseRealEstatePropertyDocument, variables, headers);
export const MergeRealEstatesDocument = `
    mutation MergeRealEstates($input: MergeRealEstatesInput!) {
  mergeRealEstates(input: $input) {
    merged
  }
}
    `;
export const useMergeRealEstatesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MergeRealEstatesMutation, TError, MergeRealEstatesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MergeRealEstatesMutation, TError, MergeRealEstatesMutationVariables, TContext>(
      ['MergeRealEstates'],
      (variables?: MergeRealEstatesMutationVariables) => fetcher<MergeRealEstatesMutation, MergeRealEstatesMutationVariables>(client, MergeRealEstatesDocument, variables, headers)(),
      options
    );
useMergeRealEstatesMutation.getKey = () => ['MergeRealEstates'];

useMergeRealEstatesMutation.fetcher = (client: GraphQLClient, variables: MergeRealEstatesMutationVariables, headers?: RequestInit['headers']) => fetcher<MergeRealEstatesMutation, MergeRealEstatesMutationVariables>(client, MergeRealEstatesDocument, variables, headers);
export const RtDetailsDocument = `
    query RtDetails($householdID: ID!, $includeScore: Boolean!, $includeTotalRealEstateEquity: Boolean!, $includeAnnualExpenses: Boolean!, $includeRealEstate: Boolean!, $includeUnattachedLoans: Boolean!, $includeTotalUnattachedLoans: Boolean!, $includeTotalRealEstateValue: Boolean!, $includeTotalRealEstateDebt: Boolean!) {
  rtDetails(householdID: $householdID) {
    rt @include(if: $includeScore)
    totalRealEstateEquity @include(if: $includeTotalRealEstateEquity) {
      ...MonetaryAmountFragment
    }
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    realEstate @include(if: $includeRealEstate) {
      realEstate {
        ...RealEstateFragment
      }
      loans {
        ...LoanFragment
      }
      ownedValue {
        ...MonetaryAmountFragment
      }
      ownedDebt {
        ...MonetaryAmountFragment
      }
      totalOwnedEquity {
        ...MonetaryAmountFragment
      }
      isBusinessOwned
    }
    unattachedLoans @include(if: $includeUnattachedLoans) {
      ...LoanFragment
    }
    totalUnattachedLoans @include(if: $includeTotalUnattachedLoans) {
      ...MonetaryAmountFragment
    }
    totalRealEstateValue @include(if: $includeTotalRealEstateValue) {
      ...MonetaryAmountFragment
    }
    totalRealEstateDebt @include(if: $includeTotalRealEstateDebt) {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${RealEstateFragmentFragmentDoc}
${LoanFragmentFragmentDoc}`;
export const useRtDetailsQuery = <
      TData = RtDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RtDetailsQueryVariables,
      options?: UseQueryOptions<RtDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RtDetailsQuery, TError, TData>(
      ['RtDetails', variables],
      fetcher<RtDetailsQuery, RtDetailsQueryVariables>(client, RtDetailsDocument, variables, headers),
      options
    );

useRtDetailsQuery.getKey = (variables: RtDetailsQueryVariables) => ['RtDetails', variables];
;

useRtDetailsQuery.fetcher = (client: GraphQLClient, variables: RtDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<RtDetailsQuery, RtDetailsQueryVariables>(client, RtDetailsDocument, variables, headers);
export const GetSelfDocument = `
    query getSelf {
  self {
    createdAt
    elementsID
    email
    emailVerified
    familyName
    givenName
    id
    updatedAt
    username
    profileColor
    profileImage
  }
}
    `;
export const useGetSelfQuery = <
      TData = GetSelfQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSelfQueryVariables,
      options?: UseQueryOptions<GetSelfQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSelfQuery, TError, TData>(
      variables === undefined ? ['getSelf'] : ['getSelf', variables],
      fetcher<GetSelfQuery, GetSelfQueryVariables>(client, GetSelfDocument, variables, headers),
      options
    );

useGetSelfQuery.getKey = (variables?: GetSelfQueryVariables) => variables === undefined ? ['getSelf'] : ['getSelf', variables];
;

useGetSelfQuery.fetcher = (client: GraphQLClient, variables?: GetSelfQueryVariables, headers?: RequestInit['headers']) => fetcher<GetSelfQuery, GetSelfQueryVariables>(client, GetSelfDocument, variables, headers);
export const DeleteSmartGroupDocument = `
    mutation deleteSmartGroup($input: DeleteSmartGroupInput!) {
  deleteSmartGroup(input: $input)
}
    `;
export const useDeleteSmartGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteSmartGroupMutation, TError, DeleteSmartGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteSmartGroupMutation, TError, DeleteSmartGroupMutationVariables, TContext>(
      ['deleteSmartGroup'],
      (variables?: DeleteSmartGroupMutationVariables) => fetcher<DeleteSmartGroupMutation, DeleteSmartGroupMutationVariables>(client, DeleteSmartGroupDocument, variables, headers)(),
      options
    );
useDeleteSmartGroupMutation.getKey = () => ['deleteSmartGroup'];

useDeleteSmartGroupMutation.fetcher = (client: GraphQLClient, variables: DeleteSmartGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteSmartGroupMutation, DeleteSmartGroupMutationVariables>(client, DeleteSmartGroupDocument, variables, headers);
export const CreateSmartGroupDocument = `
    mutation createSmartGroup($input: CreateSmartGroupInput!) {
  createSmartGroup(input: $input) {
    id
  }
}
    `;
export const useCreateSmartGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSmartGroupMutation, TError, CreateSmartGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateSmartGroupMutation, TError, CreateSmartGroupMutationVariables, TContext>(
      ['createSmartGroup'],
      (variables?: CreateSmartGroupMutationVariables) => fetcher<CreateSmartGroupMutation, CreateSmartGroupMutationVariables>(client, CreateSmartGroupDocument, variables, headers)(),
      options
    );
useCreateSmartGroupMutation.getKey = () => ['createSmartGroup'];

useCreateSmartGroupMutation.fetcher = (client: GraphQLClient, variables: CreateSmartGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateSmartGroupMutation, CreateSmartGroupMutationVariables>(client, CreateSmartGroupDocument, variables, headers);
export const UpdateSmartGroupDocument = `
    mutation updateSmartGroup($input: UpdateSmartGroupInput!) {
  updateSmartGroup(input: $input) {
    id
  }
}
    `;
export const useUpdateSmartGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateSmartGroupMutation, TError, UpdateSmartGroupMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateSmartGroupMutation, TError, UpdateSmartGroupMutationVariables, TContext>(
      ['updateSmartGroup'],
      (variables?: UpdateSmartGroupMutationVariables) => fetcher<UpdateSmartGroupMutation, UpdateSmartGroupMutationVariables>(client, UpdateSmartGroupDocument, variables, headers)(),
      options
    );
useUpdateSmartGroupMutation.getKey = () => ['updateSmartGroup'];

useUpdateSmartGroupMutation.fetcher = (client: GraphQLClient, variables: UpdateSmartGroupMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateSmartGroupMutation, UpdateSmartGroupMutationVariables>(client, UpdateSmartGroupDocument, variables, headers);
export const SmartGroupBasicLayoutPageDocument = `
    query SmartGroupBasicLayoutPage($smartGroupID: ID!, $firmID: ID!) {
  smartGroup(input: {smartGroupID: $smartGroupID, firmID: $firmID}) {
    id
    name
    firmClients {
      id
      createdAt
      familyNamesDisplay
      group {
        id
        name
      }
      individuals {
        profileImage
        profileColor
        givenName
        familyName
        age
      }
    }
  }
}
    `;
export const useSmartGroupBasicLayoutPageQuery = <
      TData = SmartGroupBasicLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SmartGroupBasicLayoutPageQueryVariables,
      options?: UseQueryOptions<SmartGroupBasicLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SmartGroupBasicLayoutPageQuery, TError, TData>(
      ['SmartGroupBasicLayoutPage', variables],
      fetcher<SmartGroupBasicLayoutPageQuery, SmartGroupBasicLayoutPageQueryVariables>(client, SmartGroupBasicLayoutPageDocument, variables, headers),
      options
    );

useSmartGroupBasicLayoutPageQuery.getKey = (variables: SmartGroupBasicLayoutPageQueryVariables) => ['SmartGroupBasicLayoutPage', variables];
;

useSmartGroupBasicLayoutPageQuery.fetcher = (client: GraphQLClient, variables: SmartGroupBasicLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<SmartGroupBasicLayoutPageQuery, SmartGroupBasicLayoutPageQueryVariables>(client, SmartGroupBasicLayoutPageDocument, variables, headers);
export const SmartGroupSaodLayoutPageDocument = `
    query SmartGroupSAODLayoutPage($smartGroupID: ID!, $firmID: ID!) {
  smartGroup(input: {smartGroupID: $smartGroupID, firmID: $firmID}) {
    name
    firmClients {
      id
    }
  }
}
    `;
export const useSmartGroupSaodLayoutPageQuery = <
      TData = SmartGroupSaodLayoutPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SmartGroupSaodLayoutPageQueryVariables,
      options?: UseQueryOptions<SmartGroupSaodLayoutPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SmartGroupSaodLayoutPageQuery, TError, TData>(
      ['SmartGroupSAODLayoutPage', variables],
      fetcher<SmartGroupSaodLayoutPageQuery, SmartGroupSaodLayoutPageQueryVariables>(client, SmartGroupSaodLayoutPageDocument, variables, headers),
      options
    );

useSmartGroupSaodLayoutPageQuery.getKey = (variables: SmartGroupSaodLayoutPageQueryVariables) => ['SmartGroupSAODLayoutPage', variables];
;

useSmartGroupSaodLayoutPageQuery.fetcher = (client: GraphQLClient, variables: SmartGroupSaodLayoutPageQueryVariables, headers?: RequestInit['headers']) => fetcher<SmartGroupSaodLayoutPageQuery, SmartGroupSaodLayoutPageQueryVariables>(client, SmartGroupSaodLayoutPageDocument, variables, headers);
export const SpendingCategoryEstimatesDocument = `
    query SpendingCategoryEstimates($householdID: ID!, $cursor: String) {
  spendingCategoryEstimates(householdID: $householdID, cursor: $cursor) {
    items {
      ...SpendingCategoryEstimateFragment
    }
  }
}
    ${SpendingCategoryEstimateFragmentFragmentDoc}`;
export const useSpendingCategoryEstimatesQuery = <
      TData = SpendingCategoryEstimatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SpendingCategoryEstimatesQueryVariables,
      options?: UseQueryOptions<SpendingCategoryEstimatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SpendingCategoryEstimatesQuery, TError, TData>(
      ['SpendingCategoryEstimates', variables],
      fetcher<SpendingCategoryEstimatesQuery, SpendingCategoryEstimatesQueryVariables>(client, SpendingCategoryEstimatesDocument, variables, headers),
      options
    );

useSpendingCategoryEstimatesQuery.getKey = (variables: SpendingCategoryEstimatesQueryVariables) => ['SpendingCategoryEstimates', variables];
;

useSpendingCategoryEstimatesQuery.fetcher = (client: GraphQLClient, variables: SpendingCategoryEstimatesQueryVariables, headers?: RequestInit['headers']) => fetcher<SpendingCategoryEstimatesQuery, SpendingCategoryEstimatesQueryVariables>(client, SpendingCategoryEstimatesDocument, variables, headers);
export const CreateSpendingCategoryEstimateDocument = `
    mutation CreateSpendingCategoryEstimate($input: CreateSpendingCategoryEstimateInput!) {
  createSpendingCategoryEstimate(input: $input) {
    spendingCategoryEstimate {
      ...SpendingCategoryEstimateFragment
    }
  }
}
    ${SpendingCategoryEstimateFragmentFragmentDoc}`;
export const useCreateSpendingCategoryEstimateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSpendingCategoryEstimateMutation, TError, CreateSpendingCategoryEstimateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateSpendingCategoryEstimateMutation, TError, CreateSpendingCategoryEstimateMutationVariables, TContext>(
      ['CreateSpendingCategoryEstimate'],
      (variables?: CreateSpendingCategoryEstimateMutationVariables) => fetcher<CreateSpendingCategoryEstimateMutation, CreateSpendingCategoryEstimateMutationVariables>(client, CreateSpendingCategoryEstimateDocument, variables, headers)(),
      options
    );
useCreateSpendingCategoryEstimateMutation.getKey = () => ['CreateSpendingCategoryEstimate'];

useCreateSpendingCategoryEstimateMutation.fetcher = (client: GraphQLClient, variables: CreateSpendingCategoryEstimateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateSpendingCategoryEstimateMutation, CreateSpendingCategoryEstimateMutationVariables>(client, CreateSpendingCategoryEstimateDocument, variables, headers);
export const UpdateSpendingCategoryEstimateDocument = `
    mutation UpdateSpendingCategoryEstimate($input: UpdateSpendingCategoryEstimateInput!) {
  updateSpendingCategoryEstimate(input: $input) {
    spendingCategoryEstimate {
      ...SpendingCategoryEstimateFragment
    }
  }
}
    ${SpendingCategoryEstimateFragmentFragmentDoc}`;
export const useUpdateSpendingCategoryEstimateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateSpendingCategoryEstimateMutation, TError, UpdateSpendingCategoryEstimateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateSpendingCategoryEstimateMutation, TError, UpdateSpendingCategoryEstimateMutationVariables, TContext>(
      ['UpdateSpendingCategoryEstimate'],
      (variables?: UpdateSpendingCategoryEstimateMutationVariables) => fetcher<UpdateSpendingCategoryEstimateMutation, UpdateSpendingCategoryEstimateMutationVariables>(client, UpdateSpendingCategoryEstimateDocument, variables, headers)(),
      options
    );
useUpdateSpendingCategoryEstimateMutation.getKey = () => ['UpdateSpendingCategoryEstimate'];

useUpdateSpendingCategoryEstimateMutation.fetcher = (client: GraphQLClient, variables: UpdateSpendingCategoryEstimateMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateSpendingCategoryEstimateMutation, UpdateSpendingCategoryEstimateMutationVariables>(client, UpdateSpendingCategoryEstimateDocument, variables, headers);
export const SrDetailsDocument = `
    query SrDetails($householdID: ID!, $includeScore: Boolean!, $includeAnnualSavings: Boolean!, $includeAnnualIncome: Boolean!, $includeCashSavings: Boolean!, $includeTotalCashSavings: Boolean!, $includePreTaxSavings: Boolean!, $includeTotalPreTaxSavings: Boolean!, $includeAfterTaxSavings: Boolean!, $includeTotalAfterTaxSavings: Boolean!, $includeEducationSavings: Boolean!, $includeTotalEducationSavings: Boolean!) {
  srDetails(householdID: $householdID) {
    sr @include(if: $includeScore)
    annualSavings @include(if: $includeAnnualSavings) {
      ...MonetaryAmountFragment
    }
    annualIncome @include(if: $includeAnnualIncome) {
      ...MonetaryAmountFragment
    }
    cashSavings @include(if: $includeCashSavings) {
      ...CashAccountFragment
    }
    totalCashSavings @include(if: $includeTotalCashSavings) {
      ...RecurringTotalsFragment
    }
    preTaxSavings @include(if: $includePreTaxSavings) {
      ...InvestmentFragment
    }
    totalPreTaxSavings @include(if: $includeTotalPreTaxSavings) {
      ...RecurringTotalsFragment
    }
    afterTaxSavings @include(if: $includeAfterTaxSavings) {
      ...InvestmentFragment
    }
    totalAfterTaxSavings @include(if: $includeTotalAfterTaxSavings) {
      ...RecurringTotalsFragment
    }
    educationSavings @include(if: $includeEducationSavings) {
      ...InvestmentFragment
    }
    totalEducationSavings @include(if: $includeTotalEducationSavings) {
      ...RecurringTotalsFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${CashAccountFragmentFragmentDoc}
${RecurringTotalsFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}`;
export const useSrDetailsQuery = <
      TData = SrDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SrDetailsQueryVariables,
      options?: UseQueryOptions<SrDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SrDetailsQuery, TError, TData>(
      ['SrDetails', variables],
      fetcher<SrDetailsQuery, SrDetailsQueryVariables>(client, SrDetailsDocument, variables, headers),
      options
    );

useSrDetailsQuery.getKey = (variables: SrDetailsQueryVariables) => ['SrDetails', variables];
;

useSrDetailsQuery.fetcher = (client: GraphQLClient, variables: SrDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<SrDetailsQuery, SrDetailsQueryVariables>(client, SrDetailsDocument, variables, headers);
export const GetStepFunctionExecutionStatusDocument = `
    query getStepFunctionExecutionStatus($executionArn: String!, $clientID: ID!) {
  stepFunctionExecutionStatus(executionArn: $executionArn, clientID: $clientID)
}
    `;
export const useGetStepFunctionExecutionStatusQuery = <
      TData = GetStepFunctionExecutionStatusQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetStepFunctionExecutionStatusQueryVariables,
      options?: UseQueryOptions<GetStepFunctionExecutionStatusQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetStepFunctionExecutionStatusQuery, TError, TData>(
      ['getStepFunctionExecutionStatus', variables],
      fetcher<GetStepFunctionExecutionStatusQuery, GetStepFunctionExecutionStatusQueryVariables>(client, GetStepFunctionExecutionStatusDocument, variables, headers),
      options
    );

useGetStepFunctionExecutionStatusQuery.getKey = (variables: GetStepFunctionExecutionStatusQueryVariables) => ['getStepFunctionExecutionStatus', variables];
;

useGetStepFunctionExecutionStatusQuery.fetcher = (client: GraphQLClient, variables: GetStepFunctionExecutionStatusQueryVariables, headers?: RequestInit['headers']) => fetcher<GetStepFunctionExecutionStatusQuery, GetStepFunctionExecutionStatusQueryVariables>(client, GetStepFunctionExecutionStatusDocument, variables, headers);
export const TargetScoreRangesDocument = `
    query targetScoreRanges($clientID: ID!) {
  targetScoreRanges(clientID: $clientID) {
    ranges {
      ...TargetScoreRangesFragment
    }
    appliedTemplate {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangesFragmentFragmentDoc}
${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useTargetScoreRangesQuery = <
      TData = TargetScoreRangesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TargetScoreRangesQueryVariables,
      options?: UseQueryOptions<TargetScoreRangesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TargetScoreRangesQuery, TError, TData>(
      ['targetScoreRanges', variables],
      fetcher<TargetScoreRangesQuery, TargetScoreRangesQueryVariables>(client, TargetScoreRangesDocument, variables, headers),
      options
    );

useTargetScoreRangesQuery.getKey = (variables: TargetScoreRangesQueryVariables) => ['targetScoreRanges', variables];
;

useTargetScoreRangesQuery.fetcher = (client: GraphQLClient, variables: TargetScoreRangesQueryVariables, headers?: RequestInit['headers']) => fetcher<TargetScoreRangesQuery, TargetScoreRangesQueryVariables>(client, TargetScoreRangesDocument, variables, headers);
export const TargetScoreRangeTemplatesDocument = `
    query targetScoreRangeTemplates($firmID: ID!, $includeDefaults: Boolean!, $cursor: String) {
  targetScoreRangeTemplates(
    firmID: $firmID
    includeDefaults: $includeDefaults
    cursor: $cursor
  ) {
    items {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useTargetScoreRangeTemplatesQuery = <
      TData = TargetScoreRangeTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TargetScoreRangeTemplatesQueryVariables,
      options?: UseQueryOptions<TargetScoreRangeTemplatesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TargetScoreRangeTemplatesQuery, TError, TData>(
      ['targetScoreRangeTemplates', variables],
      fetcher<TargetScoreRangeTemplatesQuery, TargetScoreRangeTemplatesQueryVariables>(client, TargetScoreRangeTemplatesDocument, variables, headers),
      options
    );

useTargetScoreRangeTemplatesQuery.getKey = (variables: TargetScoreRangeTemplatesQueryVariables) => ['targetScoreRangeTemplates', variables];
;

useTargetScoreRangeTemplatesQuery.fetcher = (client: GraphQLClient, variables: TargetScoreRangeTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<TargetScoreRangeTemplatesQuery, TargetScoreRangeTemplatesQueryVariables>(client, TargetScoreRangeTemplatesDocument, variables, headers);
export const TargetScoreRangeTemplateDocument = `
    query targetScoreRangeTemplate($firmID: ID!, $id: ID!) {
  targetScoreRangeTemplate(firmID: $firmID, id: $id) {
    ...TargetScoreRangeTemplateFragment
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useTargetScoreRangeTemplateQuery = <
      TData = TargetScoreRangeTemplateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TargetScoreRangeTemplateQueryVariables,
      options?: UseQueryOptions<TargetScoreRangeTemplateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TargetScoreRangeTemplateQuery, TError, TData>(
      ['targetScoreRangeTemplate', variables],
      fetcher<TargetScoreRangeTemplateQuery, TargetScoreRangeTemplateQueryVariables>(client, TargetScoreRangeTemplateDocument, variables, headers),
      options
    );

useTargetScoreRangeTemplateQuery.getKey = (variables: TargetScoreRangeTemplateQueryVariables) => ['targetScoreRangeTemplate', variables];
;

useTargetScoreRangeTemplateQuery.fetcher = (client: GraphQLClient, variables: TargetScoreRangeTemplateQueryVariables, headers?: RequestInit['headers']) => fetcher<TargetScoreRangeTemplateQuery, TargetScoreRangeTemplateQueryVariables>(client, TargetScoreRangeTemplateDocument, variables, headers);
export const FirmDefaultsTargetScoreRangeTemplateDocument = `
    query firmDefaultsTargetScoreRangeTemplate($firmID: ID!) {
  firmDefaultsTargetScoreRangeTemplate(firmID: $firmID) {
    ...TargetScoreRangeTemplateFragment
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useFirmDefaultsTargetScoreRangeTemplateQuery = <
      TData = FirmDefaultsTargetScoreRangeTemplateQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FirmDefaultsTargetScoreRangeTemplateQueryVariables,
      options?: UseQueryOptions<FirmDefaultsTargetScoreRangeTemplateQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<FirmDefaultsTargetScoreRangeTemplateQuery, TError, TData>(
      ['firmDefaultsTargetScoreRangeTemplate', variables],
      fetcher<FirmDefaultsTargetScoreRangeTemplateQuery, FirmDefaultsTargetScoreRangeTemplateQueryVariables>(client, FirmDefaultsTargetScoreRangeTemplateDocument, variables, headers),
      options
    );

useFirmDefaultsTargetScoreRangeTemplateQuery.getKey = (variables: FirmDefaultsTargetScoreRangeTemplateQueryVariables) => ['firmDefaultsTargetScoreRangeTemplate', variables];
;

useFirmDefaultsTargetScoreRangeTemplateQuery.fetcher = (client: GraphQLClient, variables: FirmDefaultsTargetScoreRangeTemplateQueryVariables, headers?: RequestInit['headers']) => fetcher<FirmDefaultsTargetScoreRangeTemplateQuery, FirmDefaultsTargetScoreRangeTemplateQueryVariables>(client, FirmDefaultsTargetScoreRangeTemplateDocument, variables, headers);
export const CreateTargetScoreRangeTemplateDocument = `
    mutation createTargetScoreRangeTemplate($input: CreateTargetScoreRangeTemplateInput!) {
  createTargetScoreRangeTemplate(input: $input) {
    template {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useCreateTargetScoreRangeTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateTargetScoreRangeTemplateMutation, TError, CreateTargetScoreRangeTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateTargetScoreRangeTemplateMutation, TError, CreateTargetScoreRangeTemplateMutationVariables, TContext>(
      ['createTargetScoreRangeTemplate'],
      (variables?: CreateTargetScoreRangeTemplateMutationVariables) => fetcher<CreateTargetScoreRangeTemplateMutation, CreateTargetScoreRangeTemplateMutationVariables>(client, CreateTargetScoreRangeTemplateDocument, variables, headers)(),
      options
    );
useCreateTargetScoreRangeTemplateMutation.getKey = () => ['createTargetScoreRangeTemplate'];

useCreateTargetScoreRangeTemplateMutation.fetcher = (client: GraphQLClient, variables: CreateTargetScoreRangeTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateTargetScoreRangeTemplateMutation, CreateTargetScoreRangeTemplateMutationVariables>(client, CreateTargetScoreRangeTemplateDocument, variables, headers);
export const UpdateTargetScoreRangeTemplateDocument = `
    mutation updateTargetScoreRangeTemplate($input: UpdateTargetScoreRangeTemplateInput!) {
  updateTargetScoreRangeTemplate(input: $input) {
    template {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useUpdateTargetScoreRangeTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateTargetScoreRangeTemplateMutation, TError, UpdateTargetScoreRangeTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateTargetScoreRangeTemplateMutation, TError, UpdateTargetScoreRangeTemplateMutationVariables, TContext>(
      ['updateTargetScoreRangeTemplate'],
      (variables?: UpdateTargetScoreRangeTemplateMutationVariables) => fetcher<UpdateTargetScoreRangeTemplateMutation, UpdateTargetScoreRangeTemplateMutationVariables>(client, UpdateTargetScoreRangeTemplateDocument, variables, headers)(),
      options
    );
useUpdateTargetScoreRangeTemplateMutation.getKey = () => ['updateTargetScoreRangeTemplate'];

useUpdateTargetScoreRangeTemplateMutation.fetcher = (client: GraphQLClient, variables: UpdateTargetScoreRangeTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateTargetScoreRangeTemplateMutation, UpdateTargetScoreRangeTemplateMutationVariables>(client, UpdateTargetScoreRangeTemplateDocument, variables, headers);
export const ResetTargetScoreRangeTemplateValueDocument = `
    mutation resetTargetScoreRangeTemplateValue($input: ResetTargetScoreRangeTemplateValueInput!) {
  resetTargetScoreRangeTemplateValue(input: $input) {
    template {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useResetTargetScoreRangeTemplateValueMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetTargetScoreRangeTemplateValueMutation, TError, ResetTargetScoreRangeTemplateValueMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetTargetScoreRangeTemplateValueMutation, TError, ResetTargetScoreRangeTemplateValueMutationVariables, TContext>(
      ['resetTargetScoreRangeTemplateValue'],
      (variables?: ResetTargetScoreRangeTemplateValueMutationVariables) => fetcher<ResetTargetScoreRangeTemplateValueMutation, ResetTargetScoreRangeTemplateValueMutationVariables>(client, ResetTargetScoreRangeTemplateValueDocument, variables, headers)(),
      options
    );
useResetTargetScoreRangeTemplateValueMutation.getKey = () => ['resetTargetScoreRangeTemplateValue'];

useResetTargetScoreRangeTemplateValueMutation.fetcher = (client: GraphQLClient, variables: ResetTargetScoreRangeTemplateValueMutationVariables, headers?: RequestInit['headers']) => fetcher<ResetTargetScoreRangeTemplateValueMutation, ResetTargetScoreRangeTemplateValueMutationVariables>(client, ResetTargetScoreRangeTemplateValueDocument, variables, headers);
export const DeleteTargetScoreRangeTemplateDocument = `
    mutation deleteTargetScoreRangeTemplate($input: DeleteTargetScoreRangeTemplateInput!) {
  deleteTargetScoreRangeTemplate(input: $input) {
    deleted
  }
}
    `;
export const useDeleteTargetScoreRangeTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteTargetScoreRangeTemplateMutation, TError, DeleteTargetScoreRangeTemplateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteTargetScoreRangeTemplateMutation, TError, DeleteTargetScoreRangeTemplateMutationVariables, TContext>(
      ['deleteTargetScoreRangeTemplate'],
      (variables?: DeleteTargetScoreRangeTemplateMutationVariables) => fetcher<DeleteTargetScoreRangeTemplateMutation, DeleteTargetScoreRangeTemplateMutationVariables>(client, DeleteTargetScoreRangeTemplateDocument, variables, headers)(),
      options
    );
useDeleteTargetScoreRangeTemplateMutation.getKey = () => ['deleteTargetScoreRangeTemplate'];

useDeleteTargetScoreRangeTemplateMutation.fetcher = (client: GraphQLClient, variables: DeleteTargetScoreRangeTemplateMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteTargetScoreRangeTemplateMutation, DeleteTargetScoreRangeTemplateMutationVariables>(client, DeleteTargetScoreRangeTemplateDocument, variables, headers);
export const ApplyTargetScoreRangeTemplateToClientDocument = `
    mutation applyTargetScoreRangeTemplateToClient($input: ApplyTargetScoreRangeTemplateToClientInput!) {
  applyTargetScoreRangeTemplateToClient(input: $input) {
    ranges {
      ...TargetScoreRangesFragment
    }
    appliedTemplate {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangesFragmentFragmentDoc}
${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useApplyTargetScoreRangeTemplateToClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ApplyTargetScoreRangeTemplateToClientMutation, TError, ApplyTargetScoreRangeTemplateToClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ApplyTargetScoreRangeTemplateToClientMutation, TError, ApplyTargetScoreRangeTemplateToClientMutationVariables, TContext>(
      ['applyTargetScoreRangeTemplateToClient'],
      (variables?: ApplyTargetScoreRangeTemplateToClientMutationVariables) => fetcher<ApplyTargetScoreRangeTemplateToClientMutation, ApplyTargetScoreRangeTemplateToClientMutationVariables>(client, ApplyTargetScoreRangeTemplateToClientDocument, variables, headers)(),
      options
    );
useApplyTargetScoreRangeTemplateToClientMutation.getKey = () => ['applyTargetScoreRangeTemplateToClient'];

useApplyTargetScoreRangeTemplateToClientMutation.fetcher = (client: GraphQLClient, variables: ApplyTargetScoreRangeTemplateToClientMutationVariables, headers?: RequestInit['headers']) => fetcher<ApplyTargetScoreRangeTemplateToClientMutation, ApplyTargetScoreRangeTemplateToClientMutationVariables>(client, ApplyTargetScoreRangeTemplateToClientDocument, variables, headers);
export const UpdateTargetScoreRangesForClientDocument = `
    mutation updateTargetScoreRangesForClient($input: UpdateTargetScoreRangesForClientInput!) {
  updateTargetScoreRangesForClient(input: $input) {
    ranges {
      ...TargetScoreRangesFragment
    }
    appliedTemplate {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangesFragmentFragmentDoc}
${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useUpdateTargetScoreRangesForClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateTargetScoreRangesForClientMutation, TError, UpdateTargetScoreRangesForClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateTargetScoreRangesForClientMutation, TError, UpdateTargetScoreRangesForClientMutationVariables, TContext>(
      ['updateTargetScoreRangesForClient'],
      (variables?: UpdateTargetScoreRangesForClientMutationVariables) => fetcher<UpdateTargetScoreRangesForClientMutation, UpdateTargetScoreRangesForClientMutationVariables>(client, UpdateTargetScoreRangesForClientDocument, variables, headers)(),
      options
    );
useUpdateTargetScoreRangesForClientMutation.getKey = () => ['updateTargetScoreRangesForClient'];

useUpdateTargetScoreRangesForClientMutation.fetcher = (client: GraphQLClient, variables: UpdateTargetScoreRangesForClientMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateTargetScoreRangesForClientMutation, UpdateTargetScoreRangesForClientMutationVariables>(client, UpdateTargetScoreRangesForClientDocument, variables, headers);
export const ResetTargetScoreRangeValueForClientDocument = `
    mutation resetTargetScoreRangeValueForClient($input: ResetTargetScoreRangeValueForClientInput!) {
  resetTargetScoreRangeValueForClient(input: $input) {
    ranges {
      ...TargetScoreRangesFragment
    }
    appliedTemplate {
      ...TargetScoreRangeTemplateFragment
    }
  }
}
    ${TargetScoreRangesFragmentFragmentDoc}
${TargetScoreRangeTemplateFragmentFragmentDoc}`;
export const useResetTargetScoreRangeValueForClientMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResetTargetScoreRangeValueForClientMutation, TError, ResetTargetScoreRangeValueForClientMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResetTargetScoreRangeValueForClientMutation, TError, ResetTargetScoreRangeValueForClientMutationVariables, TContext>(
      ['resetTargetScoreRangeValueForClient'],
      (variables?: ResetTargetScoreRangeValueForClientMutationVariables) => fetcher<ResetTargetScoreRangeValueForClientMutation, ResetTargetScoreRangeValueForClientMutationVariables>(client, ResetTargetScoreRangeValueForClientDocument, variables, headers)(),
      options
    );
useResetTargetScoreRangeValueForClientMutation.getKey = () => ['resetTargetScoreRangeValueForClient'];

useResetTargetScoreRangeValueForClientMutation.fetcher = (client: GraphQLClient, variables: ResetTargetScoreRangeValueForClientMutationVariables, headers?: RequestInit['headers']) => fetcher<ResetTargetScoreRangeValueForClientMutation, ResetTargetScoreRangeValueForClientMutationVariables>(client, ResetTargetScoreRangeValueForClientDocument, variables, headers);
export const TaxReturnSummariesDocument = `
    query taxReturnSummaries($householdID: ID!) {
  taxReturnSummaries(householdID: $householdID) {
    items {
      ...TaxReturnSummaryFragment
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${TaxReturnSummaryFragmentFragmentDoc}`;
export const useTaxReturnSummariesQuery = <
      TData = TaxReturnSummariesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TaxReturnSummariesQueryVariables,
      options?: UseQueryOptions<TaxReturnSummariesQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TaxReturnSummariesQuery, TError, TData>(
      ['taxReturnSummaries', variables],
      fetcher<TaxReturnSummariesQuery, TaxReturnSummariesQueryVariables>(client, TaxReturnSummariesDocument, variables, headers),
      options
    );

useTaxReturnSummariesQuery.getKey = (variables: TaxReturnSummariesQueryVariables) => ['taxReturnSummaries', variables];
;

useTaxReturnSummariesQuery.fetcher = (client: GraphQLClient, variables: TaxReturnSummariesQueryVariables, headers?: RequestInit['headers']) => fetcher<TaxReturnSummariesQuery, TaxReturnSummariesQueryVariables>(client, TaxReturnSummariesDocument, variables, headers);
export const CreateTaxReturnSummaryDocument = `
    mutation createTaxReturnSummary($input: CreateTaxReturnSummaryInput!) {
  createTaxReturnSummary(input: $input) {
    taxReturnSummary {
      id
      householdID
    }
  }
}
    `;
export const useCreateTaxReturnSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateTaxReturnSummaryMutation, TError, CreateTaxReturnSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateTaxReturnSummaryMutation, TError, CreateTaxReturnSummaryMutationVariables, TContext>(
      ['createTaxReturnSummary'],
      (variables?: CreateTaxReturnSummaryMutationVariables) => fetcher<CreateTaxReturnSummaryMutation, CreateTaxReturnSummaryMutationVariables>(client, CreateTaxReturnSummaryDocument, variables, headers)(),
      options
    );
useCreateTaxReturnSummaryMutation.getKey = () => ['createTaxReturnSummary'];

useCreateTaxReturnSummaryMutation.fetcher = (client: GraphQLClient, variables: CreateTaxReturnSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateTaxReturnSummaryMutation, CreateTaxReturnSummaryMutationVariables>(client, CreateTaxReturnSummaryDocument, variables, headers);
export const DeleteTaxReturnSummaryDocument = `
    mutation DeleteTaxReturnSummary($input: DeleteTaxReturnSummaryInput!) {
  deleteTaxReturnSummary(input: $input) {
    changeToken
  }
}
    `;
export const useDeleteTaxReturnSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteTaxReturnSummaryMutation, TError, DeleteTaxReturnSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteTaxReturnSummaryMutation, TError, DeleteTaxReturnSummaryMutationVariables, TContext>(
      ['DeleteTaxReturnSummary'],
      (variables?: DeleteTaxReturnSummaryMutationVariables) => fetcher<DeleteTaxReturnSummaryMutation, DeleteTaxReturnSummaryMutationVariables>(client, DeleteTaxReturnSummaryDocument, variables, headers)(),
      options
    );
useDeleteTaxReturnSummaryMutation.getKey = () => ['DeleteTaxReturnSummary'];

useDeleteTaxReturnSummaryMutation.fetcher = (client: GraphQLClient, variables: DeleteTaxReturnSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteTaxReturnSummaryMutation, DeleteTaxReturnSummaryMutationVariables>(client, DeleteTaxReturnSummaryDocument, variables, headers);
export const UpdateTaxReturnSummaryDocument = `
    mutation UpdateTaxReturnSummary($input: UpdateTaxReturnSummaryInput!) {
  updateTaxReturnSummary(input: $input) {
    taxReturnSummary {
      id
      householdID
    }
  }
}
    `;
export const useUpdateTaxReturnSummaryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateTaxReturnSummaryMutation, TError, UpdateTaxReturnSummaryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateTaxReturnSummaryMutation, TError, UpdateTaxReturnSummaryMutationVariables, TContext>(
      ['UpdateTaxReturnSummary'],
      (variables?: UpdateTaxReturnSummaryMutationVariables) => fetcher<UpdateTaxReturnSummaryMutation, UpdateTaxReturnSummaryMutationVariables>(client, UpdateTaxReturnSummaryDocument, variables, headers)(),
      options
    );
useUpdateTaxReturnSummaryMutation.getKey = () => ['UpdateTaxReturnSummary'];

useUpdateTaxReturnSummaryMutation.fetcher = (client: GraphQLClient, variables: UpdateTaxReturnSummaryMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateTaxReturnSummaryMutation, UpdateTaxReturnSummaryMutationVariables>(client, UpdateTaxReturnSummaryDocument, variables, headers);
export const GetTaxReturnSummaryDocument = `
    query GetTaxReturnSummary($householdID: ID!, $id: ID!) {
  taxReturnSummary(householdID: $householdID, id: $id) {
    ...TaxReturnSummaryFragment
  }
}
    ${TaxReturnSummaryFragmentFragmentDoc}`;
export const useGetTaxReturnSummaryQuery = <
      TData = GetTaxReturnSummaryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetTaxReturnSummaryQueryVariables,
      options?: UseQueryOptions<GetTaxReturnSummaryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTaxReturnSummaryQuery, TError, TData>(
      ['GetTaxReturnSummary', variables],
      fetcher<GetTaxReturnSummaryQuery, GetTaxReturnSummaryQueryVariables>(client, GetTaxReturnSummaryDocument, variables, headers),
      options
    );

useGetTaxReturnSummaryQuery.getKey = (variables: GetTaxReturnSummaryQueryVariables) => ['GetTaxReturnSummary', variables];
;

useGetTaxReturnSummaryQuery.fetcher = (client: GraphQLClient, variables: GetTaxReturnSummaryQueryVariables, headers?: RequestInit['headers']) => fetcher<GetTaxReturnSummaryQuery, GetTaxReturnSummaryQueryVariables>(client, GetTaxReturnSummaryDocument, variables, headers);
export const TtDetailsDocument = `
    query TtDetails($householdID: ID!, $includeScore: Boolean!, $includeNetWorth: Boolean!, $includeAnnualExpenses: Boolean!, $includeAssetSummary: Boolean!, $includeDebtSummary: Boolean!, $includeTotalLiquidAssets: Boolean!, $includeTotalQualifiedAssets: Boolean!, $includeTotalRealEstateEquity: Boolean!, $includeTotalBusinessEquity: Boolean!, $includeTotalOther: Boolean!) {
  ttDetails(householdID: $householdID) {
    tt @include(if: $includeScore)
    netWorth @include(if: $includeNetWorth) {
      ...MonetaryAmountFragment
    }
    annualExpenses @include(if: $includeAnnualExpenses) {
      ...MonetaryAmountFragment
    }
    assetSummary @include(if: $includeAssetSummary) {
      cashAccounts {
        ...CashAccountFragment
      }
      totalCashAccounts {
        ...MonetaryAmountFragment
      }
      preTaxInvestments {
        ...InvestmentFragment
      }
      totalPreTaxInvestments {
        ...MonetaryAmountFragment
      }
      afterTaxInvestments {
        ...InvestmentFragment
      }
      totalAfterTaxInvestments {
        ...MonetaryAmountFragment
      }
      personalRealEstate {
        ...RealEstateFragment
      }
      totalPersonalRealEstateValue {
        ...MonetaryAmountFragment
      }
      investmentRealEstate {
        ...RealEstateFragment
      }
      totalInvestmentRealEstateValue {
        ...MonetaryAmountFragment
      }
      businesses {
        ...BusinessFragment
      }
      totalBusinessValue {
        ...MonetaryAmountFragment
      }
      noteReceivables {
        ...NoteReceivableFragment
      }
      personalPropertyItems {
        ...PersonalPropertyItemFragment
      }
      totalOtherAssets {
        ...MonetaryAmountFragment
      }
      totalAssets {
        ...MonetaryAmountFragment
      }
    }
    debtSummary @include(if: $includeDebtSummary) {
      personalRealEstateLoans {
        ...LoanFragment
      }
      totalPersonalRealEstateLoans {
        ...MonetaryAmountFragment
      }
      investmentRealEstateLoans {
        ...LoanFragment
      }
      totalInvestmentRealEstateLoans {
        ...MonetaryAmountFragment
      }
      studentLoans {
        ...LoanFragment
      }
      totalStudentLoans {
        ...MonetaryAmountFragment
      }
      otherDebt {
        ...LoanFragment
      }
      totalOtherDebt {
        ...MonetaryAmountFragment
      }
      totalDebt {
        ...MonetaryAmountFragment
      }
      businessLoans {
        ...LoanFragment
      }
      totalBusinessLoans {
        ...MonetaryAmountFragment
      }
    }
    totalLiquidAssets @include(if: $includeTotalLiquidAssets) {
      ...MonetaryAmountFragment
    }
    totalQualifiedAssets @include(if: $includeTotalQualifiedAssets) {
      ...MonetaryAmountFragment
    }
    totalRealEstateEquity @include(if: $includeTotalRealEstateEquity) {
      ...MonetaryAmountFragment
    }
    totalBusinessEquity @include(if: $includeTotalBusinessEquity) {
      ...MonetaryAmountFragment
    }
    totalOther @include(if: $includeTotalOther) {
      ...MonetaryAmountFragment
    }
  }
}
    ${MonetaryAmountFragmentFragmentDoc}
${CashAccountFragmentFragmentDoc}
${InvestmentFragmentFragmentDoc}
${RealEstateFragmentFragmentDoc}
${BusinessFragmentFragmentDoc}
${NoteReceivableFragmentFragmentDoc}
${PersonalPropertyItemFragmentFragmentDoc}
${LoanFragmentFragmentDoc}`;
export const useTtDetailsQuery = <
      TData = TtDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: TtDetailsQueryVariables,
      options?: UseQueryOptions<TtDetailsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TtDetailsQuery, TError, TData>(
      ['TtDetails', variables],
      fetcher<TtDetailsQuery, TtDetailsQueryVariables>(client, TtDetailsDocument, variables, headers),
      options
    );

useTtDetailsQuery.getKey = (variables: TtDetailsQueryVariables) => ['TtDetails', variables];
;

useTtDetailsQuery.fetcher = (client: GraphQLClient, variables: TtDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<TtDetailsQuery, TtDetailsQueryVariables>(client, TtDetailsDocument, variables, headers);
export const UpdateUserDocument = `
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input)
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['UpdateUser'],
      (variables?: UpdateUserMutationVariables) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers)(),
      options
    );
useUpdateUserMutation.getKey = () => ['UpdateUser'];

useUpdateUserMutation.fetcher = (client: GraphQLClient, variables: UpdateUserMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateUserMutation, UpdateUserMutationVariables>(client, UpdateUserDocument, variables, headers);